webpackJsonp([1],[
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Icon_vue__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5d0258de_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Icon_vue__ = __webpack_require__(701);
function injectStyle (ssrContext) {
  __webpack_require__(699)
}
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Icon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5d0258de_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Icon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__template_id__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__template__ = __webpack_require__(1632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__window_id__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__window_props__ = __webpack_require__(275);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__template_id__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__template__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__window_id__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__window_props__["a"]; });







/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return WINDOW_CREATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return WINDOW_OPEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return WINDOW_OPEN_CREATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return WINDOW_ACTIVATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return WINDOW_CLOSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return WINDOW_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return TEMPLATE_CREATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return TEMPLATE_OPEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return TEMPLATE_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return TEMPLATE_FOLDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return TEMPLATE_LAYER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return TEMPLATE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return TEMPLATE_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return TEMPLATE_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return TEMPLATE_OVERLAY_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return TEMPLATE_OVERLAY_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ALBUM_CREATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ALBUM_OPEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ALBUM_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ALBUM_META; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ALBUM_PICTURE_CREATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ALBUM_PICTURE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ALBUM_PICTURE_REMOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return DATASET_CREATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return DATASET_OPEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return DATASET_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return TOGGLE_PLAY_STOP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return COMMAND_NEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return COMMAND_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return COMMAND_INVOKE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return OVERLAY_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return OVERLAY_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CLEAR_CHANNEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return FETCH_ACCOUNTS; });
var WINDOW_CREATE = 'WINDOW_CREATE';
var WINDOW_OPEN = 'WINDOW_OPEN';
var WINDOW_OPEN_CREATE = 'WINDOW_OPEN_CREATE';
var WINDOW_ACTIVATE = 'WINDOW_ACTIVATE';
var WINDOW_CLOSE = 'WINDOW_CLOSE';
var WINDOW_DATA = 'WINDOW_DATA';

var TEMPLATE_CREATE = 'TEMPLATE_CREATE';
var TEMPLATE_OPEN = 'TEMPLATE_OPEN';
var TEMPLATE_DELETE = 'TEMPLATE_DELETE';
var TEMPLATE_FOLDER = 'TEMPLATE_FOLDER';
var TEMPLATE_LAYER = 'TEMPLATE_LAYER';
var TEMPLATE_NAME = 'TEMPLATE_NAME';
var TEMPLATE_DATA = 'TEMPLATE_DATA';
var TEMPLATE_OPTIONS = 'TEMPLATE_OPTIONS';
var TEMPLATE_OVERLAY_DATA = 'TEMPLATE_OVERLAY_DATA';
var TEMPLATE_OVERLAY_OPTIONS = 'TEMPLATE_OVERLAY_OPTIONS';

var ALBUM_CREATE = 'ALBUM_CREATE';
var ALBUM_OPEN = 'ALBUM_OPEN';
var ALBUM_DELETE = 'ALBUM_DELETE';
var ALBUM_META = 'ALBUM_META';
var ALBUM_PICTURE_CREATE = 'ALBUM_PICTURE_CREATE';
var ALBUM_PICTURE_CHANGE = 'ALBUM_PICTURE_CHANGE';
var ALBUM_PICTURE_REMOVE = 'ALBUM_PICTURE_REMOVE';

var DATASET_CREATE = 'DATASET_CREATE';
var DATASET_OPEN = 'DATASET_OPEN';
var DATASET_DELETE = 'DATASET_DELETE';

var TOGGLE_PLAY_STOP = 'TOGGLE_PLAY_STOP';
var COMMAND_NEXT = 'COMMAND_NEXT';
var COMMAND_UPDATE = 'COMMAND_UPDATE';
var COMMAND_INVOKE = 'COMMAND_INVOKE';
var OVERLAY_DATA = 'OVERLAY_DATA';
var OVERLAY_OPTIONS = 'OVERLAY_OPTIONS';
var CLEAR_CHANNEL = 'CLEAR_CHANNEL';
var FETCH_ACCOUNTS = 'FETCH_ACCOUNTS';

/***/ }),
/* 6 */,
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return mapRecord; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__comparators__ = __webpack_require__(1555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rank__ = __webpack_require__(1556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__observe_dom__ = __webpack_require__(1557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapImageIdToImage__ = __webpack_require__(1558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mapOverlayData__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mapOverlayOptions__ = __webpack_require__(1559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mapTemplateData__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mapTemplateOptions__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mapWindowData__ = __webpack_require__(1560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__overlayDataProp__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__overlayOptionProp__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__templateDataProp__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__templateOptionProp__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__windowDataProp__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__windowTitleProp__ = __webpack_require__(1561);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__comparators__; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_2__rank__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_3__observe_dom__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__mapImageIdToImage__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_5__mapOverlayData__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_6__mapOverlayOptions__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_7__mapTemplateData__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_8__mapTemplateOptions__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_9__mapWindowData__["a"]; });
/* unused harmony reexport overlayDataProp */
/* unused harmony reexport overlayOptionProp */
/* unused harmony reexport templateDataProp */
/* unused harmony reexport templateOptionProp */
/* unused harmony reexport windowDataProp */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_15__windowTitleProp__["a"]; });


















var mapRecord = function mapRecord(record, patterns) {
  if ((typeof record === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(record)) !== 'object') return record;
  var result = {};
  for (var k in patterns) {
    if (!patterns.hasOwnProperty(k)) continue;
    result[k] = patterns[k].replace(/\$\{([\w ]+)\}/g, function (match, p1) {
      return record[p1] || '';
    });
  }
  return result;
};



/***/ }),
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return SET_ACCOUNTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return SET_SELECTED_ACCOUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return SOCKET_CONNECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return SOCKET_DISCONNECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return SOCKET_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return SOCKET_LOADED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return WINDOW_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return WINDOW_CREATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return WINDOW_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return WINDOW_OPEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return WINDOW_CLOSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return WINDOW_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return WINDOW_TITLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CHANNEL_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CHANNEL_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return OVERLAY_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return OVERLAY_REMOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return OVERLAY_PLAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return OVERLAY_STOP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return OVERLAY_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return OVERLAY_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return OVERLAY_NEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return OVERLAY_INVOKE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return TEMPLATE_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return TEMPLATE_CREATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return TEMPLATE_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return TEMPLATE_FOLDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return TEMPLATE_LAYER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return TEMPLATE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return TEMPLATE_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return TEMPLATE_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return TEMPLATE_OVERLAY_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return TEMPLATE_OVERLAY_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ALBUM_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ALBUM_CREATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ALBUM_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ALBUM_META; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ALBUM_PICTURE_CREATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ALBUM_PICTURE_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ALBUM_PICTURE_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return DATASET_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return DATASET_CREATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return DATASET_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return DATASET_UPDATE_META; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return DATASET_CREATE_RECORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return DATASET_DELETE_RECORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return DATASET_UPDATE_RECORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return DATASET_UPDATE_RECORDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return DATASET_UPDATE_VALUE; });
// Account
var SET_ACCOUNTS = 'SET_ACCOUNTS';
var SET_SELECTED_ACCOUNT = 'SET_SELECTED_ACCOUNT';

// WebSocket
var SOCKET_CONNECTED = 'SOCKET_CONNECTED';
var SOCKET_DISCONNECTED = 'SOCKET_DISCONNECTED';
var SOCKET_LOADING = 'SOCKET_LOADING';
var SOCKET_LOADED = 'SOCKET_LOADED';

// Window
var WINDOW_STATE = 'WINDOW_STATE';
var WINDOW_CREATE = 'WINDOW_CREATE';
var WINDOW_DELETE = 'WINDOW_DELETE';
var WINDOW_OPEN = 'WINDOW_OPEN';
var WINDOW_CLOSE = 'WINDOW_CLOSE';
var WINDOW_DATA = 'WINDOW_DATA';
var WINDOW_TITLE = 'WINDOW_TITLE';

// Channel
var CHANNEL_CLEAR = 'CHANNEL_CLEAR';
var CHANNEL_STATE = 'UPDATE_CHANNEL';
var OVERLAY_ADD = 'OVERLAY_ADD';
var OVERLAY_REMOVE = 'OVERLAY_REMOVE';
var OVERLAY_PLAY = 'OVERLAY_PLAY';
var OVERLAY_STOP = 'OVERLAY_STOP';
var OVERLAY_DATA = 'OVERLAY_DATA';
var OVERLAY_OPTIONS = 'OVERLAY_OPTIONS';
var OVERLAY_NEXT = 'OVERLAY_NEXT';
var OVERLAY_INVOKE = 'OVERLAY_INVOKE';

// Templates
var TEMPLATE_STATE = 'TEMPLATE_STATE';
var TEMPLATE_CREATE = 'TEMPLATE_CREATE';
var TEMPLATE_DELETE = 'TEMPLATE_DELETE';
var TEMPLATE_FOLDER = 'TEMPLATE_FOLDER';
var TEMPLATE_LAYER = 'TEMPLATE_LAYER';
var TEMPLATE_NAME = 'TEMPLATE_NAME';
var TEMPLATE_DATA = 'TEMPLATE_DATA';
var TEMPLATE_OPTIONS = 'TEMPLATE_OPTIONS';
var TEMPLATE_OVERLAY_DATA = 'TEMPLATE_OVERLAY_DATA';
var TEMPLATE_OVERLAY_OPTIONS = 'TEMPLATE_OVERLAY_OPTIONS';

// Album
var ALBUM_STATE = 'ALBUM_STATE';
var ALBUM_CREATE = 'ALBUM_CREATE';
var ALBUM_DELETE = 'ALBUM_DELETE';
var ALBUM_META = 'ALBUM_META';
var ALBUM_PICTURE_CREATE = 'ALBUM_PICTURE_CREATE';
var ALBUM_PICTURE_UPDATE = 'ALBUM_PICTURE_UPDATE';
var ALBUM_PICTURE_DELETE = 'ALBUM_PICTURE_DELETE';

// Dataset
var DATASET_STATE = 'DATASET_STATE';
var DATASET_CREATE = 'DATASET_CREATE';
var DATASET_DELETE = 'DATASET_DELETE';
var DATASET_UPDATE_META = 'DATASET_UPDATE_META';
var DATASET_CREATE_RECORD = 'DATASET_CREATE_RECORD';
var DATASET_DELETE_RECORD = 'DATASET_DELETE_RECORD';
var DATASET_UPDATE_RECORD = 'DATASET_UPDATE_RECORD';
var DATASET_UPDATE_RECORDS = 'DATASET_UPDATE_RECORDS';
var DATASET_UPDATE_VALUE = 'DATASET_UPDATE_VALUE';

/***/ }),
/* 15 */,
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export formatTime */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formatTimeDiff; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return timeStrToInt; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__normalizeMap__ = __webpack_require__(1528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Stopwatch__ = __webpack_require__(1529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__uuidv4__ = __webpack_require__(1530);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__normalizeMap__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__Stopwatch__["a"]; });
/* unused harmony reexport uuidv4 */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__uuidv4__["a"]; });




function formatTimeDiff(ms) {
  console.log('formatTimeDiff', ms);
  var time = ms < 0 ? new Date(-ms) : new Date(ms);
  var result = time.getMinutes() + ':' + ('0' + time.getSeconds()).slice(-2);
  result = (ms < 0 ? '-' : '+') + result;
  return result;
}

function timeStrToInt(s) {
  if (!s || typeof s !== 'string') return 0;
  var m = s.match(/(?:(?:([\d]+):)?([\d]+):)?(\d+)(?:\.(\d+))?/);
  if (!m) return 0;
  return parseInt(m[1] || 0) * 60 * 60 * 1000 + parseInt(m[2] || 0) * 60 * 1000 + parseInt(m[3] || 0) * 1000 + parseInt(((m[4] || 0) + '00').slice(0, 3));
}

function formatTime(currentTimeMs) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { displayHours: true, displayHundredths: true };

  var time = new Date(currentTimeMs);

  var display10 = !!options.displayTenths;
  var display100 = !!options.displayHundredths;
  var displayMinutes = !!options.displayMinutes;
  var displayHours = !!options.displayHours;

  var milliseconds = display10 || display100 ? '.' + ('00' + time.getMilliseconds()).slice(-3, display100 ? -1 : -2) : '';
  if (!displayHours && !displayMinutes && currentTimeMs < 60 * 1000) {
    // Less than one minute
    return time.getSeconds() + milliseconds;
  } else if (!displayHours && currentTimeMs < 60 * 60 * 1000) {
    // Less than one hour
    return time.getMinutes() + ':' + ('0' + time.getSeconds()).slice(-2) + milliseconds;
  } else {
    // Greater or equal one hour
    return time.getUTCHours() + ':' + ('0' + time.getMinutes()).slice(-2) + ':' + ('0' + time.getSeconds()).slice(-2) + milliseconds;
  }
}



/***/ }),
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_templates__ = __webpack_require__(1537);






var TemplateDefinitionsService = function () {
  function TemplateDefinitionsService($keycloak, $store) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, TemplateDefinitionsService);

    this.$keycloak = $keycloak;
    this.$store = $store || __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */];
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(TemplateDefinitionsService, [{
    key: 'getAllowedRules',
    value: function getAllowedRules() {
      var selectedAccount = this.$store && this.$store.getters && this.$store.getters.selectedAccount;
      var templateLibraryPolicies = selectedAccount && selectedAccount.policies && selectedAccount.policies.templateLibrary && selectedAccount.policies.templateLibrary.allow;
      if (templateLibraryPolicies && templateLibraryPolicies.length > 0) {
        return templateLibraryPolicies.filter(function (p) {
          return !p.startsWith('library:');
        });
      }
      var roles = this.$keycloak && this.$keycloak.resourceAccess && this.$keycloak.resourceAccess['webcg-studio'] && this.$keycloak.resourceAccess['webcg-studio'].roles;
      roles = roles && roles.length > 0 ? roles : __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].prototype.$env && __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].prototype.$env.DEFAULT_ROLES || [];
      if (typeof roles === 'string') {
        try {
          roles = JSON.parse(roles);
        } catch (e) {}
      }
      return roles.filter(function (p) {
        return !p.startsWith('library:');
      });
    }
  }, {
    key: 'getTemplateDefinitions',
    value: function getTemplateDefinitions() {
      var allowedRules = this.getAllowedRules();
      console.log('[template-definitions] Allowed rules', allowedRules);
      var templates = __WEBPACK_IMPORTED_MODULE_4__store_templates__["a" /* default */].filter(function (td) {
        var groups = Array.isArray(td.groups) ? td.groups : td.groups ? [td.groups] : [];
        return groups.length === 0 || allowedRules.indexOf('*') >= 0 || groups.some(function (x) {
          return allowedRules.indexOf(x) >= 0;
        });
      });
      console.log('[template-definitions] Allowed templates', templates);
      return templates;
    }
  }, {
    key: 'findTemplateDefinition',
    value: function findTemplateDefinition(componentType) {
      return this.getTemplateDefinitions().find(function (p) {
        return p.componentType === componentType;
      });
    }
  }]);

  return TemplateDefinitionsService;
}();

/* harmony default export */ __webpack_exports__["a"] = (TemplateDefinitionsService);

/***/ }),
/* 116 */,
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dataset_settings_vue__ = __webpack_require__(1653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c332121e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dataset_settings_vue__ = __webpack_require__(1654);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dataset_settings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c332121e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dataset_settings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dataset_table_vue__ = __webpack_require__(1656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_567da328_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dataset_table_vue__ = __webpack_require__(1657);
function injectStyle (ssrContext) {
  __webpack_require__(1655)
}
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dataset_table_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_567da328_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dataset_table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_clock_control_vue__ = __webpack_require__(1678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_040085a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_clock_control_vue__ = __webpack_require__(1679);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_clock_control_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_040085a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_clock_control_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_action_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_template_definitions_service__ = __webpack_require__(115);







var AppService = function () {
  function AppService($store, $keycloak) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, AppService);

    this.$store = $store;
    this.templateDefinitionsService = new __WEBPACK_IMPORTED_MODULE_5__services_template_definitions_service__["a" /* default */]($keycloak, $store);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(AppService, [{
    key: 'openCreateDataset',
    value: function openCreateDataset(_ref, componentType) {
      var datasetId = _ref.datasetId,
          name = _ref.name,
          url = _ref.url,
          columns = _ref.columns;

      datasetId = datasetId || Object(__WEBPACK_IMPORTED_MODULE_3__lib__["e" /* uuid */])();
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__store_action_types__["m" /* DATASET_DELETE */], { datasetId: datasetId });
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__store_action_types__["l" /* DATASET_CREATE */], {
        componentType: componentType,
        datasetId: datasetId,
        name: 'Dataset ' + name,
        dataUrl: url,
        columns: columns
      });
      return datasetId;
    }
  }, {
    key: 'openCreateTemplate',
    value: function openCreateTemplate(options) {
      var template = this.templateDefinitionsService.findTemplateDefinition(options.componentType);
      if (!template) {
        console.error('Could not find template definition with componentType "' + options.componentType + '"');
        return;
      }
      template = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, template);
      template.templateId = options.templateId || Object(__WEBPACK_IMPORTED_MODULE_3__lib__["e" /* uuid */])();
      template.name = options.name;
      template.data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, options.templateData, { columnMap: options.columnMap });
      template.options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, options.templateOptions);
      template.overlay = {
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, template.overlay && template.overlay.data, { title: options.title }, options.overlayData),
        options: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, template.overlay && template.overlay.options, options.overlayOptions)
      };
      template.overlays = options.overlays || template.overlays;
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__store_action_types__["t" /* TEMPLATE_DELETE */], { templateId: template.templateId });
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__store_action_types__["r" /* TEMPLATE_CREATE */], template);
    }
  }]);

  return AppService;
}();

/* harmony default export */ __webpack_exports__["a"] = (AppService);

/***/ }),
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_record_select_vue__ = __webpack_require__(1611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d2e7f6e0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_record_select_vue__ = __webpack_require__(1612);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_record_select_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d2e7f6e0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_record_select_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mutations */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__action_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mutation_types__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules__ = __webpack_require__(1526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__plugins_webSocket__ = __webpack_require__(1535);




var _mutations;










__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* default */]);

var getters = {
  connected: function connected(state) {
    return state.connected;
  },

  loading: function loading(state) {
    return state.loading > 0;
  },

  accounts: function accounts(state) {
    return state.accounts;
  },

  selectedAccount: function selectedAccount(state) {
    return state.selectedAccount;
  }
};

var actions = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_6__action_types__["o" /* FETCH_ACCOUNTS */], function (_ref) {
  var commit = _ref.commit;
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var keycloak = payload.keycloak || __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].prototype.$keycloak;
  var env = payload.env || __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].prototype.$env;
  var token = keycloak && keycloak.token;
  var tenantId = env && env.TENANT_ID || keycloak && keycloak.realm;
  var headers = token ? { Authorization: 'Bearer ' + token, 'X-Tenant-ID': tenantId } : {};
  var endpoint = (env.MANAGER_API || '') + '/me/accounts';

  function mapPolicies(p) {
    p = p || {};
    var templateLibrary = p.templateLibrary || p.templateLibraries || {};
    return {
      templateLibrary: {
        allow: templateLibrary.allow || []
      }
    };
  }

  return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(endpoint, { headers: headers }).then(function (response) {
    var accounts = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()((response.data && response.data.data ? response.data.data : []).map(function (account) {
      return {
        accountId: account.accountId,
        name: account.name,
        policies: mapPolicies(account.policies && account.policies.webcg)
      };
    })));
    console.log('[store] Fetched accounts', JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(accounts)));
    commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["A" /* SET_ACCOUNTS */], accounts);

    // Get accountId from payload, path or query parameter
    var accountId = payload.accountId || '';
    if (!accountId && typeof window !== 'undefined' && window.location) {
      if (window.location.pathname) {
        var match = window.location.pathname.match(/^\/([^/]+)/);
        if (match && match[1] && match[1] !== 'workspace') {
          accountId = decodeURIComponent(match[1]);
        }
      }
      if (!accountId) {
        accountId = new URLSearchParams(window.location.search).get('accountId') || '';
      }
    }
    console.log('[store] Selected account ID', accountId);
    var account = accounts.find(function (account) {
      return account.accountId === accountId;
    });
    console.log('[store] Selected account', JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(account)));
    commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["B" /* SET_SELECTED_ACCOUNT */], account);

    return accounts;
  }).catch(function (error) {
    console.error('[store] Failed to fetch accounts', error);
    throw error;
  });
});

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["A" /* SET_ACCOUNTS */], function (state, accounts) {
  state.accounts = accounts;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["B" /* SET_SELECTED_ACCOUNT */], function (state, account) {
  state.selectedAccount = account;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["C" /* SOCKET_CONNECTED */], function (state) {
  state.connected = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["D" /* SOCKET_DISCONNECTED */], function (state) {
  state.connected = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["F" /* SOCKET_LOADING */], function (state, _ref2) {
  var number = _ref2.number;

  state.loading = number;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["E" /* SOCKET_LOADED */], function (state) {
  state.loading = Math.max(0, state.loading - 1);
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* default */].Store({
  modules: __WEBPACK_IMPORTED_MODULE_8__modules__["a" /* default */],
  state: {
    connected: false,
    loading: 0,
    accounts: null,
    selectedAccount: null
  },
  getters: getters,
  actions: actions,
  mutations: mutations,
  plugins: [Object(__WEBPACK_IMPORTED_MODULE_9__plugins_webSocket__["a" /* default */])()]
}));

/***/ }),
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__overlayDataProp__ = __webpack_require__(265);



/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  var res = {};
  Object(__WEBPACK_IMPORTED_MODULE_0__lib__["c" /* normalizeMap */])(props).forEach(function (_ref) {
    var key = _ref.key,
        val = _ref.val;

    res[key] = Object(__WEBPACK_IMPORTED_MODULE_1__overlayDataProp__["a" /* default */])(key, val);
  });
  return res;
});

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_action_types__ = __webpack_require__(5);




function overlayDataProp(key, options) {
  options = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, options);
  return {
    get: function get() {
      var value = this.$store.getters.overlayData(this.templateId)[key] || options.default;
      return value === null || value === undefined ? options.default : value;
    },
    set: function set(val) {
      // For reasons, I couldn't figure out, the component b-form-select may emit undefined instead an empty string.
      if (val === undefined) {
        val = options.default;
      }
      // Undefined is a dangerous value because it will cause the property to be missing in the JSON strings.
      if (val === undefined) {
        val = null;
      }
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_action_types__["z" /* TEMPLATE_OVERLAY_DATA */], {
        templateId: this.templateId,
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, key, val)
      });
    }
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overlayDataProp);

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_action_types__ = __webpack_require__(5);




function overlayOptionProp(key, options) {
  options = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, options);
  return {
    get: function get() {
      var value = this.$store.getters.overlayOptions(this.templateId)[key];
      return value === null || value === undefined ? options.default : value;
    },
    set: function set(val) {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_action_types__["A" /* TEMPLATE_OVERLAY_OPTIONS */], {
        templateId: this.templateId,
        options: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, key, val)
      });
    }
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overlayOptionProp);

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templateDataProp__ = __webpack_require__(268);



/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  var res = {};
  Object(__WEBPACK_IMPORTED_MODULE_0__lib__["c" /* normalizeMap */])(props).forEach(function (_ref) {
    var key = _ref.key,
        val = _ref.val;

    res[key] = Object(__WEBPACK_IMPORTED_MODULE_1__templateDataProp__["a" /* default */])(key, val);
  });
  return res;
});

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_action_types__ = __webpack_require__(5);




function templateDataProp(key, options) {
  options = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, options);
  return {
    get: function get() {
      var value = this.$store.getters.templateData(this.templateId)[key];
      return value === null || value === undefined ? options.default : value;
    },
    set: function set(val) {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_action_types__["s" /* TEMPLATE_DATA */], {
        templateId: this.templateId,
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, key, val)
      });
    }
  };
}

/* harmony default export */ __webpack_exports__["a"] = (templateDataProp);

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__templateOptionProp__ = __webpack_require__(270);



/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  var res = {};
  Object(__WEBPACK_IMPORTED_MODULE_0__lib__["c" /* normalizeMap */])(props).forEach(function (_ref) {
    var key = _ref.key,
        val = _ref.val;

    res[key] = Object(__WEBPACK_IMPORTED_MODULE_1__templateOptionProp__["a" /* default */])(key, val);
  });
  return res;
});

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_action_types__ = __webpack_require__(5);




function templateOptionProp(key, options) {
  options = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, options);
  return {
    get: function get() {
      var value = this.$store.getters.templateOptions(this.templateId)[key] || options.default;
      return value === null || value === undefined ? options.default : value;
    },
    set: function set(val) {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_action_types__["y" /* TEMPLATE_OPTIONS */], {
        templateId: this.templateId,
        options: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, key, val)
      });
    }
  };
}

/* harmony default export */ __webpack_exports__["a"] = (templateOptionProp);

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_action_types__ = __webpack_require__(5);




function windowDataProp(key, options) {
  options = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, options);
  return {
    get: function get() {
      var value = this.$store.getters.windowData(this.windowId)[key] || options.default;
      return value !== null || value !== undefined ? value : options.default;
    },
    set: function set(val) {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_action_types__["F" /* WINDOW_DATA */], {
        windowId: this.windowId,
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, key, val)
      });
    }
  };
}

/* harmony default export */ __webpack_exports__["a"] = (windowDataProp);

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_album_select_group_vue__ = __webpack_require__(1584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bada038_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_album_select_group_vue__ = __webpack_require__(1585);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_album_select_group_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bada038_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_album_select_group_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_time_input_group_vue__ = __webpack_require__(1628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_783a8048_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_time_input_group_vue__ = __webpack_require__(1629);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_time_input_group_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_783a8048_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_time_input_group_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    templateId: function templateId() {
      return this.$store.getters.windowData(this.windowId).contentId;
    }
  }
});

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__window_id__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__window_id__["a" /* default */]],
  computed: {
    windowTitle: Object(__WEBPACK_IMPORTED_MODULE_1__utils__["k" /* windowTitleProp */])()
  }
});

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    windowId: {
      type: String,
      required: true
    }
  }
});

/***/ }),
/* 277 */,
/* 278 */,
/* 279 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 280 */,
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_floorball_scoreboard_penalty_vue__ = __webpack_require__(1697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e727606c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_floorball_scoreboard_penalty_vue__ = __webpack_require__(1698);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_floorball_scoreboard_penalty_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e727606c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_floorball_scoreboard_penalty_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);




var VerticalLifeApi = function () {
  function VerticalLifeApi() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, VerticalLifeApi);

    this.axios = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({
      headers: {
        'X-Auth-Token': options.authToken
      }
    });
    this.axios.defaults.baseURL = options.baseUrl;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(VerticalLifeApi, [{
    key: 'fetchLeagues',
    value: function fetchLeagues() {
      return this.axios.get('/api/v1/').then(function (response) {
        return response.data.seasons.reduce(function (aggr, curr) {
          var year = curr.name;
          return aggr.concat(curr.leagues.map(function (each) {
            return {
              id: each.url.match(/\/(\d+)$/)[1],
              name: year + ' ' + each.name
            };
          }));
        }, []);
      });
    }
  }, {
    key: 'fetchEvents',
    value: function fetchEvents(leagueId) {
      return this.axios.get('/api/v1/season_leagues/' + leagueId).then(function (response) {
        return response.data.events;
      });
    }
  }, {
    key: 'fetchStages',
    value: function fetchStages(eventId) {
      return this.axios('/api/v1/events/' + eventId).then(function (response) {
        return response.data.dcats;
      });
    }
  }, {
    key: 'fetchRounds',
    value: function fetchRounds(eventId, stageId) {
      return this.fetchStages(eventId).then(function (dcats) {
        return (dcats.find(function (p) {
          return p.dcat_id === stageId;
        }) || {}).category_rounds || [];
      });
    }
  }, {
    key: 'getStartingListUrl',
    value: function getStartingListUrl(round) {
      console.log('getStartingListUrl', round.routes[0].startlist, round);
      var baseUrl = this.axios.defaults.baseURL;
      return baseUrl + round.routes[0].startlist;
    }
  }, {
    key: 'getRankingListUrl',
    value: function getRankingListUrl(round) {
      console.log('getRankingListUrl', round.result_url, round);
      var baseUrl = this.axios.defaults.baseURL;
      return baseUrl + round.result_url;
    }
  }]);

  return VerticalLifeApi;
}();

/* harmony default export */ __webpack_exports__["a"] = (VerticalLifeApi);

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);




var VolleyballApi = function () {
  function VolleyballApi($env) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, VolleyballApi);

    this.$env = $env;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(VolleyballApi, [{
    key: 'setFederationCode',
    value: function setFederationCode(federationCode) {
      this.federationCode = federationCode;
      return this;
    }
  }, {
    key: 'setAuthToken',
    value: function setAuthToken(authToken) {
      this.authToken = authToken;
      return this;
    }
  }, {
    key: 'getMatchList',
    value: function getMatchList() {
      return this.getResource('MatchList');
    }
  }, {
    key: 'getMatchLiveData',
    value: function getMatchLiveData(fedMatchID) {
      return this.getResource('MatchLiveData/FedMatchID/' + fedMatchID);
    }
  }, {
    key: 'getMatchFullInfo',
    value: function getMatchFullInfo(fedMatchID) {
      return this.getResource('MatchLiveFullInfo/FedMatchID/' + fedMatchID);
    }
  }, {
    key: 'getRoster',
    value: function getRoster(fedMatchID) {
      console.log('getRoster', fedMatchID);
      return this.getResource('Roster/FedMatchID/' + fedMatchID);
    }
  }, {
    key: 'getResource',
    value: function getResource(resource) {
      // eslint-disable-next-line
      return new __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({
        headers: {
          'Authorization': this.authToken
        }
      }).get(this.getUrl(resource));
    }
  }, {
    key: 'getUrl',
    value: function getUrl(resource) {
      if (this.$env.NODE_ENV === 'development') {
        return '/static/volleyball-webapi/' + resource.replace(/\//g, '-') + '.json';
      }
      var endpoint = 'https://dataprojectserviceswebapilive.azurewebsites.net/api/v1/';
      return (endpoint + '/').slice(0, -1) + this.federationCode + '/' + resource;
    }
  }]);

  return VolleyballApi;
}();

/* harmony default export */ __webpack_exports__["a"] = (VolleyballApi);

/***/ }),
/* 284 */,
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_polyfill__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__plugins_env__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__plugins_keycloak__ = __webpack_require__(513);

// TOOD: https://babeljs.io/docs/en/babel-plugin-transform-regenerator


// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].config.productionTip = false;

getEnv().then(function (env) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3__plugins_env__["a" /* default */], env);
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4__plugins_keycloak__["a" /* default */]);
  __webpack_require__(551);
}).catch(function (err) {
  document.body.innerHTML = '<p>Bootstrap failed: ' + err.message + '</p>';
  console.error('Bootstrap failed:', err);
});

function getEnv() {
  if (false) return _Promise.resolve({});

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    // http://youmightnotneedjquery.com/#json
    var request = new XMLHttpRequest();
    console.info('[boot] requesting config.json');
    request.open('GET', 'config.json', true);
    request.onload = function () {
      if (request.status >= 200 && request.status < 400) {
        // Success!
        console.info('[boot] config.json found');
        var data = JSON.parse(request.responseText);
        resolve(data);
      } else if (request.status === 404) {
        // In case there is no config.json, we procee
        console.info('[boot] config.json not found');
        resolve({});
      } else {
        console.info('[boot] config.json request failed with ' + request.status);
        reject(request.status);
      }
    };
    request.onerror = function () {
      console.info('[boot] config.json request failed');
      reject(new Error('Connection error'));
      // There was a connection error of some sort
    };
    request.send();
  });
}

/***/ }),
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);


var Env = {
  install: function install(Vue, options) {
    var env = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, Object({"NODE_ENV":"production","WEBCG_API":null,"WEBCG_PRODUCER":null,"KEYCLOAK_URL":"https://sso.helveticstreams.ch","KEYCLOAK_REALM":"helvetic-streams","KEYCLOAK_CLIENT":"webcg-studio","MANAGER_API":"https://api.upstream-cloud.ch/mam/api","MANAGER_URL":"https://studio.helveticstreams.ch/","TENANT_ID":"default","DEFAULT_ROLES":["sstv"]}), options);
    console.debug('[plugin/env] installing ', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(env));
    Vue.$env = env;
    Vue.prototype.$env = env;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Env);

/***/ }),
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_keycloak_js__ = __webpack_require__(514);


var KeycloakStub = {
  install: function install(Vue) {
    var userId = (window.location.search.match(/[?&]userId=([^&$]+)/) || [])[1] || 'user';
    Vue.prototype.$keycloak = {
      authenticated: true,
      logout: function logout() {},

      ready: true,
      subject: userId,
      user: {
        email: userId,
        username: userId
      }
    };
  }
};

var Keycloak = {
  install: function install(Vue) {
    if (Vue.prototype.$env.KEYCLOAK_URL) {
      Vue.use(__WEBPACK_IMPORTED_MODULE_0__vue_keycloak_js__["a" /* default */], {
        keycloakOptions: {
          'clientId': Vue.prototype.$env.KEYCLOAK_CLIENT,
          'realm': Vue.prototype.$env.KEYCLOAK_REALM,
          'url': Vue.prototype.$env.KEYCLOAK_URL,
          'ssl-required': 'external',
          'resource': Vue.prototype.$env.KEYCLOAK_CLIENT,
          'public-client': true
        },
        keycloakInitOptions: {
          checkLoginIframe: false,
          onLoad: Vue.prototype.$env.MANAGER_URL ? 'check-sso' : 'login-required'
        }
      });
    } else {
      Vue.use(KeycloakStub);
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Keycloak);

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vendor_keycloak_js_lib_keycloak__ = __webpack_require__(515);





var installed = false;

var VueKeyCloak = function VueKeyCloak() {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, VueKeyCloak);
};

/* harmony default export */ __webpack_exports__["a"] = (VueKeyCloak);


VueKeyCloak.install = function (Vue, options) {
  options = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({
    keycloakOptions: {},
    keycloakInitOptions: {},
    refreshTime: 10
  }, options);
  if (installed) return;
  installed = true;

  var keycloak = new __WEBPACK_IMPORTED_MODULE_3__vendor_keycloak_js_lib_keycloak__["a" /* default */](options.keycloakOptions);

  var watch = new Vue({
    data: function data() {
      return {
        ready: false,
        authenticated: false,
        user: null,
        token: null,
        resourceAccess: null
      };
    }
  });

  keycloak.init(options.keycloakInitOptions).then(function (isAuthenticated) {
    updateWatchVariables(isAuthenticated).then(function () {
      watch.ready = true;
    });

    if (isAuthenticated) {
      setTimeout(function () {
        keycloak.updateToken(options.refreshTime + 2).then(function (refreshed) {
          if (refreshed) updateWatchVariables(true);
        });
      }, options.refreshTime * 1000);
    }
  });

  function updateWatchVariables() {
    var isAuthenticated = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    watch.authenticated = isAuthenticated;

    if (isAuthenticated) {
      watch.token = keycloak.token;
      watch.resourceAccess = keycloak.resourceAccess;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        keycloak.loadUserProfile().then(function (user) {
          watch.user = user;
          resolve();
        });
      });
    } else {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
    }
  }

  Object.defineProperty(Vue.prototype, '$keycloak', {
    get: function get() {
      keycloak.ready = watch.ready;
      keycloak.user = watch.user;
      return keycloak;
    }
  });
};

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_string_from_code_point__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_string_from_code_point___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_string_from_code_point__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_json_stringify__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_typeof__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_get_iterator__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_get_iterator__);













/**
 * @param {string} message
 * @see https://developer.mozilla.org/en-US/docs/Web/API/SubtleCrypto/digest#basic_example
 */
var sha256Digest = function () {
    var _ref20 = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee12(message) {
        var encoder, data;
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
            while (1) {
                switch (_context12.prev = _context12.next) {
                    case 0:
                        encoder = new TextEncoder();
                        data = encoder.encode(message);

                        if (!(typeof crypto === "undefined" || typeof crypto.subtle === "undefined")) {
                            _context12.next = 4;
                            break;
                        }

                        throw new Error("Web Crypto API is not available.");

                    case 4:
                        _context12.next = 6;
                        return crypto.subtle.digest("SHA-256", data);

                    case 6:
                        return _context12.abrupt("return", _context12.sent);

                    case 7:
                    case "end":
                        return _context12.stop();
                }
            }
        }, _callee12, this);
    }));

    return function sha256Digest(_x13) {
        return _ref20.apply(this, arguments);
    };
}();

/**
 * @param {string} token
 */


/*
 * Copyright 2016 Red Hat, Inc. and/or its affiliates
 * and other contributors as indicated by the @author tags.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Keycloak(config) {
    var generatePkceChallenge = function () {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee2(pkceMethod, codeVerifier) {
            var hashBytes, encodedHash;
            return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            if (!(pkceMethod !== "S256")) {
                                _context2.next = 2;
                                break;
                            }

                            throw new TypeError("Invalid value for 'pkceMethod', expected 'S256' but got '" + pkceMethod + "'.");

                        case 2:
                            _context2.t0 = Uint8Array;
                            _context2.next = 5;
                            return sha256Digest(codeVerifier);

                        case 5:
                            _context2.t1 = _context2.sent;
                            hashBytes = new _context2.t0(_context2.t1);
                            encodedHash = bytesToBase64(hashBytes).replace(/\+/g, '-').replace(/\//g, '_').replace(/\=/g, '');
                            return _context2.abrupt("return", encodedHash);

                        case 9:
                        case "end":
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));

        return function generatePkceChallenge(_x2, _x3) {
            return _ref2.apply(this, arguments);
        };
    }();

    if (!(this instanceof Keycloak)) {
        throw new Error("The 'Keycloak' constructor must be invoked with 'new'.");
    }

    if (typeof config !== 'string' && !isObject(config)) {
        throw new Error("The 'Keycloak' constructor must be provided with a configuration object, or a URL to a JSON configuration file.");
    }

    if (isObject(config)) {
        var requiredProperties = 'oidcProvider' in config ? ['clientId'] : ['url', 'realm', 'clientId'];

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_get_iterator___default()(requiredProperties), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var property = _step.value;

                if (!config[property]) {
                    throw new Error("The configuration object is missing the required '" + property + "' property.");
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }

    var kc = this;
    var adapter;
    var refreshQueue = [];
    var callbackStorage;

    var loginIframe = {
        enable: true,
        callbackList: [],
        interval: 5
    };

    kc.didInitialize = false;

    var useNonce = true;
    var logInfo = createLogger(console.info);
    var logWarn = createLogger(console.warn);

    if (!globalThis.isSecureContext) {
        logWarn("[KEYCLOAK] Keycloak JS must be used in a 'secure context' to function properly as it relies on browser APIs that are otherwise not available.\n" + "Continuing to run your application insecurely will lead to unexpected behavior and breakage.\n\n" + "For more information see: https://developer.mozilla.org/en-US/docs/Web/Security/Secure_Contexts");
    }

    kc.init = function () {
        var initOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        if (kc.didInitialize) {
            throw new Error("A 'Keycloak' instance can only be initialized once.");
        }

        kc.didInitialize = true;

        kc.authenticated = false;

        callbackStorage = createCallbackStorage();
        var adapters = ['default', 'cordova', 'cordova-native'];

        if (adapters.indexOf(initOptions.adapter) > -1) {
            adapter = loadAdapter(initOptions.adapter);
        } else if (__WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_typeof___default()(initOptions.adapter) === "object") {
            adapter = initOptions.adapter;
        } else {
            if (window.Cordova || window.cordova) {
                adapter = loadAdapter('cordova');
            } else {
                adapter = loadAdapter();
            }
        }

        if (typeof initOptions.useNonce !== 'undefined') {
            useNonce = initOptions.useNonce;
        }

        if (typeof initOptions.checkLoginIframe !== 'undefined') {
            loginIframe.enable = initOptions.checkLoginIframe;
        }

        if (initOptions.checkLoginIframeInterval) {
            loginIframe.interval = initOptions.checkLoginIframeInterval;
        }

        if (initOptions.onLoad === 'login-required') {
            kc.loginRequired = true;
        }

        if (initOptions.responseMode) {
            if (initOptions.responseMode === 'query' || initOptions.responseMode === 'fragment') {
                kc.responseMode = initOptions.responseMode;
            } else {
                throw 'Invalid value for responseMode';
            }
        }

        if (initOptions.flow) {
            switch (initOptions.flow) {
                case 'standard':
                    kc.responseType = 'code';
                    break;
                case 'implicit':
                    kc.responseType = 'id_token token';
                    break;
                case 'hybrid':
                    kc.responseType = 'code id_token token';
                    break;
                default:
                    throw 'Invalid value for flow';
            }
            kc.flow = initOptions.flow;
        }

        if (initOptions.timeSkew != null) {
            kc.timeSkew = initOptions.timeSkew;
        }

        if (initOptions.redirectUri) {
            kc.redirectUri = initOptions.redirectUri;
        }

        if (initOptions.silentCheckSsoRedirectUri) {
            kc.silentCheckSsoRedirectUri = initOptions.silentCheckSsoRedirectUri;
        }

        if (typeof initOptions.silentCheckSsoFallback === 'boolean') {
            kc.silentCheckSsoFallback = initOptions.silentCheckSsoFallback;
        } else {
            kc.silentCheckSsoFallback = true;
        }

        if (typeof initOptions.pkceMethod !== "undefined") {
            if (initOptions.pkceMethod !== "S256" && initOptions.pkceMethod !== false) {
                throw new TypeError("Invalid value for pkceMethod', expected 'S256' or false but got " + initOptions.pkceMethod + ".");
            }

            kc.pkceMethod = initOptions.pkceMethod;
        } else {
            kc.pkceMethod = "S256";
        }

        if (typeof initOptions.enableLogging === 'boolean') {
            kc.enableLogging = initOptions.enableLogging;
        } else {
            kc.enableLogging = false;
        }

        if (initOptions.logoutMethod === 'POST') {
            kc.logoutMethod = 'POST';
        } else {
            kc.logoutMethod = 'GET';
        }

        if (typeof initOptions.scope === 'string') {
            kc.scope = initOptions.scope;
        }

        if (typeof initOptions.acrValues === 'string') {
            kc.acrValues = initOptions.acrValues;
        }

        if (typeof initOptions.messageReceiveTimeout === 'number' && initOptions.messageReceiveTimeout > 0) {
            kc.messageReceiveTimeout = initOptions.messageReceiveTimeout;
        } else {
            kc.messageReceiveTimeout = 10000;
        }

        if (!kc.responseMode) {
            kc.responseMode = 'fragment';
        }
        if (!kc.responseType) {
            kc.responseType = 'code';
            kc.flow = 'standard';
        }

        var promise = createPromise();

        var initPromise = createPromise();
        initPromise.promise.then(function () {
            kc.onReady && kc.onReady(kc.authenticated);
            promise.setSuccess(kc.authenticated);
        }).catch(function (error) {
            promise.setError(error);
        });

        var configPromise = loadConfig();

        function onLoad() {
            var doLogin = function doLogin(prompt) {
                if (!prompt) {
                    options.prompt = 'none';
                }

                if (initOptions.locale) {
                    options.locale = initOptions.locale;
                }
                kc.login(options).then(function () {
                    initPromise.setSuccess();
                }).catch(function (error) {
                    initPromise.setError(error);
                });
            };

            var checkSsoSilently = function () {
                var _ref = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee() {
                    var ifrm, src, messageCallback;
                    return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    ifrm = document.createElement("iframe");
                                    _context.next = 3;
                                    return kc.createLoginUrl({ prompt: 'none', redirectUri: kc.silentCheckSsoRedirectUri });

                                case 3:
                                    src = _context.sent;

                                    ifrm.setAttribute("src", src);
                                    ifrm.setAttribute("sandbox", "allow-storage-access-by-user-activation allow-scripts allow-same-origin");
                                    ifrm.setAttribute("title", "keycloak-silent-check-sso");
                                    ifrm.style.display = "none";
                                    document.body.appendChild(ifrm);

                                    messageCallback = function messageCallback(event) {
                                        if (event.origin !== window.location.origin || ifrm.contentWindow !== event.source) {
                                            return;
                                        }

                                        var oauth = parseCallback(event.data);
                                        processCallback(oauth, initPromise);

                                        document.body.removeChild(ifrm);
                                        window.removeEventListener("message", messageCallback);
                                    };

                                    window.addEventListener("message", messageCallback);

                                case 11:
                                case "end":
                                    return _context.stop();
                            }
                        }
                    }, _callee, this);
                }));

                return function checkSsoSilently() {
                    return _ref.apply(this, arguments);
                };
            }();

            var options = {};
            switch (initOptions.onLoad) {
                case 'check-sso':
                    if (loginIframe.enable) {
                        setupCheckLoginIframe().then(function () {
                            checkLoginIframe().then(function (unchanged) {
                                if (!unchanged) {
                                    kc.silentCheckSsoRedirectUri ? checkSsoSilently() : doLogin(false);
                                } else {
                                    initPromise.setSuccess();
                                }
                            }).catch(function (error) {
                                initPromise.setError(error);
                            });
                        });
                    } else {
                        kc.silentCheckSsoRedirectUri ? checkSsoSilently() : doLogin(false);
                    }
                    break;
                case 'login-required':
                    doLogin(true);
                    break;
                default:
                    throw 'Invalid value for onLoad';
            }
        }

        function processInit() {
            var callback = parseCallback(window.location.href);

            if (callback) {
                window.history.replaceState(window.history.state, null, callback.newUrl);
            }

            if (callback && callback.valid) {
                return setupCheckLoginIframe().then(function () {
                    processCallback(callback, initPromise);
                }).catch(function (error) {
                    initPromise.setError(error);
                });
            }

            if (initOptions.token && initOptions.refreshToken) {
                setToken(initOptions.token, initOptions.refreshToken, initOptions.idToken);

                if (loginIframe.enable) {
                    setupCheckLoginIframe().then(function () {
                        checkLoginIframe().then(function (unchanged) {
                            if (unchanged) {
                                kc.onAuthSuccess && kc.onAuthSuccess();
                                initPromise.setSuccess();
                                scheduleCheckIframe();
                            } else {
                                initPromise.setSuccess();
                            }
                        }).catch(function (error) {
                            initPromise.setError(error);
                        });
                    });
                } else {
                    kc.updateToken(-1).then(function () {
                        kc.onAuthSuccess && kc.onAuthSuccess();
                        initPromise.setSuccess();
                    }).catch(function (error) {
                        kc.onAuthError && kc.onAuthError();
                        if (initOptions.onLoad) {
                            onLoad();
                        } else {
                            initPromise.setError(error);
                        }
                    });
                }
            } else if (initOptions.onLoad) {
                onLoad();
            } else {
                initPromise.setSuccess();
            }
        }

        configPromise.then(function () {
            check3pCookiesSupported().then(processInit).catch(function (error) {
                promise.setError(error);
            });
        });
        configPromise.catch(function (error) {
            promise.setError(error);
        });

        return promise.promise;
    };

    kc.login = function (options) {
        return adapter.login(options);
    };

    function generateRandomData(len) {
        if (typeof crypto === "undefined" || typeof crypto.getRandomValues === "undefined") {
            throw new Error("Web Crypto API is not available.");
        }

        return crypto.getRandomValues(new Uint8Array(len));
    }

    function generateCodeVerifier(len) {
        return generateRandomString(len, 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789');
    }

    function generateRandomString(len, alphabet) {
        var randomData = generateRandomData(len);
        var chars = new Array(len);
        for (var i = 0; i < len; i++) {
            chars[i] = alphabet.charCodeAt(randomData[i] % alphabet.length);
        }
        return String.fromCharCode.apply(null, chars);
    }

    function buildClaimsParameter(requestedAcr) {
        var claims = {
            id_token: {
                acr: requestedAcr
            }
        };
        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_json_stringify___default()(claims);
    }

    kc.createLoginUrl = function () {
        var _ref3 = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee3(options) {
            var state, nonce, redirectUri, callbackState, baseUrl, scope, url, claimsParameter, codeVerifier, pkceChallenge;
            return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            state = createUUID();
                            nonce = createUUID();
                            redirectUri = adapter.redirectUri(options);
                            callbackState = {
                                state: state,
                                nonce: nonce,
                                redirectUri: encodeURIComponent(redirectUri),
                                loginOptions: options
                            };


                            if (options && options.prompt) {
                                callbackState.prompt = options.prompt;
                            }

                            if (options && options.action == 'register') {
                                baseUrl = kc.endpoints.register();
                            } else {
                                baseUrl = kc.endpoints.authorize();
                            }

                            scope = options && options.scope || kc.scope;

                            if (!scope) {
                                // if scope is not set, default to "openid"
                                scope = "openid";
                            } else if (scope.indexOf("openid") === -1) {
                                // if openid scope is missing, prefix the given scopes with it
                                scope = "openid " + scope;
                            }

                            url = baseUrl + '?client_id=' + encodeURIComponent(kc.clientId) + '&redirect_uri=' + encodeURIComponent(redirectUri) + '&state=' + encodeURIComponent(state) + '&response_mode=' + encodeURIComponent(kc.responseMode) + '&response_type=' + encodeURIComponent(kc.responseType) + '&scope=' + encodeURIComponent(scope);

                            if (useNonce) {
                                url = url + '&nonce=' + encodeURIComponent(nonce);
                            }

                            if (options && options.prompt) {
                                url += '&prompt=' + encodeURIComponent(options.prompt);
                            }

                            if (options && typeof options.maxAge === 'number') {
                                url += '&max_age=' + encodeURIComponent(options.maxAge);
                            }

                            if (options && options.loginHint) {
                                url += '&login_hint=' + encodeURIComponent(options.loginHint);
                            }

                            if (options && options.idpHint) {
                                url += '&kc_idp_hint=' + encodeURIComponent(options.idpHint);
                            }

                            if (options && options.action && options.action != 'register') {
                                url += '&kc_action=' + encodeURIComponent(options.action);
                            }

                            if (options && options.locale) {
                                url += '&ui_locales=' + encodeURIComponent(options.locale);
                            }

                            if (options && options.acr) {
                                claimsParameter = buildClaimsParameter(options.acr);

                                url += '&claims=' + encodeURIComponent(claimsParameter);
                            }

                            if (options && options.acrValues || kc.acrValues) {
                                url += '&acr_values=' + encodeURIComponent(options.acrValues || kc.acrValues);
                            }

                            if (!kc.pkceMethod) {
                                _context3.next = 32;
                                break;
                            }

                            _context3.prev = 19;
                            codeVerifier = generateCodeVerifier(96);
                            _context3.next = 23;
                            return generatePkceChallenge(kc.pkceMethod, codeVerifier);

                        case 23:
                            pkceChallenge = _context3.sent;


                            callbackState.pkceCodeVerifier = codeVerifier;

                            url += '&code_challenge=' + pkceChallenge;
                            url += '&code_challenge_method=' + kc.pkceMethod;
                            _context3.next = 32;
                            break;

                        case 29:
                            _context3.prev = 29;
                            _context3.t0 = _context3["catch"](19);
                            throw new Error("Failed to generate PKCE challenge.", { cause: _context3.t0 });

                        case 32:

                            callbackStorage.add(callbackState);

                            return _context3.abrupt("return", url);

                        case 34:
                        case "end":
                            return _context3.stop();
                    }
                }
            }, _callee3, this, [[19, 29]]);
        }));

        return function (_x4) {
            return _ref3.apply(this, arguments);
        };
    }();

    kc.logout = function (options) {
        return adapter.logout(options);
    };

    kc.createLogoutUrl = function (options) {

        var logoutMethod = options && options.logoutMethod || kc.logoutMethod;
        if (logoutMethod === 'POST') {
            return kc.endpoints.logout();
        }

        var url = kc.endpoints.logout() + '?client_id=' + encodeURIComponent(kc.clientId) + '&post_logout_redirect_uri=' + encodeURIComponent(adapter.redirectUri(options, false));

        if (kc.idToken) {
            url += '&id_token_hint=' + encodeURIComponent(kc.idToken);
        }

        return url;
    };

    kc.register = function (options) {
        return adapter.register(options);
    };

    kc.createRegisterUrl = function () {
        var _ref4 = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee4(options) {
            return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            if (!options) {
                                options = {};
                            }
                            options.action = 'register';
                            _context4.next = 4;
                            return kc.createLoginUrl(options);

                        case 4:
                            return _context4.abrupt("return", _context4.sent);

                        case 5:
                        case "end":
                            return _context4.stop();
                    }
                }
            }, _callee4, this);
        }));

        return function (_x5) {
            return _ref4.apply(this, arguments);
        };
    }();

    kc.createAccountUrl = function (options) {
        var realm = getRealmUrl();
        var url = undefined;
        if (typeof realm !== 'undefined') {
            url = realm + '/account' + '?referrer=' + encodeURIComponent(kc.clientId) + '&referrer_uri=' + encodeURIComponent(adapter.redirectUri(options));
        }
        return url;
    };

    kc.accountManagement = function () {
        return adapter.accountManagement();
    };

    kc.hasRealmRole = function (role) {
        var access = kc.realmAccess;
        return !!access && access.roles.indexOf(role) >= 0;
    };

    kc.hasResourceRole = function (role, resource) {
        if (!kc.resourceAccess) {
            return false;
        }

        var access = kc.resourceAccess[resource || kc.clientId];
        return !!access && access.roles.indexOf(role) >= 0;
    };

    kc.loadUserProfile = function () {
        var url = getRealmUrl() + '/account';
        var req = new XMLHttpRequest();
        req.open('GET', url, true);
        req.setRequestHeader('Accept', 'application/json');
        req.setRequestHeader('Authorization', 'bearer ' + kc.token);

        var promise = createPromise();

        req.onreadystatechange = function () {
            if (req.readyState == 4) {
                if (req.status == 200) {
                    kc.profile = JSON.parse(req.responseText);
                    promise.setSuccess(kc.profile);
                } else {
                    promise.setError();
                }
            }
        };

        req.send();

        return promise.promise;
    };

    kc.loadUserInfo = function () {
        var url = kc.endpoints.userinfo();
        var req = new XMLHttpRequest();
        req.open('GET', url, true);
        req.setRequestHeader('Accept', 'application/json');
        req.setRequestHeader('Authorization', 'bearer ' + kc.token);

        var promise = createPromise();

        req.onreadystatechange = function () {
            if (req.readyState == 4) {
                if (req.status == 200) {
                    kc.userInfo = JSON.parse(req.responseText);
                    promise.setSuccess(kc.userInfo);
                } else {
                    promise.setError();
                }
            }
        };

        req.send();

        return promise.promise;
    };

    kc.isTokenExpired = function (minValidity) {
        if (!kc.tokenParsed || !kc.refreshToken && kc.flow != 'implicit') {
            throw 'Not authenticated';
        }

        if (kc.timeSkew == null) {
            logInfo('[KEYCLOAK] Unable to determine if token is expired as timeskew is not set');
            return true;
        }

        var expiresIn = kc.tokenParsed['exp'] - Math.ceil(new Date().getTime() / 1000) + kc.timeSkew;
        if (minValidity) {
            if (isNaN(minValidity)) {
                throw 'Invalid minValidity';
            }
            expiresIn -= minValidity;
        }
        return expiresIn < 0;
    };

    kc.updateToken = function (minValidity) {
        var promise = createPromise();

        if (!kc.refreshToken) {
            promise.setError();
            return promise.promise;
        }

        minValidity = minValidity || 5;

        var exec = function exec() {
            var refreshToken = false;
            if (minValidity == -1) {
                refreshToken = true;
                logInfo('[KEYCLOAK] Refreshing token: forced refresh');
            } else if (!kc.tokenParsed || kc.isTokenExpired(minValidity)) {
                refreshToken = true;
                logInfo('[KEYCLOAK] Refreshing token: token expired');
            }

            if (!refreshToken) {
                promise.setSuccess(false);
            } else {
                var params = 'grant_type=refresh_token&' + 'refresh_token=' + kc.refreshToken;
                var url = kc.endpoints.token();

                refreshQueue.push(promise);

                if (refreshQueue.length == 1) {
                    var req = new XMLHttpRequest();
                    req.open('POST', url, true);
                    req.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                    req.withCredentials = true;

                    params += '&client_id=' + encodeURIComponent(kc.clientId);

                    var timeLocal = new Date().getTime();

                    req.onreadystatechange = function () {
                        if (req.readyState == 4) {
                            if (req.status == 200) {
                                logInfo('[KEYCLOAK] Token refreshed');

                                timeLocal = (timeLocal + new Date().getTime()) / 2;

                                var tokenResponse = JSON.parse(req.responseText);

                                setToken(tokenResponse['access_token'], tokenResponse['refresh_token'], tokenResponse['id_token'], timeLocal);

                                kc.onAuthRefreshSuccess && kc.onAuthRefreshSuccess();
                                for (var p = refreshQueue.pop(); p != null; p = refreshQueue.pop()) {
                                    p.setSuccess(true);
                                }
                            } else {
                                logWarn('[KEYCLOAK] Failed to refresh token');

                                if (req.status == 400) {
                                    kc.clearToken();
                                }

                                kc.onAuthRefreshError && kc.onAuthRefreshError();
                                for (var p = refreshQueue.pop(); p != null; p = refreshQueue.pop()) {
                                    p.setError("Failed to refresh token: An unexpected HTTP error occurred while attempting to refresh the token.");
                                }
                            }
                        }
                    };

                    req.send(params);
                }
            }
        };

        if (loginIframe.enable) {
            var iframePromise = checkLoginIframe();
            iframePromise.then(function () {
                exec();
            }).catch(function (error) {
                promise.setError(error);
            });
        } else {
            exec();
        }

        return promise.promise;
    };

    kc.clearToken = function () {
        if (kc.token) {
            setToken(null, null, null);
            kc.onAuthLogout && kc.onAuthLogout();
            if (kc.loginRequired) {
                kc.login();
            }
        }
    };

    function getRealmUrl() {
        if (typeof kc.authServerUrl !== 'undefined') {
            if (kc.authServerUrl.charAt(kc.authServerUrl.length - 1) == '/') {
                return kc.authServerUrl + 'realms/' + encodeURIComponent(kc.realm);
            } else {
                return kc.authServerUrl + '/realms/' + encodeURIComponent(kc.realm);
            }
        } else {
            return undefined;
        }
    }

    function getOrigin() {
        if (!window.location.origin) {
            return window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
        } else {
            return window.location.origin;
        }
    }

    function processCallback(oauth, promise) {
        var code = oauth.code;
        var error = oauth.error;
        var prompt = oauth.prompt;

        var timeLocal = new Date().getTime();

        if (oauth['kc_action_status']) {
            kc.onActionUpdate && kc.onActionUpdate(oauth['kc_action_status'], oauth['kc_action']);
        }

        if (error) {
            if (prompt != 'none') {
                if (oauth.error_description && oauth.error_description === "authentication_expired") {
                    kc.login(oauth.loginOptions);
                } else {
                    var errorData = { error: error, error_description: oauth.error_description };
                    kc.onAuthError && kc.onAuthError(errorData);
                    promise && promise.setError(errorData);
                }
            } else {
                promise && promise.setSuccess();
            }
            return;
        } else if (kc.flow != 'standard' && (oauth.access_token || oauth.id_token)) {
            authSuccess(oauth.access_token, null, oauth.id_token, true);
        }

        if (kc.flow != 'implicit' && code) {
            var params = 'code=' + code + '&grant_type=authorization_code';
            var url = kc.endpoints.token();

            var req = new XMLHttpRequest();
            req.open('POST', url, true);
            req.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

            params += '&client_id=' + encodeURIComponent(kc.clientId);
            params += '&redirect_uri=' + oauth.redirectUri;

            if (oauth.pkceCodeVerifier) {
                params += '&code_verifier=' + oauth.pkceCodeVerifier;
            }

            req.withCredentials = true;

            req.onreadystatechange = function () {
                if (req.readyState == 4) {
                    if (req.status == 200) {

                        var tokenResponse = JSON.parse(req.responseText);
                        authSuccess(tokenResponse['access_token'], tokenResponse['refresh_token'], tokenResponse['id_token'], kc.flow === 'standard');
                        scheduleCheckIframe();
                    } else {
                        kc.onAuthError && kc.onAuthError();
                        promise && promise.setError();
                    }
                }
            };

            req.send(params);
        }

        function authSuccess(accessToken, refreshToken, idToken, fulfillPromise) {
            timeLocal = (timeLocal + new Date().getTime()) / 2;

            setToken(accessToken, refreshToken, idToken, timeLocal);

            if (useNonce && kc.idTokenParsed && kc.idTokenParsed.nonce != oauth.storedNonce) {
                logInfo('[KEYCLOAK] Invalid nonce, clearing token');
                kc.clearToken();
                promise && promise.setError();
            } else {
                if (fulfillPromise) {
                    kc.onAuthSuccess && kc.onAuthSuccess();
                    promise && promise.setSuccess();
                }
            }
        }
    }

    function loadConfig() {
        var promise = createPromise();
        var configUrl;

        if (typeof config === 'string') {
            configUrl = config;
        }

        function setupOidcEndoints(oidcConfiguration) {
            if (!oidcConfiguration) {
                kc.endpoints = {
                    authorize: function authorize() {
                        return getRealmUrl() + '/protocol/openid-connect/auth';
                    },
                    token: function token() {
                        return getRealmUrl() + '/protocol/openid-connect/token';
                    },
                    logout: function logout() {
                        return getRealmUrl() + '/protocol/openid-connect/logout';
                    },
                    checkSessionIframe: function checkSessionIframe() {
                        return getRealmUrl() + '/protocol/openid-connect/login-status-iframe.html';
                    },
                    thirdPartyCookiesIframe: function thirdPartyCookiesIframe() {
                        return getRealmUrl() + '/protocol/openid-connect/3p-cookies/step1.html';
                    },
                    register: function register() {
                        return getRealmUrl() + '/protocol/openid-connect/registrations';
                    },
                    userinfo: function userinfo() {
                        return getRealmUrl() + '/protocol/openid-connect/userinfo';
                    }
                };
            } else {
                kc.endpoints = {
                    authorize: function authorize() {
                        return oidcConfiguration.authorization_endpoint;
                    },
                    token: function token() {
                        return oidcConfiguration.token_endpoint;
                    },
                    logout: function logout() {
                        if (!oidcConfiguration.end_session_endpoint) {
                            throw "Not supported by the OIDC server";
                        }
                        return oidcConfiguration.end_session_endpoint;
                    },
                    checkSessionIframe: function checkSessionIframe() {
                        if (!oidcConfiguration.check_session_iframe) {
                            throw "Not supported by the OIDC server";
                        }
                        return oidcConfiguration.check_session_iframe;
                    },
                    register: function register() {
                        throw 'Redirection to "Register user" page not supported in standard OIDC mode';
                    },
                    userinfo: function userinfo() {
                        if (!oidcConfiguration.userinfo_endpoint) {
                            throw "Not supported by the OIDC server";
                        }
                        return oidcConfiguration.userinfo_endpoint;
                    }
                };
            }
        }

        if (configUrl) {
            var req = new XMLHttpRequest();
            req.open('GET', configUrl, true);
            req.setRequestHeader('Accept', 'application/json');

            req.onreadystatechange = function () {
                if (req.readyState == 4) {
                    if (req.status == 200 || fileLoaded(req)) {
                        var config = JSON.parse(req.responseText);

                        kc.authServerUrl = config['auth-server-url'];
                        kc.realm = config['realm'];
                        kc.clientId = config['resource'];
                        setupOidcEndoints(null);
                        promise.setSuccess();
                    } else {
                        promise.setError();
                    }
                }
            };

            req.send();
        } else {
            kc.clientId = config.clientId;

            var oidcProvider = config['oidcProvider'];
            if (!oidcProvider) {
                kc.authServerUrl = config.url;
                kc.realm = config.realm;
                setupOidcEndoints(null);
                promise.setSuccess();
            } else {
                if (typeof oidcProvider === 'string') {
                    var oidcProviderConfigUrl;
                    if (oidcProvider.charAt(oidcProvider.length - 1) == '/') {
                        oidcProviderConfigUrl = oidcProvider + '.well-known/openid-configuration';
                    } else {
                        oidcProviderConfigUrl = oidcProvider + '/.well-known/openid-configuration';
                    }
                    var req = new XMLHttpRequest();
                    req.open('GET', oidcProviderConfigUrl, true);
                    req.setRequestHeader('Accept', 'application/json');

                    req.onreadystatechange = function () {
                        if (req.readyState == 4) {
                            if (req.status == 200 || fileLoaded(req)) {
                                var oidcProviderConfig = JSON.parse(req.responseText);
                                setupOidcEndoints(oidcProviderConfig);
                                promise.setSuccess();
                            } else {
                                promise.setError();
                            }
                        }
                    };

                    req.send();
                } else {
                    setupOidcEndoints(oidcProvider);
                    promise.setSuccess();
                }
            }
        }

        return promise.promise;
    }

    function fileLoaded(xhr) {
        return xhr.status == 0 && xhr.responseText && xhr.responseURL.startsWith('file:');
    }

    function setToken(token, refreshToken, idToken, timeLocal) {
        if (kc.tokenTimeoutHandle) {
            clearTimeout(kc.tokenTimeoutHandle);
            kc.tokenTimeoutHandle = null;
        }

        if (refreshToken) {
            kc.refreshToken = refreshToken;
            kc.refreshTokenParsed = decodeToken(refreshToken);
        } else {
            delete kc.refreshToken;
            delete kc.refreshTokenParsed;
        }

        if (idToken) {
            kc.idToken = idToken;
            kc.idTokenParsed = decodeToken(idToken);
        } else {
            delete kc.idToken;
            delete kc.idTokenParsed;
        }

        if (token) {
            kc.token = token;
            kc.tokenParsed = decodeToken(token);
            kc.sessionId = kc.tokenParsed.sid;
            kc.authenticated = true;
            kc.subject = kc.tokenParsed.sub;
            kc.realmAccess = kc.tokenParsed.realm_access;
            kc.resourceAccess = kc.tokenParsed.resource_access;

            if (timeLocal) {
                kc.timeSkew = Math.floor(timeLocal / 1000) - kc.tokenParsed.iat;
            }

            if (kc.timeSkew != null) {
                logInfo('[KEYCLOAK] Estimated time difference between browser and server is ' + kc.timeSkew + ' seconds');

                if (kc.onTokenExpired) {
                    var expiresIn = (kc.tokenParsed['exp'] - new Date().getTime() / 1000 + kc.timeSkew) * 1000;
                    logInfo('[KEYCLOAK] Token expires in ' + Math.round(expiresIn / 1000) + ' s');
                    if (expiresIn <= 0) {
                        kc.onTokenExpired();
                    } else {
                        kc.tokenTimeoutHandle = setTimeout(kc.onTokenExpired, expiresIn);
                    }
                }
            }
        } else {
            delete kc.token;
            delete kc.tokenParsed;
            delete kc.subject;
            delete kc.realmAccess;
            delete kc.resourceAccess;

            kc.authenticated = false;
        }
    }

    function createUUID() {
        if (typeof crypto === "undefined" || typeof crypto.randomUUID === "undefined") {
            throw new Error("Web Crypto API is not available.");
        }

        return crypto.randomUUID();
    }

    function parseCallback(url) {
        var oauth = parseCallbackUrl(url);
        if (!oauth) {
            return;
        }

        var oauthState = callbackStorage.get(oauth.state);

        if (oauthState) {
            oauth.valid = true;
            oauth.redirectUri = oauthState.redirectUri;
            oauth.storedNonce = oauthState.nonce;
            oauth.prompt = oauthState.prompt;
            oauth.pkceCodeVerifier = oauthState.pkceCodeVerifier;
            oauth.loginOptions = oauthState.loginOptions;
        }

        return oauth;
    }

    function parseCallbackUrl(url) {
        var supportedParams;
        switch (kc.flow) {
            case 'standard':
                supportedParams = ['code', 'state', 'session_state', 'kc_action_status', 'kc_action', 'iss'];
                break;
            case 'implicit':
                supportedParams = ['access_token', 'token_type', 'id_token', 'state', 'session_state', 'expires_in', 'kc_action_status', 'kc_action', 'iss'];
                break;
            case 'hybrid':
                supportedParams = ['access_token', 'token_type', 'id_token', 'code', 'state', 'session_state', 'expires_in', 'kc_action_status', 'kc_action', 'iss'];
                break;
        }

        supportedParams.push('error');
        supportedParams.push('error_description');
        supportedParams.push('error_uri');

        var queryIndex = url.indexOf('?');
        var fragmentIndex = url.indexOf('#');

        var newUrl;
        var parsed;

        if (kc.responseMode === 'query' && queryIndex !== -1) {
            newUrl = url.substring(0, queryIndex);
            parsed = parseCallbackParams(url.substring(queryIndex + 1, fragmentIndex !== -1 ? fragmentIndex : url.length), supportedParams);
            if (parsed.paramsString !== '') {
                newUrl += '?' + parsed.paramsString;
            }
            if (fragmentIndex !== -1) {
                newUrl += url.substring(fragmentIndex);
            }
        } else if (kc.responseMode === 'fragment' && fragmentIndex !== -1) {
            newUrl = url.substring(0, fragmentIndex);
            parsed = parseCallbackParams(url.substring(fragmentIndex + 1), supportedParams);
            if (parsed.paramsString !== '') {
                newUrl += '#' + parsed.paramsString;
            }
        }

        if (parsed && parsed.oauthParams) {
            if (kc.flow === 'standard' || kc.flow === 'hybrid') {
                if ((parsed.oauthParams.code || parsed.oauthParams.error) && parsed.oauthParams.state) {
                    parsed.oauthParams.newUrl = newUrl;
                    return parsed.oauthParams;
                }
            } else if (kc.flow === 'implicit') {
                if ((parsed.oauthParams.access_token || parsed.oauthParams.error) && parsed.oauthParams.state) {
                    parsed.oauthParams.newUrl = newUrl;
                    return parsed.oauthParams;
                }
            }
        }
    }

    function parseCallbackParams(paramsString, supportedParams) {
        var p = paramsString.split('&');
        var result = {
            paramsString: '',
            oauthParams: {}
        };
        for (var i = 0; i < p.length; i++) {
            var split = p[i].indexOf("=");
            var key = p[i].slice(0, split);
            if (supportedParams.indexOf(key) !== -1) {
                result.oauthParams[key] = p[i].slice(split + 1);
            } else {
                if (result.paramsString !== '') {
                    result.paramsString += '&';
                }
                result.paramsString += p[i];
            }
        }
        return result;
    }

    function createPromise() {
        // Need to create a native Promise which also preserves the
        // interface of the custom promise type previously used by the API
        var p = {
            setSuccess: function setSuccess(result) {
                p.resolve(result);
            },

            setError: function setError(result) {
                p.reject(result);
            }
        };
        p.promise = new __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            p.resolve = resolve;
            p.reject = reject;
        });

        return p;
    }

    // Function to extend existing native Promise with timeout
    function applyTimeoutToPromise(promise, timeout, errorMessage) {
        var timeoutHandle = null;
        var timeoutPromise = new __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            timeoutHandle = setTimeout(function () {
                reject({ "error": errorMessage || "Promise is not settled within timeout of " + timeout + "ms" });
            }, timeout);
        });

        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise___default.a.race([promise, timeoutPromise]).finally(function () {
            clearTimeout(timeoutHandle);
        });
    }

    function setupCheckLoginIframe() {
        var promise = createPromise();

        if (!loginIframe.enable) {
            promise.setSuccess();
            return promise.promise;
        }

        if (loginIframe.iframe) {
            promise.setSuccess();
            return promise.promise;
        }

        var iframe = document.createElement('iframe');
        loginIframe.iframe = iframe;

        iframe.onload = function () {
            var authUrl = kc.endpoints.authorize();
            if (authUrl.charAt(0) === '/') {
                loginIframe.iframeOrigin = getOrigin();
            } else {
                loginIframe.iframeOrigin = authUrl.substring(0, authUrl.indexOf('/', 8));
            }
            promise.setSuccess();
        };

        var src = kc.endpoints.checkSessionIframe();
        iframe.setAttribute('src', src);
        iframe.setAttribute('sandbox', 'allow-storage-access-by-user-activation allow-scripts allow-same-origin');
        iframe.setAttribute('title', 'keycloak-session-iframe');
        iframe.style.display = 'none';
        document.body.appendChild(iframe);

        var messageCallback = function messageCallback(event) {
            if (event.origin !== loginIframe.iframeOrigin || loginIframe.iframe.contentWindow !== event.source) {
                return;
            }

            if (!(event.data == 'unchanged' || event.data == 'changed' || event.data == 'error')) {
                return;
            }

            if (event.data != 'unchanged') {
                kc.clearToken();
            }

            var callbacks = loginIframe.callbackList.splice(0, loginIframe.callbackList.length);

            for (var i = callbacks.length - 1; i >= 0; --i) {
                var promise = callbacks[i];
                if (event.data == 'error') {
                    promise.setError();
                } else {
                    promise.setSuccess(event.data == 'unchanged');
                }
            }
        };

        window.addEventListener('message', messageCallback, false);

        return promise.promise;
    }

    function scheduleCheckIframe() {
        if (loginIframe.enable) {
            if (kc.token) {
                setTimeout(function () {
                    checkLoginIframe().then(function (unchanged) {
                        if (unchanged) {
                            scheduleCheckIframe();
                        }
                    });
                }, loginIframe.interval * 1000);
            }
        }
    }

    function checkLoginIframe() {
        var promise = createPromise();

        if (loginIframe.iframe && loginIframe.iframeOrigin) {
            var msg = kc.clientId + ' ' + (kc.sessionId ? kc.sessionId : '');
            loginIframe.callbackList.push(promise);
            var origin = loginIframe.iframeOrigin;
            if (loginIframe.callbackList.length == 1) {
                loginIframe.iframe.contentWindow.postMessage(msg, origin);
            }
        } else {
            promise.setSuccess();
        }

        return promise.promise;
    }

    function check3pCookiesSupported() {
        var promise = createPromise();

        if ((loginIframe.enable || kc.silentCheckSsoRedirectUri) && typeof kc.endpoints.thirdPartyCookiesIframe === 'function') {
            var iframe = document.createElement('iframe');
            iframe.setAttribute('src', kc.endpoints.thirdPartyCookiesIframe());
            iframe.setAttribute('sandbox', 'allow-storage-access-by-user-activation allow-scripts allow-same-origin');
            iframe.setAttribute('title', 'keycloak-3p-check-iframe');
            iframe.style.display = 'none';
            document.body.appendChild(iframe);

            var messageCallback = function messageCallback(event) {
                if (iframe.contentWindow !== event.source) {
                    return;
                }

                if (event.data !== "supported" && event.data !== "unsupported") {
                    return;
                } else if (event.data === "unsupported") {
                    logWarn("[KEYCLOAK] Your browser is blocking access to 3rd-party cookies, this means:\n\n" + " - It is not possible to retrieve tokens without redirecting to the Keycloak server (a.k.a. no support for silent authentication).\n" + " - It is not possible to automatically detect changes to the session status (such as the user logging out in another tab).\n\n" + "For more information see: https://www.keycloak.org/securing-apps/javascript-adapter#_modern_browsers");

                    loginIframe.enable = false;
                    if (kc.silentCheckSsoFallback) {
                        kc.silentCheckSsoRedirectUri = false;
                    }
                }

                document.body.removeChild(iframe);
                window.removeEventListener("message", messageCallback);
                promise.setSuccess();
            };

            window.addEventListener('message', messageCallback, false);
        } else {
            promise.setSuccess();
        }

        return applyTimeoutToPromise(promise.promise, kc.messageReceiveTimeout, "Timeout when waiting for 3rd party check iframe message.");
    }

    function loadAdapter(type) {
        if (!type || type == 'default') {
            return {
                login: function () {
                    var _ref5 = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee5(options) {
                        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                            while (1) {
                                switch (_context5.prev = _context5.next) {
                                    case 0:
                                        _context5.t0 = window.location;
                                        _context5.next = 3;
                                        return kc.createLoginUrl(options);

                                    case 3:
                                        _context5.t1 = _context5.sent;

                                        _context5.t0.assign.call(_context5.t0, _context5.t1);

                                        return _context5.abrupt("return", createPromise().promise);

                                    case 6:
                                    case "end":
                                        return _context5.stop();
                                }
                            }
                        }, _callee5, this);
                    }));

                    function login(_x6) {
                        return _ref5.apply(this, arguments);
                    }

                    return login;
                }(),

                logout: function () {
                    var _ref6 = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee6(options) {
                        var logoutMethod, form, data, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _ref7, _ref8, name, value, input;

                        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                            while (1) {
                                switch (_context6.prev = _context6.next) {
                                    case 0:
                                        logoutMethod = options && options.logoutMethod || kc.logoutMethod;

                                        if (!(logoutMethod === "GET")) {
                                            _context6.next = 4;
                                            break;
                                        }

                                        window.location.replace(kc.createLogoutUrl(options));
                                        return _context6.abrupt("return");

                                    case 4:

                                        // Create form to send POST request.
                                        form = document.createElement("form");


                                        form.setAttribute("method", "POST");
                                        form.setAttribute("action", kc.createLogoutUrl(options));
                                        form.style.display = "none";

                                        // Add data to form as hidden input fields.
                                        data = {
                                            id_token_hint: kc.idToken,
                                            client_id: kc.clientId,
                                            post_logout_redirect_uri: adapter.redirectUri(options, false)
                                        };
                                        _iteratorNormalCompletion2 = true;
                                        _didIteratorError2 = false;
                                        _iteratorError2 = undefined;
                                        _context6.prev = 12;


                                        for (_iterator2 = __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(data)); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                            _ref7 = _step2.value;
                                            _ref8 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_ref7, 2);
                                            name = _ref8[0];
                                            value = _ref8[1];
                                            input = document.createElement("input");


                                            input.setAttribute("type", "hidden");
                                            input.setAttribute("name", name);
                                            input.setAttribute("value", value);

                                            form.appendChild(input);
                                        }

                                        // Append form to page and submit it to perform logout and redirect.
                                        _context6.next = 20;
                                        break;

                                    case 16:
                                        _context6.prev = 16;
                                        _context6.t0 = _context6["catch"](12);
                                        _didIteratorError2 = true;
                                        _iteratorError2 = _context6.t0;

                                    case 20:
                                        _context6.prev = 20;
                                        _context6.prev = 21;

                                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                            _iterator2.return();
                                        }

                                    case 23:
                                        _context6.prev = 23;

                                        if (!_didIteratorError2) {
                                            _context6.next = 26;
                                            break;
                                        }

                                        throw _iteratorError2;

                                    case 26:
                                        return _context6.finish(23);

                                    case 27:
                                        return _context6.finish(20);

                                    case 28:
                                        document.body.appendChild(form);
                                        form.submit();

                                    case 30:
                                    case "end":
                                        return _context6.stop();
                                }
                            }
                        }, _callee6, this, [[12, 16, 20, 28], [21,, 23, 27]]);
                    }));

                    function logout(_x7) {
                        return _ref6.apply(this, arguments);
                    }

                    return logout;
                }(),

                register: function () {
                    var _ref9 = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee7(options) {
                        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
                            while (1) {
                                switch (_context7.prev = _context7.next) {
                                    case 0:
                                        _context7.t0 = window.location;
                                        _context7.next = 3;
                                        return kc.createRegisterUrl(options);

                                    case 3:
                                        _context7.t1 = _context7.sent;

                                        _context7.t0.assign.call(_context7.t0, _context7.t1);

                                        return _context7.abrupt("return", createPromise().promise);

                                    case 6:
                                    case "end":
                                        return _context7.stop();
                                }
                            }
                        }, _callee7, this);
                    }));

                    function register(_x8) {
                        return _ref9.apply(this, arguments);
                    }

                    return register;
                }(),

                accountManagement: function accountManagement() {
                    var accountUrl = kc.createAccountUrl();
                    if (typeof accountUrl !== 'undefined') {
                        window.location.href = accountUrl;
                    } else {
                        throw "Not supported by the OIDC server";
                    }
                    return createPromise().promise;
                },

                redirectUri: function redirectUri(options, encodeHash) {
                    if (arguments.length == 1) {
                        encodeHash = true;
                    }

                    if (options && options.redirectUri) {
                        return options.redirectUri;
                    } else if (kc.redirectUri) {
                        return kc.redirectUri;
                    } else {
                        return location.href;
                    }
                }
            };
        }

        if (type == 'cordova') {
            loginIframe.enable = false;
            var cordovaOpenWindowWrapper = function cordovaOpenWindowWrapper(loginUrl, target, options) {
                if (window.cordova && window.cordova.InAppBrowser) {
                    // Use inappbrowser for IOS and Android if available
                    return window.cordova.InAppBrowser.open(loginUrl, target, options);
                } else {
                    return window.open(loginUrl, target, options);
                }
            };

            var shallowCloneCordovaOptions = function shallowCloneCordovaOptions(userOptions) {
                if (userOptions && userOptions.cordovaOptions) {
                    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(userOptions.cordovaOptions).reduce(function (options, optionName) {
                        options[optionName] = userOptions.cordovaOptions[optionName];
                        return options;
                    }, {});
                } else {
                    return {};
                }
            };

            var formatCordovaOptions = function formatCordovaOptions(cordovaOptions) {
                return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(cordovaOptions).reduce(function (options, optionName) {
                    options.push(optionName + "=" + cordovaOptions[optionName]);
                    return options;
                }, []).join(",");
            };

            var createCordovaOptions = function createCordovaOptions(userOptions) {
                var cordovaOptions = shallowCloneCordovaOptions(userOptions);
                cordovaOptions.location = 'no';
                if (userOptions && userOptions.prompt == 'none') {
                    cordovaOptions.hidden = 'yes';
                }
                return formatCordovaOptions(cordovaOptions);
            };

            var getCordovaRedirectUri = function getCordovaRedirectUri() {
                return kc.redirectUri || 'http://localhost';
            };

            return {
                login: function () {
                    var _ref10 = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee8(options) {
                        var promise, cordovaOptions, loginUrl, ref, completed, closed, closeBrowser;
                        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
                            while (1) {
                                switch (_context8.prev = _context8.next) {
                                    case 0:
                                        promise = createPromise();
                                        cordovaOptions = createCordovaOptions(options);
                                        _context8.next = 4;
                                        return kc.createLoginUrl(options);

                                    case 4:
                                        loginUrl = _context8.sent;
                                        ref = cordovaOpenWindowWrapper(loginUrl, '_blank', cordovaOptions);
                                        completed = false;
                                        closed = false;

                                        closeBrowser = function closeBrowser() {
                                            closed = true;
                                            ref.close();
                                        };

                                        ref.addEventListener('loadstart', function (event) {
                                            if (event.url.indexOf(getCordovaRedirectUri()) == 0) {
                                                var callback = parseCallback(event.url);
                                                processCallback(callback, promise);
                                                closeBrowser();
                                                completed = true;
                                            }
                                        });

                                        ref.addEventListener('loaderror', function (event) {
                                            if (!completed) {
                                                if (event.url.indexOf(getCordovaRedirectUri()) == 0) {
                                                    var callback = parseCallback(event.url);
                                                    processCallback(callback, promise);
                                                    closeBrowser();
                                                    completed = true;
                                                } else {
                                                    promise.setError();
                                                    closeBrowser();
                                                }
                                            }
                                        });

                                        ref.addEventListener('exit', function (event) {
                                            if (!closed) {
                                                promise.setError({
                                                    reason: "closed_by_user"
                                                });
                                            }
                                        });

                                        return _context8.abrupt("return", promise.promise);

                                    case 13:
                                    case "end":
                                        return _context8.stop();
                                }
                            }
                        }, _callee8, this);
                    }));

                    function login(_x9) {
                        return _ref10.apply(this, arguments);
                    }

                    return login;
                }(),

                logout: function logout(options) {
                    var promise = createPromise();

                    var logoutUrl = kc.createLogoutUrl(options);
                    var ref = cordovaOpenWindowWrapper(logoutUrl, '_blank', 'location=no,hidden=yes,clearcache=yes');

                    var error;

                    ref.addEventListener('loadstart', function (event) {
                        if (event.url.indexOf(getCordovaRedirectUri()) == 0) {
                            ref.close();
                        }
                    });

                    ref.addEventListener('loaderror', function (event) {
                        if (event.url.indexOf(getCordovaRedirectUri()) == 0) {
                            ref.close();
                        } else {
                            error = true;
                            ref.close();
                        }
                    });

                    ref.addEventListener('exit', function (event) {
                        if (error) {
                            promise.setError();
                        } else {
                            kc.clearToken();
                            promise.setSuccess();
                        }
                    });

                    return promise.promise;
                },

                register: function () {
                    var _ref11 = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee9(options) {
                        var promise, registerUrl, cordovaOptions, ref;
                        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
                            while (1) {
                                switch (_context9.prev = _context9.next) {
                                    case 0:
                                        promise = createPromise();
                                        _context9.next = 3;
                                        return kc.createRegisterUrl();

                                    case 3:
                                        registerUrl = _context9.sent;
                                        cordovaOptions = createCordovaOptions(options);
                                        ref = cordovaOpenWindowWrapper(registerUrl, '_blank', cordovaOptions);

                                        ref.addEventListener('loadstart', function (event) {
                                            if (event.url.indexOf(getCordovaRedirectUri()) == 0) {
                                                ref.close();
                                                var oauth = parseCallback(event.url);
                                                processCallback(oauth, promise);
                                            }
                                        });
                                        return _context9.abrupt("return", promise.promise);

                                    case 8:
                                    case "end":
                                        return _context9.stop();
                                }
                            }
                        }, _callee9, this);
                    }));

                    function register(_x10) {
                        return _ref11.apply(this, arguments);
                    }

                    return register;
                }(),

                accountManagement: function accountManagement() {
                    var accountUrl = kc.createAccountUrl();
                    if (typeof accountUrl !== 'undefined') {
                        var ref = cordovaOpenWindowWrapper(accountUrl, '_blank', 'location=no');
                        ref.addEventListener('loadstart', function (event) {
                            if (event.url.indexOf(getCordovaRedirectUri()) == 0) {
                                ref.close();
                            }
                        });
                    } else {
                        throw "Not supported by the OIDC server";
                    }
                },

                redirectUri: function redirectUri(options) {
                    return getCordovaRedirectUri();
                }
            };
        }

        if (type == 'cordova-native') {
            loginIframe.enable = false;

            return {
                login: function () {
                    var _ref12 = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee10(options) {
                        var promise, loginUrl;
                        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
                            while (1) {
                                switch (_context10.prev = _context10.next) {
                                    case 0:
                                        promise = createPromise();
                                        _context10.next = 3;
                                        return kc.createLoginUrl(options);

                                    case 3:
                                        loginUrl = _context10.sent;


                                        universalLinks.subscribe('keycloak', function (event) {
                                            universalLinks.unsubscribe('keycloak');
                                            window.cordova.plugins.browsertab.close();
                                            var oauth = parseCallback(event.url);
                                            processCallback(oauth, promise);
                                        });

                                        window.cordova.plugins.browsertab.openUrl(loginUrl);
                                        return _context10.abrupt("return", promise.promise);

                                    case 7:
                                    case "end":
                                        return _context10.stop();
                                }
                            }
                        }, _callee10, this);
                    }));

                    function login(_x11) {
                        return _ref12.apply(this, arguments);
                    }

                    return login;
                }(),

                logout: function logout(options) {
                    var promise = createPromise();
                    var logoutUrl = kc.createLogoutUrl(options);

                    universalLinks.subscribe('keycloak', function (event) {
                        universalLinks.unsubscribe('keycloak');
                        window.cordova.plugins.browsertab.close();
                        kc.clearToken();
                        promise.setSuccess();
                    });

                    window.cordova.plugins.browsertab.openUrl(logoutUrl);
                    return promise.promise;
                },

                register: function () {
                    var _ref13 = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.mark(function _callee11(options) {
                        var promise, registerUrl;
                        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
                            while (1) {
                                switch (_context11.prev = _context11.next) {
                                    case 0:
                                        promise = createPromise();
                                        _context11.next = 3;
                                        return kc.createRegisterUrl(options);

                                    case 3:
                                        registerUrl = _context11.sent;

                                        universalLinks.subscribe('keycloak', function (event) {
                                            universalLinks.unsubscribe('keycloak');
                                            window.cordova.plugins.browsertab.close();
                                            var oauth = parseCallback(event.url);
                                            processCallback(oauth, promise);
                                        });
                                        window.cordova.plugins.browsertab.openUrl(registerUrl);
                                        return _context11.abrupt("return", promise.promise);

                                    case 7:
                                    case "end":
                                        return _context11.stop();
                                }
                            }
                        }, _callee11, this);
                    }));

                    function register(_x12) {
                        return _ref13.apply(this, arguments);
                    }

                    return register;
                }(),

                accountManagement: function accountManagement() {
                    var accountUrl = kc.createAccountUrl();
                    if (typeof accountUrl !== 'undefined') {
                        window.cordova.plugins.browsertab.openUrl(accountUrl);
                    } else {
                        throw "Not supported by the OIDC server";
                    }
                },

                redirectUri: function redirectUri(options) {
                    if (options && options.redirectUri) {
                        return options.redirectUri;
                    } else if (kc.redirectUri) {
                        return kc.redirectUri;
                    } else {
                        return "http://localhost";
                    }
                }
            };
        }

        throw 'invalid adapter type: ' + type;
    }

    var STORAGE_KEY_PREFIX = 'kc-callback-';

    var LocalStorage = function LocalStorage() {
        if (!(this instanceof LocalStorage)) {
            return new LocalStorage();
        }

        localStorage.setItem('kc-test', 'test');
        localStorage.removeItem('kc-test');

        var cs = this;

        /**
         * Clears all values from local storage that are no longer valid.
         */
        function clearInvalidValues() {
            var currentTime = Date.now();

            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_get_iterator___default()(getStoredEntries()), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var _ref14 = _step3.value;

                    var _ref15 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_ref14, 2);

                    var key = _ref15[0];
                    var value = _ref15[1];

                    // Attempt to parse the expiry time from the value.
                    var expiry = parseExpiry(value);

                    // Discard the value if it is malformed or expired.
                    if (expiry === null || expiry < currentTime) {
                        localStorage.removeItem(key);
                    }
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }
        }

        /**
         * Clears all known values from local storage.
         */
        function clearAllValues() {
            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
                for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_get_iterator___default()(getStoredEntries()), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                    var _ref16 = _step4.value;

                    var _ref17 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_ref16, 1);

                    var key = _ref17[0];

                    localStorage.removeItem(key);
                }
            } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
                        _iterator4.return();
                    }
                } finally {
                    if (_didIteratorError4) {
                        throw _iteratorError4;
                    }
                }
            }
        }

        /**
         * Gets all entries stored in local storage that are known to be managed by this class.
         * @returns {Array<[string, unknown]>} An array of key-value pairs.
         */
        function getStoredEntries() {
            return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(localStorage).filter(function (_ref18) {
                var _ref19 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_ref18, 1),
                    key = _ref19[0];

                return key.startsWith(STORAGE_KEY_PREFIX);
            });
        }

        /**
         * Parses the expiry time from a value stored in local storage.
         * @param {unknown} value
         * @returns {number | null} The expiry time in milliseconds, or `null` if the value is malformed.
         */
        function parseExpiry(value) {
            var parsedValue = void 0;

            // Attempt to parse the value as JSON.
            try {
                parsedValue = JSON.parse(value);
            } catch (error) {
                return null;
            }

            // Attempt to extract the 'expires' property.
            if (isObject(parsedValue) && 'expires' in parsedValue && typeof parsedValue.expires === 'number') {
                return parsedValue.expires;
            }

            return null;
        }

        cs.get = function (state) {
            if (!state) {
                return;
            }

            var key = STORAGE_KEY_PREFIX + state;
            var value = localStorage.getItem(key);
            if (value) {
                localStorage.removeItem(key);
                value = JSON.parse(value);
            }

            clearInvalidValues();
            return value;
        };

        cs.add = function (state) {
            clearInvalidValues();

            var key = STORAGE_KEY_PREFIX + state.state;
            var value = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, state, {
                // Set the expiry time to 1 hour from now.
                expires: Date.now() + 60 * 60 * 1000
            }));

            try {
                localStorage.setItem(key, value);
            } catch (error) {
                // If the storage is full, clear all known values and try again.
                clearAllValues();
                localStorage.setItem(key, value);
            }
        };
    };

    var CookieStorage = function CookieStorage() {
        if (!(this instanceof CookieStorage)) {
            return new CookieStorage();
        }

        var cs = this;

        cs.get = function (state) {
            if (!state) {
                return;
            }

            var value = getCookie(STORAGE_KEY_PREFIX + state);
            setCookie(STORAGE_KEY_PREFIX + state, '', cookieExpiration(-100));
            if (value) {
                return JSON.parse(value);
            }
        };

        cs.add = function (state) {
            setCookie(STORAGE_KEY_PREFIX + state.state, __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_json_stringify___default()(state), cookieExpiration(60));
        };

        cs.removeItem = function (key) {
            setCookie(key, '', cookieExpiration(-100));
        };

        var cookieExpiration = function cookieExpiration(minutes) {
            var exp = new Date();
            exp.setTime(exp.getTime() + minutes * 60 * 1000);
            return exp;
        };

        var getCookie = function getCookie(key) {
            var name = key + '=';
            var ca = document.cookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return '';
        };

        var setCookie = function setCookie(key, value, expirationDate) {
            var cookie = key + '=' + value + '; ' + 'expires=' + expirationDate.toUTCString() + '; ';
            document.cookie = cookie;
        };
    };

    function createCallbackStorage() {
        try {
            return new LocalStorage();
        } catch (err) {}

        return new CookieStorage();
    }

    function createLogger(fn) {
        return function () {
            if (kc.enableLogging) {
                fn.apply(console, Array.prototype.slice.call(arguments));
            }
        };
    }
}

/* harmony default export */ __webpack_exports__["a"] = (Keycloak);

/**
 * @param {ArrayBuffer} bytes
 * @see https://developer.mozilla.org/en-US/docs/Glossary/Base64#the_unicode_problem
 */
function bytesToBase64(bytes) {
    var binString = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_string_from_code_point___default.a.apply(String, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(bytes));
    return btoa(binString);
}function decodeToken(token) {
    var _token$split = token.split("."),
        _token$split2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_token$split, 2),
        header = _token$split2[0],
        payload = _token$split2[1];

    if (typeof payload !== "string") {
        throw new Error("Unable to decode token, payload not found.");
    }

    var decoded = void 0;

    try {
        decoded = base64UrlDecode(payload);
    } catch (error) {
        throw new Error("Unable to decode token, payload is not a valid Base64URL value.", { cause: error });
    }

    try {
        return JSON.parse(decoded);
    } catch (error) {
        throw new Error("Unable to decode token, payload is not a valid JSON value.", { cause: error });
    }
}

/**
 * @param {string} input
 */
function base64UrlDecode(input) {
    var output = input.replaceAll("-", "+").replaceAll("_", "/");

    switch (output.length % 4) {
        case 0:
            break;
        case 2:
            output += "==";
            break;
        case 3:
            output += "=";
            break;
        default:
            throw new Error("Input is not of the correct length.");
    }

    try {
        return b64DecodeUnicode(output);
    } catch (error) {
        return atob(output);
    }
}

/**
 * @param {string} input
 */
function b64DecodeUnicode(input) {
    return decodeURIComponent(atob(input).replace(/(.)/g, function (m, p) {
        var code = p.charCodeAt(0).toString(16).toUpperCase();

        if (code.length < 2) {
            code = "0" + code;
        }

        return "%" + code;
    }));
}

/**
 * Check if the input is an object that can be operated on.
 * @param {unknown} input
 */
function isObject(input) {
    return (typeof input === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_typeof___default()(input)) === 'object' && input !== null;
}

/***/ }),
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_components_Icon__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_icons__ = __webpack_require__(702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App_vue__ = __webpack_require__(1489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(1494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components__ = __webpack_require__(1564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__filters__ = __webpack_require__(1847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_safe_id__ = __webpack_require__(1850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__plugins_shortcut__ = __webpack_require__(1851);
/* eslint-disable import/first */

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/**
 * Import and register/install third-party components.
 */




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('icon', __WEBPACK_IMPORTED_MODULE_2_vue_awesome_components_Icon__["a" /* default */]);

/**
 * Import and register/install application components.
 */








__WEBPACK_IMPORTED_MODULE_7__components__["a" /* default */].install(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_8__filters__["a" /* default */].install(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].mixin(__WEBPACK_IMPORTED_MODULE_9__mixins_safe_id__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_10__plugins_shortcut__["a" /* default */]);

/**
 * Create root vue instance
 */
/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_4__App_vue__["a" /* default */] }
});

/***/ }),
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_group_vue__ = __webpack_require__(616);
function injectStyle (ssrContext) {
  __webpack_require__(614)
}
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_group_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 614 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 615 */,
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_dom__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_form_row__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__form_form_text__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_form_invalid_feedback__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__form_form_valid_feedback__ = __webpack_require__(246);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins__["i" /* idMixin */], __WEBPACK_IMPORTED_MODULE_2__mixins__["h" /* formStateMixin */]],
    components: { bFormRow: __WEBPACK_IMPORTED_MODULE_3__form_form_row__["a" /* default */], bFormText: __WEBPACK_IMPORTED_MODULE_4__form_form_text__["a" /* default */], bFormInvalidFeedback: __WEBPACK_IMPORTED_MODULE_5__form_form_invalid_feedback__["a" /* default */], bFormValidFeedback: __WEBPACK_IMPORTED_MODULE_6__form_form_valid_feedback__["a" /* default */] },
    render: function render(h) {
        var t = this;
        var $slots = t.$slots;

        // Label
        var legend = h(false);
        if (t.label || $slots.label || t.horizontal) {
            legend = h('legend', { class: t.labelClasses, attrs: { id: t.labelId } }, [$slots.label || h('span', { domProps: { innerHTML: t.label || '' } })]);
        }

        // Invalid feeback text
        var invalidFeedback = h(false);
        if (t.feedback || $slots['invalid-feedback'] || $slots['feedback']) {
            invalidFeedback = h('b-form-invalid-feedback', {
                directives: [{
                    name: 'show',
                    rawName: 'v-show',
                    value: Boolean(t.feedback || $slots['invalid-feedback'] || $slots['feedback']),
                    expression: "Boolean(t.feedback || $slots['invalid-feedback'] || $slots['feedback'])"
                }],
                attrs: {
                    id: t.feedbackId,
                    role: 'alert',
                    'aria-live': 'assertive',
                    'aria-atomic': 'true'
                }
            }, [t.computedState === false ? $slots['invalid-feedback'] || $slots['feedback'] || h('span', { domProps: { innerHTML: t.feedback || '' } }) : h(false)]);
        }

        // Valid feeback text
        var validFeedback = h(false);
        if (t.validFeedback || $slots['valid-feedback']) {
            validFeedback = h('b-form-valid-feedback', {
                directives: [{
                    name: 'show',
                    rawName: 'v-show',
                    value: Boolean(t.validFeedback || $slots['valid-feedback']),
                    expression: "Boolean(t.validFeedback || $slots['valid-feedback'])"
                }],
                attrs: {
                    id: t.validFeedbackId,
                    role: 'alert',
                    'aria-live': 'assertive',
                    'aria-atomic': 'true'
                }
            }, [t.computedState === true ? $slots['valid-feedback'] || h('span', { domProps: { innerHTML: t.validFeedback || '' } }) : h(false)]);
        }

        // Form help text (description)
        var description = h(false);
        if (t.description || $slots['description']) {
            description = h('b-form-text', { attrs: { id: t.descriptionId } }, [$slots['description'] || h('span', { domProps: { innerHTML: t.description || '' } })]);
        }

        // Build layout
        var content = h('div', { ref: 'content', class: t.inputLayoutClasses }, [$slots.default, invalidFeedback, validFeedback, description]);

        // Generate fieldset wrapper
        return h('fieldset', {
            class: t.groupClasses,
            attrs: { id: t.safeId(), 'aria-describedby': t.describedByIds }
        }, [h('b-form-row', {}, [legend, content])]);
    },

    props: {
        horizontal: {
            type: Boolean,
            default: false
        },
        labelCols: {
            type: Number,
            default: 3,
            validator: function validator(value) {
                if (value >= 1 && value <= 11) {
                    return true;
                }
                Object(__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* warn */])('b-form-group: label-cols must be a value between 1 and 11');
                return false;
            }
        },
        breakpoint: {
            type: String,
            default: 'sm'
        },
        labelTextAlign: {
            type: String,
            default: null
        },
        label: {
            type: String,
            default: null
        },
        labelSrOnly: {
            type: Boolean,
            default: false
        },
        description: {
            type: String,
            default: null
        },
        feedback: {
            type: String,
            default: null
        },
        validFeedback: {
            type: String,
            default: null
        },
        validated: {
            type: Boolean,
            value: false
        }
    },
    computed: {
        inputState: function inputState() {
            return this.stateClass;
        },
        groupClasses: function groupClasses() {
            return ['b-form-group', 'form-group', this.validated ? 'was-validated' : null, this.inputState];
        },
        labelClasses: function labelClasses() {
            return [this.labelSrOnly ? 'sr-only' : 'col-form-legend', this.labelLayout, this.labelAlignClass];
        },
        labelLayout: function labelLayout() {
            if (this.labelSrOnly) {
                return null;
            }
            return this.horizontal ? 'col-' + this.breakpoint + '-' + this.labelCols : 'col-12';
        },
        labelAlignClass: function labelAlignClass() {
            if (this.labelSrOnly) {
                return null;
            }
            return this.labelTextAlign ? 'text-' + this.labelTextAlign : null;
        },
        inputLayoutClasses: function inputLayoutClasses() {
            return [this.horizontal ? 'col-' + this.breakpoint + '-' + (12 - this.labelCols) : 'col-12'];
        },
        labelId: function labelId() {
            return this.label || this.$slots['label'] ? this.safeId('_BV_label_') : null;
        },
        descriptionId: function descriptionId() {
            if (this.description || this.$slots['description']) {
                return this.safeId('_BV_description_');
            }
            return null;
        },
        feedbackId: function feedbackId() {
            if (this.feedback || this.$slots['invalid-feedback'] || this.$slots['feedback']) {
                return this.safeId('_BV_feedback_invalid_');
            }
            return null;
        },
        validFeedbackId: function validFeedbackId() {
            if (this.validFeedback || this.$slots['valid-feedback']) {
                return this.safeId('_BV_feedback_valid_');
            }
            return null;
        },
        describedByIds: function describedByIds() {
            return [this.labelId, this.descriptionId, this.computedState === false ? this.feedbackId : null, this.computedState === true ? this.validFeedbackId : null].filter(function (i) {
                return i;
            }).join(' ') || null;
        }
    }
});

/***/ }),
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_input_vue__ = __webpack_require__(625);
function injectStyle (ssrContext) {
  __webpack_require__(624)
}
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_input_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 624 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_array__ = __webpack_require__(17);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// Valid supported input types
var TYPES = ['text', 'password', 'email', 'number', 'url', 'tel', 'search', 'range', 'color', 'date', 'time', 'datetime', 'datetime-local', 'month', 'week'];

/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["i" /* idMixin */], __WEBPACK_IMPORTED_MODULE_0__mixins__["d" /* formMixin */], __WEBPACK_IMPORTED_MODULE_0__mixins__["g" /* formSizeMixin */], __WEBPACK_IMPORTED_MODULE_0__mixins__["h" /* formStateMixin */]],
    render: function render(h) {
        var t = this;
        return h('input', {
            ref: 'input',
            class: t.inputClass,
            domProps: { value: t.localValue },
            attrs: {
                id: t.safeId(),
                name: t.name,
                type: t.localType,
                disabled: t.disabled,
                required: t.required,
                readonly: t.readonly || t.plaintext,
                placeholder: t.placeholder,
                autocomplete: t.autocomplete || null,
                'aria-required': t.required ? 'true' : null,
                'aria-invalid': t.computedAriaInvalid
            },
            on: {
                input: t.onInput,
                change: t.onChange
            }
        });
    },
    data: function data() {
        return {
            localValue: this.value
        };
    },

    props: {
        value: {
            default: null
        },
        type: {
            type: String,
            default: 'text',
            validator: function validator(type) {
                return Object(__WEBPACK_IMPORTED_MODULE_1__utils_array__["a" /* arrayIncludes */])(TYPES, type);
            }
        },
        ariaInvalid: {
            type: [Boolean, String],
            default: false
        },
        readonly: {
            type: Boolean,
            default: false
        },
        plaintext: {
            type: Boolean,
            default: false
        },
        autocomplete: {
            type: String,
            default: null
        },
        placeholder: {
            type: String,
            default: null
        },
        formatter: {
            type: Function
        },
        lazyFormatter: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        localType: function localType() {
            // We only allow certain types
            return Object(__WEBPACK_IMPORTED_MODULE_1__utils_array__["a" /* arrayIncludes */])(TYPES, this.type) ? this.type : 'text';
        },
        inputClass: function inputClass() {
            return [this.plaintext ? 'form-control-plaintext' : 'form-control',
            // Fix missing width:100% in Bootstrap V4.beta.2
            this.plaintext ? 'w-100' : '', this.sizeFormClass, this.stateClass];
        },
        computedAriaInvalid: function computedAriaInvalid() {
            if (!Boolean(this.ariaInvalid) || this.ariaInvalid === 'false') {
                // this.ariaInvalid is null or false or 'false'
                return this.computedState === false ? 'true' : null;
            }
            if (this.ariaInvalid === true) {
                // User wants explicit aria-invalid=true
                return 'true';
            }
            // Most likely a string value (which could be 'true')
            return this.ariaInvalid;
        }
    },
    watch: {
        value: function value(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.localValue = newVal;
            }
        },
        localValue: function localValue(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.$emit('input', newVal);
            }
        }
    },
    methods: {
        format: function format(value, e) {
            if (this.formatter) {
                var formattedValue = this.formatter(value, e);
                if (formattedValue !== value) {
                    return formattedValue;
                }
            }
            return value;
        },
        onInput: function onInput(evt) {
            var value = evt.target.value;
            if (this.lazyFormatter) {
                // Update the model with the current unformated value
                this.localValue = value;
            } else {
                this.localValue = this.format(value, evt);
            }
        },
        onChange: function onChange(evt) {
            this.localValue = this.format(evt.target.value, evt);
            this.$emit('change', this.localValue);
        },
        focus: function focus() {
            if (!this.disabled) {
                this.$el.focus();
            }
        }
    }
});

/***/ }),
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_file_vue__ = __webpack_require__(632);
function injectStyle (ssrContext) {
  __webpack_require__(631)
}
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_file_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 631 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_array__ = __webpack_require__(17);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins__["i" /* idMixin */], __WEBPACK_IMPORTED_MODULE_1__mixins__["d" /* formMixin */], __WEBPACK_IMPORTED_MODULE_1__mixins__["h" /* formStateMixin */], __WEBPACK_IMPORTED_MODULE_1__mixins__["c" /* formCustomMixin */]],
    render: function render(h) {
        var t = this;

        // Form Input
        var input = h('input', {
            ref: 'input',
            class: t.inputClasses,
            attrs: {
                type: 'file',
                id: t.safeId(),
                name: t.name,
                disabled: t.disabled,
                required: t.required,
                capture: t.capture || null,
                'aria-required': t.required ? 'true' : null,
                accept: t.accept || null,
                multiple: t.multiple,
                webkitdirectory: t.directory,
                'aria-describedby': t.plain ? null : t.safeId('_BV_file_control_')
            },
            on: {
                change: t.onFileChange,
                focusin: t.focusHandler,
                focusout: t.focusHandler
            }
        });

        if (t.plain) {
            return input;
        }

        // 'Drop Here' target
        var droptarget = h(false);
        if (t.dragging) {
            droptarget = h('span', {
                class: ['drop-here'],
                attrs: { 'data-drop': t.dropLabel },
                on: {
                    dragover: t.dragover,
                    drop: t.drop,
                    dragleave: t.dragleave
                }
            });
        }

        // Overlay Labels
        var labels = h('span', {
            class: ['custom-file-control', t.dragging ? 'dragging' : null],
            attrs: {
                id: t.safeId('_BV_file_control_'),
                'data-choose': t.computedChooseLabel,
                'data-selected': t.selectedLabel
            }
        });

        // Return rendered custom file input
        return h('label', {
            class: ['custom-file', 'b-form-file', t.stateClass, 'w-100', 'd-block'],
            attrs: { id: t.safeId('_BV_file_outer_') },
            on: { dragover: t.dragover }
        }, [droptarget, input, labels]);
    },
    data: function data() {
        return {
            selectedFile: null,
            dragging: false,
            hasFocus: false
        };
    },

    props: {
        accept: {
            type: String,
            default: ''
        },
        capture: {
            // Instruct input to capture from camera
            type: Boolean,
            default: false
        },
        placeholder: {
            type: String,
            default: null
        },
        chooseLabel: {
            type: String,
            default: null
        },
        multiple: {
            type: Boolean,
            default: false
        },
        directory: {
            type: Boolean,
            default: false
        },
        noTraverse: {
            type: Boolean,
            default: false
        },
        selectedFormat: {
            type: String,
            default: ':count Files'
        },
        noDrop: {
            type: Boolean,
            default: false
        },
        dropLabel: {
            type: String,
            default: 'Drop files here'
        }
    },
    computed: {
        inputClasses: function inputClasses() {
            return [{
                'form-control-file': this.plain,
                'custom-file-input': this.custom,
                'w-100': true, // BS4 beta missing this
                'focus': this.custom && this.hasFocus
            }, this.stateClass];
        },
        selectedLabel: function selectedLabel() {
            if (!this.selectedFile || this.selectedFile.length === 0) {
                return this.placeholder || 'No file chosen';
            }
            if (this.multiple) {
                if (this.selectedFile.length === 1) {
                    return this.selectedFile[0].name;
                }
                return this.selectedFormat.replace(':names', this.selectedFile.map(function (file) {
                    return file.name;
                }).join(',')).replace(':count', this.selectedFile.length);
            }
            return this.selectedFile.name;
        },
        computedChooseLabel: function computedChooseLabel() {
            return this.chooseLabel || (this.multiple ? 'Choose Files' : 'Choose File');
        }
    },
    watch: {
        selectedFile: function selectedFile(newVal, oldVal) {
            if (newVal === oldVal) {
                return;
            }
            if (!newVal && this.multiple) {
                this.$emit('input', []);
            } else {
                this.$emit('input', newVal);
            }
        }
    },
    methods: {
        focusHandler: function focusHandler(evt) {
            // Boostrap v4.beta doesn't have focus styling for custom file input
            // Firefox has a borked '[type=file]:focus ~ sibling' selector issue,
            // So we add a 'focus' class to get around these "bugs"
            if (this.plain || evt.type === 'focusout') {
                this.hasFocus = false;
            } else {
                // Add focus styling for custom file input
                this.hasFocus = true;
            }
        },
        reset: function reset() {
            try {
                // Wrapped in try in case IE < 11 craps out
                this.$refs.input.value = '';
            } catch (e) {}
            // IE < 11 doesn't support setting input.value to '' or null
            // So we use this little extra hack to reset the value, just in case
            // This also appears to work on modern browsers as well.
            this.$refs.input.type = '';
            this.$refs.input.type = 'file';
            this.selectedFile = this.multiple ? [] : null;
        },
        onFileChange: function onFileChange(evt) {
            var _this = this;

            // Always emit original event
            this.$emit('change', evt);
            // Check if special `items` prop is available on event (drop mode)
            // Can be disabled by setting no-traverse
            var items = evt.dataTransfer && evt.dataTransfer.items;
            if (items && !this.noTraverse) {
                var queue = [];
                for (var i = 0; i < items.length; i++) {
                    var item = items[i].webkitGetAsEntry();
                    if (item) {
                        queue.push(this.traverseFileTree(item));
                    }
                }
                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(queue).then(function (filesArr) {
                    _this.setFiles(Object(__WEBPACK_IMPORTED_MODULE_2__utils_array__["c" /* from */])(filesArr));
                });
                return;
            }
            // Normal handling
            this.setFiles(evt.target.files || evt.dataTransfer.files);
        },
        setFiles: function setFiles(files) {
            if (!files) {
                this.selectedFile = null;
                return;
            }
            if (!this.multiple) {
                this.selectedFile = files[0];
                return;
            }
            // Convert files to array
            var filesArray = [];
            for (var i = 0; i < files.length; i++) {
                if (files[i].type.match(this.accept)) {
                    filesArray.push(files[i]);
                }
            }
            this.selectedFile = filesArray;
        },
        dragover: function dragover(evt) {
            evt.preventDefault();
            evt.stopPropagation();
            if (this.noDrop || !this.custom) {
                return;
            }
            this.dragging = true;
            evt.dataTransfer.dropEffect = 'copy';
        },
        dragleave: function dragleave(evt) {
            evt.preventDefault();
            evt.stopPropagation();
            this.dragging = false;
        },
        drop: function drop(evt) {
            evt.preventDefault();
            evt.stopPropagation();
            if (this.noDrop) {
                return;
            }
            this.dragging = false;
            if (evt.dataTransfer.files && evt.dataTransfer.files.length > 0) {
                this.onFileChange(evt);
            }
        },
        traverseFileTree: function traverseFileTree(item, path) {
            var _this2 = this;

            // Based on http://stackoverflow.com/questions/3590058
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
                path = path || '';
                if (item.isFile) {
                    // Get file
                    item.file(function (file) {
                        file.$path = path; // Inject $path to file obj
                        resolve(file);
                    });
                } else if (item.isDirectory) {
                    // Get folder contents
                    item.createReader().readEntries(function (entries) {
                        var queue = [];
                        for (var i = 0; i < entries.length; i++) {
                            queue.push(_this2.traverseFileTree(entries[i], path + item.name + '/'));
                        }
                        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(queue).then(function (filesArr) {
                            resolve(Object(__WEBPACK_IMPORTED_MODULE_2__utils_array__["c" /* from */])(filesArr));
                        });
                    });
                }
            });
        }
    }
});

/***/ }),
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_modal_vue__ = __webpack_require__(649);
function injectStyle (ssrContext) {
  __webpack_require__(648)
}
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_modal_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 648 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__button_button__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__button_button_close__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_bv_event_class__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_dom__ = __webpack_require__(25);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








// Selectors for padding/margin adjustments
var Selector = {
    FIXED_CONTENT: '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top',
    STICKY_CONTENT: '.sticky-top',
    NAVBAR_TOGGLER: '.navbar-toggler'
};

// ObserveDom config
var OBSERVER_CONFIG = {
    subtree: true,
    childList: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['style', 'class']
};

/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins__["i" /* idMixin */], __WEBPACK_IMPORTED_MODULE_3__mixins__["j" /* listenOnRootMixin */]],
    components: { bBtn: __WEBPACK_IMPORTED_MODULE_1__button_button__["a" /* default */], bBtnClose: __WEBPACK_IMPORTED_MODULE_2__button_button_close__["a" /* default */] },
    render: function render(h) {
        var t = this;
        var $slots = t.$slots;

        // Modal Header
        var header = h(false);
        if (!t.hideHeader) {
            var modalHeader = $slots['modal-header'];
            if (!modalHeader) {
                var closeButton = h(false);
                if (!t.hideHeaderClose) {
                    closeButton = h('b-btn-close', {
                        props: {
                            disabled: t.is_transitioning,
                            ariaLabel: t.headerCloseLabel,
                            textVariant: t.headerTextVariant
                        },
                        on: { click: function click(evt) {
                                t.hide('header-close');
                            } }
                    }, [$slots['modal-header-close']]);
                }
                modalHeader = [h(t.titleTag, { class: ['modal-title'] }, [$slots['modal-title'] || t.title]), closeButton];
            }
            header = h('header', {
                ref: 'header',
                class: t.headerClasses,
                attrs: { id: t.safeId('__BV_modal_header_') }
            }, [modalHeader]);
        }

        // Modal Body
        var body = h('div', {
            ref: 'body',
            class: t.bodyClasses,
            attrs: { id: t.safeId('__BV_modal_body_') }
        }, [$slots.default]);

        // Modal Footer
        var footer = h(false);
        if (!t.hideFooter) {
            var modalFooter = $slots['modal-footer'];
            if (!modalFooter) {
                var okButton = h(false);
                if (!t.okOnly) {
                    okButton = h('b-btn', {
                        props: {
                            variant: t.cancelVariant,
                            size: t.buttonSize,
                            disabled: t.cancelDisabled || t.busy || t.is_transitioning
                        },
                        on: { click: function click(evt) {
                                t.hide('cancel');
                            } }

                    }, [$slots['modal-cancel'] || t.cancelTitle]);
                }
                var cancelButton = h('b-btn', {
                    props: {
                        variant: t.okVariant,
                        size: t.buttonSize,
                        disabled: t.okDisabled || t.busy || t.is_transitioning
                    },
                    on: { click: function click(evt) {
                            t.hide('ok');
                        } }
                }, [$slots['modal-ok'] || t.okTitle]);
                modalFooter = [cancelButton, okButton];
            }
            footer = h('footer', {
                ref: 'footer',
                class: t.footerClasses,
                attrs: { id: t.safeId('__BV_modal_footer_') }
            }, [modalFooter]);
        }

        // Assemble Modal Content
        var modalContent = h('div', {
            ref: 'content',
            class: ['modal-content'],
            attrs: {
                tabindex: '-1',
                role: 'document',
                'aria-labelledby': t.hideHeader ? null : t.safeId('__BV_modal_header_'),
                'aria-describedby': t.safeId('__BV_modal_body_')
            },
            on: {
                focusout: t.onFocusout,
                click: function click(evt) {
                    evt.stopPropagation();
                }
            }
        }, [header, body, footer]);

        // Modal Dialog wrapper
        var modalDialog = h('div', { class: t.dialogClasses }, [modalContent]);

        // Modal
        var modal = h('div', {
            ref: 'modal',
            class: t.modalClasses,
            directives: [{ name: 'show', rawName: 'v-show', value: t.is_visible, expression: 'is_visible' }],
            attrs: {
                id: t.safeId(),
                role: 'dialog',
                'aria-hidden': t.is_visible ? null : 'true'
            },
            on: {
                click: t.onClickOut,
                keydown: t.onEsc
            }
        }, [modalDialog]);
        // Wrap modal in transition
        modal = h('transition', {
            props: {
                enterClass: '',
                enterToClass: '',
                enterActiveClass: '',
                leaveClass: '',
                leaveActiveClass: '',
                leaveToClass: ''
            },
            on: {
                'before-enter': t.onBeforeEnter,
                'enter': t.onEnter,
                'after-enter': t.onAfterEnter,
                'before-leave': t.onBeforeLeave,
                'leave': t.onLeave,
                'after-leave': t.onAfterLeave
            }
        }, [modal]);

        // Modal Backdrop
        var backdrop = h(false);
        if (!t.hideBackdrop && (t.is_visible || t.is_transitioning)) {
            backdrop = h('div', { class: t.backdropClasses, attrs: { id: t.safeId('__BV_modal_backdrop_') } });
        }

        // Assemble modal and backdrop
        var outer = h(false);
        if (!t.is_hidden) {
            outer = h('div', { attrs: { id: t.safeId('__BV_modal_outer_') } }, [modal, backdrop]);
        }

        // Wrap in DIV to maintain thi.$el reference for hide/show method aceess
        return h('div', {}, [outer]);
    },
    data: function data() {
        return {
            is_hidden: this.lazy || false,
            is_visible: false,
            is_transitioning: false,
            is_show: false,
            is_block: false,
            scrollbarWidth: 0,
            isBodyOverflowing: false,
            return_focus: this.returnFocus || null
        };
    },

    model: {
        prop: 'visible',
        event: 'change'
    },
    props: {
        title: {
            type: String,
            default: ''
        },
        titleTag: {
            type: String,
            default: 'h5'
        },
        size: {
            type: String,
            default: 'md'
        },
        centered: {
            type: Boolean,
            default: false
        },
        buttonSize: {
            type: String,
            default: ''
        },
        noFade: {
            type: Boolean,
            default: false
        },
        noCloseOnBackdrop: {
            type: Boolean,
            default: false
        },
        noCloseOnEsc: {
            type: Boolean,
            default: false
        },
        noEnforceFocus: {
            type: Boolean,
            default: false
        },
        headerBgVariant: {
            type: String,
            default: null
        },
        headerBorderVariant: {
            type: String,
            default: null
        },
        headerTextVariant: {
            type: String,
            default: null
        },
        bodyBgVariant: {
            type: String,
            default: null
        },
        bodyTextVariant: {
            type: String,
            default: null
        },
        footerBgVariant: {
            type: String,
            default: null
        },
        footerBorderVariant: {
            type: String,
            default: null
        },
        footerTextVariant: {
            type: String,
            default: null
        },
        hideHeader: {
            type: Boolean,
            default: false
        },
        hideFooter: {
            type: Boolean,
            default: false
        },
        hideHeaderClose: {
            type: Boolean,
            default: false
        },
        hideBackdrop: {
            type: Boolean,
            default: false
        },
        okOnly: {
            type: Boolean,
            default: false
        },
        okDisabled: {
            type: Boolean,
            default: false
        },
        cancelDisabled: {
            type: Boolean,
            default: false
        },
        visible: {
            type: Boolean,
            default: false
        },
        returnFocus: {
            default: null
        },
        headerCloseLabel: {
            type: String,
            default: 'Close'
        },
        cancelTitle: {
            type: String,
            default: 'Cancel'
        },
        okTitle: {
            type: String,
            default: 'OK'
        },
        cancelVariant: {
            type: String,
            default: 'secondary'
        },
        okVariant: {
            type: String,
            default: 'primary'
        },
        lazy: {
            type: Boolean,
            default: false
        },
        busy: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        modalClasses: function modalClasses() {
            return ['modal', {
                fade: !this.noFade,
                show: this.is_show,
                'd-block': this.is_block
            }];
        },
        dialogClasses: function dialogClasses() {
            var _ref;

            return ['modal-dialog', (_ref = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'modal-' + this.size, Boolean(this.size)), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'modal-dialog-centered', this.centered), _ref)];
        },
        backdropClasses: function backdropClasses() {
            return ['modal-backdrop', {
                fade: !this.noFade,
                show: this.is_show || this.noFade
            }];
        },
        headerClasses: function headerClasses() {
            var _ref2;

            return ['modal-header', (_ref2 = {
                'rounded-top': Boolean(this.headerBgVariant)
            }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref2, 'bg-' + this.headerBgVariant, Boolean(this.headerBgVariant)), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref2, 'text-' + this.headerTextVariant, Boolean(this.headerTextVariant)), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref2, 'border-' + this.headerBorderVariant, Boolean(this.headerBorderVariant)), _ref2)];
        },
        bodyClasses: function bodyClasses() {
            var _ref3;

            return ['modal-body', (_ref3 = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref3, 'bg-' + this.bodyBgVariant, Boolean(this.bodyBgVariant)), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref3, 'text-' + this.bodyTextVariant, Boolean(this.bodyTextVariant)), _ref3)];
        },
        footerClasses: function footerClasses() {
            var _ref4;

            return ['modal-footer', (_ref4 = {
                'rounded-bottom': Boolean(this.footerBgVariant)
            }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref4, 'bg-' + this.footerBgVariant, Boolean(this.footerBgVariant)), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref4, 'text-' + this.footerTextVariant, Boolean(this.footerTextVariant)), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref4, 'border-' + this.footerBorderVariant, Boolean(this.footerBorderVariant)), _ref4)];
        }
    },
    watch: {
        visible: function visible(newVal, oldVal) {
            if (newVal === oldVal) {
                return;
            }
            this[newVal ? 'show' : 'hide']();
        }
    },
    methods: {
        // Public Methods
        show: function show() {
            if (this.is_visible) {
                return;
            }
            var showEvt = new __WEBPACK_IMPORTED_MODULE_5__utils_bv_event_class__["a" /* default */]('show', {
                cancelable: true,
                vueTarget: this,
                target: this.$refs.modal,
                relatedTarget: null
            });
            this.emitEvent(showEvt);
            if (showEvt.defaultPrevented || this.is_visible) {
                // Don't show if canceled
                return;
            }
            if (Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["j" /* hasClass */])(document.body, 'modal-open')) {
                // If another modal is already open, wait for it to close
                this.$root.$once('bv::modal::hidden', this.doShow);
            } else {
                // Show the modal
                this.doShow();
            }
        },
        hide: function hide(trigger) {
            if (!this.is_visible) {
                return;
            }
            var hideEvt = new __WEBPACK_IMPORTED_MODULE_5__utils_bv_event_class__["a" /* default */]('hide', {
                cancelable: true,
                vueTarget: this,
                target: this.$refs.modal,
                // this could be the trigger element/component reference
                relatedTarget: null,
                isOK: trigger || null,
                trigger: trigger || null,
                cancel: function cancel() {
                    // Backwards compatibility
                    Object(__WEBPACK_IMPORTED_MODULE_4__utils__["n" /* warn */])('b-modal: evt.cancel() is deprecated. Please use evt.preventDefault().');
                    this.preventDefault();
                }
            });
            if (trigger === 'ok') {
                this.$emit('ok', hideEvt);
            } else if (trigger === 'cancel') {
                this.$emit('cancel', hideEvt);
            }
            this.emitEvent(hideEvt);
            // Hide if not canceled
            if (hideEvt.defaultPrevented || !this.is_visible) {
                return;
            }
            // stop observing for content changes
            if (this._observer) {
                this._observer.disconnect();
                this._observer = null;
            }
            this.is_visible = false;
            this.$emit('change', false);
        },

        // Private method to finish showing modal
        doShow: function doShow() {
            var _this = this;

            // Plce modal in DOM if lazy
            this.is_hidden = false;
            this.$nextTick(function () {
                // We do this in nextTick to ensure the modal is in DOM first before we show it
                _this.is_visible = true;
                _this.$emit('change', true);
                // Observe changes in modal content and adjust if necessary
                _this._observer = Object(__WEBPACK_IMPORTED_MODULE_4__utils__["f" /* observeDom */])(_this.$refs.content, _this.adjustDialog.bind(_this), OBSERVER_CONFIG);
            });
        },

        // Transition Handlers
        onBeforeEnter: function onBeforeEnter() {
            this.is_transitioning = true;
            this.checkScrollbar();
            this.setScrollbar();
            this.adjustDialog();
            Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["a" /* addClass */])(document.body, 'modal-open');
            this.setResizeEvent(true);
        },
        onEnter: function onEnter() {
            this.is_block = true;
            this.$refs.modal.scrollTop = 0;
        },
        onAfterEnter: function onAfterEnter() {
            var _this2 = this;

            this.is_show = true;
            this.is_transitioning = false;
            this.$nextTick(function () {
                _this2.focusFirst();
                var shownEvt = new __WEBPACK_IMPORTED_MODULE_5__utils_bv_event_class__["a" /* default */]('shown', {
                    cancelable: false,
                    vueTarget: _this2,
                    target: _this2.$refs.modal,
                    relatedTarget: null
                });
                _this2.emitEvent(shownEvt);
            });
        },
        onBeforeLeave: function onBeforeLeave() {
            this.is_transitioning = true;
            this.setResizeEvent(false);
        },
        onLeave: function onLeave() {
            // Remove the 'show' class
            this.is_show = false;
        },
        onAfterLeave: function onAfterLeave() {
            var _this3 = this;

            this.is_block = false;
            this.resetAdjustments();
            this.resetScrollbar();
            this.is_transitioning = false;
            Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["s" /* removeClass */])(document.body, 'modal-open');
            this.$nextTick(function () {
                _this3.is_hidden = _this3.lazy || false;
                _this3.returnFocusTo();
                var hiddenEvt = new __WEBPACK_IMPORTED_MODULE_5__utils_bv_event_class__["a" /* default */]('hidden', {
                    cancelable: false,
                    vueTarget: _this3,
                    target: _this3.lazy ? null : _this3.$refs.modal,
                    relatedTarget: null
                });
                _this3.emitEvent(hiddenEvt);
            });
        },

        // Event emitter
        emitEvent: function emitEvent(bvEvt) {
            var type = bvEvt.type;
            this.$emit(type, bvEvt);
            this.$root.$emit('bv::modal::' + type, bvEvt);
        },

        // UI Event Handlers
        onClickOut: function onClickOut(evt) {
            // If backdrop clicked, hide modal
            if (this.is_visible && !this.noCloseOnBackdrop) {
                this.hide('backdrop');
            }
        },
        onEsc: function onEsc(evt) {
            // If ESC pressed, hide modal
            if (evt.keyCode === __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* KeyCodes */].ESC && this.is_visible && !this.noCloseOnEsc) {
                this.hide('esc');
            }
        },
        onFocusout: function onFocusout(evt) {
            // If focus leaves modal, bring it back
            // 'focusout' Event Listener bound on content
            var content = this.$refs.content;
            if (!this.noEnforceFocus && this.is_visible && content && !content.contains(evt.relatedTarget)) {
                content.focus();
            }
        },

        // Resize Listener
        setResizeEvent: function setResizeEvent(on) {
            var _this4 = this;

            ['resize', 'orientationchange'].forEach(function (evtName) {
                if (on) {
                    Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["d" /* eventOn */])(window, evtName, _this4.adjustDialog);
                } else {
                    Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["c" /* eventOff */])(window, evtName, _this4.adjustDialog);
                }
            });
        },

        // Root Listener handlers
        showHandler: function showHandler(id, triggerEl) {
            if (id === this.id) {
                this.return_focus = triggerEl || null;
                this.show();
            }
        },
        hideHandler: function hideHandler(id) {
            if (id === this.id) {
                this.hide();
            }
        },
        modalListener: function modalListener(bvEvt) {
            // If another modal opens, close this one
            if (bvEvt.vueTarget !== this) {
                this.hide();
            }
        },

        // Focus control handlers
        focusFirst: function focusFirst() {
            // Don't try and focus if we are SSR
            if (typeof document === 'undefined') {
                return;
            }
            var content = this.$refs.content;
            var modal = this.$refs.modal;
            var activeElement = document.activeElement;
            if (activeElement && content && content.contains(activeElement)) {
                // If activeElement is child of content, no need to change focus
            } else if (content) {
                if (modal) {
                    modal.scrollTop = 0;
                }
                // Focus the modal content wrapper
                content.focus();
            }
        },
        returnFocusTo: function returnFocusTo() {
            // Prefer returnFocus prop over event specified return_focus value
            var el = this.returnFocus || this.return_focus || null;
            if (typeof el === 'string') {
                // CSS Selector
                el = Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["t" /* select */])(el);
            }
            if (el) {
                el = el.$el || el;
                if (Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["m" /* isVisible */])(el)) {
                    el.focus();
                }
            }
        },

        // Utility methods
        getScrollbarWidth: function getScrollbarWidth() {
            var scrollDiv = document.createElement('div');
            scrollDiv.className = 'modal-scrollbar-measure';
            document.body.appendChild(scrollDiv);
            this.scrollbarWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
            document.body.removeChild(scrollDiv);
        },
        adjustDialog: function adjustDialog() {
            if (!this.is_visible) {
                return;
            }
            var modal = this.$refs.modal;
            var isModalOverflowing = modal.scrollHeight > document.documentElement.clientHeight;
            if (!this.isBodyOverflowing && isModalOverflowing) {
                modal.style.paddingLeft = this.scrollbarWidth + 'px';
            }
            if (this.isBodyOverflowing && !isModalOverflowing) {
                modal.style.paddingRight = this.scrollbarWidth + 'px';
            }
        },
        resetAdjustments: function resetAdjustments() {
            var modal = this.$refs.modal;
            if (modal) {
                modal.style.paddingLeft = '';
                modal.style.paddingRight = '';
            }
        },
        checkScrollbar: function checkScrollbar() {
            var rect = Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["f" /* getBCR */])(document.body);
            this.isBodyOverflowing = rect.left + rect.right < window.innerWidth;
        },
        setScrollbar: function setScrollbar() {
            if (this.isBodyOverflowing) {
                // Note: DOMNode.style.paddingRight returns the actual value or '' if not set
                //   while $(DOMNode).css('padding-right') returns the calculated value or 0 if not set
                var computedStyle = window.getComputedStyle;
                var body = document.body;
                var scrollbarWidth = this.scrollbarWidth;
                // Adjust fixed content padding
                Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["u" /* selectAll */])(Selector.FIXED_CONTENT).forEach(function (el) {
                    var actualPadding = el.style.paddingRight;
                    var calculatedPadding = computedStyle(el).paddingRight || 0;
                    Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["v" /* setAttr */])(el, 'data-padding-right', actualPadding);
                    el.style.paddingRight = parseFloat(calculatedPadding) + scrollbarWidth + 'px';
                });
                // Adjust sticky content margin
                Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["u" /* selectAll */])(Selector.STICKY_CONTENT).forEach(function (el) {
                    var actualMargin = el.style.marginRight;
                    var calculatedMargin = computedStyle(el).marginRight || 0;
                    Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["v" /* setAttr */])(el, 'data-margin-right', actualMargin);
                    el.style.marginRight = parseFloat(calculatedMargin) - scrollbarWidth + 'px';
                });
                // Adjust navbar-toggler margin
                Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["u" /* selectAll */])(Selector.NAVBAR_TOGGLER).forEach(function (el) {
                    var actualMargin = el.style.marginRight;
                    var calculatedMargin = computedStyle(el).marginRight || 0;
                    Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["v" /* setAttr */])(el, 'data-margin-right', actualMargin);
                    el.style.marginRight = parseFloat(calculatedMargin) + scrollbarWidth + 'px';
                });
                // Adjust body padding
                var actualPadding = body.style.paddingRight;
                var calculatedPadding = computedStyle(body).paddingRight;
                Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["v" /* setAttr */])(body, 'data-padding-right', actualPadding);
                body.style.paddingRight = parseFloat(calculatedPadding) + scrollbarWidth + 'px';
            }
        },
        resetScrollbar: function resetScrollbar() {
            // Restore fixed content padding
            Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["u" /* selectAll */])(Selector.FIXED_CONTENT).forEach(function (el) {
                if (Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["i" /* hasAttr */])(el, 'data-padding-right')) {
                    el.style.paddingRight = Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["e" /* getAttr */])(el, 'data-padding-right') || '';
                    Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["r" /* removeAttr */])(el, 'data-padding-right');
                }
            });
            // Restore sticky content and navbar-toggler margin
            Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["u" /* selectAll */])(Selector.STICKY_CONTENT + ', ' + Selector.NAVBAR_TOGGLER).forEach(function (el) {
                if (Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["i" /* hasAttr */])(el, 'data-margin-right')) {
                    el.style.marginRight = Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["e" /* getAttr */])(el, 'data-margin-right') || '';
                    Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["r" /* removeAttr */])(el, 'data-margin-right');
                }
            });
            // Restore body padding
            var body = document.body;
            if (Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["i" /* hasAttr */])(body, 'data-padding-right')) {
                body.style.paddingRight = Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["e" /* getAttr */])(body, 'data-padding-right') || '';
                Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["r" /* removeAttr */])(body, 'data-padding-right');
            }
        }
    },
    created: function created() {
        // create non-reactive property
        this._observer = null;
    },
    mounted: function mounted() {
        // Measure scrollbar
        this.getScrollbarWidth();
        // Listen for events from others to either open or close ourselves
        this.listenOnRoot('bv::show::modal', this.showHandler);
        this.listenOnRoot('bv::hide::modal', this.hideHandler);
        // Listen for bv:modal::show events, and close ourselves if the opening modal not us
        this.listenOnRoot('bv::modal::show', this.modalListener);
        // Initially show modal?
        if (this.visible === true) {
            this.show();
        }
    },
    beforeDestroy: function beforeDestroy() {
        // Ensure everything is back to normal
        if (this._observer) {
            this._observer.disconnect();
            this._observer = null;
        }
        this.setResizeEvent(false);
        // Re-adjust body/navbar/fixed padding/margins (if needed)
        Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["s" /* removeClass */])(document.body, 'modal-open');
        this.resetAdjustments();
        this.resetScrollbar();
    }
});

/***/ }),
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_pagination_vue__ = __webpack_require__(667);
function injectStyle (ssrContext) {
  __webpack_require__(666)
}
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_pagination_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 666 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_dom__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//





var props = {
  perPage: {
    type: Number,
    default: 20
  },
  totalRows: {
    type: Number,
    default: 20
  },
  ariaControls: {
    type: String,
    default: null
  }

  // Our render function is brought in from the pagination mixin
};/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["k" /* paginationMixin */]],
  props: props,
  computed: {
    numberOfPages: function numberOfPages() {
      var result = Math.ceil(this.totalRows / this.perPage);
      return result < 1 ? 1 : result;
    }
  },
  methods: {
    // These methods are used by the render function
    onClick: function onClick(num, evt) {
      var _this = this;

      // Handle edge cases where number of pages has changed (i.e. if perPage changes)
      if (num > this.numberOfPages) {
        num = this.numberOfPages;
      } else if (num < 1) {
        num = 1;
      }
      this.currentPage = num;
      this.$nextTick(function () {
        // Keep the current button focused if possible
        var target = evt.target;
        if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["m" /* isVisible */])(target) && _this.$el.contains(target) && target.focus) {
          target.focus();
        } else {
          _this.focusCurrent();
        }
      });
      this.$emit('change', this.currentPage);
    },
    makePage: function makePage(pagenum) {
      return pagenum;
    },
    linkProps: function linkProps(pagenum) {
      return { href: '#' };
    }
  }
});

/***/ }),
/* 668 */,
/* 669 */,
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_pagination_nav_vue__ = __webpack_require__(672);
function injectStyle (ssrContext) {
  __webpack_require__(671)
}
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_pagination_nav_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 671 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_object__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__link_link__ = __webpack_require__(51);

//
//
//
//
//
//
//
//
//
//
//






// Props needed for router links
var routerProps = Object(__WEBPACK_IMPORTED_MODULE_4__link_link__["b" /* pickLinkProps */])('activeClass', 'exactActiveClass', 'append', 'exact', 'replace', 'target', 'rel');

// Props object
var props = Object(__WEBPACK_IMPORTED_MODULE_1__utils_object__["a" /* assign */])(
// pagination-nav specific props
{
  numberOfPages: {
    type: Number,
    default: 1
  },
  baseUrl: {
    type: String,
    default: '/'
  },
  useRouter: {
    type: Boolean,
    default: false
  },
  linkGen: {
    type: Function,
    default: null
  },
  pageGen: {
    type: Function,
    default: null
  }
},
// Router specific props
routerProps);

// Our render function is brought in via the pagination mixin
/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins__["k" /* paginationMixin */]],
  props: props,
  computed: {
    // Used by render function to trigger wraping in '<nav>' element
    isNav: function isNav() {
      return true;
    }
  },
  methods: {
    onClick: function onClick(pageNum, evt) {
      this.currentPage = pageNum;
    },
    makePage: function makePage(pagenum) {
      if (this.pageGen && typeof this.pageGen === 'function') {
        return this.pageGen(pagenum);
      }
      return pagenum;
    },
    makeLink: function makeLink(pagenum) {
      if (this.linkGen && typeof this.linkGen === 'function') {
        return this.linkGen(pagenum);
      }
      var link = '' + this.baseUrl + pagenum;
      return this.useRouter ? { path: link } : link;
    },
    linkProps: function linkProps(pagenum) {
      var link = this.makeLink(pagenum);
      var props = {
        href: typeof link === 'string' ? link : void 0,
        target: this.target || null,
        rel: this.rel || null,
        disabled: this.disabled
      };
      if (this.useRouter || (typeof link === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(link)) === 'object') {
        props = Object(__WEBPACK_IMPORTED_MODULE_1__utils_object__["a" /* assign */])(props, {
          to: link,
          exact: this.exact,
          activeClass: this.activeClass,
          exactActiveClass: this.exactActiveClass,
          append: this.append,
          replace: this.replace
        });
      }
      return props;
    }
  }
});

/***/ }),
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_progress_vue__ = __webpack_require__(679);
function injectStyle (ssrContext) {
  __webpack_require__(678)
}
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_progress_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 678 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__progress_bar__ = __webpack_require__(256);
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    components: { bProgressBar: __WEBPACK_IMPORTED_MODULE_0__progress_bar__["a" /* default */] },
    render: function render(h) {
        var t = this;
        var childNodes = t.$slots.default;
        if (!childNodes) {
            childNodes = h('b-progress-bar', {
                props: {
                    value: t.value,
                    max: t.max,
                    precision: t.precision,
                    variant: t.variant,
                    animated: t.animated,
                    striped: t.striped,
                    showProgress: t.showProgress,
                    showValue: t.showValue
                }
            });
        }
        return h('div', { class: ['progress'], style: t.progressHeight }, [childNodes]);
    },

    props: {
        // These props can be inherited via the child b-progress-bar(s)
        variant: {
            type: String,
            default: null
        },
        striped: {
            type: Boolean,
            default: false
        },
        animated: {
            type: Boolean,
            default: false
        },
        height: {
            type: String,
            default: null
        },
        precision: {
            type: Number,
            default: 0
        },
        showProgress: {
            type: Boolean,
            default: false
        },
        showValue: {
            type: Boolean,
            default: false
        },
        max: {
            type: Number,
            default: 100
        },
        // This prop is not inherited by child b-progress-bar(s)
        value: {
            type: Number,
            default: 0
        }
    },
    computed: {
        progressHeight: function progressHeight() {
            return { height: this.height || null };
        }
    }
});

/***/ }),
/* 680 */,
/* 681 */,
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_table_vue__ = __webpack_require__(684);
function injectStyle (ssrContext) {
  __webpack_require__(683)
}
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_table_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 683 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_object__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_array__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_startcase__ = __webpack_require__(685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_startcase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_startcase__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







function toString(v) {
  if (!v) {
    return '';
  }
  if (v instanceof Object) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__utils_object__["e" /* keys */])(v).map(function (k) {
      return toString(v[k]);
    }).join(' ');
  }
  return String(v);
}

function recToString(obj) {
  if (!(obj instanceof Object)) {
    return '';
  }
  return toString(Object(__WEBPACK_IMPORTED_MODULE_2__utils_object__["e" /* keys */])(obj).reduce(function (o, k) {
    // Ignore fields that start with _
    if (!/^_/.test(k)) {
      o[k] = obj[k];
    }
    return o;
  }, {}));
}

function defaultSortCompare(a, b, sortBy) {
  if (typeof a[sortBy] === 'number' && typeof b[sortBy] === 'number') {
    return a[sortBy] < b[sortBy] && -1 || a[sortBy] > b[sortBy] && 1 || 0;
  }
  return toString(a[sortBy]).localeCompare(toString(b[sortBy]), undefined, {
    numeric: true
  });
}

function processField(key, value) {
  var field = null;
  if (typeof value === 'string') {
    // Label shortcut
    field = { key: key, label: value };
  } else if (typeof value === 'function') {
    // Formatter shortcut
    field = { key: key, formatter: value };
  } else if ((typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(value)) === 'object') {
    field = Object(__WEBPACK_IMPORTED_MODULE_2__utils_object__["a" /* assign */])({}, value);
    field.key = field.key || key;
  } else if (value !== false) {
    // Fallback to just key
    field = { key: key };
  }
  return field;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins__["j" /* listenOnRootMixin */]],
  render: function render(h) {
    var t = this;
    var $slots = t.$slots;
    var $scoped = t.$scopedSlots;
    var fields = t.computedFields;
    var items = t.computedItems;

    // Build the caption
    var caption = h(false);
    if (t.caption || $slots['table-caption']) {
      var data = { style: t.captionStyles };
      if (!$slots['table-caption']) {
        data.domProps = { innerHTML: t.caption };
      }
      caption = h('caption', data, $slots['table-caption']);
    }

    // Build the colgroup
    var colgroup = $slots['table-colgroup'] ? h('colgroup', {}, $slots['table-colgroup']) : h(false);

    // Build the thead
    var ths = fields.map(function (field) {
      var data = {
        key: field.key,
        class: t.fieldClasses(field),
        style: field.thStyle || {},
        attrs: {
          'tabindex': field.sortable ? '0' : null,
          'aria-label': field.sortable ? t.localSortDesc && t.localSortBy === field.key ? t.labelSortAsc : t.labelSortDesc : null,
          'aria-sort': field.sortable && t.localSortBy === field.key ? t.localSortDesc ? 'descending' : 'ascending' : null
        },
        on: {
          click: function click(evt) {
            evt.stopPropagation();
            evt.preventDefault();
            t.headClicked(evt, field);
          },
          keydown: function keydown(evt) {
            var keyCode = evt.keyCode;
            if (keyCode === __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* KeyCodes */].ENTER || keyCode === __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* KeyCodes */].SPACE) {
              evt.stopPropagation();
              evt.preventDefault();
              t.headClicked(evt, field);
            }
          }
        }
      };
      var slot = $scoped['HEAD_' + field.key];
      if (slot) {
        slot = slot({ label: field.label, column: field.key, field: field });
      } else {
        data.domProps = { innerHTML: field.label };
      }
      return h('th', data, slot);
    });
    var thead = h('thead', { class: t.headClasses }, [h('tr', {}, ths)]);

    // Build the tfoot
    var tfoot = h(false);
    if (t.footClone) {
      var _ths = fields.map(function (field) {
        var data = {
          key: field.key,
          class: t.fieldClasses(field),
          style: field.thStyle || {},
          attrs: {
            'tabindex': field.sortable ? '0' : null,
            'aria-label': field.sortable ? t.localSortDesc && t.localSortBy === field.key ? t.labelSortAsc : t.labelSortDesc : null,
            'aria-sort': field.sortable && t.localSortBy === field.key ? t.localSortDesc ? 'descending' : 'ascending' : null
          },
          on: {
            click: function click(evt) {
              evt.stopPropagation();
              evt.preventDefault();
              t.headClicked(evt, field);
            },
            keydown: function keydown(evt) {
              var keyCode = evt.keyCode;
              if (keyCode === __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* KeyCodes */].ENTER || keyCode === __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* KeyCodes */].SPACE) {
                evt.stopPropagation();
                evt.preventDefault();
                t.headClicked(evt, field);
              }
            }
          }
        };
        var slot = $scoped['FOOT_' + field.key] ? $scoped['FOOT_' + field.key] : $scoped['HEAD_' + field.key];
        if (slot) {
          slot = [slot({ label: field.label, column: field.key, field: field })];
        } else {
          data.domProps = { innerHTML: field.label };
        }
        return h('th', data, slot);
      });
      tfoot = h('tfoot', { class: t.footClasses }, [h('tr', {}, _ths)]);
    }

    var rows = [];

    // Add static Top Row slot
    if ($scoped['top-row']) {
      rows.push(h('tr', {}, [$scoped['top-row']({ coloumns: fields.length, fields: fields })]));
    } else {
      rows.push(h(false));
    }

    // Add the body rows
    items.forEach(function (item, index) {
      var detailsSlot = $scoped['row-details'];
      // For Each Row
      var tds = fields.map(function (field) {
        // Foe Each field in the row
        var data = {
          key: field.key,
          class: t.tdClasses(field, item),
          attrs: field.tdAttr || {}
        };
        var childNodes = void 0;
        if ($scoped[field.key]) {
          childNodes = [$scoped[field.key]({
            item: item,
            index: index,
            unformatted: item[field.key],
            value: t.getFormattedValue(item, field)
          })];
        } else {
          data.domProps = { innerHTML: t.getFormattedValue(item, field) };
        }
        return h('td', data, childNodes);
      });
      // Assemble and add the row
      rows.push(h('tr', {
        key: index,
        class: [t.rowClasses(item), item._showDetails && detailsSlot ? 'b-table-has-details' : ''],
        on: {
          click: function click(evt) {
            t.rowClicked(evt, item, index);
          },
          dblclick: function dblclick(evt) {
            t.rowDblClicked(evt, item, index);
          },
          mouseenter: function mouseenter(evt) {
            t.rowHovered(evt, item, index);
          }
        }
      }, tds));
      // Row Details slot
      if (item._showDetails && detailsSlot) {
        var details = h('td', { attrs: { colspan: String(fields.length) } }, [detailsSlot({ item: item, index: index, fields: fields })]);
        rows.push(h('tr', { key: index + '-details', class: ['b-table-details'] }, [details]));
      } else {
        rows.push(h(false));
      }
    });

    // Empty Items / Empty Filtered Row slot
    if (t.showEmpty && (!items || items.length === 0)) {
      var inner = t.filter ? $slots['emptyfiltered'] : $slots['empty'];
      if (!inner) {
        inner = h('div', {
          class: ['text-center', 'my-2'],
          domProps: { innerHTML: t.filter ? t.emptyFilteredText : t.emptyText }
        });
      }
      var content = h('div', { attrs: { role: 'alert', 'aria-live': 'polite' } }, [inner]);
      rows.push(h('tr', [h('td', { attrs: { colspan: String(fields.length) } }, [content])]));
    } else {
      rows.push(h(false));
    }

    // Static bottom row slot
    if ($scoped['bottom-row']) {
      rows.push(h('tr', {}, [$scoped['bottom-row']({ columns: fields.length, fields: fields })]));
    } else {
      rows.push(h(false));
    }

    // Assemble the rows into the tbody
    var tbody = h('tbody', {}, rows);

    // Return the assembled table
    return h('table', {
      class: t.tableClasses,
      attrs: { id: t.id || null, 'aria-busy': t.computedBusy ? 'true' : 'false' }
    }, [caption, colgroup, thead, tfoot, tbody]);
  },
  data: function data() {
    return {
      localSortBy: this.sortBy || '',
      localSortDesc: this.sortDesc || false,
      localItems: [],
      // Note: filteredItems only used to determine if # of items changed
      filteredItems: [],
      localBusy: this.busy
    };
  },

  props: {
    id: {
      type: String,
      default: ''
    },
    caption: {
      type: String,
      default: null
    },
    captionTop: {
      type: Boolean,
      default: false
    },
    items: {
      type: [Array, Function],
      default: function _default() {
        return [];
      }
    },
    sortBy: {
      type: String,
      default: null
    },
    sortDesc: {
      type: Boolean,
      default: false
    },
    apiUrl: {
      type: String,
      default: ''
    },
    fields: {
      type: [Object, Array],
      default: null
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    outlined: {
      type: Boolean,
      default: false
    },
    dark: {
      type: Boolean,
      default: function _default() {
        if (this && typeof this.inverse === 'boolean') {
          // Deprecate inverse
          Object(__WEBPACK_IMPORTED_MODULE_1__utils__["n" /* warn */])("b-table: prop 'inverse' has been deprecated. Use 'dark' instead");
          return this.dark;
        }
        return false;
      }
    },
    inverse: {
      // Deprecated in v1.0.0.beta.10 in favor of `dark`
      type: Boolean,
      default: null
    },
    hover: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    responsive: {
      type: [Boolean, String],
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    },
    headVariant: {
      type: String,
      default: ''
    },
    footVariant: {
      type: String,
      default: ''
    },
    perPage: {
      type: Number,
      default: null
    },
    currentPage: {
      type: Number,
      default: 1
    },
    filter: {
      type: [String, RegExp, Function],
      default: null
    },
    sortCompare: {
      type: Function,
      default: null
    },
    noLocalSorting: {
      type: Boolean,
      default: false
    },
    noProviderPaging: {
      type: Boolean,
      default: false
    },
    noProviderSorting: {
      type: Boolean,
      default: false
    },
    noProviderFiltering: {
      type: Boolean,
      default: false
    },
    busy: {
      type: Boolean,
      default: false
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    footClone: {
      type: Boolean,
      default: false
    },
    labelSortAsc: {
      type: String,
      default: 'Click to sort Ascending'
    },
    labelSortDesc: {
      type: String,
      default: 'Click to sort Descending'
    },
    showEmpty: {
      type: Boolean,
      default: false
    },
    emptyText: {
      type: String,
      default: 'There are no records to show'
    },
    emptyFilteredText: {
      type: String,
      default: 'There are no records matching your request'
    }
  },
  watch: {
    items: function items(newVal, oldVal) {
      if (oldVal !== newVal) {
        this._providerUpdate();
      }
    },
    context: function context(newVal, oldVal) {
      if (!Object(__WEBPACK_IMPORTED_MODULE_1__utils__["c" /* looseEqual */])(newVal, oldVal)) {
        this.$emit('context-changed', newVal);
      }
    },
    filteredItems: function filteredItems(newVal, oldVal) {
      if (this.localFiltering && newVal.length !== oldVal.length) {
        // Emit a filtered notification event, as number of filtered items has changed
        this.$emit('filtered', newVal);
      }
    },
    sortDesc: function sortDesc(newVal, oldVal) {
      if (newVal === this.localSortDesc) {
        return;
      }
      this.localSortDesc = newVal || false;
    },
    localSortDesc: function localSortDesc(newVal, oldVal) {
      // Emit update to sort-desc.sync
      if (newVal !== oldVal) {
        this.$emit('update:sortDesc', newVal);
        if (!this.noProviderSorting) {
          this._providerUpdate();
        }
      }
    },
    sortBy: function sortBy(newVal, oldVal) {
      if (newVal === this.localSortBy) {
        return;
      }
      this.localSortBy = newVal || null;
    },
    localSortBy: function localSortBy(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$emit('update:sortBy', newVal);
        if (!this.noProviderSorting) {
          this._providerUpdate();
        }
      }
    },
    perPage: function perPage(newVal, oldVal) {
      if (oldVal !== newVal && !this.noProviderPaging) {
        this._providerUpdate();
      }
    },
    currentPage: function currentPage(newVal, oldVal) {
      if (oldVal !== newVal && !this.noProviderPaging) {
        this._providerUpdate();
      }
    },
    filter: function filter(newVal, oldVal) {
      if (oldVal !== newVal && !this.noProviderFiltering) {
        this._providerUpdate();
      }
    },
    localBusy: function localBusy(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$emit('update:busy', newVal);
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.localSortBy = this.sortBy;
    this.localSortDesc = this.sortDesc;
    this.localBusy = this.busy;
    if (this.hasProvider) {
      this._providerUpdate();
    }
    this.listenOnRoot('bv::refresh::table', function (id) {
      if (id === _this.id || id === _this) {
        _this._providerUpdate();
      }
    });
  },

  computed: {
    tableClasses: function tableClasses() {
      var responsive = this.responsive === '' ? true : this.responsive;
      return ['table', 'b-table', this.striped ? 'table-striped' : '', this.hover ? 'table-hover' : '', this.dark ? 'table-dark' : '', this.bordered ? 'table-bordered' : '', this.outlined ? 'border' : '', responsive === true ? 'table-responsive' : Boolean(responsive) ? 'table-responsive-' + responsive : '', this.fixed ? 'table-fixed' : '', this.small ? 'table-sm' : ''];
    },
    headClasses: function headClasses() {
      return this.headVariant ? 'thead-' + this.headVariant : '';
    },
    footClasses: function footClasses() {
      var variant = this.footVariant || this.headVariant || null;
      return variant ? 'thead-' + variant : '';
    },
    captionStyles: function captionStyles() {
      // Move caption to top
      return this.captionTop ? { captionSide: 'top' } : {};
    },
    hasProvider: function hasProvider() {
      return this.items instanceof Function;
    },
    localFiltering: function localFiltering() {
      return this.hasProvider ? this.noProviderFiltering : true;
    },
    localSorting: function localSorting() {
      return this.hasProvider ? this.noProviderSorting : !this.noLocalSorting;
    },
    localPaging: function localPaging() {
      return this.hasProvider ? this.noProviderPaging : true;
    },
    context: function context() {
      return {
        perPage: this.perPage,
        currentPage: this.currentPage,
        filter: this.filter,
        apiUrl: this.apiUrl,
        sortBy: this.localSortBy,
        sortDesc: this.localSortDesc
      };
    },
    computedFields: function computedFields() {
      var _this2 = this;

      // We normalize fields into an array of objects
      // [ { key:..., label:..., ...}, {...}, ..., {..}]
      var fields = [];
      if (Object(__WEBPACK_IMPORTED_MODULE_3__utils_array__["d" /* isArray */])(this.fields)) {
        // Normalize array Form
        this.fields.filter(function (f) {
          return f;
        }).forEach(function (f) {
          if (typeof f === 'string') {
            fields.push({ key: f, label: __WEBPACK_IMPORTED_MODULE_5_lodash_startcase___default()(f) });
          } else if ((typeof f === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(f)) === 'object' && f.key && typeof f.key === 'string') {
            // Full object definition. We use assign so that we don't mutate the original
            fields.push(Object(__WEBPACK_IMPORTED_MODULE_2__utils_object__["a" /* assign */])({}, f));
          } else if ((typeof f === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(f)) === 'object' && Object(__WEBPACK_IMPORTED_MODULE_2__utils_object__["e" /* keys */])(f).length === 1) {
            // Shortcut object (i.e. { 'foo_bar': 'This is Foo Bar' }
            var key = Object(__WEBPACK_IMPORTED_MODULE_2__utils_object__["e" /* keys */])(f)[0];
            var field = processField(key, f[key]);
            if (field) {
              fields.push(field);
            }
          }
        });
      } else if (this.fields && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.fields) === 'object' && Object(__WEBPACK_IMPORTED_MODULE_2__utils_object__["e" /* keys */])(this.fields).length > 0) {
        // Normalize object Form
        Object(__WEBPACK_IMPORTED_MODULE_2__utils_object__["e" /* keys */])(this.fields).forEach(function (key) {
          var field = processField(key, _this2.fields[key]);
          if (field) {
            fields.push(field);
          }
        });
      }
      // If no field provided, take a sample from first record (if exits)
      if (fields.length === 0 && this.computedItems.length > 0) {
        var sample = this.computedItems[0];
        Object(__WEBPACK_IMPORTED_MODULE_2__utils_object__["e" /* keys */])(sample).forEach(function (k) {
          fields.push({ key: k, label: __WEBPACK_IMPORTED_MODULE_5_lodash_startcase___default()(k) });
        });
      }
      // Ensure we have a unique array of fields and that they have labels
      var memo = {};
      return fields.filter(function (f) {
        if (!memo[f.key]) {
          memo[f.key] = true;
          f.label = f.label || __WEBPACK_IMPORTED_MODULE_5_lodash_startcase___default()(f.key);
          return true;
        }
        return false;
      });
    },
    computedItems: function computedItems() {
      // Grab some props/data to ensure reactivity
      var perPage = this.perPage;
      var currentPage = this.currentPage;
      var filter = this.filter;
      var sortBy = this.localSortBy;
      var sortDesc = this.localSortDesc;
      var sortCompare = this.sortCompare;
      var localFiltering = this.localFiltering;
      var localSorting = this.localSorting;
      var localPaging = this.localPaging;
      var items = this.hasProvider ? this.localItems : this.items;
      if (!items) {
        this.$nextTick(this._providerUpdate);
        return [];
      }
      // Array copy for sorting, filtering, etc.
      items = items.slice();
      // Apply local filter
      if (filter && localFiltering) {
        if (filter instanceof Function) {
          items = items.filter(filter);
        } else {
          var regex = void 0;
          if (filter instanceof RegExp) {
            regex = filter;
          } else {
            regex = new RegExp('.*' + filter + '.*', 'ig');
          }
          items = items.filter(function (item) {
            var test = regex.test(recToString(item));
            regex.lastIndex = 0;
            return test;
          });
        }
      }
      if (localFiltering) {
        // Make a local copy of filtered items to trigger filtered event
        this.filteredItems = items.slice();
      }
      // Apply local Sort
      if (sortBy && localSorting) {
        items = items.sort(function sortItemsFn(a, b) {
          var ret = null;
          if (typeof sortCompare === 'function') {
            // Call user provided sortCompare routine
            ret = sortCompare(a, b, sortBy);
          }
          if (ret === null || ret === undefined) {
            // Fallback to defaultSortCompare if sortCompare not defined or returns null
            ret = defaultSortCompare(a, b, sortBy);
          }
          // Handle sorting direction
          return (ret || 0) * (sortDesc ? -1 : 1);
        });
      }
      // Apply local pagination
      if (Boolean(perPage) && localPaging) {
        // Grab the current page of data (which may be past filtered items)
        items = items.slice((currentPage - 1) * perPage, currentPage * perPage);
      }
      // Update the value model with the filtered/sorted/paginated data set
      this.$emit('input', items);
      return items;
    },
    computedBusy: function computedBusy() {
      return this.busy || this.localBusy;
    }
  },
  methods: {
    keys: __WEBPACK_IMPORTED_MODULE_2__utils_object__["e" /* keys */],
    fieldClasses: function fieldClasses(field) {
      return [field.sortable ? 'sorting' : '', field.sortable && this.localSortBy === field.key ? 'sorting_' + (this.localSortDesc ? 'desc' : 'asc') : '', field.variant ? 'table-' + field.variant : '', field.class ? field.class : '', field.thClass ? field.thClass : ''];
    },
    tdClasses: function tdClasses(field, item) {
      var cellVariant = '';
      if (item._cellVariants && item._cellVariants[field.key]) {
        cellVariant = (this.dark ? 'bg' : 'table') + '-' + item._cellVariants[field.key];
      }
      return [field.variant && !cellVariant ? (this.dark ? 'bg' : 'table') + '-' + field.variant : '', cellVariant, field.class ? field.class : '', field.tdClass ? field.tdClass : ''];
    },
    rowClasses: function rowClasses(item) {
      return [item._rowVariant ? (this.dark ? 'bg' : 'table') + '-' + item._rowVariant : ''];
    },
    rowClicked: function rowClicked(e, item, index) {
      if (this.stopIfBusy(e)) {
        // If table is busy (via provider) then don't propagate
        return;
      }
      this.$emit('row-clicked', item, index, e);
    },
    rowDblClicked: function rowDblClicked(e, item, index) {
      if (this.stopIfBusy(e)) {
        // If table is busy (via provider) then don't propagate
        return;
      }
      this.$emit('row-dblclicked', item, index, e);
    },
    rowHovered: function rowHovered(e, item, index) {
      if (this.stopIfBusy(e)) {
        // If table is busy (via provider) then don't propagate
        return;
      }
      this.$emit('row-hovered', item, index, e);
    },
    headClicked: function headClicked(e, field) {
      if (this.stopIfBusy(e)) {
        // If table is busy (via provider) then don't propagate
        return;
      }
      var sortChanged = false;
      if (field.sortable) {
        if (field.key === this.localSortBy) {
          // Change sorting direction on current column
          this.localSortDesc = !this.localSortDesc;
        } else {
          // Start sorting this column ascending
          this.localSortBy = field.key;
          this.localSortDesc = false;
        }
        sortChanged = true;
      } else if (this.localSortBy) {
        this.localSortBy = null;
        this.localSortDesc = false;
        sortChanged = true;
      }
      this.$emit('head-clicked', field.key, field, e);
      if (sortChanged) {
        // Sorting parameters changed
        this.$emit('sort-changed', this.context);
      }
    },
    stopIfBusy: function stopIfBusy(evt) {
      if (this.computedBusy) {
        // If table is busy (via provider) then don't propagate
        evt.preventDefault();
        evt.stopPropagation();
        return true;
      }
      return false;
    },
    refresh: function refresh() {
      // Expose refresh method
      if (this.hasProvider) {
        this._providerUpdate();
      }
    },
    _providerSetLocal: function _providerSetLocal(items) {
      this.localItems = items && items.length > 0 ? items.slice() : [];
      this.localBusy = false;
      this.$emit('refreshed');
      this.emitOnRoot('table::refreshed', this.id);
    },
    _providerUpdate: function _providerUpdate() {
      var _this3 = this;

      // Refresh the provider items
      if (this.computedBusy || !this.hasProvider) {
        // Don't refresh remote data if we are 'busy' or if no provider
        return;
      }
      // Set internal busy state
      this.localBusy = true;
      // Call provider function with context and optional callback
      var data = this.items(this.context, this._providerSetLocal);
      if (data) if (data.then && typeof data.then === 'function') {
        // Provider returned Promise
        data.then(function (items) {
          _this3._providerSetLocal(items);
        });
      } else {
        // Provider returned Array data
        this._providerSetLocal(data);
      }
    },
    getFormattedValue: function getFormattedValue(item, field) {
      var key = field.key;
      var formatter = field.formatter;
      var parent = this.$parent;
      var value = item[key];
      if (formatter) {
        if (typeof formatter === 'function') {
          value = formatter(value, key, item);
        } else if (typeof formatter === 'string' && typeof parent[formatter] === 'function') {
          value = parent[formatter](value, key, item);
        }
      }
      return value;
    }
  }
});

/***/ }),
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var icons = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'icon',
  props: {
    name: {
      type: String,
      validator: function validator(val) {
        if (val) {
          if (!(val in icons)) {
            console.warn('Invalid prop: prop "name" is referring to an unregistered icon "' + val + '".' + '\nPlesase make sure you have imported this icon before using it.');
            return false;
          }
          return true;
        }
        console.warn('Invalid prop: prop "name" is required.');
        return false;
      }
    },
    scale: [Number, String],
    spin: Boolean,
    inverse: Boolean,
    pulse: Boolean,
    flip: {
      validator: function validator(val) {
        return val === 'horizontal' || val === 'vertical';
      }
    },
    label: String
  },
  data: function data() {
    return {
      x: false,
      y: false,
      childrenWidth: 0,
      childrenHeight: 0,
      outerScale: 1
    };
  },

  computed: {
    normalizedScale: function normalizedScale() {
      var scale = this.scale;
      scale = typeof scale === 'undefined' ? 1 : Number(scale);
      if (isNaN(scale) || scale <= 0) {
        console.warn('Invalid prop: prop "scale" should be a number over 0.', this);
        return this.outerScale;
      }
      return scale * this.outerScale;
    },
    klass: function klass() {
      return {
        'fa-icon': true,
        'fa-spin': this.spin,
        'fa-flip-horizontal': this.flip === 'horizontal',
        'fa-flip-vertical': this.flip === 'vertical',
        'fa-inverse': this.inverse,
        'fa-pulse': this.pulse
      };
    },
    icon: function icon() {
      if (this.name) {
        return icons[this.name];
      }
      return null;
    },
    box: function box() {
      if (this.icon) {
        return '0 0 ' + this.icon.width + ' ' + this.icon.height;
      }
      return '0 0 ' + this.width + ' ' + this.height;
    },
    ratio: function ratio() {
      if (!this.icon) {
        return 1;
      }
      var _icon = this.icon,
          width = _icon.width,
          height = _icon.height;

      return Math.max(width, height) / 16;
    },
    width: function width() {
      return this.childrenWidth || this.icon && this.icon.width / this.ratio * this.normalizedScale || 0;
    },
    height: function height() {
      return this.childrenHeight || this.icon && this.icon.height / this.ratio * this.normalizedScale || 0;
    },
    style: function style() {
      if (this.normalizedScale === 1) {
        return false;
      }
      return {
        fontSize: this.normalizedScale + 'em'
      };
    },
    raw: function raw() {
      // generate unique id for each icon's SVG element with ID
      if (!this.icon || !this.icon.raw) {
        return null;
      }
      var raw = this.icon.raw;
      var ids = {};
      raw = raw.replace(/\s(?:xml:)?id=["']?([^"')\s]+)/g, function (match, id) {
        var uniqueId = getId();
        ids[id] = uniqueId;
        return ' id="' + uniqueId + '"';
      });
      raw = raw.replace(/#(?:([^'")\s]+)|xpointer\(id\((['"]?)([^')]+)\2\)\))/g, function (match, rawId, _, pointerId) {
        var id = rawId || pointerId;
        if (!id || !ids[id]) {
          return match;
        }

        return '#' + ids[id];
      });

      return raw;
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.icon) {
      return;
    }
    this.$children.forEach(function (child) {
      child.outerScale = _this.normalizedScale;
    });
    var width = 0;
    var height = 0;
    this.$children.forEach(function (child) {
      width = Math.max(width, child.width);
      height = Math.max(height, child.height);
    });
    this.childrenWidth = width;
    this.childrenHeight = height;
    this.$children.forEach(function (child) {
      child.x = (width - child.width) / 2;
      child.y = (height - child.height) / 2;
    });
  },
  register: function register(data) {
    for (var name in data) {
      var icon = data[name];

      if (!icon.paths) {
        icon.paths = [];
      }
      if (icon.d) {
        icon.paths.push({ d: icon.d });
      }

      if (!icon.polygons) {
        icon.polygons = [];
      }
      if (icon.points) {
        icon.polygons.push({ points: icon.points });
      }

      icons[name] = icon;
    }
  },

  icons: icons
});

var cursor = 0xd4937;
function getId() {
  return 'fa-' + (cursor++).toString(16);
}

/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:_vm.klass,style:(_vm.style),attrs:{"version":"1.1","role":_vm.label ? 'img' : 'presentation',"aria-label":_vm.label,"x":_vm.x,"y":_vm.y,"width":_vm.width,"height":_vm.height,"viewBox":_vm.box}},[_vm._t("default",[(_vm.icon && _vm.icon.paths)?_vm._l((_vm.icon.paths),function(path,i){return _c('path',_vm._b({key:("path-" + i)},'path',path,false))}):_vm._e(),_vm._v(" "),(_vm.icon && _vm.icon.polygons)?_vm._l((_vm.icon.polygons),function(polygon,i){return _c('polygon',_vm._b({key:("polygon-" + i)},'polygon',polygon,false))}):_vm._e(),_vm._v("\b\n    "),(_vm.icon && _vm.icon.raw)?[_c('g',{domProps:{"innerHTML":_vm._s(_vm.raw)}})]:_vm._e()])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */,
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */,
/* 1239 */,
/* 1240 */,
/* 1241 */,
/* 1242 */,
/* 1243 */,
/* 1244 */,
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */,
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */,
/* 1256 */,
/* 1257 */,
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */,
/* 1269 */,
/* 1270 */,
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */,
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */,
/* 1298 */,
/* 1299 */,
/* 1300 */,
/* 1301 */,
/* 1302 */,
/* 1303 */,
/* 1304 */,
/* 1305 */,
/* 1306 */,
/* 1307 */,
/* 1308 */,
/* 1309 */,
/* 1310 */,
/* 1311 */,
/* 1312 */,
/* 1313 */,
/* 1314 */,
/* 1315 */,
/* 1316 */,
/* 1317 */,
/* 1318 */,
/* 1319 */,
/* 1320 */,
/* 1321 */,
/* 1322 */,
/* 1323 */,
/* 1324 */,
/* 1325 */,
/* 1326 */,
/* 1327 */,
/* 1328 */,
/* 1329 */,
/* 1330 */,
/* 1331 */,
/* 1332 */,
/* 1333 */,
/* 1334 */,
/* 1335 */,
/* 1336 */,
/* 1337 */,
/* 1338 */,
/* 1339 */,
/* 1340 */,
/* 1341 */,
/* 1342 */,
/* 1343 */,
/* 1344 */,
/* 1345 */,
/* 1346 */,
/* 1347 */,
/* 1348 */,
/* 1349 */,
/* 1350 */,
/* 1351 */,
/* 1352 */,
/* 1353 */,
/* 1354 */,
/* 1355 */,
/* 1356 */,
/* 1357 */,
/* 1358 */,
/* 1359 */,
/* 1360 */,
/* 1361 */,
/* 1362 */,
/* 1363 */,
/* 1364 */,
/* 1365 */,
/* 1366 */,
/* 1367 */,
/* 1368 */,
/* 1369 */,
/* 1370 */,
/* 1371 */,
/* 1372 */,
/* 1373 */,
/* 1374 */,
/* 1375 */,
/* 1376 */,
/* 1377 */,
/* 1378 */,
/* 1379 */,
/* 1380 */,
/* 1381 */,
/* 1382 */,
/* 1383 */,
/* 1384 */,
/* 1385 */,
/* 1386 */,
/* 1387 */,
/* 1388 */,
/* 1389 */,
/* 1390 */,
/* 1391 */,
/* 1392 */,
/* 1393 */,
/* 1394 */,
/* 1395 */,
/* 1396 */,
/* 1397 */,
/* 1398 */,
/* 1399 */,
/* 1400 */,
/* 1401 */,
/* 1402 */,
/* 1403 */,
/* 1404 */,
/* 1405 */,
/* 1406 */,
/* 1407 */,
/* 1408 */,
/* 1409 */,
/* 1410 */,
/* 1411 */,
/* 1412 */,
/* 1413 */,
/* 1414 */,
/* 1415 */,
/* 1416 */,
/* 1417 */,
/* 1418 */,
/* 1419 */,
/* 1420 */,
/* 1421 */,
/* 1422 */,
/* 1423 */,
/* 1424 */,
/* 1425 */,
/* 1426 */,
/* 1427 */,
/* 1428 */,
/* 1429 */,
/* 1430 */,
/* 1431 */,
/* 1432 */,
/* 1433 */,
/* 1434 */,
/* 1435 */,
/* 1436 */,
/* 1437 */,
/* 1438 */,
/* 1439 */,
/* 1440 */,
/* 1441 */,
/* 1442 */,
/* 1443 */,
/* 1444 */,
/* 1445 */,
/* 1446 */,
/* 1447 */,
/* 1448 */,
/* 1449 */,
/* 1450 */,
/* 1451 */,
/* 1452 */,
/* 1453 */,
/* 1454 */,
/* 1455 */,
/* 1456 */,
/* 1457 */,
/* 1458 */,
/* 1459 */,
/* 1460 */,
/* 1461 */,
/* 1462 */,
/* 1463 */,
/* 1464 */,
/* 1465 */,
/* 1466 */,
/* 1467 */,
/* 1468 */,
/* 1469 */,
/* 1470 */,
/* 1471 */,
/* 1472 */,
/* 1473 */,
/* 1474 */,
/* 1475 */,
/* 1476 */,
/* 1477 */,
/* 1478 */,
/* 1479 */,
/* 1480 */,
/* 1481 */,
/* 1482 */,
/* 1483 */,
/* 1484 */,
/* 1485 */,
/* 1486 */,
/* 1487 */,
/* 1488 */,
/* 1489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(1491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_94ebee48_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(1493);
function injectStyle (ssrContext) {
  __webpack_require__(1490)
}
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_94ebee48_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1490 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package__ = __webpack_require__(1492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__package__);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  mounted: function mounted() {
    document.title = 'webcg-studio ' + __WEBPACK_IMPORTED_MODULE_0__package__["version"];
  },

  watch: {
    $keycloak: {
      handler: function handler(val) {
        var _this = this;

        window.clearInterval(this.updateKeycloakTokenId);
        if (val.ready && !val.authenticated) {
          var url = this.$env.MANAGER_URL;
          if (url) {
            console.log('[app] redirecting to ' + url);
            window.location = url;
          } else {
            console.error('[app] no authentication endpoint configured. Specify MANAGER_URL and/or KEYCLOAK_URL.');
          }
        }
        if (val.ready && val.authenticated) {
          this.updateKeycloakTokenId = window.setInterval(function () {
            console.debug('[app] updating keycloak token');
            val.updateToken().then(function () {
              console.debug('[app] keycloak token updated');
            }).catch(function () {
              window.clearInterval(_this.updateKeycloakTokenId);
              console.debug('[app] failed to update keycloak token');
            });
          }, 3 * 60 * 1000);
        }
      },
      deep: true
    }
  }
});

/***/ }),
/* 1492 */
/***/ (function(module, exports) {

module.exports = {"name":"webcg-studio","version":"4.2.0","description":"A Vue.js project","author":"Reto Inderbitzin <mail@indr.ch>","private":true,"scripts":{"dev":"node build/dev-server.js","start":"node build/dev-server.js","build":"node build/build.js","build:docker":"npm run build && func() { docker build -t usmedia/webcg-studio:latest -t usmedia/webcg-studio:$npm_package_version -t nexus.upstream-cloud.ch:48082/usmedia/webcg-studio:latest -t nexus.upstream-cloud.ch:48082/usmedia/webcg-studio:$npm_package_version .; }; func","unit":"cross-env BABEL_ENV=test karma start test/unit/karma.conf.js --single-run","unit:watch":"cross-env BABEL_ENV=test karma start test/unit/karma.conf.js --auto-watch","e2e":"node test/e2e/runner.js","test":"npm run unit && npm run e2e","lint":"eslint --ext .js,.vue src test/unit/specs test/e2e/specs","release":"standard-version --commit-all","deploy:docker":"func() { docker push nexus.upstream-cloud.ch:48082/usmedia/webcg-studio:$npm_package_version; docker push nexus.upstream-cloud.ch:48082/usmedia/webcg-studio:latest; }; func","deploy:heroku-1":"git push -f heroku-1 `git subtree split --prefix dist`:master","deploy:heroku-2":"git push -f heroku-2 `git subtree split --prefix dist`:master"},"dependencies":{"@adonisjs/websocket-client":"^1.0.9","axios":"^0.18.0","keycloak-js":"^26.2.0","lodash.startcase":"^4.4.0","vue":"^2.5.9","vue-analytics":"^5.5.0","vue-awesome":"^2.3.4","vue-picture-input":"git+https://github.com/indr/vue-picture-input.git","vue-router":"^3.0.1","vuex":"^3.0.1"},"devDependencies":{"@babel/polyfill":"^7.7.0","autoprefixer":"^7.1.6","babel-core":"^6.22.1","babel-eslint":"^8.0.2","babel-loader":"^7.1.1","babel-plugin-istanbul":"^4.1.1","babel-plugin-transform-runtime":"^6.22.0","babel-polyfill":"^6.26.0","babel-preset-env":"^1.3.2","babel-preset-stage-2":"^6.22.0","babel-register":"^6.22.0","bootstrap":"^4.0.0-beta.2","bootstrap-vue":"1.2.0","chai":"^4.1.2","chalk":"^2.3.0","chromedriver":"^2.33.2","connect-history-api-fallback":"^1.5.0","copy-webpack-plugin":"^4.2.3","cross-env":"^5.1.1","cross-spawn":"^5.0.1","css-loader":"^0.28.0","cssnano":"^3.10.0","eslint":"^4.12.0","eslint-config-standard":"^10.2.1","eslint-friendly-formatter":"^3.0.0","eslint-loader":"^1.7.1","eslint-plugin-html":"^4.0.1","eslint-plugin-import":"^2.8.0","eslint-plugin-node":"^5.2.1","eslint-plugin-promise":"^3.4.0","eslint-plugin-standard":"^3.0.1","eventsource-polyfill":"^0.9.6","express":"^4.14.1","extract-text-webpack-plugin":"^3.0.2","file-loader":"^1.1.5","friendly-errors-webpack-plugin":"^1.1.3","html-webpack-plugin":"^2.28.0","http-proxy-middleware":"^0.17.3","inject-loader":"^3.0.0","karma":"^1.4.1","karma-coverage":"^1.1.1","karma-mocha":"^1.3.0","karma-phantomjs-launcher":"^1.0.2","karma-phantomjs-shim":"^1.4.0","karma-sinon-chai":"^1.3.3","karma-sourcemap-loader":"^0.3.7","karma-spec-reporter":"0.0.31","karma-webpack":"^2.0.6","keyboardjs":"^2.4.1","lolex":"^2.3.1","mocha":"^4.0.1","nightwatch":"^0.9.12","node-sass":"^5.0.0","opn":"^5.1.0","optimize-css-assets-webpack-plugin":"^3.2.0","ora":"^1.2.0","phantomjs-prebuilt":"^2.1.16","rimraf":"^2.6.0","sass-loader":"^6.0.6","selenium-server":"^3.7.1","semver":"^5.3.0","shelljs":"^0.7.6","sinon":"^2.4.1","sinon-chai":"^2.8.0","standard-version":"^6.0.1","tinycolor2":"^1.4.1","url-loader":"^0.6.2","vue-loader":"^13.5.0","vue-style-loader":"^3.0.1","vue-template-compiler":"^2.5.9","webpack":"^3.8.1","webpack-bundle-analyzer":"^2.9.1","webpack-dev-middleware":"^1.12.2","webpack-hot-middleware":"^2.21.0","webpack-merge":"^4.1.1","xlsx":"^0.17.0"},"engines":{"node":"12.x","npm":"6.x"},"browserslist":["> 1%","last 2 versions","not ie <= 8"],"standard-version":{"scripts":{"postbump":"npm --prefix dist/ --no-git-tag-version version $(node -e \"console.log(require('./package.json').version)\") && npm run build && git add ."}}}

/***/ }),
/* 1493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(1495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_analytics__ = __webpack_require__(1496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layout__ = __webpack_require__(1497);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  // Keycloak doesn't work with hash mode, because
  // the redirection gets messed up and results in an
  // infinite redirection loop or bad gateway.
  // @see https://router.vuejs.org/en/essentials/history-mode.html
  mode: 'history',
  // Don't fallback to hash mode when the browser does not
  // support history.pushState
  // @see https://router.vuejs.org/en/api/options.html#fallback
  fallback: false,
  routes: [{
    path: '/workspace',
    name: 'Workspace',
    component: __WEBPACK_IMPORTED_MODULE_3__layout__["b" /* Workspace */],
    meta: { auth: true }
  }, {
    path: '/:accountId/workspace',
    name: 'AccountWorkspace',
    component: __WEBPACK_IMPORTED_MODULE_3__layout__["b" /* Workspace */],
    meta: { auth: true }
  }, {
    path: '/:accountId',
    name: 'AccountWelcome',
    component: __WEBPACK_IMPORTED_MODULE_3__layout__["a" /* Welcome */]
  }, {
    path: '/',
    name: 'Welcome',
    component: __WEBPACK_IMPORTED_MODULE_3__layout__["a" /* Welcome */]
  }]
});

router.beforeEach(function (to, from, next) {
  if (!to.matched.some(function (record) {
    return record.meta.auth;
  })) {
    return next();
  }

  // Not sure on how to access keycloak
  var keycloak = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]().$keycloak;
  if (keycloak.ready && keycloak.authenticated) {
    // Allow transition if keycloak authenticated user
    return next();
  } else {
    // Transition to index/welcome page
    if (to.params.accountId) {
      return next('/' + to.params.accountId);
    }
    return next('/');
  }
});

if (Object({"NODE_ENV":"production","WEBCG_API":null,"WEBCG_PRODUCER":null,"KEYCLOAK_URL":"https://sso.helveticstreams.ch","KEYCLOAK_REALM":"helvetic-streams","KEYCLOAK_CLIENT":"webcg-studio","MANAGER_API":"https://api.upstream-cloud.ch/mam/api","MANAGER_URL":"https://studio.helveticstreams.ch/","TENANT_ID":"default","DEFAULT_ROLES":["sstv"]}).GOOGLE_ANALYTICS_ID) {
  __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_analytics___default.a, {
    id: Object({"NODE_ENV":"production","WEBCG_API":null,"WEBCG_PRODUCER":null,"KEYCLOAK_URL":"https://sso.helveticstreams.ch","KEYCLOAK_REALM":"helvetic-streams","KEYCLOAK_CLIENT":"webcg-studio","MANAGER_API":"https://api.upstream-cloud.ch/mam/api","MANAGER_URL":"https://studio.helveticstreams.ch/","TENANT_ID":"default","DEFAULT_ROLES":["sstv"]}).GOOGLE_ANALYTICS_ID,
    router: router
  });
}

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 1495 */,
/* 1496 */,
/* 1497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__welcome_vue__ = __webpack_require__(1498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__workspace_vue__ = __webpack_require__(1502);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__welcome_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__workspace_vue__["a"]; });





/***/ }),
/* 1498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_welcome_vue__ = __webpack_require__(1500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0737af1c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_welcome_vue__ = __webpack_require__(1501);
function injectStyle (ssrContext) {
  __webpack_require__(1499)
}
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0737af1c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_welcome_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0737af1c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_welcome_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1499 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_action_types__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'welcome',
  data: function data() {
    return {
      error: null
    };
  },

  computed: {
    hasError: function hasError() {
      return !!(this.error || this.accounts && !this.selectedAccount);
    },
    status: function status() {
      if (this.error) return 'Failed to fetch accounts';
      if (!this.authenticated) return 'Authenticating...';
      if (!this.accounts) return 'Fetching accounts...';
      if (!this.selectedAccount) {
        var accountId = this.$route.params.accountId;
        return accountId ? 'Account \'' + accountId + '\' does not exist' : 'Account does not exist';
      }
      if (!this.connected) return 'Connecting...';
      return 'Loading...';
    },
    authenticated: function authenticated() {
      return this.$keycloak.authenticated;
    },
    accounts: function accounts() {
      return this.$store.getters.accounts;
    },
    selectedAccount: function selectedAccount() {
      return this.$store.getters.selectedAccount;
    },
    connected: function connected() {
      return this.$store.getters.connected;
    }
  },
  created: function created() {
    this.checkAndFetchAccounts();
    this.transitionToWorkspace();
  },

  methods: {
    checkAndFetchAccounts: function checkAndFetchAccounts() {
      var _this = this;

      if (this.authenticated && !this.accounts) {
        this.error = null;
        this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_action_types__["o" /* FETCH_ACCOUNTS */], {
          keycloak: this.$keycloak,
          env: this.$env,
          accountId: this.$route.params.accountId
        }).catch(function (error) {
          _this.error = error;
        });
      }
    },
    transitionToWorkspace: function transitionToWorkspace() {
      if (this.connected && this.authenticated && this.selectedAccount) {
        if (this.$route.params.accountId) {
          this.$router.push('/' + this.$route.params.accountId + '/workspace');
        } else {
          this.$router.push('/' + this.selectedAccount.accountId + '/workspace');
        }
      }
    }
  },
  watch: {
    authenticated: function authenticated(val) {
      if (val) {
        this.checkAndFetchAccounts();
      }
      this.transitionToWorkspace();
    },
    selectedAccount: function selectedAccount() {
      this.transitionToWorkspace();
    },
    connected: function connected() {
      this.transitionToWorkspace();
    }
  }
});

/***/ }),
/* 1501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"welcome"},[_c('h1',[_vm._v("webcg-studio")]),_vm._v(" "),_c('p',[_vm._v("\n    "+_vm._s(_vm.status)+"\n    "),(!_vm.hasError)?_c('icon',{staticClass:"fa-spin",attrs:{"name":"spinner"}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_workspace_vue__ = __webpack_require__(1504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6599f475_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_workspace_vue__ = __webpack_require__(1563);
function injectStyle (ssrContext) {
  __webpack_require__(1503)
}
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_workspace_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6599f475_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_workspace_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1503 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__navbar__ = __webpack_require__(1506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__notifications__ = __webpack_require__(1548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_draggable_resizable__ = __webpack_require__(1552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_action_types__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Navbar: __WEBPACK_IMPORTED_MODULE_1__navbar__["a" /* default */], Notifications: __WEBPACK_IMPORTED_MODULE_2__notifications__["a" /* default */], VueDraggableResizable: __WEBPACK_IMPORTED_MODULE_3__vue_draggable_resizable__["a" /* default */] },
  name: 'workspace',
  data: function data() {
    return {
      defaultWidth: 400,
      defaultHeight: 300
    };
  },

  computed: {
    folders: function folders() {
      return this.$store.getters.folders();
    },
    loading: function loading() {
      return this.$store.getters.loading;
    },
    windows: function windows() {
      return this.$store.getters.windows().filter(function (w) {
        return w.visible;
      });
    }
  },
  mounted: function mounted() {
    // Prevent page refresh
    this.$shortcut.bind('f5', function () {});
  },

  methods: {
    /**
     * Returns maximum x for a given window with respect to it's dimension and the workspace size
     * @param window
     * @returns {number}
     */
    getWindowX: function getWindowX(window) {
      if (!window || !window.data) return 0;
      if (!this.$refs.workspace) return window.data.x || 0;
      var maxX = this.$refs.workspace.clientWidth - (window.data.w || this.defaultWidth);
      return Math.max(0, Math.min(window.data.x || 0, maxX)) || 0;
    },

    /**
     * Returns maximum y for a given window with respect to it's dimension and the workspace size.
     * @param window
     * @returns {number}
     */
    getWindowY: function getWindowY(window) {
      if (!window || !window.data) return 0;
      if (!this.$refs.workspace) return window.data.y || 0;
      var maxY = this.$refs.workspace.clientHeight - (window.data.h || this.defaultHeight);
      return Math.max(0, Math.min(window.data.y || 0, maxY)) || 0;
    },

    onResized: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.debounce(function (windowId, x, y, w, h) {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__store_action_types__["F" /* WINDOW_DATA */], { windowId: windowId, data: { x: x, y: y, w: w, h: h } });
    }, 1000),
    onDragged: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.debounce(function (windowId, x, y) {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__store_action_types__["F" /* WINDOW_DATA */], { windowId: windowId, data: { x: x, y: y } });
    }, 1000),
    activated: function activated(windowId) {
      this.$shortcut.setContext(windowId);
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__store_action_types__["C" /* WINDOW_ACTIVATE */], { windowId: windowId });
    }
  }
});

/***/ }),
/* 1505 */,
/* 1506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_navbar_vue__ = __webpack_require__(1507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66d0fc6e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_navbar_vue__ = __webpack_require__(1547);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_navbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66d0fc6e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_navbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_action_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_template_definitions_service__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(50);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'navbar',
  created: function created() {
    this.templateDefinitionsService = new __WEBPACK_IMPORTED_MODULE_3__services_template_definitions_service__["a" /* default */](this.$keycloak, this.$store);
  },
  computed: {
    loaded: function loaded() {
      return !this.$store.getters.loading;
    },
    userTemplates: function userTemplates() {
      var templates = this.templateDefinitionsService.getTemplateDefinitions().filter(function (p) {
        return !p.hidden;
      });
      templates.sort(function (a, b) {
        // if a.sortOrder or b.sortOrder is a number
        if (!isNaN(a.sortOrder) || !isNaN(b.sortOrder)) {
          if (isNaN(a.sortOrder)) return 1;
          if (isNaN(b.sortOrder)) return -1;
          var result = a.sortOrder - b.sortOrder;
          if (result !== 0) return result;
        }
        // if (sortOrder !== 0) return sortOrder
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
      });
      return templates;
    },
    isRaceResult: function isRaceResult() {
      var roles = this.$keycloak.resourceAccess && this.$keycloak.resourceAccess['webcg-studio'] && this.$keycloak.resourceAccess['webcg-studio'].roles;
      roles = roles && roles.length > 0 ? roles : __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].prototype.$env.DEFAULT_ROLES;
      return roles.indexOf('race-result') >= 0;
    },
    hasLibraryRole: function hasLibraryRole() {
      var selectedAccount = this.$store.getters.selectedAccount;
      var templateLibraryPolicies = selectedAccount && selectedAccount.policies && selectedAccount.policies.templateLibrary && selectedAccount.policies.templateLibrary.allow;
      if (templateLibraryPolicies && templateLibraryPolicies.length > 0) {
        return templateLibraryPolicies.some(function (p) {
          return p.startsWith('library:');
        });
      }
      var roles = this.$keycloak.resourceAccess && this.$keycloak.resourceAccess['webcg-studio'] && this.$keycloak.resourceAccess['webcg-studio'].roles;
      roles = roles && roles.length > 0 ? roles : __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].prototype.$env.DEFAULT_ROLES;
      if (typeof roles === 'string') {
        try {
          roles = JSON.parse(roles);
        } catch (e) {}
      }
      return roles.some(function (p) {
        return p.startsWith('library:');
      });
    },
    isUiaa: function isUiaa() {
      var roles = this.$keycloak.resourceAccess && this.$keycloak.resourceAccess['webcg-studio'] && this.$keycloak.resourceAccess['webcg-studio'].roles;
      roles = roles && roles.length > 0 ? roles : __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].prototype.$env.DEFAULT_ROLES;
      return roles.indexOf('uiaa') >= 0;
    },
    albums: function albums() {
      return this.$store.getters.albums();
    },
    datasets: function datasets() {
      var datasets = this.$store.getters.datasets();
      datasets.sort(function (a, b) {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
      });
      return datasets;
    },
    templates: function templates() {
      var templates = this.$store.getters.templates();
      templates.sort(function (a, b) {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
      });
      return templates;
    },
    folders: function folders() {
      // Group templates
      var folders = this.templates.reduce(function (res, template) {
        var name = String(template.folder || '').trim();
        res[name] = (res[name] || []).concat([template]);
        return res;
      }, {});
      // Sort keys
      var keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(folders).sort();
      return keys.reduce(function (res, name) {
        res[name] = folders[name];
        return res;
      }, {});
    },
    windows: function windows() {
      return this.$store.getters.windows();
    },
    username: function username() {
      return this.$keycloak.user.username;
    },
    email: function email() {
      return this.$keycloak.user.email;
    }
  },
  methods: {
    openTemplateSelection: function openTemplateSelection() {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_action_types__["E" /* WINDOW_CREATE */], {
        componentType: 'template-library',
        title: 'Template Library',
        data: {}
      });
    },
    addAlbum: function addAlbum() {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_action_types__["a" /* ALBUM_CREATE */], { componentType: 'album-window' });
    },
    openAlbum: function openAlbum(albumId) {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_action_types__["d" /* ALBUM_OPEN */], { albumId: albumId });
    },
    addDatasetExcel: function addDatasetExcel() {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_action_types__["l" /* DATASET_CREATE */], { componentType: 'dataset-window' });
    },
    addDatasetRaceResult: function addDatasetRaceResult(componentType) {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_action_types__["l" /* DATASET_CREATE */], { componentType: componentType });
    },
    addDatasetUiaa: function addDatasetUiaa(componentType) {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_action_types__["l" /* DATASET_CREATE */], { componentType: componentType });
    },
    openDataset: function openDataset(datasetId) {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_action_types__["n" /* DATASET_OPEN */], { datasetId: datasetId });
    },
    addTemplate: function addTemplate(templateDefinition) {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_action_types__["r" /* TEMPLATE_CREATE */], templateDefinition);
    },
    openTemplate: function openTemplate(templateId) {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_action_types__["x" /* TEMPLATE_OPEN */], { templateId: templateId });
    },
    addProducer: function addProducer(title, channelId) {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_action_types__["E" /* WINDOW_CREATE */], {
        componentType: 'producer-window',
        title: title,
        data: { channelId: channelId, contentId: channelId }
      });
    },
    openWindow: function openWindow(windowId) {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["U" /* WINDOW_OPEN */], { windowId: windowId });
    },
    logout: function logout() {
      this.$keycloak.logout();
    }
  }
});

/***/ }),
/* 1508 */,
/* 1509 */,
/* 1510 */,
/* 1511 */,
/* 1512 */,
/* 1513 */,
/* 1514 */,
/* 1515 */,
/* 1516 */,
/* 1517 */,
/* 1518 */,
/* 1519 */,
/* 1520 */,
/* 1521 */,
/* 1522 */,
/* 1523 */,
/* 1524 */,
/* 1525 */,
/* 1526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__albums__ = __webpack_require__(1527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__channels__ = __webpack_require__(1531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__datasets__ = __webpack_require__(1532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__templates__ = __webpack_require__(1533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__windows__ = __webpack_require__(1534);






/* harmony default export */ __webpack_exports__["a"] = ({
  albums: __WEBPACK_IMPORTED_MODULE_0__albums__["a" /* default */],
  channels: __WEBPACK_IMPORTED_MODULE_1__channels__["a" /* default */],
  datasets: __WEBPACK_IMPORTED_MODULE_2__datasets__["a" /* default */],
  templates: __WEBPACK_IMPORTED_MODULE_3__templates__["a" /* default */],
  windows: __WEBPACK_IMPORTED_MODULE_4__windows__["a" /* default */]
});

/***/ }),
/* 1527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export state */
/* unused harmony export getters */
/* unused harmony export actions */
/* unused harmony export mutations */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__action_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutation_types__ = __webpack_require__(14);


var _actions, _mutations;






var state = {
  albums: []
};

var getters = {
  albums: function albums(state) {
    return function () {
      return state.albums;
    };
  },

  album: function album(state) {
    return function (albumId) {
      return state.albums.find(function (a) {
        return a.albumId === albumId;
      });
    };
  },

  picture: function picture(state) {
    return function (albumId, pictureId) {
      var album = state.albums.find(function (a) {
        return a.albumId === albumId;
      });
      if (!album) return null;
      if (typeof pictureId === 'function') {
        return album.pictures.find(function (p) {
          return pictureId(p);
        });
      }
      return album.pictures.find(function (p) {
        return p.pictureId === pictureId;
      });
    };
  }
};

var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__action_types__["a" /* ALBUM_CREATE */], function (_ref, _ref2) {
  var commit = _ref.commit,
      dispatch = _ref.dispatch;
  var albumId = _ref2.albumId,
      componentType = _ref2.componentType,
      name = _ref2.name;

  albumId = albumId || Object(__WEBPACK_IMPORTED_MODULE_2__lib__["e" /* uuid */])();
  name = name || 'Unnamed Album';
  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* ALBUM_CREATE */], {
    albumId: albumId,
    componentType: componentType,
    name: name,
    emit: true
  });
  dispatch(__WEBPACK_IMPORTED_MODULE_3__action_types__["E" /* WINDOW_CREATE */], {
    componentType: componentType,
    title: name,
    data: { albumId: albumId, contentId: albumId }
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__action_types__["d" /* ALBUM_OPEN */], function (_ref3, _ref4) {
  var dispatch = _ref3.dispatch,
      getters = _ref3.getters;
  var albumId = _ref4.albumId;

  var album = getters.album(albumId);
  if (!album) return;
  dispatch(__WEBPACK_IMPORTED_MODULE_3__action_types__["H" /* WINDOW_OPEN_CREATE */], {
    componentType: album.componentType || 'album-window',
    title: album.name,
    contentId: albumId
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__action_types__["b" /* ALBUM_DELETE */], function (_ref5, _ref6) {
  var commit = _ref5.commit;
  var windowId = _ref6.windowId,
      albumId = _ref6.albumId;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["T" /* WINDOW_DELETE */], {
    windowId: windowId,
    emit: true
  });
  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["b" /* ALBUM_DELETE */], {
    albumId: albumId,
    emit: true
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__action_types__["c" /* ALBUM_META */], function (_ref7, _ref8) {
  var commit = _ref7.commit;
  var albumId = _ref8.albumId,
      name = _ref8.name;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["c" /* ALBUM_META */], {
    albumId: albumId,
    name: name,
    emit: true
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__action_types__["f" /* ALBUM_PICTURE_CREATE */], function (_ref9, _ref10) {
  var commit = _ref9.commit;
  var albumId = _ref10.albumId,
      pictureId = _ref10.pictureId,
      fileName = _ref10.fileName,
      fileType = _ref10.fileType,
      fileSize = _ref10.fileSize,
      image = _ref10.image;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["d" /* ALBUM_PICTURE_CREATE */], {
    albumId: albumId,
    pictureId: pictureId,
    fileName: fileName,
    fileType: fileType,
    fileSize: fileSize,
    image: image,
    emit: true
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__action_types__["e" /* ALBUM_PICTURE_CHANGE */], function (_ref11, _ref12) {
  var getters = _ref11.getters,
      commit = _ref11.commit;
  var albumId = _ref12.albumId,
      pictureId = _ref12.pictureId,
      fileName = _ref12.fileName,
      fileType = _ref12.fileType,
      fileSize = _ref12.fileSize,
      image = _ref12.image;

  var picture = getters.picture(albumId, pictureId);
  if (picture && picture.image === image) return;
  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["f" /* ALBUM_PICTURE_UPDATE */], {
    albumId: albumId,
    pictureId: pictureId,
    fileName: fileName,
    fileType: fileType,
    fileSize: fileSize,
    image: image,
    emit: true
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__action_types__["g" /* ALBUM_PICTURE_REMOVE */], function (_ref13, _ref14) {
  var commit = _ref13.commit;
  var albumId = _ref14.albumId,
      pictureId = _ref14.pictureId;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["e" /* ALBUM_PICTURE_DELETE */], {
    albumId: albumId,
    pictureId: pictureId,
    emit: true
  });
}), _actions);

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["g" /* ALBUM_STATE */], function (state, _ref15) {
  var albums = _ref15.albums,
      pictures = _ref15.pictures;

  pictures = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.groupBy(pictures, 'albumId');
  state.albums = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(albums, function (album) {
    album.pictures = pictures[album.albumId] || [];
    return album;
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* ALBUM_CREATE */], function (state, _ref16) {
  var albumId = _ref16.albumId,
      name = _ref16.name;

  var idx = state.albums.findIndex(function (a) {
    return a.albumId === albumId;
  });
  if (idx >= 0) return;
  state.albums.push({ albumId: albumId, name: name, pictures: [] });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["b" /* ALBUM_DELETE */], function (state, _ref17) {
  var albumId = _ref17.albumId;

  var idx = state.albums.findIndex(function (a) {
    return a.albumId === albumId;
  });
  state.albums.splice(idx, 1);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["c" /* ALBUM_META */], function (state, _ref18) {
  var albumId = _ref18.albumId,
      name = _ref18.name;

  var album = state.albums.find(function (a) {
    return a.albumId === albumId;
  });
  if (!album) return;
  album.name = name || album.name;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["d" /* ALBUM_PICTURE_CREATE */], function (state, _ref19) {
  var albumId = _ref19.albumId,
      pictureId = _ref19.pictureId,
      fileName = _ref19.fileName,
      fileType = _ref19.fileType,
      fileSize = _ref19.fileSize,
      image = _ref19.image;

  var album = state.albums.find(function (a) {
    return a.albumId === albumId;
  });
  if (!album) return;
  album.pictures.push({
    pictureId: pictureId,
    fileName: fileName,
    fileType: fileType,
    fileSize: fileSize,
    image: image
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["f" /* ALBUM_PICTURE_UPDATE */], function (state, _ref20) {
  var albumId = _ref20.albumId,
      pictureId = _ref20.pictureId,
      fileName = _ref20.fileName,
      fileType = _ref20.fileType,
      fileSize = _ref20.fileSize,
      image = _ref20.image;

  var album = state.albums.find(function (a) {
    return a.albumId === albumId;
  });
  if (!album) return;
  var picture = album.pictures.find(function (p) {
    return p.pictureId === pictureId;
  });
  if (!picture) return;
  picture.fileName = fileName;
  picture.fileType = fileType;
  picture.fileSize = fileSize;
  picture.image = image;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["e" /* ALBUM_PICTURE_DELETE */], function (state, _ref21) {
  var albumId = _ref21.albumId,
      pictureId = _ref21.pictureId;

  var album = state.albums.find(function (a) {
    return a.albumId === albumId;
  });
  if (!album) return;
  var idx = album.pictures.findIndex(function (p) {
    return p.pictureId === pictureId;
  });
  album.pictures.splice(idx, 1);
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 1528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

function normalizeMap(map) {
  return Array.isArray(map) ? map.map(function (key) {
    return { key: key, val: key };
  }) : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(map).map(function (key) {
    return { key: key, val: map[key] };
  });
}

/* harmony default export */ __webpack_exports__["a"] = (normalizeMap);

/***/ }),
/* 1529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);


var Direction = {
  UP: 'up',
  DOWN: 'down'
};

var Stopwatch = function () {
  function Stopwatch(data, now) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Stopwatch);

    this._isRunning = data.isRunning;
    this._currentTimeMs = data.currentTimeMs;
    this._currentTimeUtc = data.currentTimeUtc;
    this._startTimeMs = data.startTimeMs || 0;
    this._endTimeMs = data.endTimeMs || 0;

    this._direction = this._startTimeMs <= this._endTimeMs ? Direction.UP : Direction.DOWN;
    this._now = now || Date.now();
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Stopwatch, [{
    key: 'isRunning',
    get: function get() {
      return this._isRunning;
    }
  }, {
    key: 'currentTimeMs',
    get: function get() {
      if (!this._isRunning) {
        return this._currentTimeMs;
      }

      if (this._direction === Direction.UP) {
        return this._now - this._currentTimeUtc;
      } else {
        return this._currentTimeUtc - this._now;
      }
    }
  }, {
    key: 'elapsedMs',
    get: function get() {
      if (this._direction === Direction.UP) {
        return this.currentTimeMs - this._startTimeMs;
      } else {
        return this._startTimeMs - this.currentTimeMs;
      }
    }
  }, {
    key: 'leftMs',
    get: function get() {
      if (this._direction === Direction.UP) {
        return this._endTimeMs - this.currentTimeMs;
      } else {
        return this.currentTimeMs - this._endTimeMs;
      }
    }
  }]);

  return Stopwatch;
}();

/* harmony default export */ __webpack_exports__["a"] = (Stopwatch);

/***/ }),
/* 1530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = uuidv4;
/* https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript#2117523 */
function uuidv4() {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, function (c) {
    return (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16);
  });
}

/***/ }),
/* 1531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export state */
/* unused harmony export getters */
/* unused harmony export actions */
/* unused harmony export mutations */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__action_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutation_types__ = __webpack_require__(14);




var _actions, _mutations;




var CHANNEL_ID = {
  PREVIEW: 'preview',
  PROGRAM: 'program'
};

var state = {
  overlays: []
};

var getters = {
  isPlaying: function isPlaying(state, getters) {
    return function (templateId, channelId) {
      var template = getters.template(templateId);
      if (!template) return false;
      var layer = template.layer;
      var overlay = state.overlays.find(function (o) {
        return o.channelId === channelId && o.layer === layer;
      });
      return overlay && overlay.playing;
    };
  },
  overlay: function overlay(state) {
    return function (channelId, layer) {
      return state.overlays.find(function (o) {
        return o.channelId === channelId && o.layer === layer;
      });
    };
  }
};

var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__action_types__["h" /* CLEAR_CHANNEL */], function (_ref, _ref2) {
  var commit = _ref.commit;
  var channelId = _ref2.channelId;

  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["h" /* CHANNEL_CLEAR */], { channelId: channelId, emit: true });
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__action_types__["B" /* TOGGLE_PLAY_STOP */], function (_ref3, _ref4) {
  var getters = _ref3.getters,
      commit = _ref3.commit;
  var channelId = _ref4.channelId,
      templateId = _ref4.templateId;

  if (typeof channelId !== 'string' || !channelId) throw TypeError('channelId must be a string');
  if (typeof templateId !== 'string' || !templateId) throw TypeError('templateId must be a string');
  var template = getters.template(templateId);
  if (!template) throw Error('template not found');
  var layer = template.layer;
  var overlay = getters.overlay(channelId, layer);
  if (overlay && overlay.playing) {
    commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["z" /* OVERLAY_STOP */], {
      fileName: template.overlayFileName, channelId: channelId, layer: layer, emit: true
    });
  } else {
    var data = getters.overlayData(templateId);
    var options = getters.overlayOptions(templateId);
    if (overlay) {
      commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["x" /* OVERLAY_PLAY */], {
        fileName: template.overlayFileName, channelId: channelId, layer: layer, data: data, options: options, emit: true
      });
    } else {
      commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["s" /* OVERLAY_ADD */], {
        fileName: template.overlayFileName, channelId: channelId, layer: layer, data: data, options: options, emit: true
      });
    }
    // "Take" from preview to program
    if (channelId === CHANNEL_ID.PROGRAM) {
      commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["z" /* OVERLAY_STOP */], {
        fileName: template.overlayFileName, channelId: CHANNEL_ID.PREVIEW, layer: layer, emit: true
      });
    }
  }
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__action_types__["j" /* COMMAND_NEXT */], function (_ref5, _ref6) {
  var getters = _ref5.getters,
      commit = _ref5.commit;
  var channelId = _ref6.channelId,
      templateId = _ref6.templateId;

  if (typeof channelId !== 'string' || !channelId) throw TypeError('channelId must be a string');
  if (typeof templateId !== 'string' || !templateId) throw TypeError('templateId must be a string');
  var template = getters.template(templateId);
  if (!template) throw Error('template not found');
  var layer = template.layer;
  var overlay = getters.overlay(channelId, layer);
  if (!overlay || !overlay.playing) return;
  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["v" /* OVERLAY_NEXT */], {
    channelId: channelId,
    layer: template.layer,
    emit: true
  });
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__action_types__["i" /* COMMAND_INVOKE */], function (_ref7, _ref8) {
  var getters = _ref7.getters,
      commit = _ref7.commit;
  var channelId = _ref8.channelId,
      templateId = _ref8.templateId,
      func = _ref8.func;

  if (typeof channelId !== 'string' || !channelId) throw TypeError('channelId must be a string');
  if (typeof templateId !== 'string' || !templateId) throw TypeError('templateId must be a string');
  var template = getters.template(templateId);
  if (!template) throw Error('template not found');
  var layer = template.layer;
  var overlay = getters.overlay(channelId, layer);
  if (!overlay || !overlay.playing) return;
  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["u" /* OVERLAY_INVOKE */], {
    channelId: channelId,
    layer: template.layer,
    func: func,
    emit: true
  });
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__action_types__["k" /* COMMAND_UPDATE */], function (_ref9, _ref10) {
  var getters = _ref9.getters,
      commit = _ref9.commit;
  var channelId = _ref10.channelId,
      templateId = _ref10.templateId;

  if (typeof channelId !== 'string' || !channelId) throw TypeError('channelId must be a string');
  if (typeof templateId !== 'string' || !templateId) throw TypeError('templateId must be a string');
  var template = getters.template(templateId);
  if (!template) throw Error('template not found');
  var layer = template.layer;
  var overlay = getters.overlay(channelId, layer);
  if (!overlay || !overlay.playing) return;
  var data = getters.overlayData(templateId);
  commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["t" /* OVERLAY_DATA */], {
    channelId: channelId,
    layer: template.layer,
    data: data,
    emit: true
  });
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__action_types__["p" /* OVERLAY_DATA */], function (_ref11, _ref12) {
  var getters = _ref11.getters,
      commit = _ref11.commit;
  var templateId = _ref12.templateId,
      channelIds = _ref12.channelIds,
      data = _ref12.data;

  if (typeof templateId !== 'string' || !templateId) throw TypeError('templateId must be a string');
  channelIds = Array.isArray(channelIds) ? channelIds : [channelIds];
  var template = getters.template(templateId);
  if (!template) throw Error('template not found');
  data = data || getters.overlayData(templateId);
  channelIds.forEach(function (channelId) {
    commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["t" /* OVERLAY_DATA */], {
      channelId: channelId,
      layer: template.layer,
      data: data,
      emit: true
    });
  });
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__action_types__["q" /* OVERLAY_OPTIONS */], function (_ref13, _ref14) {
  var getters = _ref13.getters,
      commit = _ref13.commit;
  var templateId = _ref14.templateId,
      channelIds = _ref14.channelIds,
      options = _ref14.options;

  if (typeof templateId !== 'string' || !templateId) throw TypeError('templateId must be a string');
  channelIds = Array.isArray(channelIds) ? channelIds : [channelIds];
  var template = getters.template(templateId);
  if (!template) throw Error('template not found');
  options = options || getters.templateOptions(templateId);
  channelIds.forEach(function (channelId) {
    commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["w" /* OVERLAY_OPTIONS */], {
      channelId: channelId,
      layer: template.layer,
      options: options,
      emit: true
    });
  });
}), _actions);

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["h" /* CHANNEL_CLEAR */], function (state, _ref15) {
  var channelId = _ref15.channelId;

  if (typeof channelId !== 'string') throw TypeError('channelId must be a string');
  for (var idx = state.overlays.length - 1; idx >= 0; idx--) {
    if (state.overlays[idx].channelId === channelId) {
      state.overlays.splice(idx, 1);
    }
  }
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["i" /* CHANNEL_STATE */], function (state, _ref16) {
  var channelId = _ref16.channelId,
      overlays = _ref16.overlays;

  overlays.forEach(function (each) {
    var overlay = state.overlays.find(function (o) {
      return o.channelId === each.channelId && o.layer === each.layer;
    });
    if (!overlay) {
      overlay = {
        channelId: channelId,
        layer: each.layer,
        overlayFileName: each.overlayFileName,
        playing: !!each.playing,
        options: each.options,
        data: each.options
      };
      state.overlays.push(overlay);
    }
  });
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["s" /* OVERLAY_ADD */], function (state, _ref17) {
  var channelId = _ref17.channelId,
      layer = _ref17.layer,
      fileName = _ref17.fileName,
      data = _ref17.data,
      options = _ref17.options,
      playing = _ref17.playing;

  if (typeof channelId !== 'string' || !channelId) throw TypeError('channelId must be a string');
  if (typeof layer !== 'number') throw TypeError('layer must be a number');
  if (typeof fileName !== 'string' || !fileName) throw TypeError('fileName must be a string');
  data = data || {};
  options = options || {};
  var overlay = state.overlays.find(function (o) {
    return o.channelId === channelId && o.layer === layer;
  });
  if (!overlay) {
    overlay = { channelId: channelId, layer: layer, fileName: fileName, playing: !!playing, options: options, data: data };
    state.overlays.push(overlay);
  } else {
    overlay.playing = true;
    overlay.data = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, data);
    overlay.options = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, options);
  }
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["y" /* OVERLAY_REMOVE */], function (state, _ref18) {
  var channelId = _ref18.channelId,
      layer = _ref18.layer;

  if (typeof channelId !== 'string') throw TypeError('channelId must be a string');
  if (typeof layer !== 'number') throw TypeError('layer must be a number');
  var idx = state.overlays.findIndex(function (o) {
    return o.channelId === channelId && o.layer === layer;
  });
  if (idx < 0) return;
  state.overlays.splice(idx, 1);
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["x" /* OVERLAY_PLAY */], function (state, _ref19) {
  var channelId = _ref19.channelId,
      layer = _ref19.layer;

  if (typeof channelId !== 'string') throw TypeError('channelId must be a string');
  if (typeof layer !== 'number') throw TypeError('layer must be a number');
  var overlay = state.overlays.find(function (o) {
    return o.channelId === channelId && o.layer === layer;
  });
  if (!overlay) return;
  overlay.playing = true;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["z" /* OVERLAY_STOP */], function (state, _ref20) {
  var channelId = _ref20.channelId,
      layer = _ref20.layer;

  if (typeof channelId !== 'string') throw TypeError('channelId must be a string');
  if (typeof layer !== 'number') throw TypeError('layer must be a number');
  var overlay = state.overlays.find(function (o) {
    return o.channelId === channelId && o.layer === layer;
  });
  if (!overlay) return;
  overlay.playing = false;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["t" /* OVERLAY_DATA */], function (state, _ref21) {
  var channelId = _ref21.channelId,
      layer = _ref21.layer,
      data = _ref21.data;

  if (typeof channelId !== 'string') throw TypeError('channelId must be a string');
  if (typeof layer !== 'number') throw TypeError('layer must be a number');
  if ((typeof data === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(data)) !== 'object') throw TypeError('data must be an object');
  var overlay = state.overlays.find(function (o) {
    return o.channelId === channelId && o.layer === layer;
  });
  if (!overlay) return;
  overlay.data = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, overlay.data, data);
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["w" /* OVERLAY_OPTIONS */], function (state, _ref22) {
  var channelId = _ref22.channelId,
      layer = _ref22.layer,
      options = _ref22.options;

  if (typeof channelId !== 'string') throw TypeError('channelId must be a string');
  if (typeof layer !== 'number') throw TypeError('layer must be a number');
  if ((typeof options === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(options)) !== 'object') throw TypeError('options must be an object');
  var overlay = state.overlays.find(function (o) {
    return o.channelId === channelId && o.layer === layer;
  });
  if (!overlay) return;
  overlay.options = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, overlay.options, options);
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["v" /* OVERLAY_NEXT */], function (state, _ref23) {
  // Noop

  var channelId = _ref23.channelId,
      layer = _ref23.layer;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["u" /* OVERLAY_INVOKE */], function (state, _ref24) {
  // Noop

  var channelId = _ref24.channelId,
      layer = _ref24.layer,
      func = _ref24.func;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 1532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export state */
/* unused harmony export getters */
/* unused harmony export actions */
/* unused harmony export mutations */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__action_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mutation_types__ = __webpack_require__(14);



var _actions, _mutations;






var state = {
  datasets: []
};

var getters = {
  datasets: function datasets(state) {
    return function () {
      return state.datasets;
    };
  },

  dataset: function dataset(state) {
    return function (datasetId) {
      return state.datasets.find(function (d) {
        return d.datasetId === datasetId;
      });
    };
  },

  datasetColumns: function datasetColumns(state) {
    return function (datasetId) {
      return (state.datasets.find(function (d) {
        return d.datasetId === datasetId;
      }) || {}).columns || [];
    };
  },

  datasetRecord: function datasetRecord(state) {
    return function (datasetId, recordId) {
      return ((state.datasets.find(function (d) {
        return d.datasetId === datasetId;
      }) || {}).records || []).find(function (each) {
        return each.recordId === recordId;
      });
    };
  },

  datasetRecords: function datasetRecords(state) {
    return function (datasetId) {
      return (state.datasets.find(function (d) {
        return d.datasetId === datasetId;
      }) || {}).records || [];
    };
  }
};

var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__action_types__["l" /* DATASET_CREATE */], function (_ref, _ref2) {
  var commit = _ref.commit,
      dispatch = _ref.dispatch;
  var datasetId = _ref2.datasetId,
      componentType = _ref2.componentType,
      name = _ref2.name,
      dataUrl = _ref2.dataUrl,
      columns = _ref2.columns,
      records = _ref2.records;

  datasetId = datasetId || Object(__WEBPACK_IMPORTED_MODULE_3__lib__["e" /* uuid */])();
  componentType = componentType || 'dataset-window';
  name = name || 'Unnamed Dataset';
  commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["j" /* DATASET_CREATE */], {
    datasetId: datasetId,
    componentType: componentType,
    name: name,
    fileName: dataUrl,
    columns: columns,
    records: records,
    emit: true
  });
  dispatch(__WEBPACK_IMPORTED_MODULE_4__action_types__["E" /* WINDOW_CREATE */], {
    componentType: componentType,
    title: name,
    data: { datasetId: datasetId, contentId: datasetId }
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__action_types__["n" /* DATASET_OPEN */], function (_ref3, _ref4) {
  var getters = _ref3.getters,
      dispatch = _ref3.dispatch;
  var datasetId = _ref4.datasetId;

  var dataset = getters.dataset(datasetId);
  if (!dataset) return;
  dispatch(__WEBPACK_IMPORTED_MODULE_4__action_types__["H" /* WINDOW_OPEN_CREATE */], {
    componentType: dataset.componentType || 'dataset-window',
    title: dataset.name,
    contentId: datasetId
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__action_types__["m" /* DATASET_DELETE */], function (_ref5, _ref6) {
  var commit = _ref5.commit,
      getters = _ref5.getters;
  var datasetId = _ref6.datasetId;

  var window = getters.windowByContentId(datasetId);
  if (window) {
    commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["T" /* WINDOW_DELETE */], {
      windowId: window.windowId,
      emit: true
    });
  }
  commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["l" /* DATASET_DELETE */], {
    datasetId: datasetId,
    emit: true
  });
}), _actions);

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["n" /* DATASET_STATE */], function (state, datasets) {
  datasets = Array.isArray(datasets) ? datasets : (typeof datasets === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(datasets)) === 'object' ? [datasets] : [];
  state.datasets = datasets.map(function (ds) {
    ds.datasetId = ds.datasetId || Object(__WEBPACK_IMPORTED_MODULE_3__lib__["e" /* uuid */])();
    ds.name = ds.name || 'Unnamed Dataset';
    ds.fileName = ds.fileName || null;
    ds.columns = ds.columns || [];
    ds.records = ds.records || [];
    return ds;
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["j" /* DATASET_CREATE */], function (state, _ref7) {
  var datasetId = _ref7.datasetId,
      name = _ref7.name,
      componentType = _ref7.componentType,
      fileName = _ref7.fileName,
      columns = _ref7.columns,
      records = _ref7.records;

  var idx = state.datasets.findIndex(function (d) {
    return d.datasetId === datasetId;
  });
  if (idx >= 0) return;
  state.datasets.push({ datasetId: datasetId, name: name, componentType: componentType, fileName: fileName, columns: columns || [], records: records || [] });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["l" /* DATASET_DELETE */], function (state, _ref8) {
  var datasetId = _ref8.datasetId;

  var idx = state.datasets.findIndex(function (d) {
    return d.datasetId === datasetId;
  });
  if (idx < 0) return;
  state.datasets.splice(idx, 1);
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["o" /* DATASET_UPDATE_META */], function (state, _ref9) {
  var datasetId = _ref9.datasetId,
      name = _ref9.name,
      fileName = _ref9.fileName,
      columns = _ref9.columns;

  var dataset = state.datasets.find(function (d) {
    return d.datasetId === datasetId;
  });
  if (!dataset) return;
  dataset.name = name || dataset.name;
  dataset.fileName = fileName || dataset.fileName;
  dataset.columns = columns || dataset.columns;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["k" /* DATASET_CREATE_RECORD */], function (state, _ref10) {
  var datasetId = _ref10.datasetId,
      record = _ref10.record;

  var dataset = state.datasets.find(function (d) {
    return d.datasetId === datasetId;
  });
  if (!dataset) return;
  dataset.records.push(record);
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["m" /* DATASET_DELETE_RECORD */], function (state, _ref11) {
  var datasetId = _ref11.datasetId,
      recordId = _ref11.recordId;

  var dataset = state.datasets.find(function (d) {
    return d.datasetId === datasetId;
  });
  if (!dataset) return;
  var idx = dataset.records.findIndex(function (r) {
    return r.recordId === recordId;
  });
  if (idx < 0) return;
  dataset.records.splice(idx, 1);
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["p" /* DATASET_UPDATE_RECORD */], function (state, _ref12) {
  var datasetId = _ref12.datasetId,
      record = _ref12.record;

  var dataset = state.datasets.find(function (d) {
    return d.datasetId === datasetId;
  });
  if (!dataset) return;
  var idx = dataset.records.findIndex(function (r) {
    return r.recordId === record.recordId;
  });
  if (idx < 0) return;
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(dataset.records, idx, record);
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["q" /* DATASET_UPDATE_RECORDS */], function (state, _ref13) {
  var datasetId = _ref13.datasetId,
      columns = _ref13.columns,
      records = _ref13.records;

  var dataset = state.datasets.find(function (d) {
    return d.datasetId === datasetId;
  });
  if (!dataset) return;
  dataset.columns = columns || dataset.columns;
  dataset.records = records;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["r" /* DATASET_UPDATE_VALUE */], function (state, _ref14) {
  var datasetId = _ref14.datasetId,
      recordId = _ref14.recordId,
      column = _ref14.column,
      value = _ref14.value;

  var dataset = state.datasets.find(function (d) {
    return d.datasetId === datasetId;
  });
  if (!dataset) return console.warn('Dataset not found', datasetId);
  var record = dataset.records.find(function (r) {
    return r.recordId === recordId;
  });
  if (!record) return console.warn('Record not found', recordId);
  // if (!record.hasOwnProperty(column)) return console.warn('Column not found', column, record)
  __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(record, column, value);
}), _mutations);
/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 1533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export state */
/* unused harmony export getters */
/* unused harmony export actions */
/* unused harmony export mutations */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__action_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mutation_types__ = __webpack_require__(14);





var _actions, _mutations;






var state = {
  templates: []
};

var getters = {
  templates: function templates(state) {
    return function () {
      return state.templates;
    };
  },

  template: function template(state) {
    return function (templateId) {
      return state.templates.find(function (t) {
        return t.templateId === templateId;
      });
    };
  },

  overlayData: function overlayData(state) {
    return function (templateId) {
      var template = state.templates.find(function (t) {
        return t.templateId === templateId;
      });
      return template && template.overlay && template.overlay.data ? template.overlay.data : {};
    };
  },

  overlayOptions: function overlayOptions(state) {
    return function (templateId) {
      var template = state.templates.find(function (t) {
        return t.templateId === templateId;
      });
      return template && template.overlay && template.overlay.options ? template.overlay.options : {};
    };
  },

  templateData: function templateData(state) {
    return function (templateId) {
      var template = state.templates.find(function (t) {
        return t.templateId === templateId;
      });
      return template && template.data ? template.data : {};
    };
  },

  templateOptions: function templateOptions(state) {
    return function (templateId) {
      var template = state.templates.find(function (t) {
        return t.templateId === templateId;
      });
      return template && template.options ? template.options : {};
    };
  },

  folders: function folders(state) {
    return function () {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(state.templates.reduce(function (res, template) {
        if (template.folder) res[template.folder] = template.folder;
        return res;
      }, {}));
    };
  },

  nextLayer: function nextLayer(state) {
    return function () {
      var layer = state.templates.reduce(function (res, template) {
        return Math.max(res, template.layer || 0);
      }, -1);
      return layer + 1;
    };
  }
};

var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__action_types__["r" /* TEMPLATE_CREATE */], function (_ref, _ref2) {
  var getters = _ref.getters,
      commit = _ref.commit,
      dispatch = _ref.dispatch;
  var templateId = _ref2.templateId,
      componentType = _ref2.componentType,
      name = _ref2.name,
      overlays = _ref2.overlays,
      data = _ref2.data,
      options = _ref2.options,
      overlay = _ref2.overlay;

  if (!__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].component(componentType)) {
    componentType = 'template-not-found';
  }
  templateId = templateId || Object(__WEBPACK_IMPORTED_MODULE_5__lib__["e" /* uuid */])();
  var layer = getters.nextLayer();
  var fileName = overlays[0];
  name = name || 'Unnamed Template';
  var overlayData = overlay && overlay.data ? overlay.data || {} : {};
  var overlayOptions = overlay && overlay.options ? overlay.options || {} : {};
  commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["G" /* TEMPLATE_CREATE */], {
    templateId: templateId,
    componentType: componentType,
    overlayFileName: fileName,
    layer: layer,
    name: name,
    data: data || {},
    options: options || {},
    overlay: {
      data: overlayData,
      options: overlayOptions
    },
    emit: true
  });
  dispatch(__WEBPACK_IMPORTED_MODULE_6__action_types__["E" /* WINDOW_CREATE */], {
    componentType: componentType,
    title: name,
    data: { templateId: templateId, contentId: templateId }
  });
  commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["s" /* OVERLAY_ADD */], {
    fileName: fileName,
    channelId: 'preview',
    layer: layer,
    data: overlayData,
    options: overlayOptions,
    playing: false,
    emit: true
  });
  commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["s" /* OVERLAY_ADD */], {
    fileName: fileName,
    channelId: 'program',
    layer: layer,
    data: overlayData,
    options: overlayOptions,
    playing: false,
    emit: true
  });
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__action_types__["x" /* TEMPLATE_OPEN */], function (_ref3, _ref4) {
  var getters = _ref3.getters,
      dispatch = _ref3.dispatch;
  var templateId = _ref4.templateId;

  var template = getters.template(templateId);
  if (!template) return;
  if (!__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].component(template.componentType)) {
    template.componentType = 'template-not-found';
  }
  dispatch(__WEBPACK_IMPORTED_MODULE_6__action_types__["H" /* WINDOW_OPEN_CREATE */], {
    componentType: template.componentType,
    title: template.name,
    contentId: templateId
  });
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__action_types__["t" /* TEMPLATE_DELETE */], function (_ref5, _ref6) {
  var getters = _ref5.getters,
      commit = _ref5.commit;
  var templateId = _ref6.templateId;

  var window = getters.windowByContentId(templateId);
  if (window) {
    commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["T" /* WINDOW_DELETE */], {
      windowId: window.windowId,
      emit: true
    });
  }
  var template = getters.template(templateId);
  if (template) {
    commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["y" /* OVERLAY_REMOVE */], {
      channelId: 'preview',
      layer: template.layer,
      emit: true
    });
    commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["y" /* OVERLAY_REMOVE */], {
      channelId: 'program',
      layer: template.layer,
      emit: true
    });
  }
  commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["I" /* TEMPLATE_DELETE */], {
    templateId: templateId,
    emit: true
  });
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__action_types__["v" /* TEMPLATE_LAYER */], function (_ref7, _ref8) {
  var getters = _ref7.getters,
      commit = _ref7.commit;
  var templateId = _ref8.templateId,
      layer = _ref8.layer;

  if (typeof layer !== 'number') throw TypeError('layer must be a number');
  var template = getters.template(templateId);
  if (template) {
    commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["y" /* OVERLAY_REMOVE */], {
      channelId: 'preview',
      layer: template.layer,
      emit: true
    });
    commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["y" /* OVERLAY_REMOVE */], {
      channelId: 'program',
      layer: template.layer,
      emit: true
    });
  }
  commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["K" /* TEMPLATE_LAYER */], {
    templateId: templateId,
    layer: layer,
    emit: true
  });
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__action_types__["w" /* TEMPLATE_NAME */], function (_ref9, _ref10) {
  var getters = _ref9.getters,
      commit = _ref9.commit;
  var templateId = _ref10.templateId,
      name = _ref10.name;

  commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["L" /* TEMPLATE_NAME */], {
    templateId: templateId,
    name: name,
    emit: true
  });

  var window = getters.windowByContentId(templateId);
  if (!window) return;
  commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["W" /* WINDOW_TITLE */], {
    windowId: window.windowId,
    title: name,
    emit: true
  });
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__action_types__["u" /* TEMPLATE_FOLDER */], function (_ref11, _ref12) {
  var getters = _ref11.getters,
      commit = _ref11.commit;
  var templateId = _ref12.templateId,
      folder = _ref12.folder;

  commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["J" /* TEMPLATE_FOLDER */], {
    templateId: templateId,
    folder: folder,
    emit: true
  });
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__action_types__["s" /* TEMPLATE_DATA */], function (_ref13, _ref14) {
  var commit = _ref13.commit;
  var templateId = _ref14.templateId,
      data = _ref14.data;

  commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["H" /* TEMPLATE_DATA */], {
    templateId: templateId,
    data: data,
    emit: true
  });
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__action_types__["y" /* TEMPLATE_OPTIONS */], function (_ref15, _ref16) {
  var commit = _ref15.commit;
  var templateId = _ref16.templateId,
      options = _ref16.options;

  commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["M" /* TEMPLATE_OPTIONS */], {
    templateId: templateId,
    options: options,
    emit: true
  });
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__action_types__["z" /* TEMPLATE_OVERLAY_DATA */], function (_ref17, _ref18) {
  var commit = _ref17.commit;
  var templateId = _ref18.templateId,
      data = _ref18.data;

  commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["N" /* TEMPLATE_OVERLAY_DATA */], {
    templateId: templateId,
    data: data,
    emit: true
  });
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__action_types__["A" /* TEMPLATE_OVERLAY_OPTIONS */], function (_ref19, _ref20) {
  var commit = _ref19.commit;
  var templateId = _ref20.templateId,
      options = _ref20.options;

  commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["O" /* TEMPLATE_OVERLAY_OPTIONS */], {
    templateId: templateId,
    options: options,
    emit: true
  });
}), _actions);

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["P" /* TEMPLATE_STATE */], function (state, templates) {
  templates = Array.isArray(templates) ? templates : (typeof templates === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(templates)) === 'object' ? [templates] : [];
  state.templates = templates.map(function (each) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, {
      overlay: { data: {}, options: {} }
    }, each);
  });
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["G" /* TEMPLATE_CREATE */], function (state, payload) {
  if (typeof payload.componentType !== 'string') throw TypeError('componentType must be a string');
  if (typeof payload.overlayFileName !== 'string') throw TypeError('overlayFileName must be a string');
  var idx = state.templates.findIndex(function (t) {
    return t.templateId === payload.templateId;
  });
  if (idx >= 0) return;
  var template = {
    templateId: payload.templateId,
    name: payload.name || 'Unnamed Template',
    componentType: payload.componentType || null,
    overlayFileName: payload.overlayFileName,
    layer: payload.layer || 0,
    data: payload.data || {},
    options: payload.options || {},
    settings: payload.settings || {},
    overlay: {
      data: (payload.overlay ? payload.overlay.data : {}) || {},
      options: (payload.overlay ? payload.overlay.options : {}) || {}
    }
  };
  state.templates.push(template);
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["I" /* TEMPLATE_DELETE */], function (state, _ref21) {
  var templateId = _ref21.templateId;

  var idx = state.templates.findIndex(function (t) {
    return t.templateId === templateId;
  });
  if (idx < 0) return;
  state.templates.splice(idx, 1);
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["K" /* TEMPLATE_LAYER */], function (state, _ref22) {
  var templateId = _ref22.templateId,
      layer = _ref22.layer;

  if (typeof layer !== 'number') throw TypeError('layer must be a number');
  var template = state.templates.find(function (t) {
    return t.templateId === templateId;
  });
  if (!template) return;
  template.layer = layer;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["L" /* TEMPLATE_NAME */], function (state, _ref23) {
  var templateId = _ref23.templateId,
      name = _ref23.name;

  var template = state.templates.find(function (t) {
    return t.templateId === templateId;
  });
  if (!template) return;
  template.name = name;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["J" /* TEMPLATE_FOLDER */], function (state, _ref24) {
  var templateId = _ref24.templateId,
      folder = _ref24.folder;

  var template = state.templates.find(function (t) {
    return t.templateId === templateId;
  });
  if (!template) return;
  template.folder = folder;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["H" /* TEMPLATE_DATA */], function (state, _ref25) {
  var templateId = _ref25.templateId,
      data = _ref25.data;

  var template = state.templates.find(function (t) {
    return t.templateId === templateId;
  });
  if (!template) return;
  // Replace entire object for reactive properties to fire
  // Object.assign(template.data, data)
  template.data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, template.data, data);
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["M" /* TEMPLATE_OPTIONS */], function (state, _ref26) {
  var templateId = _ref26.templateId,
      options = _ref26.options;

  var template = state.templates.find(function (t) {
    return t.templateId === templateId;
  });
  if (!template) return;
  // Replace entire object for reactive properties to fire
  // Object.assign(template.options, options)
  template.options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, template.options, options);
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["N" /* TEMPLATE_OVERLAY_DATA */], function (state, _ref27) {
  var templateId = _ref27.templateId,
      data = _ref27.data;

  var template = state.templates.find(function (t) {
    return t.templateId === templateId;
  });
  if (!template) return;
  // Replace entire object for reactive properties to fire
  // Object.assign(template.overlay.data, data)
  template.overlay.data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, template.overlay.data, data);
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["O" /* TEMPLATE_OVERLAY_OPTIONS */], function (state, _ref28) {
  var templateId = _ref28.templateId,
      options = _ref28.options;

  var template = state.templates.find(function (t) {
    return t.templateId === templateId;
  });
  if (!template) return;
  // Replace entire object for reactive properties to fire
  // Object.assign(template.overlay.options, options)
  template.overlay.options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, template.overlay.options, options);
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 1534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export state */
/* unused harmony export getters */
/* unused harmony export actions */
/* unused harmony export mutations */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__action_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mutation_types__ = __webpack_require__(14);




var _actions, _mutations;





var state = {
  windows: []
};

var getters = {
  windows: function windows(state) {
    return function () {
      return state.windows;
    };
  },

  window: function window(state) {
    return function (windowId) {
      return state.windows.find(function (w) {
        return w.windowId === windowId;
      });
    };
  },

  windowByContentId: function windowByContentId(state) {
    return function (contentId) {
      return state.windows.find(function (w) {
        return w.data.contentId === contentId;
      });
    };
  },

  windowTitle: function windowTitle(state) {
    return function (windowId) {
      return state.windows.find(function (w) {
        return w.windowId === windowId;
      }).title;
    };
  },

  windowData: function windowData(state) {
    return function (windowId) {
      var window = state.windows.find(function (w) {
        return w.windowId === windowId;
      });
      return window && window.data ? window.data : {};
    };
  },

  zIndex: function zIndex(state) {
    return function (windowId) {
      var zIndex = state.windows.reduce(function (res, window) {
        return Math.max(res, window.data.zIndex || 0);
      }, 0);
      var window = windowId ? state.windows.find(function (w) {
        return w.windowId === windowId;
      }) : null;
      if (window && window.data.zIndex === zIndex) return zIndex;
      return zIndex + 1;
    };
  }
};

function numberWindowTitle(getters, title) {
  var window = getters.windows().find(function (p) {
    return p.title === title;
  });
  if (!window) return title;
  var result = '';
  var number = 2;
  while (window) {
    result = title + ' (' + number++ + ')';
    window = getters.windows().find(function (p) {
      return p.title === result;
    });
  }
  return result;
}

var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__action_types__["E" /* WINDOW_CREATE */], function (_ref, _ref2) {
  var commit = _ref.commit,
      getters = _ref.getters;
  var componentType = _ref2.componentType,
      title = _ref2.title,
      data = _ref2.data;

  var zIndex = getters.zIndex();
  data = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, { zIndex: zIndex }, data);
  title = numberWindowTitle(getters, title);
  commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["R" /* WINDOW_CREATE */], {
    windowId: Object(__WEBPACK_IMPORTED_MODULE_3__lib__["e" /* uuid */])(),
    componentType: componentType,
    title: title,
    data: data,
    emit: true
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__action_types__["G" /* WINDOW_OPEN */], function (_ref3, _ref4) {
  var commit = _ref3.commit,
      getters = _ref3.getters;
  var windowId = _ref4.windowId,
      componentType = _ref4.componentType,
      title = _ref4.title;

  var zIndex = getters.zIndex(windowId);
  commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["U" /* WINDOW_OPEN */], { windowId: windowId, componentType: componentType, title: title, zIndex: zIndex, emit: true });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__action_types__["H" /* WINDOW_OPEN_CREATE */], function (_ref5, _ref6) {
  var dispatch = _ref5.dispatch,
      getters = _ref5.getters;
  var contentId = _ref6.contentId,
      componentType = _ref6.componentType,
      title = _ref6.title;

  var window = getters.windowByContentId(contentId);
  if (!window) {
    dispatch(__WEBPACK_IMPORTED_MODULE_4__action_types__["E" /* WINDOW_CREATE */], { componentType: componentType, title: title, data: { contentId: contentId } });
  } else {
    dispatch(__WEBPACK_IMPORTED_MODULE_4__action_types__["G" /* WINDOW_OPEN */], { windowId: window.windowId, componentType: componentType, title: title });
  }
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__action_types__["C" /* WINDOW_ACTIVATE */], function (_ref7, _ref8) {
  var commit = _ref7.commit,
      getters = _ref7.getters;
  var windowId = _ref8.windowId;

  var zIndex = getters.zIndex(windowId);
  commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["U" /* WINDOW_OPEN */], { windowId: windowId, zIndex: zIndex, emit: true });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__action_types__["D" /* WINDOW_CLOSE */], function (_ref9, _ref10) {
  var commit = _ref9.commit;
  var windowId = _ref10.windowId;

  commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["T" /* WINDOW_DELETE */], { windowId: windowId, emit: true });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__action_types__["F" /* WINDOW_DATA */], function (_ref11, _ref12) {
  var commit = _ref11.commit;
  var windowId = _ref12.windowId,
      data = _ref12.data;

  commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["S" /* WINDOW_DATA */], { windowId: windowId, data: data, emit: true });
}), _actions);

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["V" /* WINDOW_STATE */], function (state, windows) {
  windows = Array.isArray(windows) ? windows : (typeof windows === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(windows)) === 'object' ? [windows] : [];
  state.windows = windows.map(function (each) {
    each.data = each.data || {};
    return each;
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["R" /* WINDOW_CREATE */], function (state, payload) {
  var window = {
    windowId: payload.windowId,
    componentType: payload.componentType,
    title: payload.title || payload.name || 'Unnamed Window',
    data: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({ tabIndex: 0, zIndex: 0 }, payload.data),
    visible: true
  };
  state.windows.push(window);
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["T" /* WINDOW_DELETE */], function (state, _ref13) {
  var windowId = _ref13.windowId;

  var idx = state.windows.findIndex(function (w) {
    return w.windowId === windowId;
  });
  state.windows.splice(idx, 1);
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["U" /* WINDOW_OPEN */], function (state, _ref14) {
  var windowId = _ref14.windowId,
      componentType = _ref14.componentType,
      title = _ref14.title,
      zIndex = _ref14.zIndex;

  var window = state.windows.find(function (w) {
    return w.windowId === windowId;
  });
  if (!window) return;
  window.visible = true;
  window.componentType = componentType || window.componentType;
  window.title = title || window.title;
  window.data.zIndex = zIndex;
  // Computed properties don't fire on properties update on an object in an array
  // 09.12.2017: This seems to be a dangerous thing, because computed properties
  // that depend on window contentId (?) and template data fire
  // state.windows = Object.assign([], state.windows)
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["Q" /* WINDOW_CLOSE */], function (state, _ref15) {
  var windowId = _ref15.windowId;

  var window = state.windows.find(function (w) {
    return w.windowId === windowId;
  });
  if (!window) return;
  window.visible = false;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["W" /* WINDOW_TITLE */], function (state, _ref16) {
  var windowId = _ref16.windowId,
      title = _ref16.title;

  var window = state.windows.find(function (w) {
    return w.windowId === windowId;
  });
  if (!window) return;
  window.title = title;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["S" /* WINDOW_DATA */], function (state, _ref17) {
  var windowId = _ref17.windowId,
      data = _ref17.data;

  var window = state.windows.find(function (w) {
    return w.windowId === windowId;
  });
  if (!window) return;
  // window.data = Object.assign({}, window.data, data)
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(window.data, data);
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 1535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = webSocketPlugin;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__adonisjs_websocket_client__ = __webpack_require__(1536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__adonisjs_websocket_client___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__adonisjs_websocket_client__);




function isCurrentUser(userId, mutation) {
  if (!mutation.payload) console.warn('[studio/socket/chat] mutation has no payload', mutation);
  return mutation.payload && userId === mutation.payload.userId;
}

function initChat(topic, store, userId, baseUrl) {
  topic.on('ready', function () {
    console.info('[studio/socket/chat] subscribed to topic chat:%s', userId);
    topic.emit('workspaceStateRequest', { userId: userId });
    topic.emit('channelStateRequest', { channelId: 'program', userId: userId });
    topic.emit('channelStateRequest', { channelId: 'preview', userId: userId });
  });

  topic.on('error', function (error) {
    console.error('[studio/socket/chat] error', error);
  });

  topic.on('close', function () {
    console.info('[studio/socket/chat] close');
  });

  topic.on('workspaceStateResponse', function (payload) {
    console.debug('[studio/socket/chat] onWorkspaceStateResponse');
    // if (!isCurrentUser(payload)) return console.warn('[socket/chat] ignoring message not belonging to current user')
    store.commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["P" /* TEMPLATE_STATE */], payload.templates);
    store.commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["g" /* ALBUM_STATE */], {
      albums: payload.albums,
      pictures: payload.pictures.map(function (each) {
        each.image = baseUrl + each.imagePath;
        return each;
      })
    });
    store.commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["n" /* DATASET_STATE */], payload.datasets);
    store.commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["V" /* WINDOW_STATE */], payload.windows);
    store.commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["E" /* SOCKET_LOADED */]);
  });

  topic.on('channelStateResponse', function (payload) {
    console.debug('[studio/socket/chat] onChannelStateResponse');
    // if (!isCurrentUser(payload)) return console.warn('[socket/chat] ignoring message not belonging to current user')
    store.commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["i" /* CHANNEL_STATE */], payload);
    store.commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["E" /* SOCKET_LOADED */]);
  });

  topic.on('mutation', function (mutation) {
    console.debug('[studio/socket/chat] onMutation, %s', mutation.type);
    if (!isCurrentUser(userId, mutation)) return console.warn('[socket/chat] ignoring message not belonging to current user');

    // Set remote flag to prevent echoing back to socket/server
    mutation.payload.remote = true;

    // Commit mutation to local store
    store.commit(mutation.type, mutation.payload);
  });
}

function init(endpoint, store, userId, keycloak) {
  store.commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["F" /* SOCKET_LOADING */], { number: 3 });

  console.info('[studio/socket] connecting to ' + endpoint);
  var socket = __WEBPACK_IMPORTED_MODULE_2__adonisjs_websocket_client___default()(endpoint);
  socket.connect();

  socket.on('open', function (_ref) {
    var connId = _ref.connId;

    console.info('[studio/socket] connected', connId);
    store.commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["C" /* SOCKET_CONNECTED */]);
    var baseUrl = (endpoint || '').replace(/ws(s)?:\/\//, 'http$1://');
    initChat(socket.subscribe('chat:' + userId), store, userId, baseUrl);
  });

  socket.on('error', function (error) {
    console.error('[studio/socket] error', error);
  });

  socket.on('close', function () {
    console.info('[studio/socket] disconnected');
    store.commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["D" /* SOCKET_DISCONNECTED */]);
  });

  store.subscribe(function (mutation) {
    if (mutation.payload && mutation.payload.emit) {
      // Don't reemit remote mutations
      if (!mutation.payload.remote) {
        // Add user id
        mutation.payload.userId = userId;
        var chat = socket.getSubscription('chat:' + userId);
        if (chat) {
          if (keycloak && keycloak.updateToken) {
            keycloak.updateToken().then(function () {
              console.debug('[studio/socket/chat] emitting', mutation);
              chat.emit('mutation', mutation);
            }).catch(function () {
              console.error('[studio/socket/chat] failed to update keycloak token');
            });
          } else {
            console.debug('[studio/socket/chat] emitting', mutation);
            chat.emit('mutation', mutation);
          }
        } else {
          console.warn('[studio/socket/chat] no topic chat, are you offline?');
        }
      }
    }
  });
}

function webSocketPlugin() {
  return function (store) {
    // Quick hack to disable the websocket plugin in testing env
    if (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$env.NODE_ENV === 'testing') return;

    var vue = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();
    vue.$nextTick(function () {
      var endpoint = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$env.WEBCG_API;

      var startSocket = function startSocket(account) {
        init(endpoint, store, account.accountId, vue.$keycloak);
      };

      if (store.getters.selectedAccount) {
        startSocket(store.getters.selectedAccount);
      } else {
        var unwatch = store.watch(function (state) {
          return state.selectedAccount;
        }, function (selectedAccount) {
          if (selectedAccount) {
            startSocket(selectedAccount);
            unwatch();
          }
        });
      }
    });
  };
}

/***/ }),
/* 1536 */,
/* 1537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__classic__ = __webpack_require__(1538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__classic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__classic__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fig__ = __webpack_require__(1539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fig___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__fig__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__glassy__ = __webpack_require__(1540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__glassy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__glassy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ifsc__ = __webpack_require__(1541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ifsc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ifsc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sstv__ = __webpack_require__(1542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sstv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__sstv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__swiss1__ = __webpack_require__(1543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__swiss1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__swiss1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__swiss_wrestling_2026__ = __webpack_require__(1544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__swiss_wrestling_2026___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__swiss_wrestling_2026__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__uiaa__ = __webpack_require__(1545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__uiaa___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__uiaa__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__various__ = __webpack_require__(1546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__various___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__various__);









/* harmony default export */ __webpack_exports__["a"] = ([].concat(__WEBPACK_IMPORTED_MODULE_0__classic___default.a, __WEBPACK_IMPORTED_MODULE_1__fig___default.a, __WEBPACK_IMPORTED_MODULE_2__glassy___default.a, __WEBPACK_IMPORTED_MODULE_3__ifsc___default.a, __WEBPACK_IMPORTED_MODULE_4__sstv___default.a, __WEBPACK_IMPORTED_MODULE_5__swiss1___default.a, __WEBPACK_IMPORTED_MODULE_6__swiss_wrestling_2026___default.a, __WEBPACK_IMPORTED_MODULE_7__uiaa___default.a, __WEBPACK_IMPORTED_MODULE_8__various___default.a));

/***/ }),
/* 1538 */
/***/ (function(module, exports) {

module.exports = [{"componentType":"floorball-scoreboard","name":"Floorball Scoreboard","overlays":["sstv/floorball-scoreboard.vue"],"groups":["floorball","sstv"],"overlay":{"data":{"css":"","name1":"HOME","name2":"AWAY","currentTimeMs":1200000,"direction":"down","period":"1st"},"options":{"displayMinutes":true}},"data":{"currentTimeMs":1200000},"options":{"customCss":true,"customColors":true,"customPosition":true,"startTimeMs":1200000}},{"componentType":"floorball-scoreboard","name":"Football Scoreboard","overlays":["sstv/floorball-scoreboard.vue"],"groups":["avms-football-clubs","sstv"],"overlay":{"data":{"css":"","name1":"HOME","name2":"AWAY","currentTimeMs":0,"direction":"up","period":"1st"},"options":{"displayMinutes":true}},"data":{"currentTimeMs":0},"options":{"customCss":true,"customColors":true,"customPosition":true,"startTimeMs":0,"endTimeMs":2700000}},{"componentType":"floorball-scoreboard","name":"Futsal Scoreboard","overlays":["sstv/floorball-scoreboard.vue"],"groups":["futsal","sstv"],"overlay":{"data":{"css":"","name1":"HOME","name2":"AWAY","currentTimeMs":1200000,"direction":"down","period":"1st"},"options":{"displayMinutes":true}},"data":{"currentTimeMs":1200000},"options":{"customCss":true,"customColors":true,"customPosition":true,"startTimeMs":1200000}},{"componentType":"generic-clock","name":"Generic Clock","overlays":["sstv/lower-third-clock.vue"],"groups":"sstv","overlay":{"options":{"autoHideSecs":0,"displayMinutes":true}},"options":{"customColors":true}},{"componentType":"generic-lower-third","name":"Lower Third Generic","overlays":["sstv/lower-third-generic.vue"],"groups":["floorball","futsal","sstv","tennis","volleyball"],"options":{"customColors":true,"hasExtraInfo":true}},{"componentType":"lower-third-athlete","name":"Lower Third Athlete","overlays":["sstv/lower-third-athlete.vue"],"groups":["floorball","futsal","sstv","tennis","volleyball"],"options":{"customColors":true}},{"componentType":"match-title","name":"Match Title","overlays":["sstv/match-title.vue"],"groups":["floorball","futsal","sstv","tennis","volleyball"],"options":{"customColors":true,"customPosition":true}},{"componentType":"ranking-list","name":"Ranking List","overlays":["sstv/ranking-list.vue"],"groups":"sstv","options":{"customColors":true}},{"componentType":"ranking-list","name":"Side List","overlays":["sstv/side-list.vue"],"groups":"sstv","overlay":{"options":{"itemsPerPage":10}},"options":{"customColors":true}},{"componentType":"sponsors","name":"Sponsors","overlays":["sstv/lower-third-sponsors.vue"],"groups":"sstv"},{"componentType":"sponsors-auto","name":"Sponsors (Auto)","overlays":["sstv/lower-third-auto-sponsors.vue"],"groups":["floorball","futsal","sstv","tennis","volleyball"],"options":{"customColors":true}},{"componentType":"starting-list","name":"Starting List","overlays":["sstv/starting-list.vue"],"groups":["floorball","futsal","sstv","tennis","volleyball"],"options":{"customColors":true}},{"componentType":"swiss-wrestling-duel","name":"Schwingen","overlays":["sstv/swiss-wrestling-duel.vue"],"groups":"sstv"},{"componentType":"tennis-scoreboard","name":"Tennis Scoreboard","overlays":["sstv/tennis-scoreboard.vue"],"groups":["sstv","tennis"],"options":{"customColors":true,"customPosition":true}},{"componentType":"volleyball-scoreboard","name":"Volleyball Scoreboard","overlays":["sstv/volleyball-scoreboard.vue"],"groups":["sstv","volleyball"],"options":{"customColors":true,"customPosition":true}}]

/***/ }),
/* 1539 */
/***/ (function(module, exports) {

module.exports = [{"componentType":"generic-lower-third","name":"01 Event ID","overlays":["fig/event-id.html"],"groups":["fig"],"overlay":{"options":{}},"options":{}},{"componentType":"fig-team-presentation","name":"21 Athlete presentation (IND)","overlays":["fig/presentation-athlete.html"],"groups":["fig"],"overlay":{"options":{}},"options":{}},{"componentType":"fig-team-presentation","name":"31 Team presentation (SYN)","overlays":["fig/presentation-team.html"],"groups":["fig"],"overlay":{"options":{}},"options":{}},{"componentType":"fig-score-card","name":"22 Athlete score card (IND)","overlays":["fig/score-card-IND-DMT-TUM.html"],"groups":["fig"],"overlay":{"options":{}},"data":{"patternRank":"${rank}","patternFirstName":"${firstName0}","patternLastName":"${lastName0}","patternCountry":"${country0}","patternScore":"${score}","patternValue1":"${difficulty}","patternValue2":"${execution}","patternValue3":"${flight}","patternValue4":"${HD}","patternValue5":"${penalty}"}},{"componentType":"fig-score-card","name":"32 Team score card (SYN)","overlays":["fig/score-card-SYN.html"],"groups":["fig"],"data":{"patternRank":"${rank}","patternFirstName":"${countryName}","patternLastName":"","patternCountry":"${country0}","patternScore":"${score}","patternValue1":"${difficulty}","patternValue2":"${execution}","patternValue3":"${syncro}","patternValue4":"${HD}","patternValue5":"${penalty}"}},{"componentType":"ranking-list","name":"24 Ranking list IND","overlays":["fig/ranking-list-IND-DMT-TUM.html"],"groups":["fig"],"overlay":{"data":{},"options":{"pageIntervalSecs":7,"itemsPerPage":10}},"options":{}},{"componentType":"ranking-list","name":"34 Ranking list SYN","overlays":["fig/ranking-list-SYN.html"],"groups":["fig"],"overlay":{"data":{},"options":{"pageIntervalSecs":7,"itemsPerPage":10}},"options":{}},{"componentType":"starting-list","name":"20 Start list IND","overlays":["fig/start-list-IND-DMT-TUM.html"],"groups":["fig"],"overlay":{"data":{},"options":{"pageIntervalSecs":7,"itemsPerPage":10}},"options":{}},{"componentType":"starting-list","name":"30 Start list SYN","overlays":["fig/start-list-SYN.html"],"groups":["fig"],"overlay":{"data":{},"options":{"pageIntervalSecs":7,"itemsPerPage":10}},"options":{}},{"componentType":"generic-lower-third","name":"80 Victory presentation","overlays":["fig/event-id.html"],"groups":["fig"],"overlay":{"options":{}},"options":{}},{"componentType":"ranking-list","name":"83 Medallists IND","overlays":["fig/medallists-individual.html"],"groups":["fig"]},{"componentType":"ranking-list","name":"84 Medallists SYN","overlays":["fig/medallists-team.html"],"groups":["fig"]},{"componentType":"fig-score-lower-third","name":"81 Medal presentation IND","overlays":["fig/medal-presentation-individual.html"],"groups":["fig"],"data":{"patternRank":"${rank}","patternFirstName":"${firstName0}","patternLastName":"${lastName0}","patternCountry":"${country0}","patternScore":"${score}","patternDiscipline":"${discipline}"}},{"componentType":"fig-score-lower-third","name":"82 Medal presentation SYN","overlays":["fig/medal-presentation-team.html"],"groups":["fig"],"data":{"patternRank":"${rank}","patternFirstName":"${countryName}","patternLastName":"","patternCountry":"${country0}","patternScore":"${score}","patternDiscipline":"${discipline}"}},{"componentType":"fig-score-lower-third","name":"23 Athlete lower third (IND)","overlays":["fig/lower-third-athlete.html"],"groups":["fig"],"data":{"patternRank":"${rank}","patternFirstName":"${firstName0}","patternLastName":"${lastName0}","patternCountry":"${country0}","patternScore":"${score}","patternDiscipline":"${discipline}","patternSubtitle":""}},{"componentType":"fig-score-lower-third","name":"33 Team lower third (SYN)","overlays":["fig/lower-third-team.html"],"groups":["fig"],"data":{"patternRank":"${rank}","patternFirstName":"${countryName}","patternLastName":"","patternCountry":"${country0}","patternScore":"${score}","patternDiscipline":"${discipline}"}},{"componentType":"starting-list","name":"02 Judges list","overlays":["fig/list-judges.html"],"groups":["fig"],"overlay":{"data":{},"options":{"pageIntervalSecs":7,"itemsPerPage":10}},"options":{}}]

/***/ }),
/* 1540 */
/***/ (function(module, exports) {

module.exports = [{"componentType":"football-tactical","name":"Football Tactical","overlays":["glassy/football-tactical.html"],"groups":["demo","glassy"],"overlay":{"options":{"cssTop":"15vh","cssBottom":"15vh","cssLeft":"5vw","cssRight":"5vw","colors":{"backgroundColor1":"#bd0926","fontColor1":"white","backgroundColor2":"#ddd","fontColor2":"#333"}}},"options":{"customColors":["backgroundColor1","fontColor1","backgroundColor2","fontColor2"],"customPosition":true}},{"componentType":"generic-clock","name":"Generic Clock (Colors)","overlays":["glassy/lower-third-clock.html"],"groups":["demo","glassy","fig"],"overlay":{"options":{"autoHideSecs":0,"cssTop":"15vh","cssBottom":"5vh","cssLeft":"80vw","cssRight":"5vw","colors":{"backgroundColor1":"#bd0926","fontColor1":"white","backgroundColor2":"#ddd","fontColor2":"#333"},"displayMinutes":true}},"options":{"customColors":["backgroundColor1","fontColor1","backgroundColor2","fontColor2"],"customPosition":true}},{"componentType":"generic-lower-third","name":"Lower Third Generic (Colors)","overlays":["glassy/lower-third-generic.html"],"groups":["demo","glassy"],"overlay":{"options":{"cssTop":"15vh","cssBottom":"5vh","cssLeft":"25vw","cssRight":"25vw","colors":{"backgroundColor1":"#bd0926","fontColor1":"white","backgroundColor2":"#ddd","fontColor2":"#333"}}},"options":{"customColors":["backgroundColor1","fontColor1","backgroundColor2","fontColor2"],"customPosition":true,"hasExtraInfo":true}},{"componentType":"lower-third-athlete","name":"Lower Third Athlete (Colors)","overlays":["glassy/lower-third-athlete.html"],"groups":["demo","glassy"],"overlay":{"options":{"cssTop":"15vh","cssBottom":"5vh","cssLeft":"25vw","cssRight":"25vw","colors":{"backgroundColor1":"#bd0926","fontColor1":"white","backgroundColor2":"#ddd","fontColor2":"#333"}}},"options":{"customColors":["backgroundColor1","fontColor1","backgroundColor2","fontColor2"],"customPosition":true}},{"componentType":"ranking-list","name":"Ranking List (Colors)","overlays":["glassy/ranking-list.html"],"groups":["demo","glassy"],"overlay":{"options":{"cssTop":"15vh","cssBottom":"15vh","cssLeft":"5vw","cssRight":"5vw","colors":{"backgroundColor1":"#bd0926","fontColor1":"white","backgroundColor2":"#ddd","fontColor2":"#333"}}},"options":{"customColors":["backgroundColor1","fontColor1","backgroundColor2","fontColor2"],"customPosition":true}},{"componentType":"ranking-list","name":"Side List (Colors)","overlays":["glassy/side-list.html"],"groups":["demo","glassy"],"overlay":{"data":{"css":".col-rank {\n  flex-basis: 1.3em;\n}\n\n.col-score {\n  flex-basis: 2.8em;\n}\n"},"options":{"itemsPerPage":10,"cssTop":"5vh","cssBottom":"5vh","cssLeft":"5vw","cssRight":"5vw","colors":{"backgroundColor1":"#bd0926","fontColor1":"white","backgroundColor2":"#ddd","fontColor2":"#333"}}},"options":{"customCss":true,"customColors":["backgroundColor1","fontColor1","backgroundColor2","fontColor2"],"customPosition":true}},{"componentType":"sponsors","name":"Sponsors (Colors)","overlays":["glassy/lower-third-sponsors.html"],"groups":["demo","glassy"],"overlay":{"options":{"cssTop":"15vh","cssBottom":"5vh","cssLeft":"5vw","cssRight":"80vw","colors":{"backgroundColor1":"#bd0926","fontColor1":"white","backgroundColor2":"#ddd","fontColor2":"#333"}}},"options":{"customColors":["backgroundColor1","fontColor1","backgroundColor2","fontColor2"],"customPosition":true}},{"componentType":"sponsors-auto","name":"Sponsors (Colors/Auto)","overlays":["glassy/lower-third-sponsors.html"],"groups":["demo","glassy"],"overlay":{"options":{"cssTop":"15vh","cssBottom":"5vh","cssLeft":"5vw","cssRight":"80vw","colors":{"backgroundColor1":"#bd0926","fontColor1":"white","backgroundColor2":"#ddd","fontColor2":"#333"}}},"options":{"customColors":["backgroundColor1","fontColor1","backgroundColor2","fontColor2"],"customPosition":true}},{"componentType":"starting-list","name":"Starting List (Colors)","overlays":["glassy/starting-list.html"],"groups":["demo","glassy"],"overlay":{"options":{"cssTop":"15vh","cssBottom":"15vh","cssLeft":"5vw","cssRight":"5vw","colors":{"backgroundColor1":"#bd0926","fontColor1":"white","backgroundColor2":"#ddd","fontColor2":"#333"}}},"options":{"customColors":["backgroundColor1","fontColor1","backgroundColor2","fontColor2"],"customPosition":true}},{"componentType":"boxing-duel","name":"Boxing Paarung (Colors)","overlays":["glassy/boxing-duel.html"],"groups":["demo","glassy"],"overlay":{"data":{"color1":"#bd0926","color2":"#bd0926"},"options":{"cssTop":"15vh","cssBottom":"15vh","cssLeft":"5vw","cssRight":"5vw","colors":{"backgroundColor1":"#bd0926","fontColor1":"white","backgroundColor2":"#ddd","fontColor2":"#333"}}},"options":{"customColors":["backgroundColor1","fontColor1","backgroundColor2","fontColor2"],"customPosition":true}},{"componentType":"swiss-wrestling-duel","name":"Schwingen Paarung (Colors)","overlays":["glassy/swiss-wrestling-duel.html"],"groups":["demo","glassy"],"overlay":{"options":{"cssTop":"15vh","cssBottom":"15vh","cssLeft":"5vw","cssRight":"5vw","colors":{"backgroundColor1":"#bd0926","fontColor1":"white","backgroundColor2":"#ddd","fontColor2":"#333"}}},"options":{"customColors":["backgroundColor1","fontColor1","backgroundColor2","fontColor2"],"customPosition":true}},{"componentType":"swiss-wrestling-duel-2024","name":"Schwingen Paarung 2024 (Colors)","overlays":["glassy/swiss-wrestling-duel.html"],"groups":["demo","glassy"],"overlay":{"options":{"cssTop":"15vh","cssBottom":"15vh","cssLeft":"5vw","cssRight":"5vw","colors":{"backgroundColor1":"#bd0926","fontColor1":"white","backgroundColor2":"#ddd","fontColor2":"#333"}}},"options":{"customColors":["backgroundColor1","fontColor1","backgroundColor2","fontColor2"],"customPosition":true}},{"componentType":"swiss-wrestling-result","name":"Schwingen Resultat (Colors)","overlays":["glassy/swiss-wrestling-result.html"],"groups":["demo","glassy"],"overlay":{"options":{"cssTop":"15vh","cssBottom":"15vh","cssLeft":"5vw","cssRight":"5vw","colors":{"backgroundColor1":"#bd0926","fontColor1":"white","backgroundColor2":"#ddd","fontColor2":"#333"}}},"options":{"customColors":["backgroundColor1","fontColor1","backgroundColor2","fontColor2"],"customPosition":true}},{"componentType":"swiss-wrestling-result-2024","name":"Schwingen Resultat 2024 (Colors)","overlays":["glassy/swiss-wrestling-result.html"],"groups":["demo","glassy"],"overlay":{"options":{"cssTop":"15vh","cssBottom":"15vh","cssLeft":"5vw","cssRight":"5vw","colors":{"backgroundColor1":"#bd0926","fontColor1":"white","backgroundColor2":"#ddd","fontColor2":"#333"}}},"options":{"customColors":["backgroundColor1","fontColor1","backgroundColor2","fontColor2"],"customPosition":true}},{"componentType":"swiss-wrestling-leaderboard","name":"Schwingen Rangliste (Colors)","overlays":["glassy/ranking-list.html"],"groups":["demo","glassy"],"overlay":{"options":{"cssTop":"15vh","cssBottom":"15vh","cssLeft":"5vw","cssRight":"5vw","colors":{"backgroundColor1":"#bd0926","fontColor1":"white","backgroundColor2":"#ddd","fontColor2":"#333"}}},"options":{"customColors":["backgroundColor1","fontColor1","backgroundColor2","fontColor2"],"customPosition":true}},{"componentType":"swiss-wrestling-matches","name":"Schwingen Spitzenpaarungen","overlays":["glassy/starting-list.html"],"groups":["demo","glassy"],"overlay":{"data":{"title":"Spitzenpaarungen 1. Gang"},"options":{"cssTop":"15vh","cssBottom":"15vh","cssLeft":"5vw","cssRight":"5vw","colors":{"backgroundColor1":"#bd0926","fontColor1":"white","backgroundColor2":"#ddd","fontColor2":"#333"}}},"data":{"gang":"1","columnMap":{"nachname1":"p1_lastName","vorname1":"p1_firstName","sterne1":"p1_a_sterne","verband1":"p1_a_verband","nachname2":"p2_lastName","vorname2":"p2_firstName","sterne2":"p2_a_sterne","verband2":"p2_a_verband"}},"options":{"customColors":["backgroundColor1","fontColor1","backgroundColor2","fontColor2"],"customPosition":true}},{"componentType":"swiss-wrestling-notenblatt","name":"Schwingen Notenblatt","overlays":["glassy/swiss-wrestling-notenblatt.html"],"groups":["demo","glassy"],"overlay":{"data":{"title":""},"options":{"cssTop":"15vh","cssBottom":"15vh","cssLeft":"5vw","cssRight":"5vw","colors":{"backgroundColor1":"#bd0926","fontColor1":"white","backgroundColor2":"#ddd","fontColor2":"#333"}}},"data":{"bibNumber":"1","columnMap":{"bibNumber1":"p1_bibNumber","lastName1":"p1_lastName","firstName1":"p1_firstName","stars1":"p1_a_sterne","result1":"p1_a_resultat","score1":"p1_a_note","bibNumber2":"p2_bibNumber","lastName2":"p2_lastName","firstName2":"p2_firstName","stars2":"p2_a_sterne","result2":"p2_a_resultat","score2":"p2_a_note"}},"options":{"customColors":["backgroundColor1","fontColor1","backgroundColor2","fontColor2"],"customPosition":true}},{"componentType":"ranking-list","name":"Schwingen Seitenrangliste","overlays":["glassy/swiss-wrestling-side-list.html"],"groups":["demo","glassy"],"overlay":{"data":{"title":"Rangliste","css":".col-rank {\n  flex-basis: 1.3em;\n}\n\n.col-score {\n  flex-basis: 2.8em;\n}\n"},"options":{"autoDispatch":true,"itemsPerPage":10,"cssTop":"5vh","cssBottom":"5vh","cssLeft":"5vw","cssRight":"5vw","colors":{"backgroundColor1":"#bd0926","fontColor1":"white","backgroundColor2":"#ddd","fontColor2":"#333"}}},"options":{"customCss":true,"customColors":["backgroundColor1","fontColor1","backgroundColor2","fontColor2"],"customPosition":true}},{"componentType":"volleyball-scoreboard","name":"Volleyball Scoreboard (Colors)","overlays":["glassy/volleyball-scoreboard.html"],"groups":["demo","glassy"],"overlay":{"data":{"title1":"Team A","title2":"Team B","sets1":"0","sets2":"0","points1":"0","points2":"0"},"options":{"cssTop":"15vh","cssBottom":"15vh","cssLeft":"5vw","cssRight":"5vw","colors":{"backgroundColor1":"#bd0926","fontColor1":"white","backgroundColor2":"#ddd","fontColor2":"#333"}}},"options":{"customColors":["backgroundColor1","fontColor1","backgroundColor2","fontColor2"],"customPosition":true}},{"componentType":"match-title","name":"Match Title (Colors)","overlays":["glassy/match-title.html"],"groups":["floorball","futsal","sstv","tennis","volleyball"],"overlay":{"options":{"cssTop":"15vh","cssBottom":"15vh","cssLeft":"21vw","cssRight":"21vw","colors":{"backgroundColor1":"#bd0926","fontColor1":"white"}}},"options":{"customColors":["backgroundColor1","fontColor1"],"customPosition":true}}]

/***/ }),
/* 1541 */
/***/ (function(module, exports) {

module.exports = [{"componentType":"ifsc-vertical-life","name":"IFSC Vertical Life","overlays":["sstv/sstv-logo.html"],"groups":"ifsc","sortOrder":1},{"componentType":"uiaa-lead-intermediate-standings","name":"IFSC Lead Intermediate Standings","overlays":["ifsc/lead-intermediate-standings.vue"],"groups":"ifsc","overlay":{"options":{"itemsPerPage":10,"cssTop":"5vh","cssBottom":"5vh","cssLeft":"5vw","cssRight":"5vw","colors":{"backgroundColor1":"#bd0926","fontColor1":"white","backgroundColor2":"#ddd","fontColor2":"#333"}}},"options":{"customColors":["backgroundColor1","fontColor1","backgroundColor2","fontColor2"],"customPosition":true}}]

/***/ }),
/* 1542 */
/***/ (function(module, exports) {

module.exports = [{"componentType":"sstv-bug","name":"SSTV Logo","overlays":["sstv/sstv-logo-2021.html"],"groups":["floorball","futsal","sstv","tennis","uiaa","volleyball"],"options":{"customCss":true}},{"componentType":"sstv-bug","name":"SSTV Logo Cuadrado","overlays":["sstv/sstv-logo-cuadrado-2021.html"],"groups":["floorball","futsal","sstv","tennis","uiaa","volleyball"],"options":{"customCss":true}},{"componentType":"sstv-bug","name":"SSTV Station Bug (Obsolete)","overlays":["sstv/sstv-logo.html"],"groups":["floorball","futsal","sstv","tennis","uiaa","volleyball"]},{"componentType":"sstv-bug","name":"SSTV Channel Bug (Obsolete)","overlays":["sstv/sstv-channel-bug.vue"],"groups":["sstv","uiaa"]}]

/***/ }),
/* 1543 */
/***/ (function(module, exports) {

module.exports = [{"componentType":"generic-lower-third","name":"Bauchbinde","overlays":["swiss1/bb.html"],"groups":["swiss1"],"overlay":{"options":{"cssTop":"","cssBottom":"10vh","cssLeft":"10vw","cssRight":""}},"options":{"customPosition":true,"hasExtraInfo":false}},{"componentType":"swiss-wrestling-duel-2024","name":"Bauchbinde Paarung","overlays":["swiss1/bb_paarung.html"],"groups":["swiss1"],"overlay":{"options":{"cssTop":"","cssBottom":"10vh","cssLeft":"","cssRight":""}},"options":{"customPosition":true}},{"componentType":"swiss-wrestling-result-2024","name":"Bauchbinde Punkte","overlays":["swiss1/bb_punkte.html"],"groups":["swiss1"],"overlay":{"options":{"cssTop":"","cssBottom":"10vh","cssLeft":"","cssRight":""}},"options":{"customPosition":true}},{"componentType":"credits","name":"Credits","overlays":["swiss1/credits.html"],"groups":["swiss1"],"overlay":{"options":{"cssTop":"","cssBottom":"10vh","cssLeft":"","cssRight":""}},"options":{"customPosition":true}},{"componentType":"generic-lower-third","name":"Event-Titel","overlays":["swiss1/eventtitel.html"],"groups":["swiss1"],"overlay":{"options":{"cssTop":"","cssBottom":"10vh","cssLeft":"","cssRight":""}},"options":{"customPosition":true,"hasExtraInfo":false,"hasSubtitle":false}},{"componentType":"swiss-wrestling-duel-2024","name":"Paarung während Kampf","overlays":["swiss1/paarung_waehrend_kampf.html"],"groups":["swiss1"],"overlay":{"options":{"cssTop":"10vh","cssBottom":"","cssLeft":"7vw","cssRight":""}},"options":{"customPosition":true}},{"componentType":"swiss-wrestling-leaderboard","name":"Rangliste","overlays":["swiss1/rangliste.html"],"groups":["swiss1"],"overlay":{"data":{"gang":1},"options":{"cssTop":"10vh","cssBottom":"","cssLeft":"","cssRight":"","pageIntervalSecs":7,"itemsPerPage":10}},"options":{"customPosition":true}},{"componentType":"swiss-wrestling-matches","name":"Spitzenpaarungen","overlays":["swiss1/spitzenpaarungen.html"],"groups":["swiss1"],"overlay":{"data":{"title":"Spitzenpaarungen X. Gang"},"options":{"cssTop":"19vh","cssBottom":"","cssLeft":"","cssRight":"","pageIntervalSecs":7,"itemsPerPage":6}},"options":{"customPosition":true}},{"componentType":"swiss-wrestling-steckbrief","name":"Steckbrief","overlays":["swiss1/steckbrief.html"],"groups":["swiss1"],"overlay":{"options":{"cssTop":"","cssBottom":"10vh","cssLeft":"10vw","cssRight":""}},"options":{"customPosition":true}},{"componentType":"generic-clock","name":"Uhr während Kampf","overlays":["swiss1/uhr_waehrend_kampf.html"],"groups":"swiss1","overlay":{"options":{"cssTop":"10vh","cssBottom":"","cssLeft":"7vw","cssRight":"","autoHideSecs":5,"displayMinutes":true}},"options":{"customPosition":true}}]

/***/ }),
/* 1544 */
/***/ (function(module, exports) {

module.exports = [{"componentType":"swiss-wrestling-duel-2026","name":"Swiss Wrestling Duel 2026","hidden":true,"overlays":[],"groups":["demo","glassy"],"overlay":{"options":{}}}]

/***/ }),
/* 1545 */
/***/ (function(module, exports) {

module.exports = [{"componentType":"uiaa-results-center","name":"UIAA Results Center","overlays":["sstv/sstv-logo.html"],"groups":"uiaa","sortOrder":1},{"componentType":"uiaa-vertical-life","name":"UIAA Vertical Life","overlays":["sstv/sstv-logo.html"],"groups":"uiaa","sortOrder":1},{"componentType":"sstv-bug","name":"UIAA Bug","overlays":["uiaa/uiaa-bug.vue"],"groups":"uiaa","sortOrder":2},{"componentType":"generic-lower-third","name":"Trailer","overlays":["uiaa/trailer.vue"],"groups":"uiaa","sortOrder":3},{"componentType":"sstv-bug","name":"Trailer 2","overlays":["uiaa/trailer-2.vue"],"groups":"uiaa","sortOrder":4},{"componentType":"sstv-bug","name":"Partner Logo OR","overlays":["uiaa/partner-logo-or.vue"],"groups":"uiaa","sortOrder":5},{"componentType":"uiaa-partner-logos","name":"Partner Logos","overlays":["uiaa/partner-logos.vue"],"groups":"uiaa","sortOrder":6},{"componentType":"generic-lower-third","name":"Lower Third","overlays":["uiaa/lower-third-generic.vue"],"groups":"uiaa","sortOrder":7},{"componentType":"uiaa-lower-third-lead","name":"Lead Athlete","overlays":["uiaa/lower-third-lead-athlete.vue"],"groups":"uiaa"},{"componentType":"generic-clock","name":"Lead Clock","overlays":["uiaa/lower-third-lead-clock.vue"],"groups":"uiaa","overlay":{"data":{"title":"TIME LEFT","elapsedTimeMs":1200000},"options":{"direction":"down","displayMinutes":true}},"options":{"startHours":0,"startMins":20,"startSecs":0}},{"componentType":"uiaa-lead-intermediate-standings","name":"Lead Intermediate Standings","overlays":["uiaa/lead-intermediate-standings.vue"],"groups":"uiaa"},{"componentType":"uiaa-lead-intermediate-chart","name":"Lead Intermediate Chart","overlays":["uiaa/lead-intermediate-chart.vue"],"groups":"uiaa"},{"componentType":"uiaa-lower-third-speed","name":"Speed Dual Athlete","overlays":["uiaa/lower-third-speed-dual-athlete.vue"],"groups":"uiaa"},{"componentType":"generic-clock","name":"Speed Dual Clock","overlays":["uiaa/lower-third-speed-dual-clock.vue"],"groups":"uiaa","overlay":{"options":{"displayMinutes":true}}},{"componentType":"uiaa-lower-third-speed","name":"Speed Single Athlete","overlays":["uiaa/lower-third-speed-single-athlete.vue"],"groups":"uiaa"},{"componentType":"generic-clock","name":"Speed Single Clock","overlays":["uiaa/lower-third-speed-single-clock.vue"],"groups":"uiaa","overlay":{"options":{"displayMinutes":true}}},{"componentType":"uiaa-speed-intermediate-standings","name":"Speed Intermediate Standings","overlays":["uiaa/speed-intermediate-standings.vue"],"groups":"uiaa"},{"componentType":"knockout","name":"Speed Knockout Results","overlays":["uiaa/knockout-results.vue"],"groups":"uiaa","overlay":{"data":{"title":"SPEED DUEL","rounds":4}}},{"componentType":"ranking-list","name":"Ranking List Provisional","overlays":["uiaa/ranking-list-without-results.vue"],"groups":"uiaa","overlay":{"data":{"title":"PROVISIONAL RANKINGS"},"options":{"pageIntervalSecs":40}},"sortOrder":22},{"componentType":"ranking-list","name":"Ranking List Results","overlays":["uiaa/ranking-list-with-results.vue"],"groups":"uiaa","overlay":{"data":{"title":"PROVISIONAL RANKINGS"},"options":{"pageIntervalSecs":40}},"sortOrder":23},{"componentType":"starting-list","name":"Starting List","overlays":["uiaa/starting-list.vue"],"groups":"uiaa","overlay":{"data":{"title":"STARTING LIST"},"options":{"pageIntervalSecs":40}},"sortOrder":21},{"componentType":"uiaa-victory-ceremony-athlete","name":"Victory Ceremony Athlete","overlays":["uiaa/lower-third-victory-ceremony-athlete.vue"],"groups":"uiaa"},{"componentType":"uiaa-victory-ceremony-group","name":"Victory Ceremony Group","overlays":["uiaa/lower-third-victory-ceremony-group.vue"],"groups":"uiaa"}]

/***/ }),
/* 1546 */
/***/ (function(module, exports) {

module.exports = [{"componentType":"loopic-template","name":"loopic-template","hidden":true,"overlays":[],"groups":[],"options":{"customCss":false}},{"componentType":"generic-lower-third","name":"Custom Lower Third","overlays":["custom-style/lower-third.html"],"groups":["avms-football-clubs","floorball","futsal","sstv","tennis","volleyball"],"overlay":{"data":{"title":"","subtitle":"","extraInfo":"","css":"#overlay {\n  left: 5vw;\n  bottom: 5vh;\n  max-width: calc(100vw - 10vw);\n}\n\n#title {\n  padding: 0.3em;\n  font-family: Verdana, Arial, Helvetica, sans-serif;\n  font-size: 40px;\n  font-weight: bold;\n  background-color: #008;\n  color: #fff;\n}\n\n#subtitle {\n  padding: 0.3em;\n  font-family: Verdana, Arial, Helvetica, sans-serif;\n  font-size: 30px;\n  font-weight: bold;\n  background-color: #fff;\n  color: #222;\n}\n\n#extra-info {\n  display: inline-block;\n  padding: 0.3em;\n  font-family: Verdana, Arial, Helvetica, sans-serif;\n  font-size: 30px;\n  font-weight:bold;\n  background-color: #fff;\n  color: #222;\n}"}},"options":{"customBackgroundImage":true,"customCss":true,"hasExtraInfo":true},"sortOrder":1},{"componentType":"generic-image","name":"Custom Image","overlays":["custom-style/image.html"],"groups":["avms-football-clubs","sstv","fig"],"overlay":{"data":{"image":null,"css":"#overlay {\n  left: 0%;\n  top: 0%;\n  right: 0%;\n  bottom: 0%;\n  background-size: cover;\n  transition: opacity 0s;\n}"}},"options":{"customCss":true},"sortOrder":1},{"componentType":"athletica","name":"Athletica","overlays":["sstv/sstv-logo.html"],"groups":["sstv","athletics"]},{"componentType":"sponsors-auto","name":"Custom Sponsors (Auto)","overlays":["custom-style/sponsors.html"],"groups":["avms-football-clubs","sstv"],"overlay":{"data":{"image":null,"css":"#overlay {\n  left: 0%;\n  top: 0%;\n  right: 0%;\n  bottom: 0%;\n  background-size: cover;\n  transition: opacity 0.9s;\n}"},"options":{"interval":1,"duration":9}},"options":{"customCss":true},"sortOrder":1},{"componentType":"manager-video","name":"Manager Video","overlays":["custom-style/manager-video.html"],"groups":["avms-football-clubs","sstv"],"overlay":{"data":{"muted":true,"css":"#overlay {\n  position: absolute;\n  left: 0%;\n  top: 0%;\n  right: 0%;\n  bottom: 0%;\n}\n\n#video {\n  background: none;\n}\n"}},"options":{"customCss":true},"sortOrder":1},{"componentType":"pdf-presentation","name":"PDF Presentation","overlays":["custom-style/pdf-presentation.html"],"groups":["avms-football-clubs","sstv"],"overlay":{"data":{"css":"#overlay { background-color: black; }"}},"options":{"customCss":true}},{"componentType":"polling-results","name":"Polling Results Chart","overlays":["custom-style/polling-results.html"],"groups":["sstv"],"overlay":{"data":{"css":"#overlay {\n  position: absolute;\n  left: 10%;\n  top: 10%;\n  right: 10%;\n  bottom: 10%;\n  background: rgba(255, 255, 255, 0.8);\n  border: solid #333 1px;\n  border-radius: 15px;\n  padding: 30px;\n}","title":"{{ question }}","labels":[],"colors":["#bd0926","#bd0926","#bd0926","#bd0926","#bd0926","#bd0926","#bd0926","#bd0926","#bd0926","#bd0926"]},"options":{"colors":{"barColor":"#bd0926","fontColor":"#333333","xAxisFontColor":"#333333","yAxisFontColor":"#333333"},"customJson":{"chart":{"textStyle":{"fontFamily":"Avenir, Verdana, sans-serif","fontSize":35},"title":{"textStyle":{"fontSize":35},"textAlign":"auto","left":"center"},"xAxis":{"axisLabel":{"fontSize":35}},"yAxis":{"axisLabel":{"fontSize":35}},"series":[{"realtimeSort":true}]}}}},"options":{"customCss":true,"customJson":true,"customColors":["barColor","fontColor","xAxisFontColor","yAxisFontColor"]}},{"componentType":"polling-results-list","name":"Polling Results List","overlays":["custom-style/polling-results-list.html"],"groups":["sstv"],"overlay":{"data":{"css":"#overlay {\n  left: 5vw;\n  bottom: 5vh;\n  max-width: calc(100vw - 10vw);\n}\n\n#title {\n  padding: 0.3em;\n  font-family: Verdana, Arial, Helvetica, sans-serif;\n  font-size: 40px;\n  font-weight: bold;\n  background-color: #008;\n  color: #fff;\n}\n\ntable {\n  width: 100%;\n  background-color: #fff;\n}\n\ntd {\n  padding: 0.3em;\n  font-family: Verdana, Arial, Helvetica, sans-serif;\n  font-size: 30px;\n  font-weight: bold;\n  color: #222;\n}\n\ntd:nth-child(2) {\n  text-align: right;\n  font-weight: bolder;\n}","title":"{{ question }}"}},"options":{"customCss":true}},{"componentType":"sstv-bug","name":"Stadtlauf-Uhr","overlays":["sstv/analog-clock.vue"],"groups":["stadtlauf"]},{"componentType":"sstv-bug","name":"Stadtlauf-Banner","overlays":["sstv/stadtlauf.vue"],"groups":["stadtlauf"]},{"componentType":"custom-bug","name":"Custom Bug","overlays":["sstv/custom-bug.vue"],"groups":["avms-football-clubs","floorball","futsal","sstv","tennis","volleyball"]},{"componentType":"volleyball","name":"Volleyball","overlays":["sstv/sstv-logo.html"],"groups":["sstv","volleyball"]}]

/***/ }),
/* 1547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-navbar',{attrs:{"toggleable":"sm","variant":"dark","type":"dark","sticky":""}},[_c('b-navbar-brand',{attrs:{"href":"#"}},[_vm._v("webcg-studio")]),_vm._v(" "),_c('b-nav-toggle',{attrs:{"toggleable":"false","target":"nav_collapse","right":""}}),_vm._v(" "),(_vm.loaded)?_c('b-collapse',{attrs:{"is-nav":"","id":"nav_collapse"}},[_c('b-navbar-nav',[_c('b-nav-item-dropdown',{attrs:{"text":"New"}},[(_vm.hasLibraryRole)?_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){_vm.openTemplateSelection()}}},[_vm._v("Template Library...")]):_vm._e(),_vm._v(" "),(_vm.hasLibraryRole && _vm.userTemplates && _vm.userTemplates.length)?_c('div',{staticClass:"dropdown-divider"}):_vm._e(),_vm._v(" "),_vm._l((_vm.userTemplates),function(t){return _c('b-dropdown-item',{attrs:{"href":"#"},domProps:{"innerHTML":_vm._s(t.name)},on:{"click":function($event){_vm.addTemplate(t)}}})})],2),_vm._v(" "),_vm._l((_vm.folders),function(templates,name){return _c('b-nav-item-dropdown',{key:name,attrs:{"text":name || 'Templates'}},_vm._l((templates),function(template){return _c('b-dropdown-item',{key:template.templateId,attrs:{"href":"#"},domProps:{"innerHTML":_vm._s(template.name)},on:{"click":function($event){_vm.openTemplate(template.templateId)}}})}))}),_vm._v(" "),_c('b-nav-item-dropdown',{attrs:{"text":"Datasets"}},[_vm._l((_vm.datasets),function(dataset){return _c('b-dropdown-item',{key:dataset.datasetId,attrs:{"href":"#"},domProps:{"innerHTML":_vm._s(dataset.name)},on:{"click":function($event){_vm.openDataset(dataset.datasetId)}}})}),_vm._v(" "),(_vm.datasets && _vm.datasets.length)?_c('div',{staticClass:"dropdown-divider"}):_vm._e(),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){_vm.addDatasetExcel()}}},[_vm._v("New Excel-Dataset")]),_vm._v(" "),(_vm.isRaceResult)?_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){_vm.addDatasetRaceResult('race-result-dataset-window')}}},[_vm._v("New Race Result Dataset")]):_vm._e(),_vm._v(" "),(_vm.isUiaa)?_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){_vm.addDatasetUiaa('uiaa-dataset-window')}}},[_vm._v("New UIAA Results Center Dataset")]):_vm._e(),_vm._v(" "),(_vm.isUiaa)?_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){_vm.addDatasetUiaa('vertical-life-dataset-window')}}},[_vm._v("New Vertical Life Dataset")]):_vm._e()],2),_vm._v(" "),_c('b-nav-item-dropdown',{attrs:{"text":"Albums"}},[_vm._l((_vm.albums),function(album){return _c('b-dropdown-item',{key:album.albumId,attrs:{"href":"#"},domProps:{"innerHTML":_vm._s(album.name)},on:{"click":function($event){_vm.openAlbum(album.albumId)}}})}),_vm._v(" "),(_vm.albums && _vm.albums.length)?_c('div',{staticClass:"dropdown-divider"}):_vm._e(),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){_vm.addAlbum()}}},[_vm._v("New Album")])],2),_vm._v(" "),_c('b-nav-item-dropdown',{attrs:{"text":"Windows"}},[_vm._l((_vm.windows),function(window){return _c('b-dropdown-item',{key:window.windowId,attrs:{"href":"#"},on:{"click":function($event){_vm.openWindow(window.windowId)}}},[_vm._v(_vm._s(window.title)+"\n        ")])}),_vm._v(" "),(_vm.windows && _vm.windows.length)?_c('div',{staticClass:"dropdown-divider"}):_vm._e(),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){_vm.addProducer('Preview', 'preview')}}},[_vm._v("New Preview")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){_vm.addProducer('Program', 'program')}}},[_vm._v("New Program")])],2)],2),_vm._v(" "),_c('b-navbar-nav',{staticClass:"ml-auto"},[_c('b-nav-item-dropdown',{attrs:{"right":""}},[_c('template',{slot:"button-content"},[_vm._v("\n          "+_vm._s(_vm.username)+"\n        ")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"},on:{"click":function($event){_vm.logout()}}},[_vm._v("Logout")])],2)],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_notifications_vue__ = __webpack_require__(1550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e1d21e0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notifications_vue__ = __webpack_require__(1551);
function injectStyle (ssrContext) {
  __webpack_require__(1549)
}
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4e1d21e0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_notifications_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e1d21e0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notifications_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1549 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'notifications',
  computed: {
    hasNotifications: function hasNotifications() {
      return this.notificationConnection;
    },
    notificationConnection: function notificationConnection() {
      return !this.$store.getters.connected;
    }
  }
});

/***/ }),
/* 1551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasNotifications)?_c('div',{attrs:{"id":"notifications"}},[(_vm.notificationConnection)?_c('div',{staticClass:"alert alert-danger",attrs:{"id":"notification_connection"}},[_c('h4',{staticClass:"alert-heading"},[_vm._v("Connection lost!")]),_vm._v(" "),_c('p',[_vm._v("Attempting to restore connection. Changes made now are not saved.")])]):_vm._e()]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vue_draggable_resizable_vue__ = __webpack_require__(1554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73b51f70_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vue_draggable_resizable_vue__ = __webpack_require__(1562);
function injectStyle (ssrContext) {
  __webpack_require__(1553)
}
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-73b51f70"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vue_draggable_resizable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73b51f70_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vue_draggable_resizable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1553 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(7);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  replace: true,
  name: 'vue-draggable-resizable',
  props: {
    draggable: {
      type: Boolean, default: true
    },
    resizable: {
      type: Boolean, default: true
    },
    w: {
      type: Number,
      default: 200,
      validator: function validator(val) {
        return val > 0;
      }
    },
    h: {
      type: Number,
      default: 200,
      validator: function validator(val) {
        return val > 0;
      }
    },
    minw: {
      type: Number,
      default: 10,
      validator: function validator(val) {
        return val > 0;
      }
    },
    minh: {
      type: Number,
      default: 10,
      validator: function validator(val) {
        return val > 0;
      }
    },
    x: {
      type: Number,
      default: 0,
      validator: function validator(val) {
        return val >= 0;
      }
    },
    y: {
      type: Number,
      default: 0,
      validator: function validator(val) {
        return val >= 0;
      }
    },
    handles: {
      type: Array,
      default: function _default() {
        return ['tm', 'mr', 'bm', 'ml', 'tl', 'tr', 'bl', 'br'];
      }
    },
    axis: {
      type: String,
      default: 'both',
      validator: function validator(val) {
        return ['x', 'y', 'both'].indexOf(val) !== -1;
      }
    },
    grid: {
      type: Array,
      default: function _default() {
        return [1, 1];
      }
    },
    parent: {
      type: Boolean, default: false
    },
    maximize: {
      type: Boolean, default: false
    },
    zIndex: {
      type: Number, default: 1
    }
  },
  created: function created() {
    this.parentX = 0;
    this.parentW = 9999;
    this.parentY = 0;
    this.parentH = 9999;

    this.mouseX = 0;
    this.mouseY = 0;

    this.lastMouseX = 0;
    this.lastMouseY = 0;

    this.mouseOffX = 0;
    this.mouseOffY = 0;

    this.elmX = 0;
    this.elmY = 0;

    this.elmW = 0;
    this.elmH = 0;
  },
  mounted: function mounted() {
    this.$dragHandle = this.$el;
    this.$dragHandle.addEventListener('mousedown', this.dragHandleDown, true);
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["i" /* observeDom */])(this.$el, function () {
      if (this.$dragHandle) this.$dragHandle.removeEventListener('mousedown', this.dragHandleDown, true);
      this.$dragHandle = this.$el.getElementsByClassName('vdr-drag-handle')[0];
      if (this.$dragHandle) this.$dragHandle.addEventListener('mousedown', this.dragHandleDown, true);
    }.bind(this), { subtree: true });

    document.documentElement.addEventListener('mousemove', this.handleMove, true);
    document.documentElement.addEventListener('mousedown', this.deselect, true);
    document.documentElement.addEventListener('mouseup', this.handleUp, true);

    if (this.minw > this.w) this.width = this.minw;

    if (this.minh > this.h) this.height = this.minh;

    if (this.parent) {
      var parentW = parseInt(this.$el.parentNode.clientWidth, 10);
      var parentH = parseInt(this.$el.parentNode.clientHeight, 10);

      this.parentW = parentW;
      this.parentH = parentH;

      if (this.w > this.parentW) this.width = parentW;

      if (this.h > this.parentH) this.height = parentH;

      if (this.x + this.w > this.parentW) this.width = parentW - this.x;

      if (this.y + this.h > this.parentH) this.height = parentH - this.y;
    }

    this.$emit('resizing', this.left, this.top, this.width, this.height);
  },
  beforeDestroy: function beforeDestroy() {
    if (this.$dragHandle) {
      this.$dragHandle.removeEventListener('mousedown', this.dragHandleDown, true);
    }
    document.documentElement.removeEventListener('mousemove', this.handleMove, true);
    document.documentElement.removeEventListener('mousedown', this.deselect, true);
    document.documentElement.removeEventListener('mouseup', this.handleUp, true);
  },
  data: function data() {
    return {
      $dragHandle: null,
      top: this.y,
      left: this.x,
      width: this.w,
      height: this.h,
      resizing: false,
      dragging: false,
      active: false,
      handle: null
    };
  },
  methods: {
    elmDown: function elmDown(e) {
      var target = e.target || e.srcElement;

      if (this.$el.contains(target)) {
        if (!this.active) {
          // this.zIndex += 1
          this.active = true;

          this.$emit('activated');
        }

        this.elmX = parseInt(this.$el.style.left);
        this.elmY = parseInt(this.$el.style.top);
        this.elmW = this.$el.offsetWidth || this.$el.clientWidth;
        this.elmH = this.$el.offsetHeight || this.$el.clientHeight;

        // if (this.draggable) {
        //   this.dragging = true
        // }
      }
    },
    dragHandleDown: function dragHandleDown(e) {
      var target = e.target || e.srcElement;

      if (this.$el.contains(target)) {
        if (this.draggable) {
          this.dragging = true;
        }
      }
    },
    deselect: function deselect(e) {
      var target = e.target || e.srcElement;
      var regex = new RegExp('handle-([trmbl]{2})', '');

      if (!this.$el.contains(target) && !regex.test(target.className)) {
        if (this.active) {
          this.active = false;

          this.$emit('deactivated');
        }
      }
    },
    handleDown: function handleDown(handle, e) {
      this.handle = handle;

      if (e.stopPropagation) e.stopPropagation();
      if (e.preventDefault) e.preventDefault();

      this.resizing = true;
    },
    fillParent: function fillParent(e) {
      var _this = this;

      if (!this.parent || !this.resizable || !this.maximize) return;

      var done = false;

      var animate = function animate() {
        if (!done) {
          window.requestAnimationFrame(animate);
        }

        if (_this.axis === 'x') {
          if (_this.width === _this.parentW && _this.left === _this.parentX) done = true;
        } else if (_this.axis === 'y') {
          if (_this.height === _this.parentH && _this.top === _this.parentY) done = true;
        } else if (_this.axis === 'both') {
          if (_this.width === _this.parentW && _this.height === _this.parentH && _this.top === _this.parentY && _this.left === _this.parentX) done = true;
        }

        if (_this.axis === 'x' || _this.axis === 'both') {
          if (_this.width < _this.parentW) {
            _this.width++;
            _this.elmW++;
          }

          if (_this.left > _this.parentX) {
            _this.left--;
            _this.elmX--;
          }
        }

        if (_this.axis === 'y' || _this.axis === 'both') {
          if (_this.height < _this.parentH) {
            _this.height++;
            _this.elmH++;
          }

          if (_this.top > _this.parentY) {
            _this.top--;
            _this.elmY--;
          }
        }

        _this.$emit('resizing', _this.left, _this.top, _this.width, _this.height);
      };

      window.requestAnimationFrame(animate);
    },
    handleMove: function handleMove(e) {
      this.mouseX = e.pageX || e.clientX + document.documentElement.scrollLeft;
      this.mouseY = e.pageY || e.clientY + document.documentElement.scrollTop;

      var diffX = this.mouseX - this.lastMouseX + this.mouseOffX;
      var diffY = this.mouseY - this.lastMouseY + this.mouseOffY;

      this.mouseOffX = this.mouseOffY = 0;

      this.lastMouseX = this.mouseX;
      this.lastMouseY = this.mouseY;

      var dX = diffX;
      var dY = diffY;

      if (this.resizing) {
        if (this.handle.indexOf('t') >= 0) {
          if (this.elmH - dY < this.minh) this.mouseOffY = dY - (diffY = this.elmH - this.minh);else if (this.elmY + dY < this.parentY) this.mouseOffY = dY - (diffY = this.parentY - this.elmY);
          this.elmY += diffY;
          this.elmH -= diffY;
        }

        if (this.handle.indexOf('b') >= 0) {
          if (this.elmH + dY < this.minh) this.mouseOffY = dY - (diffY = this.minh - this.elmH);else if (this.elmY + this.elmH + dY > this.parentH) this.mouseOffY = dY - (diffY = this.parentH - this.elmY - this.elmH);
          this.elmH += diffY;
        }

        if (this.handle.indexOf('l') >= 0) {
          if (this.elmW - dX < this.minw) this.mouseOffX = dX - (diffX = this.elmW - this.minw);else if (this.elmX + dX < this.parentX) this.mouseOffX = dX - (diffX = this.parentX - this.elmX);
          this.elmX += diffX;
          this.elmW -= diffX;
        }

        if (this.handle.indexOf('r') >= 0) {
          if (this.elmW + dX < this.minw) this.mouseOffX = dX - (diffX = this.minw - this.elmW);else if (this.elmX + this.elmW + dX > this.parentW) this.mouseOffX = dX - (diffX = this.parentW - this.elmX - this.elmW);
          this.elmW += diffX;
        }

        this.left = Math.round(this.elmX / this.grid[0]) * this.grid[0];
        this.top = Math.round(this.elmY / this.grid[1]) * this.grid[1];

        this.width = Math.round(this.elmW / this.grid[0]) * this.grid[0];
        this.height = Math.round(this.elmH / this.grid[1]) * this.grid[1];

        this.$emit('resizing', this.left, this.top, this.width, this.height);
      } else if (this.dragging) {
        if (this.elmX + dX < this.parentX) this.mouseOffX = dX - (diffX = this.parentX - this.elmX);else if (this.elmX + this.elmW + dX > this.parentW) this.mouseOffX = dX - (diffX = this.parentW - this.elmX - this.elmW);

        if (this.elmY + dY < this.parentY) this.mouseOffY = dY - (diffY = this.parentY - this.elmY);else if (this.elmY + this.elmH + dY > this.parentH) this.mouseOffY = dY - (diffY = this.parentH - this.elmY - this.elmH);

        this.elmX += diffX;
        this.elmY += diffY;

        if (this.axis === 'x' || this.axis === 'both') {
          this.left = Math.round(this.elmX / this.grid[0]) * this.grid[0];
        }
        if (this.axis === 'y' || this.axis === 'both') {
          this.top = Math.round(this.elmY / this.grid[1]) * this.grid[1];
        }

        this.$emit('dragging', this.left, this.top);
      }
    },
    handleUp: function handleUp(e) {
      this.handle = null;
      if (this.resizing) {
        this.resizing = false;
        this.$emit('resizestop', this.left, this.top, this.width, this.height);
      }
      if (this.dragging) {
        this.dragging = false;
        this.$emit('dragstop', this.left, this.top);
      }

      this.elmX = this.left;
      this.elmY = this.top;
    }
  },
  computed: {
    draggableClass: function draggableClass() {
      return this.draggable && this.$el === this.$dragHandle;
    },
    style: function style() {
      return {
        top: this.top + 'px',
        left: this.left + 'px',
        width: this.width + 'px',
        height: this.height + 'px',
        zIndex: this.zIndex
      };
    }
  },
  watch: {
    active: function active(val) {
      if (!this.$dragHandle) return;
      this.$dragHandle.classList.toggle('vdr-handle-active', val);
    }
  }
});

/***/ }),
/* 1555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["uiaaLeadScore"] = uiaaLeadScore;
function uiaaLeadScore(a, b) {
  if (typeof a !== 'string') a = '';
  if (typeof b !== 'string') b = '';

  function match(s) {
    var m = s.match(/(TOP|[\d.]+)(?:\((.+)\))?/i);
    if (!m) return { h: 0, t: 0 };
    return {
      h: m[1].toLowerCase() === 'top' ? Number.MAX_VALUE : parseFloat(m[1]),
      t: parseFloat(m[2])
    };
  }

  a = match(a);
  b = match(b);
  if (a.h !== b.h) return b.h - a.h;
  if (a.t !== b.t) return a.t - b.t;
  return 0;
}

/* harmony default export */ __webpack_exports__["default"] = ({
  uiaaLeadScore: uiaaLeadScore
});

/***/ }),
/* 1556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function rank(rankKey, scoreKey) {
  return function (each, idx, array) {
    if (idx > 0 && array[idx - 1][scoreKey] === each[scoreKey]) {
      each[rankKey] = array[idx - 1][rankKey];
    } else {
      each[rankKey] = idx + 1;
    }
  };
}

/* harmony default export */ __webpack_exports__["a"] = (rank);

/***/ }),
/* 1557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = observeDOM;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

/**
 * Observe a DOM element changes, falls back to eventListener mode
 * @param {Element} el The DOM element to observe
 * @param {Function} callback callback to be called on change
 * @param {object} [opts={childList: true, subtree: true}] observe options
 * @see http://stackoverflow.com/questions/3219758
 */
function observeDOM(el, callback, opts) {
  var MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
  var eventListenerSupported = window.addEventListener;

  if (MutationObserver) {
    // Define a new observer
    var obs = new MutationObserver(function (mutations) {
      if (mutations[0].addedNodes.length > 0 || mutations[0].removedNodes.length > 0) {
        callback();
      }
    });

    // Have the observer observe foo for changes in children
    obs.observe(el, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ childList: true, subtree: true }, opts));
  } else if (eventListenerSupported) {
    el.addEventListener('DOMNodeInserted', callback, false);
    el.addEventListener('DOMNodeRemoved', callback, false);
  }
}

/***/ }),
/* 1558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mapImageIdToImage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_action_types__ = __webpack_require__(5);


function mapImageIdToImage(albumIdProp, imageIdProp, imageProp) {
  var ret = {};
  ret[imageIdProp] = function (val) {
    var image = this.$store.getters.picture(this[albumIdProp], val) || null;
    var data = {};
    data[imageProp] = image;
    this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_action_types__["z" /* TEMPLATE_OVERLAY_DATA */], { templateId: this.templateId, data: data });
  };
  return ret;
}

/***/ }),
/* 1559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__overlayOptionProp__ = __webpack_require__(266);



/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  var res = {};
  Object(__WEBPACK_IMPORTED_MODULE_0__lib__["c" /* normalizeMap */])(props).forEach(function (_ref) {
    var key = _ref.key,
        val = _ref.val;

    res[key] = Object(__WEBPACK_IMPORTED_MODULE_1__overlayOptionProp__["a" /* default */])(key, val);
  });
  return res;
});

/***/ }),
/* 1560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__windowDataProp__ = __webpack_require__(271);



/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  var res = {};
  Object(__WEBPACK_IMPORTED_MODULE_0__lib__["c" /* normalizeMap */])(props).forEach(function (_ref) {
    var key = _ref.key,
        val = _ref.val;

    res[key] = Object(__WEBPACK_IMPORTED_MODULE_1__windowDataProp__["a" /* default */])(key, val);
  });
  return res;
});

/***/ }),
/* 1561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_mutation_types__ = __webpack_require__(14);


function windowTitleProp() {
  return {
    get: function get() {
      return this.$store.getters.windowTitle(this.windowId);
    },
    set: function set(val) {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["W" /* WINDOW_TITLE */], {
        windowId: this.windowId,
        title: val,
        emit: true
      });
    }
  };
}

/* harmony default export */ __webpack_exports__["a"] = (windowTitleProp);

/***/ }),
/* 1562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vdr",class:{ draggable: _vm.draggableClass, resizable: _vm.resizable, active: _vm.active, dragging: _vm.dragging, resizing: _vm.resizing },style:(_vm.style),on:{"mousedown":_vm.elmDown,"dblclick":_vm.fillParent}},[_vm._l((_vm.handles),function(handle){return (_vm.resizable)?_c('div',{staticClass:"handle",class:'handle-' + handle,style:({ display: _vm.active ? 'block' : 'none'}),on:{"mousedown":function($event){$event.stopPropagation();$event.preventDefault();_vm.handleDown(handle, $event)}}}):_vm._e()}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('navbar'),_vm._v(" "),_c('notifications'),_vm._v(" "),_c('div',{staticClass:"container-fluid workspace-wrapper"},[_c('div',{ref:"workspace",staticClass:"workspace"},[(_vm.loading)?_c('div',{staticClass:"loading"},[_c('icon',{staticClass:"fa-spin",attrs:{"name":"spinner"}})],1):_vm._e(),_vm._v(" "),_vm._l((_vm.windows),function(window){return (!_vm.loading)?_c('vue-draggable-resizable',{key:window.windowId,staticClass:"window-wrapper",attrs:{"w":window.data.w || _vm.defaultWidth,"minw":200,"h":window.data.h || _vm.defaultHeight,"minh":40,"x":_vm.getWindowX(window),"y":_vm.getWindowY(window),"zIndex":window.data.zIndex,"parent":true,"grid":[5, 5]},on:{"dragging":function (x,y) { return _vm.onDragged(window.windowId, x, y); },"resizing":function (x,y,w,h) { return _vm.onResized(window.windowId, x, y, w, h); },"activated":function () { return _vm.activated(window.windowId); }}},[_c(window.componentType,{tag:"component",staticClass:"window-container",attrs:{"window-id":window.windowId}})],1):_vm._e()})],2)]),_vm._v(" "),_c('datalist',{attrs:{"id":"folders"}},_vm._l((_vm.folders),function(folder){return _c('option',{domProps:{"value":folder}})}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__template_settings_template_settings_vue__ = __webpack_require__(1565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui__ = __webpack_require__(1580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__album_vue__ = __webpack_require__(1630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dataset_vue__ = __webpack_require__(1643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__race_result_dataset_vue__ = __webpack_require__(1659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__uiaa_results_center_dataset_vue__ = __webpack_require__(1664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__producer_window_vue__ = __webpack_require__(1667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__templates__ = __webpack_require__(1671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__template_not_found_vue__ = __webpack_require__(1826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__template_library_vue__ = __webpack_require__(1829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__vertical_life_dataset_vue__ = __webpack_require__(1833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__window_vue__ = __webpack_require__(1836);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__window_tab_vue__ = __webpack_require__(1839);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__window_tabs_vue__ = __webpack_require__(1843);















var Components = {
  install: function install(Vue) {
    Vue.component('template-settings', __WEBPACK_IMPORTED_MODULE_0__template_settings_template_settings_vue__["a" /* default */]);

    Vue.component('album-select', __WEBPACK_IMPORTED_MODULE_1__ui__["a" /* AlbumSelect */]);
    Vue.component('album-select-group', __WEBPACK_IMPORTED_MODULE_1__ui__["b" /* AlbumSelectGroup */]);
    Vue.component('checkbox-input-group', __WEBPACK_IMPORTED_MODULE_1__ui__["c" /* CheckboxInputGroup */]);
    Vue.component('color-select-group', __WEBPACK_IMPORTED_MODULE_1__ui__["d" /* ColorSelectGroup */]);
    Vue.component('column-select', __WEBPACK_IMPORTED_MODULE_1__ui__["e" /* ColumnSelect */]);
    Vue.component('dataset-select', __WEBPACK_IMPORTED_MODULE_1__ui__["f" /* DatasetSelect */]);
    Vue.component('dataset-select-group', __WEBPACK_IMPORTED_MODULE_1__ui__["g" /* DatasetSelectGroup */]);
    Vue.component('number-input-group', __WEBPACK_IMPORTED_MODULE_1__ui__["h" /* NumberInputGroup */]);
    Vue.component('picture-select', __WEBPACK_IMPORTED_MODULE_1__ui__["i" /* PictureSelect */]);
    Vue.component('picture-select-group', __WEBPACK_IMPORTED_MODULE_1__ui__["j" /* PictureSelectGroup */]);
    Vue.component('switch-buttons', __WEBPACK_IMPORTED_MODULE_1__ui__["m" /* SwitchButtons */]);
    Vue.component('record-select', __WEBPACK_IMPORTED_MODULE_1__ui__["k" /* RecordSelect */]);
    Vue.component('record-select-group', __WEBPACK_IMPORTED_MODULE_1__ui__["l" /* RecordSelectGroup */]);
    Vue.component('table-edit', __WEBPACK_IMPORTED_MODULE_1__ui__["n" /* TableEdit */]);
    Vue.component('template-select', __WEBPACK_IMPORTED_MODULE_1__ui__["o" /* TemplateSelect */]);
    Vue.component('text-input-group', __WEBPACK_IMPORTED_MODULE_1__ui__["p" /* TextInputGroup */]);

    Vue.component('album-window', __WEBPACK_IMPORTED_MODULE_2__album_vue__["a" /* default */]);
    Vue.component('dataset-window', __WEBPACK_IMPORTED_MODULE_3__dataset_vue__["a" /* default */]);
    Vue.component('race-result-dataset-window', __WEBPACK_IMPORTED_MODULE_4__race_result_dataset_vue__["a" /* default */]);
    Vue.component('uiaa-dataset-window', __WEBPACK_IMPORTED_MODULE_5__uiaa_results_center_dataset_vue__["a" /* default */]);
    Vue.component('vertical-life-dataset-window', __WEBPACK_IMPORTED_MODULE_10__vertical_life_dataset_vue__["a" /* default */]);

    Vue.component('producer-window', __WEBPACK_IMPORTED_MODULE_6__producer_window_vue__["a" /* default */]);

    __WEBPACK_IMPORTED_MODULE_7__templates__["a" /* default */].install(Vue);

    Vue.component('template-not-found', __WEBPACK_IMPORTED_MODULE_8__template_not_found_vue__["a" /* default */]);
    Vue.component('template-library', __WEBPACK_IMPORTED_MODULE_9__template_library_vue__["a" /* default */]);

    Vue.component('window', __WEBPACK_IMPORTED_MODULE_11__window_vue__["a" /* default */]);
    Vue.component('window-tab', __WEBPACK_IMPORTED_MODULE_12__window_tab_vue__["a" /* default */]);
    Vue.component('window-tabs', __WEBPACK_IMPORTED_MODULE_13__window_tabs_vue__["a" /* default */]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Components);

/***/ }),
/* 1565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_template_settings_vue__ = __webpack_require__(1566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65d8b948_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_template_settings_vue__ = __webpack_require__(1579);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_template_settings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65d8b948_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_template_settings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__template_setting_delete_vue__ = __webpack_require__(1567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__template_setting_folder_vue__ = __webpack_require__(1570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__template_setting_name_vue__ = __webpack_require__(1573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__template_setting_overlay_vue__ = __webpack_require__(1576);
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: { TemplateSettingDelete: __WEBPACK_IMPORTED_MODULE_0__template_setting_delete_vue__["a" /* default */], TemplateSettingFolder: __WEBPACK_IMPORTED_MODULE_1__template_setting_folder_vue__["a" /* default */], TemplateSettingName: __WEBPACK_IMPORTED_MODULE_2__template_setting_name_vue__["a" /* default */], TemplateSettingOverlay: __WEBPACK_IMPORTED_MODULE_3__template_setting_overlay_vue__["a" /* default */] },
  props: ['templateId']
});

/***/ }),
/* 1567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_template_setting_delete_vue__ = __webpack_require__(1568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c8707ca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_template_setting_delete_vue__ = __webpack_require__(1569);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_template_setting_delete_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c8707ca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_template_setting_delete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_action_types__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'template-setting-delete',
  props: {
    templateId: {
      type: String,
      required: true
    }
  },
  methods: {
    remove: function remove() {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_action_types__["t" /* TEMPLATE_DELETE */], {
        templateId: this.templateId
      });
    }
  }
});

/***/ }),
/* 1569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label"},[_vm._v("Danger zone")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('p',{staticClass:"form-text"},[_vm._v("Once you delete a template, there is no going back. Please be certain. ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":_vm.remove}},[_vm._v("Delete Template")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_template_setting_folder_vue__ = __webpack_require__(1571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40d2f21a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_template_setting_folder_vue__ = __webpack_require__(1572);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_template_setting_folder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40d2f21a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_template_setting_folder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_action_types__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'template-setting-folder',
  props: {
    templateId: {
      type: String,
      required: true
    }
  },
  computed: {
    folder: {
      get: function get() {
        return this.$store.getters.template(this.templateId).folder;
      },
      set: function set(val) {
        this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_action_types__["u" /* TEMPLATE_FOLDER */], {
          templateId: this.templateId,
          folder: val
        });
      }
    }
  }
});

/***/ }),
/* 1572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('folder')}},[_vm._v("Folder")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.folder),expression:"folder",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('folder'),"list":"folders"},domProps:{"value":(_vm.folder)},on:{"change":function($event){_vm.folder=$event.target.value}}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_template_setting_name_vue__ = __webpack_require__(1574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07a664d4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_template_setting_name_vue__ = __webpack_require__(1575);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_template_setting_name_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07a664d4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_template_setting_name_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_action_types__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'template-setting-name',
  props: {
    templateId: {
      type: String,
      required: true
    }
  },
  computed: {
    name: {
      get: function get() {
        return this.$store.getters.template(this.templateId).name;
      },
      set: function set(val) {
        this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_action_types__["w" /* TEMPLATE_NAME */], {
          templateId: this.templateId,
          name: val
        });
      }
    }
  }
});

/***/ }),
/* 1575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('name')}},[_vm._v("Name")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.name),expression:"name",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('name')},domProps:{"value":(_vm.name)},on:{"change":function($event){_vm.name=$event.target.value}}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_template_setting_overlay_vue__ = __webpack_require__(1577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f7b7f152_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_template_setting_overlay_vue__ = __webpack_require__(1578);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_template_setting_overlay_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f7b7f152_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_template_setting_overlay_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_action_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_index__ = __webpack_require__(7);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'template-setting-overlay',
  props: {
    templateId: {
      type: String,
      required: true
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    hasCustomBackgroundImage: function hasCustomBackgroundImage() {
      return this.$store.getters.template(this.templateId).options.customBackgroundImage;
    },
    hasCustomColors: function hasCustomColors() {
      return this.$store.getters.template(this.templateId).options.customColors === true;
    },
    hasCustomCss: function hasCustomCss() {
      return this.$store.getters.template(this.templateId).options.customCss;
    },
    hasCustomJson: function hasCustomJson() {
      return this.$store.getters.template(this.templateId).options.customJson;
    },
    hasCustomPosition: function hasCustomPosition() {
      return this.$store.getters.template(this.templateId).options.customPosition;
    },
    colorKeys: function colorKeys() {
      var keys = this.$store.getters.template(this.templateId).options.customColors;
      return Array.isArray(keys) ? keys : [];
    },
    colorOptions: function colorOptions() {
      return ['red', 'blue', 'white', 'black'];
    },
    unitOptionsTopBottom: function unitOptionsTopBottom() {
      return ['', 'px', 'vh', '%'];
    },
    unitOptionsLeftRight: function unitOptionsLeftRight() {
      return ['', 'px', 'vw', '%'];
    },

    overlayFileName: {
      get: function get() {
        return this.$store.getters.template(this.templateId).overlayFileName;
      }
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_4__utils_index__["c" /* mapOverlayData */])({
    'css': { default: '.overlay {\n\n}' }
  }), Object(__WEBPACK_IMPORTED_MODULE_4__utils_index__["d" /* mapOverlayOptions */])({
    'color1': { default: 'white' },
    'color2': { default: 'red' },
    'cssLeft': { default: '' },
    'cssTop': { default: '' },
    'cssRight': { default: '' },
    'cssBottom': { default: '' },
    'backgroundImage': { default: null },
    'position': { default: {} },
    'colors': { default: {} },
    'customJson': { default: {} }
  }), Object(__WEBPACK_IMPORTED_MODULE_4__utils_index__["f" /* mapTemplateData */])(['backgroundImageAlbumId', 'backgroundImagePictureId']), {
    layer: {
      get: function get() {
        return this.$store.getters.template(this.templateId).layer || 0;
      },
      set: function set(val) {
        this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__store_action_types__["v" /* TEMPLATE_LAYER */], {
          templateId: this.templateId,
          layer: val
        });
      }
    },
    customJsonString: {
      get: function get() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.customJson, null, 2);
      },
      set: function set(value) {
        try {
          this.customJson = JSON.parse(value);
        } catch (ex) {
          console.error('[studio/template-setting-overlay] Error parsing JSON: ', ex.message || ex);
        }
      }
    },
    cssTopValue: {
      get: function get() {
        return this.cssTop.replace(/[^\d]/g, '');
      },
      set: function set(value) {
        this.cssTop = value + this.cssTopUnit;
      }
    },
    cssTopUnit: {
      get: function get() {
        return this.cssTop.replace(/[\d]/g, '');
      },
      set: function set(value) {
        this.cssTop = value === '' ? '' : this.cssTopValue + value;
      }
    },
    cssBottomValue: {
      get: function get() {
        return this.cssBottom.replace(/[^\d]/g, '');
      },
      set: function set(value) {
        this.cssBottom = value + this.cssBottomUnit;
      }
    },
    cssBottomUnit: {
      get: function get() {
        return this.cssBottom.replace(/[\d]/g, '');
      },
      set: function set(value) {
        this.cssBottom = value === '' ? '' : this.cssBottomValue + value;
      }
    },
    cssLeftValue: {
      get: function get() {
        return this.cssLeft.replace(/[^\d]/g, '');
      },
      set: function set(value) {
        this.cssLeft = value + this.cssLeftUnit;
      }
    },
    cssLeftUnit: {
      get: function get() {
        return this.cssLeft.replace(/[\d]/g, '');
      },
      set: function set(value) {
        this.cssLeft = value === '' ? '' : this.cssLeftValue + value;
      }
    },
    cssRightValue: {
      get: function get() {
        return this.cssRight.replace(/[^\d]/g, '');
      },
      set: function set(value) {
        this.cssRight = value + this.cssRightUnit;
      }
    },
    cssRightUnit: {
      get: function get() {
        return this.cssRight.replace(/[\d]/g, '');
      },
      set: function set(value) {
        this.cssRight = value === '' ? '' : this.cssRightValue + value;
      }
    }
  }),
  watch: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4__utils_index__["b" /* mapImageIdToImage */])('backgroundImageAlbumId', 'backgroundImagePictureId', 'backgroundImage')),
  methods: {
    updateColors: function updateColors() {
      this.colors = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.colors);
    }
  }
});

/***/ }),
/* 1578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('overlayFileName')}},[_vm._v("Template")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.overlayFileName),expression:"overlayFileName"}],staticClass:"form-control-plaintext",attrs:{"type":"text","readonly":"","id":_vm.safeId('overlayFileName')},domProps:{"value":(_vm.overlayFileName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.overlayFileName=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('layer')}},[_vm._v("Layer")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.layer),expression:"layer",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","min":"0","max":"4294967295","id":_vm.safeId('layer')},domProps:{"value":(_vm.layer)},on:{"input":function($event){if($event.target.composing){ return; }_vm.layer=_vm._n($event.target.value)},"blur":function($event){_vm.$forceUpdate()}}})])]),_vm._v(" "),(_vm.hasCustomPosition)?_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('cssLeftValue')}},[_vm._v("Left")]),_vm._v(" "),_c('div',{staticClass:"col-sm-5"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.cssLeftValue),expression:"cssLeftValue",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","id":_vm.safeId('cssLeftValue')},domProps:{"value":(_vm.cssLeftValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cssLeftValue=_vm._n($event.target.value)},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('b-form-select',{attrs:{"id":_vm.safeId('cssLeftUnit'),"options":_vm.unitOptionsLeftRight},model:{value:(_vm.cssLeftUnit),callback:function ($$v) {_vm.cssLeftUnit=$$v},expression:"cssLeftUnit"}})],1)]):_vm._e(),_vm._v(" "),(_vm.hasCustomPosition)?_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('cssTopValue')}},[_vm._v("Top")]),_vm._v(" "),_c('div',{staticClass:"col-sm-5"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.cssTopValue),expression:"cssTopValue",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","id":_vm.safeId('cssTopValue')},domProps:{"value":(_vm.cssTopValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cssTopValue=_vm._n($event.target.value)},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('b-form-select',{attrs:{"id":_vm.safeId('cssTopUnit'),"options":_vm.unitOptionsTopBottom},model:{value:(_vm.cssTopUnit),callback:function ($$v) {_vm.cssTopUnit=$$v},expression:"cssTopUnit"}})],1)]):_vm._e(),_vm._v(" "),(_vm.hasCustomPosition)?_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('cssRightValue')}},[_vm._v("Right")]),_vm._v(" "),_c('div',{staticClass:"col-sm-5"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.cssRightValue),expression:"cssRightValue",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","id":_vm.safeId('cssRightValue')},domProps:{"value":(_vm.cssRightValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cssRightValue=_vm._n($event.target.value)},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('b-form-select',{attrs:{"id":_vm.safeId('cssRightUnit'),"options":_vm.unitOptionsLeftRight},model:{value:(_vm.cssRightUnit),callback:function ($$v) {_vm.cssRightUnit=$$v},expression:"cssRightUnit"}})],1)]):_vm._e(),_vm._v(" "),(_vm.hasCustomPosition)?_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('cssBottomValue')}},[_vm._v("Bottom")]),_vm._v(" "),_c('div',{staticClass:"col-sm-5"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.cssBottomValue),expression:"cssBottomValue",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","id":_vm.safeId('cssBottomValue')},domProps:{"value":(_vm.cssBottomValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cssBottomValue=_vm._n($event.target.value)},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('b-form-select',{attrs:{"id":_vm.safeId('cssBottomUnit'),"options":_vm.unitOptionsTopBottom},model:{value:(_vm.cssBottomUnit),callback:function ($$v) {_vm.cssBottomUnit=$$v},expression:"cssBottomUnit"}})],1)]):_vm._e(),_vm._v(" "),(_vm.hasCustomColors)?_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('color1')}},[_vm._v("Color 1")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('b-form-select',{attrs:{"id":_vm.safeId('color1'),"options":_vm.colorOptions},model:{value:(_vm.color1),callback:function ($$v) {_vm.color1=$$v},expression:"color1"}})],1)]):_vm._e(),_vm._v(" "),_vm._l((_vm.colorKeys),function(colorKey){return _c('div',[_c('color-select-group',{attrs:{"label":colorKey},on:{"change":function($event){_vm.updateColors(_vm.colors)}},model:{value:(_vm.colors[colorKey]),callback:function ($$v) {_vm.$set(_vm.colors, colorKey, $$v)},expression:"colors[colorKey]"}})],1)}),_vm._v(" "),(_vm.hasCustomColors)?_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('color2')}},[_vm._v("Color 2")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('b-form-select',{attrs:{"id":_vm.safeId('color2'),"options":_vm.colorOptions},model:{value:(_vm.color2),callback:function ($$v) {_vm.color2=$$v},expression:"color2"}})],1)]):_vm._e(),_vm._v(" "),(_vm.hasCustomCss)?_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('css')}},[_vm._v("Custom CSS")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('textarea',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.css),expression:"css",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"id":_vm.safeId('css'),"rows":"5"},domProps:{"value":(_vm.css)},on:{"change":function($event){_vm.css=$event.target.value}}})])]):_vm._e(),_vm._v(" "),(_vm.hasCustomJson)?_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('json')}},[_vm._v("Custom JSON")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('textarea',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.customJsonString),expression:"customJsonString",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"id":_vm.safeId('json'),"rows":"5"},domProps:{"value":(_vm.customJsonString)},on:{"change":function($event){_vm.customJsonString=$event.target.value}}})])]):_vm._e(),_vm._v(" "),_c('album-select-group',{attrs:{"label":"Background"},model:{value:(_vm.backgroundImageAlbumId),callback:function ($$v) {_vm.backgroundImageAlbumId=$$v},expression:"backgroundImageAlbumId"}}),_vm._v(" "),_c('picture-select-group',{attrs:{"album-id":_vm.backgroundImageAlbumId,"label":"Image"},model:{value:(_vm.backgroundImagePictureId),callback:function ($$v) {_vm.backgroundImagePictureId=$$v},expression:"backgroundImagePictureId"}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('template-setting-name',{attrs:{"templateId":_vm.templateId}}),_vm._v(" "),_c('template-setting-folder',{attrs:{"templateId":_vm.templateId}}),_vm._v(" "),_c('template-setting-overlay',{attrs:{"templateId":_vm.templateId}}),_vm._v(" "),_vm._t("default"),_vm._v(" "),_c('template-setting-delete',{attrs:{"templateId":_vm.templateId}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__album_select_vue__ = __webpack_require__(1581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__album_select_group_vue__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__checkbox_input_group_vue__ = __webpack_require__(1586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__color_select_group_vue__ = __webpack_require__(1589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__column_select_vue__ = __webpack_require__(1593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dataset_select_vue__ = __webpack_require__(1596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dataset_select_group_vue__ = __webpack_require__(1599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__number_input_group_vue__ = __webpack_require__(1602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__picture_select_vue__ = __webpack_require__(1605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__picture_select_group_vue__ = __webpack_require__(1608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__record_select_vue__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__record_select_group_vue__ = __webpack_require__(1613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__switch_buttons_vue__ = __webpack_require__(1616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__table_edit_vue__ = __webpack_require__(1619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__template_select_vue__ = __webpack_require__(1622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__text_input_group_vue__ = __webpack_require__(1625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__time_input_group_vue__ = __webpack_require__(273);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__album_select_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__album_select_group_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__checkbox_input_group_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__color_select_group_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__column_select_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__dataset_select_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_6__dataset_select_group_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_7__number_input_group_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_8__picture_select_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_9__picture_select_group_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_10__record_select_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_11__record_select_group_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_12__switch_buttons_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_13__table_edit_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_14__template_select_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_15__text_input_group_vue__["a"]; });
/* unused harmony reexport TimeInputGroup */




















/***/ }),
/* 1581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_album_select_vue__ = __webpack_require__(1582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8f333fa2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_album_select_vue__ = __webpack_require__(1583);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_album_select_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8f333fa2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_album_select_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'album-select',
  props: ['value'],
  data: function data() {
    return {
      localValue: this.value
    };
  },

  computed: {
    options: function options() {
      var options = this.$store.getters.albums().map(function (a) {
        return {
          albumId: a.albumId,
          label: a.name || a.albumId
        };
      });
      options.push({ albumId: null, label: '' });
      options.sort(function (a, b) {
        if (a.label < b.label) return -1;
        if (a.label > b.label) return 1;
        return 0;
      });
      return options;
    }
  },
  watch: {
    localValue: function localValue(val) {
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 1583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-select',{attrs:{"id":_vm.safeId(),"options":_vm.options,"text-field":"label","value-field":"albumId"},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'album-select-group',
  props: {
    value: { required: true },
    label: { default: 'Album' }
  },
  data: function data() {
    return {
      localValue: this.value
    };
  },

  watch: {
    localValue: function localValue(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      this.localValue = val;
    }
  }
});

/***/ }),
/* 1585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('albumId')}},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('album-select',{attrs:{"id":_vm.safeId('albumId')},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_checkbox_input_group_vue__ = __webpack_require__(1587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c8a2d8a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_checkbox_input_group_vue__ = __webpack_require__(1588);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_checkbox_input_group_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c8a2d8a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_checkbox_input_group_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'checkbox-input-group',
  props: ['label', 'value', 'text'],
  data: function data() {
    return {
      localValue: this.value
    };
  },

  watch: {
    localValue: function localValue(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      this.localValue = !!val;
    }
  }
});

/***/ }),
/* 1588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId()}},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.localValue),expression:"localValue"}],staticClass:"form-check-input",attrs:{"type":"checkbox","name":_vm.safeId()},domProps:{"checked":Array.isArray(_vm.localValue)?_vm._i(_vm.localValue,null)>-1:(_vm.localValue)},on:{"change":function($event){var $$a=_vm.localValue,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.localValue=$$a.concat([$$v]))}else{$$i>-1&&(_vm.localValue=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.localValue=$$c}}}}),_vm._v(_vm._s(_vm.text))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_color_select_group_vue__ = __webpack_require__(1590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13735020_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_color_select_group_vue__ = __webpack_require__(1592);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_color_select_group_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13735020_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_color_select_group_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tinycolor2__ = __webpack_require__(1591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tinycolor2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_tinycolor2__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'color-select-group',
  props: ['label', 'value'],
  data: function data() {
    var color = __WEBPACK_IMPORTED_MODULE_0_tinycolor2___default()(this.value);
    return {
      localColor: color.toHexString(),
      localAlpha: color.getAlpha()
    };
  },

  computed: {
    labelText: function labelText() {
      return {
        'backgroundColor1': 'Background color 1',
        'fontColor1': 'Font color 1',
        'backgroundColor2': 'Background color 2',
        'fontColor2': 'Font color 2'
      }[this.label] || this.label;
    }
  },
  watch: {
    localColor: function localColor(val) {
      this.$emit('input', __WEBPACK_IMPORTED_MODULE_0_tinycolor2___default()(val).setAlpha(this.localAlpha).toRgbString());
      this.$emit('change');
    },
    localAlpha: function localAlpha(val) {
      this.$emit('input', __WEBPACK_IMPORTED_MODULE_0_tinycolor2___default()(this.localColor).setAlpha(val).toRgbString());
    },
    value: function value(val) {
      var color = __WEBPACK_IMPORTED_MODULE_0_tinycolor2___default()(val);
      this.localColor = color.toHexString();
      this.localAlpha = color.getAlpha();
    }
  }
});

/***/ }),
/* 1591 */,
/* 1592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group form-row"},[(_vm.label)?_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId()}},[_vm._v(_vm._s(_vm.labelText))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.localColor),expression:"localColor",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId()},domProps:{"value":(_vm.localColor)},on:{"change":function($event){_vm.localColor=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.localColor),expression:"localColor",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"color","id":_vm.safeId()},domProps:{"value":(_vm.localColor)},on:{"change":function($event){_vm.localColor=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.localAlpha),expression:"localAlpha",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"number","min":"0","max":"1","step":"0.01"},domProps:{"value":(_vm.localAlpha)},on:{"change":function($event){_vm.localAlpha=$event.target.value}}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_column_select_vue__ = __webpack_require__(1594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ad08c62_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_column_select_vue__ = __webpack_require__(1595);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_column_select_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ad08c62_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_column_select_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'column-select',
  props: {
    'datasetId': { required: true },
    'value': { required: true }
  },
  data: function data() {
    return {
      localValue: this.value
    };
  },

  computed: {
    options: function options() {
      if (!this.datasetId) return [{ label: '', value: null }];
      return [{ label: '', value: null }].concat(this.$store.getters.datasetColumns(this.datasetId).map(function (column) {
        return {
          label: column,
          value: column
        };
      }));
    }
  },
  watch: {
    localValue: function localValue(val) {
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 1595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-select',{attrs:{"id":_vm.safeId(),"options":_vm.options,"text-field":"label","value-field":"value"},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dataset_select_vue__ = __webpack_require__(1597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ba05018_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dataset_select_vue__ = __webpack_require__(1598);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dataset_select_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ba05018_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dataset_select_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dataset-select',
  props: ['value'],
  data: function data() {
    return {
      localValue: this.value
    };
  },

  computed: {
    options: function options() {
      var options = this.$store.getters.datasets().map(function (ds) {
        return {
          text: ds.name || ds.datasetId,
          value: ds.datasetId
        };
      });
      return [{ text: '', value: null }].concat(options);
    }
  },
  watch: {
    localValue: function localValue(val) {
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 1598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-select',{attrs:{"id":_vm.safeId(),"options":_vm.options,"text-field":"text","value-field":"value"},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dataset_select_group_vue__ = __webpack_require__(1600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae3c71d2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dataset_select_group_vue__ = __webpack_require__(1601);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dataset_select_group_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae3c71d2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dataset_select_group_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dataset-select-group',
  props: {
    label: { default: 'Dataset' },
    value: { required: true },
    showFields: { default: false }
  },
  data: function data() {
    return {
      localValue: this.value
    };
  },

  computed: {
    datasetColumns: function datasetColumns() {
      return this.$store.getters.datasetColumns(this.localValue).join(', ');
    }
  },
  watch: {
    localValue: function localValue(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      this.localValue = val;
    }
  }
});

/***/ }),
/* 1601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId()}},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('dataset-select',{attrs:{"id":_vm.safeId()},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}}),_vm._v(" "),(_vm.datasetColumns)?_c('small',{staticClass:"form-text text-muted"},[_vm._v(_vm._s(_vm.datasetColumns))]):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_number_input_group_vue__ = __webpack_require__(1603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68d02b1d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_number_input_group_vue__ = __webpack_require__(1604);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_number_input_group_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68d02b1d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_number_input_group_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'number-input-group',
  props: { 'label': {}, 'value': { type: Number } },
  data: function data() {
    return {
      localValue: this.value
    };
  },

  watch: {
    localValue: function localValue(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      this.localValue = val;
    }
  }
});

/***/ }),
/* 1604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId()}},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy.number",value:(_vm.localValue),expression:"localValue",modifiers:{"lazy":true,"number":true}}],staticClass:"form-control",attrs:{"type":"number","id":_vm.safeId()},domProps:{"value":(_vm.localValue)},on:{"change":function($event){_vm.localValue=_vm._n($event.target.value)},"blur":function($event){_vm.$forceUpdate()}}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_picture_select_vue__ = __webpack_require__(1606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03800c2a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_picture_select_vue__ = __webpack_require__(1607);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_picture_select_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03800c2a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_picture_select_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'picture-select',
  props: ['value', 'albumId'],
  data: function data() {
    return {
      localValue: this.value
    };
  },

  computed: {
    options: function options() {
      var album = this.$store.getters.album(this.albumId);
      if (!album) return [];
      var options = album.pictures.map(function (p) {
        return {
          pictureId: p.pictureId,
          label: p.fileName
        };
      });
      options.sort(function (a, b) {
        if (a.label < b.label) return -1;
        if (a.label > b.label) return 1;
        return 0;
      });
      return [{ label: '', pictureId: null }].concat(options);
    }
  },
  watch: {
    localValue: function localValue(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      this.localValue = val;
    }
  }
});

/***/ }),
/* 1607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-select',{attrs:{"id":_vm.safeId(),"options":_vm.options,"text-field":"label","value-field":"pictureId"},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_picture_select_group_vue__ = __webpack_require__(1609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d569cfa6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_picture_select_group_vue__ = __webpack_require__(1610);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_picture_select_group_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d569cfa6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_picture_select_group_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'picture-select-group',
  props: {
    label: { default: 'Picture' },
    value: { required: true },
    albumId: { required: true }
  },
  data: function data() {
    return {
      localValue: this.value
    };
  },

  watch: {
    localValue: function localValue(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      this.localValue = val;
    }
  }
});

/***/ }),
/* 1610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId()}},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('picture-select',{attrs:{"id":_vm.safeId(),"album-id":_vm.albumId},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);

//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'record-select',
  props: {
    'datasetId': { required: true },
    'value': { required: true },
    'labelFn': { require: false }
  },
  data: function data() {
    return {
      localValue: this.value
    };
  },

  computed: {
    columns: function columns() {
      return this.$store.getters.datasetColumns(this.datasetId);
    },
    options: function options() {
      var _this = this;

      return [{ label: '', value: null }].concat(this.$store.getters.datasetRecords(this.datasetId).map(function (each) {
        return {
          label: _this.mapLabel(each),
          value: each.recordId
        };
      }));
    }
  },
  watch: {
    value: function value(val) {
      this.localValue = val;
    },
    localValue: function localValue(val) {
      this.$emit('input', val);
    }
  },
  methods: {
    mapLabel: function mapLabel(record) {
      if (this.labelFn && typeof this.labelFn === 'function') {
        return this.labelFn(record);
      }
      var result = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.columns), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var k = _step.value;

          if (!record.hasOwnProperty(k)) continue;
          result.push(record[k]);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return result.join(', ');
    }
  }
});

/***/ }),
/* 1612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-select',{attrs:{"id":_vm.safeId(),"options":_vm.options,"text-field":"label","value-field":"value"},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_record_select_group_vue__ = __webpack_require__(1614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc00c948_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_record_select_group_vue__ = __webpack_require__(1615);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_record_select_group_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc00c948_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_record_select_group_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'record-select-group',
  props: {
    value: { required: true },
    label: { default: 'Record' },
    datasetId: { required: true }
  },
  data: function data() {
    return {
      localValue: this.value
    };
  },

  watch: {
    localValue: function localValue(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      this.localValue = val;
    }
  }
});

/***/ }),
/* 1615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId()}},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('record-select',{attrs:{"id":_vm.safeId(),"dataset-id":_vm.datasetId},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_switch_buttons_vue__ = __webpack_require__(1617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9fd8cb70_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_switch_buttons_vue__ = __webpack_require__(1618);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_switch_buttons_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9fd8cb70_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_switch_buttons_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_action_types__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var PREVIEW_TEXT = 'PRV';
var PROGRAM_TEXT = 'PRG';

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'switch-buttons',
  props: {
    templateId: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      previewText: PREVIEW_TEXT,
      previewTopUtc: null,
      programText: PROGRAM_TEXT,
      programTopUtc: null
    };
  },

  computed: {
    isPreview: function isPreview() {
      return this.$store.getters.isPlaying(this.templateId, 'preview');
    },
    isProgram: function isProgram() {
      return this.$store.getters.isPlaying(this.templateId, 'program');
    },
    previewClass: function previewClass() {
      return {
        'btn-outline-preview-off': !this.isPreview,
        'btn-preview-on': this.isPreview
      };
    },
    programClass: function programClass() {
      return {
        'btn-outline-program-off': !this.isProgram,
        'btn-program-on': this.isProgram
      };
    }
  },
  methods: {
    toggle: function toggle(channelId) {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_action_types__["B" /* TOGGLE_PLAY_STOP */], {
        templateId: this.templateId, channelId: channelId
      });
    },
    update: function update(channelId) {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_action_types__["k" /* COMMAND_UPDATE */], {
        templateId: this.templateId, channelId: channelId
      });
    },
    next: function next(channelId) {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_action_types__["j" /* COMMAND_NEXT */], {
        templateId: this.templateId, channelId: channelId
      });
    },
    updatePreviewButton: function updatePreviewButton() {
      if (this.previewTopUtc > 0) {
        var d = new Date(Date.now() - this.previewTopUtc);
        this.previewText = (d.getUTCHours() > 0 ? d.getUTCHours() + ':' : '') + ('0' + d.getUTCMinutes()).slice(-2) + ':' + ('0' + d.getUTCSeconds()).slice(-2);
        var delay = 1000 - d.getMilliseconds();
        window.setTimeout(this.updatePreviewButton.bind(this), delay);
      } else {
        this.previewText = PREVIEW_TEXT;
      }
    },
    updateProgramButton: function updateProgramButton() {
      if (this.programTopUtc > 0) {
        var d = new Date(Date.now() - this.programTopUtc);
        this.programText = (d.getUTCHours() > 0 ? d.getUTCHours() + ':' : '') + ('0' + d.getUTCMinutes()).slice(-2) + ':' + ('0' + d.getUTCSeconds()).slice(-2);
        var delay = 1000 - d.getMilliseconds();
        window.setTimeout(this.updateProgramButton.bind(this), delay);
      } else {
        this.programText = PROGRAM_TEXT;
      }
    }
  },
  watch: {
    isPreview: function isPreview(val) {
      if (!val) {
        this.previewTopUtc = null;
      } else {
        this.previewTopUtc = Date.now();
      }
      this.updatePreviewButton();
    },
    isProgram: function isProgram(val) {
      if (!val) {
        this.programTopUtc = null;
      } else {
        this.programTopUtc = Date.now();
      }
      this.updateProgramButton();
    }
  }
});

/***/ }),
/* 1618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-row flex-wrap",staticStyle:{"margin-bottom":"0.5rem","margin-left":"-0.25rem","margin-right":"-0.25rem"}},[_c('div',{staticClass:"btn-group",staticStyle:{"width":"100%","display":"flex","justify-content":"space-between","flex":"1 0 50%","margin-bottom":"0.5rem","padding":"0 0.25rem"}},[_c('button',{staticClass:"btn",class:_vm.previewClass,attrs:{"title":"Preview (F5)"},on:{"click":function($event){_vm.toggle('preview')}}},[_vm._v(_vm._s(_vm.previewText)+"\n    ")]),_vm._v(" "),_c('button',{staticClass:"btn",class:_vm.previewClass,attrs:{"title":"Update (F6)"},on:{"click":function($event){_vm.update('preview')}}},[_vm._v("UPD")]),_vm._v(" "),_c('button',{staticClass:"btn",class:_vm.previewClass,attrs:{"title":"Next (F7)"},on:{"click":function($event){_vm.next('preview')}}},[_vm._v("NXT")])]),_vm._v(" "),_c('div',{staticClass:"btn-group",staticStyle:{"width":"100%","display":"flex","justify-content":"space-between","flex":"1 0 50%","margin-bottom":"0.5rem","padding":"0 0.25rem"}},[_c('button',{staticClass:"btn",class:_vm.programClass,attrs:{"title":"Program (F9)"},on:{"click":function($event){_vm.toggle('program')}}},[_vm._v(_vm._s(_vm.programText)+"\n    ")]),_vm._v(" "),_c('button',{staticClass:"btn",class:_vm.programClass,attrs:{"title":"Update (F10)"},on:{"click":function($event){_vm.update('program')}}},[_vm._v("UPD")]),_vm._v(" "),_c('button',{staticClass:"btn",class:_vm.programClass,attrs:{"title":"Next (F11)"},on:{"click":function($event){_vm.next('program')}}},[_vm._v("NXT")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_table_edit_vue__ = __webpack_require__(1620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b6d24fc4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_table_edit_vue__ = __webpack_require__(1621);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_table_edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b6d24fc4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_table_edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'table-edit',
  props: {
    'cols': {
      type: Object, required: true
    },
    'rows': {
      type: Array, required: true
    }
  }
});

/***/ }),
/* 1621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"table table-bordered table-responsive table-hover table-sm"},[_c('thead',[_c('tr',_vm._l((_vm.cols),function(col){return _c('th',[_vm._v(_vm._s(col))])}))]),_vm._v(" "),_c('tbody',_vm._l((_vm.rows),function(row){return _c('tr',_vm._l((_vm.cols),function(v,k){return _c('td',[_vm._v(_vm._s(row[k]))])}))}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_template_select_vue__ = __webpack_require__(1623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e4ff848_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_template_select_vue__ = __webpack_require__(1624);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_template_select_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e4ff848_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_template_select_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'template-select',
  props: ['value'],
  data: function data() {
    return {
      localValue: this.value
    };
  },

  computed: {
    options: function options() {
      return this.$store.getters.templates().map(function (each) {
        return {
          templateId: each.templateId,
          label: each.name || each.templateId
        };
      });
    }
  },
  watch: {
    localValue: function localValue(val) {
      this.$emit('input', val);
    }
  }
});

/***/ }),
/* 1624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-select',{attrs:{"id":_vm.safeId(),"options":_vm.options,"text-field":"label","value-field":"templateId"},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_text_input_group_vue__ = __webpack_require__(1626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e86f7d2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_text_input_group_vue__ = __webpack_require__(1627);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_text_input_group_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e86f7d2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_text_input_group_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'text-input-group',
  props: ['label', 'value'],
  data: function data() {
    return {
      focused: false,
      localValue: this.value
    };
  },

  watch: {
    localValue: function localValue(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      if (!this.focused) {
        this.localValue = val;
      }
    }
  }
});

/***/ }),
/* 1627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId()}},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.localValue),expression:"localValue",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId()},domProps:{"value":(_vm.localValue)},on:{"focus":function($event){_vm.focused = true},"blur":function($event){_vm.focused = false},"change":function($event){_vm.localValue=$event.target.value}}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

function format(value) {
  var time = new Date(value);

  var milliseconds = ('000' + value % 1000).slice(-3);
  if (value < 60 * 60 * 1000) {
    // Less than one hour
    return time.getMinutes() + ':' + ('0' + time.getSeconds()).slice(-2) + '.' + milliseconds;
  } else {
    // Greater or equal one hour
    return time.getUTCHours() + ':' + ('0' + time.getMinutes()).slice(-2) + ':' + ('0' + time.getSeconds()).slice(-2) + '.' + milliseconds;
  }
}

function parse(s) {
  var parts = s.split('.');
  var milliseconds = parseInt(parts[1]) || 0;
  parts = parts[0].split(':').reverse();
  var result = (parseInt(parts[0]) || 0) + (parseInt(parts[1]) || 0) * 60 + (parseInt(parts[2]) || 0) * 3600;
  return result * 1000 + milliseconds;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'time-input-group',
  props: ['label', 'value'],
  data: function data() {
    return {
      localValue: format(this.value)
    };
  },

  watch: {
    localValue: function localValue(val) {
      this.$emit('input', parse(val));
    },
    value: function value(val) {
      this.localValue = format(val);
    }
  }
});

/***/ }),
/* 1629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group form-row"},[(_vm.label)?_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId()}},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_vm._v(" "),_c('div',{class:{'col-sm-8': _vm.label, 'col-sm-12': !_vm.label}},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.localValue),expression:"localValue",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId()},domProps:{"value":(_vm.localValue)},on:{"change":function($event){_vm.localValue=$event.target.value}}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_album_vue__ = __webpack_require__(1631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02b87fd4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_album_vue__ = __webpack_require__(1642);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_album_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02b87fd4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_album_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_action_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__album_settings__ = __webpack_require__(1633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_picture_input_PictureInput__ = __webpack_require__(1636);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'album',
  components: { AlbumSettings: __WEBPACK_IMPORTED_MODULE_3__album_settings__["a" /* default */], PictureInput: __WEBPACK_IMPORTED_MODULE_4_vue_picture_input_PictureInput__["a" /* default */] },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins__["d" /* windowPropsMixin */]],
  computed: {
    albumId: function albumId() {
      return this.$store.getters.windowData(this.windowId).contentId;
    },
    album: function album() {
      return this.$store.getters.album(this.albumId) || {};
    },
    pictures: function pictures() {
      // Make copy of array in order to add an empty picture
      // with isNew flag
      var pictures = (this.album.pictures || []).slice(0);
      pictures.push({
        pictureId: Object(__WEBPACK_IMPORTED_MODULE_0__lib__["e" /* uuid */])(),
        isNew: true
      });
      return pictures;
    }
  },
  methods: {
    onNew: function onNew(pictureId) {
      var input = this.$refs.pictureInput.find(function (pi) {
        return pi.id === pictureId;
      });
      if (!input || !input.file) return;
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_action_types__["f" /* ALBUM_PICTURE_CREATE */], {
        albumId: this.albumId,
        pictureId: pictureId,
        fileName: input.file.name,
        fileType: input.file.type,
        fileSize: input.file.size,
        image: input.image
      });
    },
    onChanged: function onChanged(pictureId) {
      var input = this.$refs.pictureInput.find(function (pi) {
        return pi.id === pictureId;
      });
      if (!input || !input.file) return;
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_action_types__["e" /* ALBUM_PICTURE_CHANGE */], {
        albumId: this.albumId,
        pictureId: pictureId,
        fileName: input.file.name,
        fileType: input.file.type,
        fileSize: input.file.size,
        image: input.image
      });
    },
    onRemoved: function onRemoved(pictureId) {
      if (!pictureId) return;
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_action_types__["g" /* ALBUM_PICTURE_REMOVE */], {
        albumId: this.albumId,
        pictureId: pictureId
      });
    },
    download: function download(picture) {
      var pom = document.createElement('a');
      pom.setAttribute('href', picture.image);
      pom.setAttribute('download', picture.fileName);
      pom.style.display = 'none';
      document.body.appendChild(pom);
      pom.click();
      document.body.removeChild(pom);
    }
  }
});

/***/ }),
/* 1632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_action_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__template_id__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__window_props__ = __webpack_require__(275);




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__template_id__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__window_props__["a" /* default */]],
  mounted: function mounted() {
    var _this = this;

    this.$shortcut.setContext(this.windowId);
    this.$shortcut.bind('f5', function () {
      return _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_action_types__["B" /* TOGGLE_PLAY_STOP */], {
        templateId: _this.templateId, channelId: 'preview'
      });
    });
    this.$shortcut.bind('f6', function () {
      return _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_action_types__["k" /* COMMAND_UPDATE */], {
        templateId: _this.templateId, channelId: 'preview'
      });
    });
    this.$shortcut.bind('f7', function () {
      return _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_action_types__["j" /* COMMAND_NEXT */], {
        templateId: _this.templateId, channelId: 'preview'
      });
    });
    this.$shortcut.bind('f9', function () {
      return _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_action_types__["B" /* TOGGLE_PLAY_STOP */], {
        templateId: _this.templateId, channelId: 'program'
      });
    });
    this.$shortcut.bind('f10', function () {
      return _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_action_types__["k" /* COMMAND_UPDATE */], {
        templateId: _this.templateId, channelId: 'program'
      });
    });
    this.$shortcut.bind('f11', function () {
      return _this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__store_action_types__["j" /* COMMAND_NEXT */], {
        templateId: _this.templateId, channelId: 'program'
      });
    });
  }
});

/***/ }),
/* 1633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_album_settings_vue__ = __webpack_require__(1634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f74fe412_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_album_settings_vue__ = __webpack_require__(1635);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_album_settings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f74fe412_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_album_settings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_action_types__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'album-settings',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["d" /* windowPropsMixin */]],
  props: ['albumId'],
  data: function data() {
    return {
      localName: ''
    };
  },

  computed: {
    album: function album() {
      return this.$store.getters.album(this.albumId) || {};
    },
    computedName: function computedName() {
      return this.album.name || this.windowTitle;
    }
  },
  created: function created() {
    this.reset();
  },

  watch: {
    computedName: function computedName(val) {
      this.localName = val;
    }
  },
  methods: {
    save: function save() {
      this.windowTitle = this.localName;
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_action_types__["c" /* ALBUM_META */], {
        albumId: this.albumId,
        name: this.localName
      });
    },
    reset: function reset() {
      this.localName = this.computedName;
    },
    remove: function remove() {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_action_types__["b" /* ALBUM_DELETE */], {
        windowId: this.windowId,
        albumId: this.albumId
      });
    }
  }
});

/***/ }),
/* 1635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('name')}},[_vm._v("Name")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.localName),expression:"localName",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('name')},domProps:{"value":(_vm.localName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.localName=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row justify-content-end"},[_c('div',{staticClass:"col-sm-8"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":_vm.save}},[_vm._v("Save")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":_vm.reset}},[_vm._v("Cancel")])])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-4 col-form-label"},[_vm._v("Danger zone")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('p',{staticClass:"form-text"},[_vm._v("Once you delete an album, all pictures will be deleted, too. There is no going back. Please be certain. ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":_vm.remove}},[_vm._v("Delete Album")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_PictureInput_vue__ = __webpack_require__(1638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_b12889d4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_PictureInput_vue__ = __webpack_require__(1641);
function injectStyle (ssrContext) {
  __webpack_require__(1637)
}
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b12889d4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_PictureInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_b12889d4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_PictureInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1637 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_max_safe_integer__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_max_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_max_safe_integer__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'picture-input',
  props: {
    width: {
      type: [String, Number],
      default: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_max_safe_integer___default.a
    },
    height: {
      type: [String, Number],
      default: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_max_safe_integer___default.a
    },
    margin: {
      type: [String, Number],
      default: 0
    },
    accept: {
      type: String,
      default: 'image/*'
    },
    size: {
      type: [String, Number],
      default: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_max_safe_integer___default.a
    },
    name: {
      type: String,
      default: null
    },
    id: {
      type: [String, Number],
      default: null
    },
    buttonClass: {
      type: String,
      default: 'btn btn-primary button'
    },
    removeButtonClass: {
      type: String,
      default: 'btn btn-secondary button secondary'
    },
    aspectButtonClass: {
      type: String,
      default: 'btn btn-secondary button secondary'
    },
    prefill: {
      type: [String, File],
      default: ''
    },
    prefillOptions: {
      type: Object,
      default: {}
    },
    crop: {
      type: Boolean,
      default: true
    },
    radius: {
      type: [String, Number],
      default: 0
    },
    removable: {
      type: Boolean,
      default: false
    },
    autoToggleAspectRatio: {
      type: Boolean,
      default: false
    },
    toggleAspectRatio: {
      type: Boolean,
      default: false
    },
    plain: {
      type: Boolean,
      default: false
    },
    zIndex: {
      type: Number,
      default: 10000
    },
    customStrings: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  watch: {
    prefill: function prefill() {
      if (this.prefill) {
        this.preloadImage(this.prefill, this.prefillOptions);
      } else {
        this.removeImage();
      }
    }
  },
  data: function data() {
    return {
      imageSelected: false,
      previewHeight: 0,
      previewWidth: 0,
      draggingOver: false,
      canvasWidth: 0,
      canvasHeight: 0,
      strings: {
        upload: '<p>Your device does not support file uploading.</p>',
        drag: 'Drag an image or <br>click here to select a file',
        tap: 'Tap here to select a photo <br>from your gallery',
        change: 'Change Photo',
        aspect: 'Landscape/Portrait',
        remove: 'Remove Photo',
        select: 'Select a Photo',
        selected: '<p>Photo successfully selected!</p>',
        fileSize: 'The file size exceeds the limit',
        fileType: 'This file type is not supported.'
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.updateStrings();
    if (this.prefill) {
      this.preloadImage(this.prefill, this.prefillOptions);
    }

    this.$nextTick(function () {
      window.addEventListener('resize', _this.onResize);
      _this.onResize();
    });
    if (this.supportsPreview) {
      this.pixelRatio = Math.round(window.devicePixelRatio || window.screen.deviceXDPI / window.screen.logicalXDPI);
      var canvas = this.$refs.previewCanvas;
      if (canvas.getContext) {
        this.context = canvas.getContext('2d');
        this.context.scale(this.pixelRatio, this.pixelRatio);
      }
    }
    if (this.accept !== 'image/*') {
      this.fileTypes = this.accept.split(',');
      this.fileTypes = this.fileTypes.map(function (s) {
        return s.trim();
      });
    }

    this.canvasWidth = this.width;
    this.canvasHeight = this.height;
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },

  methods: {
    updateStrings: function updateStrings() {
      for (var s in this.customStrings) {
        if (s in this.strings && typeof this.customStrings[s] === 'string') {
          this.strings[s] = this.customStrings[s];
        }
      }
    },
    onResize: function onResize() {
      this.resizeCanvas();

      if (this.imageObject) {
        this.drawImage(this.imageObject);
      }
    },
    onDragStart: function onDragStart() {
      if (!this.supportsDragAndDrop) {
        return;
      }
      this.draggingOver = true;
    },
    onDragStop: function onDragStop() {
      if (!this.supportsDragAndDrop) {
        return;
      }
      this.draggingOver = false;
    },
    onFileDrop: function onFileDrop(e) {
      this.onDragStop();
      this.onFileChange(e);
    },
    onFileChange: function onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      if (files[0].size <= 0 || files[0].size > this.size * 1024 * 1024) {
        alert(this.strings.fileSize + ' (' + this.size + 'MB)');
        return;
      }
      if (files[0].name === this.fileName && files[0].size === this.fileSize && this.fileModified === files[0].lastModified) {
        return;
      }

      this.file = files[0];
      this.fileName = files[0].name;
      this.fileSize = files[0].size;
      this.fileModified = files[0].lastModified;
      this.fileType = files[0].type;
      if (this.accept === 'image/*') {
        if (files[0].type.substr(0, 6) !== 'image/') {
          return;
        }
      } else {
        if (this.fileTypes.indexOf(files[0].type) === -1) {
          alert(this.strings.fileType);
          return;
        }
      }
      this.imageSelected = true;
      this.image = '';
      if (this.supportsPreview) {
        this.loadImage(files[0]);
      } else {
        this.$emit('change');
      }
    },
    loadImage: function loadImage(file) {
      var _this2 = this;

      this.getEXIFOrientation(file, function (orientation) {
        _this2.setOrientation(orientation);
        var reader = new FileReader();
        reader.onload = function (e) {
          _this2.image = e.target.result;
          _this2.$emit('change');
          _this2.imageObject = new Image();
          _this2.imageObject.onload = function () {
            if (_this2.autoToggleAspectRatio) {
              var canvasOrientation = _this2.getOrientation(_this2.canvasWidth, _this2.canvasHeight);
              var imageOrientation = _this2.getOrientation(_this2.imageObject.width, _this2.imageObject.height);

              if (canvasOrientation !== imageOrientation) {
                _this2.rotateCanvas();
              }
            }

            _this2.drawImage(_this2.imageObject);
          };
          _this2.imageObject.src = _this2.image;
        };
        reader.readAsDataURL(file);
      });
    },
    drawImage: function drawImage(image) {
      this.imageWidth = image.width;
      this.imageHeight = image.height;
      this.imageRatio = image.width / image.height;
      var offsetX = 0;
      var offsetY = 0;
      var scaledWidth = this.previewWidth;
      var scaledHeight = this.previewHeight;
      if (this.crop) {
        if (this.imageRatio > 1) {
          scaledWidth = scaledHeight * this.imageRatio;
          offsetX = (this.previewWidth - scaledWidth) / 2;
        } else {
          scaledHeight = scaledWidth / this.imageRatio;
          offsetY = (this.previewHeight - scaledHeight) / 2;
        }
      } else {
        if (this.imageRatio > 1) {
          scaledHeight = scaledWidth / this.imageRatio;
          offsetY = (this.previewHeight - scaledHeight) / 2;
        } else {
          scaledWidth = scaledHeight * this.imageRatio;
          offsetX = (this.previewWidth - scaledWidth) / 2;
        }
      }
      var canvas = this.$refs.previewCanvas;
      canvas.style.background = 'none';
      canvas.width = this.previewWidth * this.pixelRatio;
      canvas.height = this.previewHeight * this.pixelRatio;
      this.context.setTransform(1, 0, 0, 1, 0, 0);
      this.context.clearRect(0, 0, canvas.width, canvas.height);
      if (this.rotate) {
        this.context.translate(offsetX * this.pixelRatio, offsetY * this.pixelRatio);
        this.context.translate(scaledWidth / 2 * this.pixelRatio, scaledHeight / 2 * this.pixelRatio);
        this.context.rotate(this.rotate);
        offsetX = -scaledWidth / 2;
        offsetY = -scaledHeight / 2;
      }
      this.context.drawImage(image, offsetX * this.pixelRatio, offsetY * this.pixelRatio, scaledWidth * this.pixelRatio, scaledHeight * this.pixelRatio);
    },
    selectImage: function selectImage() {
      this.$refs.fileInput.click();
    },
    removeImage: function removeImage() {
      this.$refs.fileInput.value = '';
      this.$refs.fileInput.type = '';
      this.$refs.fileInput.type = 'file';
      this.fileName = '';
      this.fileType = '';
      this.fileSize = 0;
      this.fileModified = 0;
      this.imageSelected = false;
      this.image = '';
      this.file = null;
      this.imageObject = null;
      this.$refs.previewCanvas.style.backgroundColor = 'rgba(200,200,200,.25)';
      this.$refs.previewCanvas.width = this.previewWidth * this.pixelRatio;
      this.$emit('remove');
    },
    rotateImage: function rotateImage() {
      this.rotateCanvas();

      if (this.imageObject) {
        this.drawImage(this.imageObject);
      }

      var newOrientation = this.getOrientation(this.canvasWidth, this.canvasHeight);
      this.$emit('aspectratiochange', newOrientation);
    },
    resizeCanvas: function resizeCanvas() {
      var previewRatio = this.canvasWidth / this.canvasHeight;
      var newWidth = this.$refs.container.clientWidth;
      if (!this.toggleAspectRatio && newWidth === this.containerWidth) {
        return;
      }
      this.containerWidth = newWidth;
      this.previewWidth = Math.min(this.containerWidth - this.margin * 2, this.canvasWidth);
      this.previewHeight = this.previewWidth / previewRatio;
    },
    getOrientation: function getOrientation(width, height) {
      var orientation = 'square';

      if (width > height) {
        orientation = 'landscape';
      } else if (width < height) {
        orientation = 'portrait';
      }

      return orientation;
    },
    switchCanvasOrientation: function switchCanvasOrientation() {
      var canvasWidth = this.canvasWidth;
      var canvasHeight = this.canvasHeight;

      this.canvasWidth = canvasHeight;
      this.canvasHeight = canvasWidth;
    },
    rotateCanvas: function rotateCanvas() {
      this.switchCanvasOrientation();
      this.resizeCanvas();
    },
    setOrientation: function setOrientation(orientation) {
      this.rotate = false;
      if (orientation === 8) {
        this.rotate = -Math.PI / 2;
      } else if (orientation === 6) {
        this.rotate = Math.PI / 2;
      } else if (orientation === 3) {
        this.rotate = -Math.PI;
      }
    },
    getEXIFOrientation: function getEXIFOrientation(file, callback) {
      var reader = new FileReader();
      reader.onload = function (e) {
        var view = new DataView(e.target.result);
        if (view.getUint16(0, false) !== 0xFFD8) {
          return callback(-2);
        }
        var length = view.byteLength;
        var offset = 2;
        while (offset < length) {
          var marker = view.getUint16(offset, false);
          offset += 2;
          if (marker === 0xFFE1) {
            if (view.getUint32(offset += 2, false) !== 0x45786966) {
              return callback(-1);
            }
            var little = view.getUint16(offset += 6, false) === 0x4949;
            offset += view.getUint32(offset + 4, little);
            var tags = view.getUint16(offset, little);
            offset += 2;
            for (var i = 0; i < tags; i++) {
              if (view.getUint16(offset + i * 12, little) === 0x0112) {
                return callback(view.getUint16(offset + i * 12 + 8, little));
              }
            }
          } else if ((marker & 0xFF00) !== 0xFF00) {
            break;
          } else {
            offset += view.getUint16(offset, false);
          }
        }
        return callback(-1);
      };
      reader.readAsArrayBuffer(file.slice(0, 65536));
    },
    preloadImage: function preloadImage(source, options) {
      var _this3 = this;

      options = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, options);
      if ((typeof source === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(source)) === 'object') {
        this.imageSelected = true;
        this.image = '';
        if (this.supportsPreview) {
          this.loadImage(source);
        } else {
          this.$emit('change');
        }
        return;
      }
      var headers = new Headers();
      headers.append('Accept', 'image/*');
      fetch(source, {
        method: 'GET',
        mode: 'cors',
        headers: headers
      }).then(function (response) {
        return response.blob();
      }).then(function (imageBlob) {
        var e = { target: { files: [] } };
        var fileName = options.fileName || source.split('/').slice(-1)[0];
        var mediaType = options.mediaType || 'image/' + (options.fileType || fileName.split('.').slice(-1)[0]);
        mediaType = mediaType.replace('jpg', 'jpeg');
        e.target.files[0] = new File([imageBlob], fileName, { type: mediaType });
        _this3.onFileChange(e);
      }).catch(function (err) {
        console.log('Failed loading prefill image: ' + err.message);
      });
    }
  },
  computed: {
    supportsUpload: function supportsUpload() {
      if (navigator.userAgent.match(/(Android (1.0|1.1|1.5|1.6|2.0|2.1))|(Windows Phone (OS 7|8.0))|(XBLWP)|(ZuneWP)|(w(eb)?OSBrowser)|(webOS)|(Kindle\/(1.0|2.0|2.5|3.0))/)) {
        return false;
      }
      var el = document.createElement('input');
      el.type = 'file';
      return !el.disabled;
    },
    supportsPreview: function supportsPreview() {
      return window.FileReader && !!window.CanvasRenderingContext2D;
    },
    supportsDragAndDrop: function supportsDragAndDrop() {
      var div = document.createElement('div');
      return ('draggable' in div || 'ondragstart' in div && 'ondrop' in div) && !('ontouchstart' in window || navigator.msMaxTouchPoints);
    },
    computedClasses: function computedClasses() {
      var classObject = {};
      classObject['dragging-over'] = this.draggingOver;
      return classObject;
    },
    fontSize: function fontSize() {
      return Math.min(0.04 * this.previewWidth, 21) + 'px';
    }
  }
});

/***/ }),
/* 1639 */,
/* 1640 */,
/* 1641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"picture-input",attrs:{"id":"picture-input"}},[(!_vm.supportsUpload)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.strings.upload)}}):(_vm.supportsPreview)?_c('div',[_c('div',{staticClass:"preview-container",style:({maxWidth: _vm.previewWidth + 'px', height: _vm.previewHeight + 'px', borderRadius: _vm.radius + '%'})},[_c('canvas',{ref:"previewCanvas",staticClass:"picture-preview",class:_vm.computedClasses,style:({height: _vm.previewHeight + 'px', zIndex: _vm.zIndex + 1 }),on:{"drag":function($event){$event.stopPropagation();$event.preventDefault();},"dragover":function($event){$event.stopPropagation();$event.preventDefault();},"dragstart":function($event){$event.stopPropagation();$event.preventDefault();_vm.onDragStart($event)},"dragenter":function($event){$event.stopPropagation();$event.preventDefault();_vm.onDragStart($event)},"dragend":function($event){$event.stopPropagation();$event.preventDefault();_vm.onDragStop($event)},"dragleave":function($event){$event.stopPropagation();$event.preventDefault();_vm.onDragStop($event)},"drop":function($event){$event.stopPropagation();$event.preventDefault();_vm.onFileDrop($event)},"click":function($event){$event.preventDefault();_vm.selectImage($event)}}}),_vm._v(" "),(!_vm.imageSelected && !_vm.plain)?_c('div',{staticClass:"picture-inner",style:({top: -_vm.previewHeight + 'px', marginBottom: -_vm.previewHeight + 'px', fontSize: _vm.fontSize, borderRadius: _vm.radius + '%', zIndex: _vm.zIndex + 2})},[(_vm.supportsDragAndDrop)?_c('span',{staticClass:"picture-inner-text",domProps:{"innerHTML":_vm._s(_vm.strings.drag)}}):_c('span',{staticClass:"picture-inner-text",domProps:{"innerHTML":_vm._s(_vm.strings.tap)}})]):_vm._e()]),_vm._v(" "),(_vm.imageSelected)?_c('button',{class:_vm.buttonClass,on:{"click":function($event){$event.preventDefault();_vm.selectImage($event)}}},[_vm._v(_vm._s(_vm.strings.change))]):_vm._e(),_vm._v(" "),(_vm.imageSelected && _vm.removable)?_c('button',{class:_vm.removeButtonClass,on:{"click":function($event){$event.preventDefault();_vm.removeImage($event)}}},[_vm._v(_vm._s(_vm.strings.remove))]):_vm._e(),_vm._v(" "),(_vm.imageSelected && _vm.toggleAspectRatio && _vm.width !== _vm.height)?_c('button',{class:_vm.aspectButtonClass,on:{"click":function($event){$event.preventDefault();_vm.rotateImage($event)}}},[_vm._v(_vm._s(_vm.strings.aspect))]):_vm._e()]):_c('div',[(!_vm.imageSelected)?_c('button',{class:_vm.buttonClass,on:{"click":function($event){$event.preventDefault();_vm.selectImage($event)}}},[_vm._v(_vm._s(_vm.strings.select))]):_c('div',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.strings.selected)}}),_vm._v(" "),_c('button',{class:_vm.buttonClass,on:{"click":function($event){$event.preventDefault();_vm.selectImage($event)}}},[_vm._v(_vm._s(_vm.strings.change))]),_vm._v(" "),(_vm.removable)?_c('button',{class:_vm.removeButtonClass,on:{"click":function($event){$event.preventDefault();_vm.removeImage($event)}}},[_vm._v(_vm._s(_vm.strings.remove))]):_vm._e()])]),_vm._v(" "),_c('input',{ref:"fileInput",attrs:{"type":"file","name":_vm.name,"id":_vm.id,"accept":_vm.accept},on:{"change":_vm.onFileChange}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('window',{attrs:{"window-id":_vm.windowId}},[_c('window-tab',{attrs:{"title":_vm.windowTitle}},[_c('div',{staticClass:"row"},_vm._l((_vm.pictures),function(picture){return _c('div',{key:picture.pictureId,staticClass:"col-sm-3"},[_c('picture-input',{ref:"pictureInput",refInFor:true,attrs:{"id":picture.pictureId,"width":200,"removable":true,"removeButtonClass":"btn btn-danger btn-sm","height":200,"accept":"application/pdf,image/gif,image/jpg,image/jpeg,image/png,image/svg","buttonClass":"btn btn-primary btn-sm","customStrings":{
        change: 'Change',
        remove: 'Delete'
      },"prefill":picture.image,"prefillOptions":{fileName: picture.fileName, mediaType: picture.fileType}},on:{"change":function($event){picture.isNew ? _vm.onNew(picture.pictureId) : _vm.onChanged(picture.pictureId)},"remove":function($event){_vm.onRemoved(picture.pictureId)}}})],1)}))]),_vm._v(" "),_c('window-tab',{attrs:{"title":"Settings","icon":"cog"}},[_c('album-settings',{attrs:{"window-id":_vm.windowId,"album-id":_vm.albumId}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dataset_vue__ = __webpack_require__(1644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_212ebdfa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dataset_vue__ = __webpack_require__(1658);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dataset_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_212ebdfa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dataset_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_xlsx__ = __webpack_require__(1645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_xlsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_xlsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_mutation_types__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dataset_settings_vue__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dataset_table_vue__ = __webpack_require__(118);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dataset',
  components: { DatasetSettings: __WEBPACK_IMPORTED_MODULE_5__dataset_settings_vue__["a" /* default */], DatasetTable: __WEBPACK_IMPORTED_MODULE_6__dataset_table_vue__["a" /* default */] },
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins__["d" /* windowPropsMixin */]],
  data: function data() {
    return {
      errorMessage: null,
      localDataUrl: null,
      refetchSecs: 0,
      timeoutId: null
    };
  },

  watch: {
    refetchSecs: function refetchSecs(val) {
      this.setTimeout();
    },
    dataset: {
      handler: function handler(val) {
        if (val.fileName !== this.localDataUrl) {
          this.localDataUrl = val.fileName;
          this.fetchUrl();
        }
      },
      deep: true
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.clearTimeout();
  },
  created: function created() {
    this.localDataUrl = this.dataUrl;
    if (this.dataUrl) {
      this.fetchUrl();
    }
  },

  computed: {
    datasetId: function datasetId() {
      return this.$store.getters.windowData(this.windowId).contentId;
    },
    dataset: function dataset() {
      return this.$store.getters.dataset(this.datasetId) || {};
    },
    title: function title() {
      return this.dataset.title || 'Unnamed data source';
    },
    fileName: function fileName() {
      return ('' + this.dataset.fileName).indexOf('://') >= 0 ? '' : this.dataset.fileName;
    },

    dataUrl: {
      get: function get() {
        return this.localDataUrl || (('' + this.dataset.fileName).indexOf('://') >= 0 ? this.dataset.fileName : '');
      },
      set: function set(val) {
        this.localDataUrl = val;
      }
    }
  },
  methods: {
    downloadExcelFile: function downloadExcelFile() {
      var data = this.$store.getters.dataset(this.datasetId) || {};
      console.log('data', data.records || []);
      var sheet = __WEBPACK_IMPORTED_MODULE_1_xlsx___default.a.utils.json_to_sheet(data.records || []);
      var book = __WEBPACK_IMPORTED_MODULE_1_xlsx___default.a.utils.book_new();
      __WEBPACK_IMPORTED_MODULE_1_xlsx___default.a.utils.book_append_sheet(book, sheet);
      __WEBPACK_IMPORTED_MODULE_1_xlsx___default.a.writeFile(book, data.name + '.xlsx');
    },

    /* See https://github.com/SheetJS/js-xlsx/blob/master/demos/vue/SheetJS-vue.js */
    onFileChange: function onFileChange(evt) {
      var file = void 0;
      var files = evt.target.files;

      if (!files || files.length === 0) return;

      file = files[0];

      var reader = new FileReader();
      reader.onload = function (e) {
        // pre-process data
        var binary = '';
        var bytes = new Uint8Array(e.target.result);
        var length = bytes.byteLength;
        for (var i = 0; i < length; i++) {
          binary += String.fromCharCode(bytes[i]);
        }

        /* read workbook */
        var wb = __WEBPACK_IMPORTED_MODULE_1_xlsx___default.a.read(binary, { type: 'binary' });

        /* grab first sheet */
        var wsname = wb.SheetNames[0];
        var ws = wb.Sheets[wsname];

        var records = __WEBPACK_IMPORTED_MODULE_1_xlsx___default.a.utils.sheet_to_json(ws);
        this.saveRecords(file.name, records);
      }.bind(this);

      reader.readAsArrayBuffer(file);
    },
    fetchUrl: function fetchUrl() {
      if (!this.dataUrl) {
        return;
      }
      console.info('Fetching ' + this.dataUrl);
      window.clearTimeout(this.timeoutId);
      this.errorMessage = null;
      var request = new XMLHttpRequest();
      request.open('GET', this.dataUrl, true);
      request.onload = function (event) {
        if (!event.target) {
          this.errorMessage = 'Unknown error';
          // Set timeout to refresh data
          this.setTimeout();
          return;
        }

        if (event.target.status !== 200) {
          this.errorMessage = event.target.statusText;
          // Set timeout to refresh data
          this.setTimeout();
          return;
        }

        var response = event.target.response;
        var contentType = event.target.getResponseHeader('Content-Type') || '';

        var records = null;
        if (contentType.split(';')[0] === 'application/json') {
          records = JSON.parse(response);
        } else {
          /* read workbook from string (your existing response) */
          var wb = __WEBPACK_IMPORTED_MODULE_1_xlsx___default.a.read(response, { type: 'string' });

          /* get first worksheet */
          var wsname = wb.SheetNames[0];
          var ws = wb.Sheets[wsname];

          /* read first row (headers) */
          var data = __WEBPACK_IMPORTED_MODULE_1_xlsx___default.a.utils.sheet_to_json(ws, { header: 1 });
          if (data.length > 0) {
            var headers = data[0].map(function (h) {
              return typeof h === 'string' ? h.replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/Ä/g, 'Ae').replace(/Ö/g, 'Oe').replace(/Ü/g, 'Ue').replace(/ß/g, 'ss') : h;
            });

            /* write headers back into row 1 */
            __WEBPACK_IMPORTED_MODULE_1_xlsx___default.a.utils.sheet_add_aoa(ws, [headers], { origin: 'A1' });
          }

          /* convert to JSON */
          records = __WEBPACK_IMPORTED_MODULE_1_xlsx___default.a.utils.sheet_to_json(ws, { defval: null });
          console.log('records', records);
        }
        this.saveRecords(this.localDataUrl, records);

        // Set timeout to refresh data
        this.setTimeout();
      }.bind(this);
      request.onerror = function (event) {
        console.log(event);
        this.errorMessage = 'Network error';
        // Set timeout to refresh data
        this.setTimeout();
      }.bind(this);
      request.send();
    },
    setTimeout: function setTimeout() {
      this.clearTimeout();
      if (this.refetchSecs > 0) {
        this.timeoutId = window.setTimeout(this.fetchUrl.bind(this), this.refetchSecs * 1000);
      }
    },
    clearTimeout: function clearTimeout() {
      if (this.timeoutId) {
        window.clearTimeout(this.timeoutId);
        this.timeoutId = null;
      }
    },
    saveRecords: function saveRecords(fileName, records) {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types__["o" /* DATASET_UPDATE_META */], {
        datasetId: this.datasetId,
        fileName: fileName,
        emit: true
      });
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types__["q" /* DATASET_UPDATE_RECORDS */], {
        datasetId: this.datasetId,
        columns: records[0] ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(records[0]) : [],
        records: records.map(function (record, index) {
          record.recordId = record.id || Object(__WEBPACK_IMPORTED_MODULE_2__lib__["e" /* uuid */])();
          record.SORT_ORDER = index + 1;
          return record;
        }),
        emit: true
      });
    }
  }
});

/***/ }),
/* 1645 */,
/* 1646 */,
/* 1647 */,
/* 1648 */,
/* 1649 */,
/* 1650 */,
/* 1651 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1652 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_action_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__ = __webpack_require__(14);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dataset-settings',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["d" /* windowPropsMixin */]],
  props: ['datasetId'],
  data: function data() {
    return {
      localName: '',
      localColumns: ''
    };
  },

  computed: {
    dataset: function dataset() {
      return this.$store.getters.dataset(this.datasetId);
    },
    computedName: function computedName() {
      return this.dataset.name || this.windowTitle;
    },
    computedColumns: function computedColumns() {
      return this.dataset.columns.join('\n');
    }
  },
  created: function created() {
    this.reset();
  },

  watch: {
    computedName: function computedName(val) {
      this.localName = val;
    },
    computedColumns: function computedColumns(val) {
      this.localColumns = val;
    }
  },
  methods: {
    save: function save() {
      this.windowTitle = this.localName;
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["o" /* DATASET_UPDATE_META */], {
        datasetId: this.datasetId,
        name: this.localName,
        columns: this.localColumns.split('\n'),
        emit: true
      });
    },
    reset: function reset() {
      this.localName = this.computedName;
      this.localColumns = this.computedColumns;
    },
    remove: function remove() {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_action_types__["m" /* DATASET_DELETE */], {
        windowId: this.windowId,
        datasetId: this.datasetId
      });
    }
  }
});

/***/ }),
/* 1654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('name')}},[_vm._v("Name")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.localName),expression:"localName",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('name')},domProps:{"value":(_vm.localName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.localName=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('columns')}},[_vm._v("Columns")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.localColumns),expression:"localColumns"}],staticClass:"form-control",attrs:{"id":_vm.safeId('columns'),"rows":"5"},domProps:{"value":(_vm.localColumns)},on:{"input":function($event){if($event.target.composing){ return; }_vm.localColumns=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row justify-content-end"},[_c('div',{staticClass:"col-sm-8"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":_vm.save}},[_vm._v("Save")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":_vm.reset}},[_vm._v("Cancel")])])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-4 col-form-label"},[_vm._v("Danger zone")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('p',{staticClass:"form-text"},[_vm._v("Once you delete a dataset, there is no going back. Please be certain. ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":_vm.remove}},[_vm._v("Delete Dataset")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1655 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_mutation_types__ = __webpack_require__(14);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dataset-table',
  props: ['datasetId'],
  data: function data() {
    return {
      newRecord: {}
    };
  },

  computed: {
    dataset: function dataset() {
      return this.$store.getters.dataset(this.datasetId) || {};
    },
    cols: function cols() {
      return this.dataset.columns;
    },
    rows: function rows() {
      return this.dataset.records;
    }
  },
  methods: {
    resetNewRecord: function resetNewRecord() {
      this.newRecord = {};
      if (this.$refs.newRecordInput && this.$refs.newRecordInput[0]) {
        this.$refs.newRecordInput[0].focus();
      }
    },
    createRecord: function createRecord() {
      var record = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.newRecord, { recordId: Object(__WEBPACK_IMPORTED_MODULE_1__lib__["e" /* uuid */])() });
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["k" /* DATASET_CREATE_RECORD */], {
        datasetId: this.datasetId,
        record: record,
        emit: true
      });
      this.resetNewRecord();
    },
    deleteRecord: function deleteRecord(recordId) {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["m" /* DATASET_DELETE_RECORD */], {
        datasetId: this.datasetId,
        recordId: recordId,
        emit: true
      });
    },
    updateRecord: function updateRecord(record) {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_mutation_types__["p" /* DATASET_UPDATE_RECORD */], {
        datasetId: this.datasetId,
        recordId: record.recordId,
        record: record,
        emit: true
      });
    }
  }
});

/***/ }),
/* 1657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.cols && _vm.cols.length)?_c('table',{staticClass:"table table-bordered table-responsive table-hover table-sm"},[_c('thead',[_c('tr',[_vm._l((_vm.cols),function(col){return _c('th',[_vm._v(_vm._s(col))])}),_vm._v(" "),_c('th',{staticClass:"inline-buttons"})],2)]),_vm._v(" "),_c('tbody',[_vm._l((_vm.rows),function(row){return _c('tr',[_vm._l((_vm.cols),function(col){return _c('td',{staticClass:"inline-edit"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row[col]),expression:"row[col]"}],staticClass:"inline-input form-control",attrs:{"type":"text"},domProps:{"value":(row[col])},on:{"change":function($event){_vm.updateRecord(row)},"input":function($event){if($event.target.composing){ return; }_vm.$set(row, col, $event.target.value)}}})])}),_vm._v(" "),_c('td',{staticClass:"inline-buttons"},[_c('button',{staticClass:"btn btn-outline-danger btn-sm",on:{"click":function($event){_vm.deleteRecord(row.recordId)}}},[_c('icon',{attrs:{"name":"minus"}})],1)])],2)}),_vm._v(" "),_c('tr',[_vm._l((_vm.cols),function(col){return _c('td',{staticClass:"inline-edit"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newRecord[col]),expression:"newRecord[col]"}],ref:"newRecordInput",refInFor:true,staticClass:"inline-input form-control",attrs:{"type":"text"},domProps:{"value":(_vm.newRecord[col])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newRecord, col, $event.target.value)}}})])}),_vm._v(" "),_c('td',{staticClass:"inline-buttons"},[_c('button',{staticClass:"btn btn-outline-success btn-sm",on:{"click":function($event){_vm.createRecord(_vm.newRecord)}}},[_c('icon',{attrs:{"name":"plus"}})],1)])],2)],2)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('window',{attrs:{"window-id":_vm.windowId}},[_c('window-tab',{attrs:{"title":_vm.windowTitle}},[_c('div',{staticClass:"form-group form-row"},[_c('div',{staticClass:"col-12"},[_c('b-form-file',{staticClass:"w-100",attrs:{"placeholder":_vm.fileName || 'Choose file...',"choose-label":"...","accept":".csv, .ods, .xls, .xlsx"},on:{"change":_vm.onFileChange}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('div',{staticClass:"col-12",staticStyle:{"text-align":"center"}},[_vm._v("--- or ---")])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.localDataUrl),expression:"localDataUrl"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"URL..."},domProps:{"value":(_vm.localDataUrl)},on:{"input":function($event){if($event.target.composing){ return; }_vm.localDataUrl=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":_vm.fetchUrl}},[_vm._v("Fetch")])])])])]),_vm._v(" "),(_vm.datasetId)?_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-8 col-form-label",attrs:{"for":_vm.safeId('refetchSecs')}},[_vm._v("Automatic refresh (seconds)")]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.refetchSecs),expression:"refetchSecs",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"number","id":_vm.safeId('refetchSecs')},domProps:{"value":(_vm.refetchSecs)},on:{"change":function($event){_vm.refetchSecs=$event.target.value}}})])]):_vm._e(),_vm._v(" "),(_vm.errorMessage)?_c('div',{staticClass:"alert alert-danger"},[_c('p',[_c('b',[_vm._v("Error:")]),_vm._v(" "+_vm._s(_vm.errorMessage))])]):_vm._e(),_vm._v(" "),(_vm.datasetId)?_c('div',{staticClass:"form-group form-row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"d-flex flex-row justify-content-end"},[_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"button"},on:{"click":_vm.downloadExcelFile}},[_vm._v("Download Excel file\n          ")])])])]):_vm._e(),_vm._v(" "),_c('dataset-table',{attrs:{"dataset-id":_vm.datasetId}})],1),_vm._v(" "),_c('window-tab',{attrs:{"title":"Settings","icon":"cog"}},[_c('dataset-settings',{attrs:{"window-id":_vm.windowId,"dataset-id":_vm.datasetId}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_race_result_dataset_vue__ = __webpack_require__(1660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c7b98786_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_race_result_dataset_vue__ = __webpack_require__(1663);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_race_result_dataset_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c7b98786_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_race_result_dataset_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dataset_settings_vue__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__dataset_table_vue__ = __webpack_require__(118);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var optionMergeRecords = false;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'race-result-dataset',
  components: { DatasetSettings: __WEBPACK_IMPORTED_MODULE_6__dataset_settings_vue__["a" /* default */], DatasetTable: __WEBPACK_IMPORTED_MODULE_7__dataset_table_vue__["a" /* default */] },
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins__["d" /* windowPropsMixin */]],
  data: function data() {
    return {
      errorMessage: null,
      refetchSecs: 0,
      timeoutId: null
    };
  },

  computed: {
    datasetId: function datasetId() {
      return this.$store.getters.windowData(this.windowId).contentId;
    },
    dataset: function dataset() {
      return this.$store.getters.dataset(this.datasetId) || {};
    },
    title: function title() {
      return this.dataset.title || 'Unnamed dataset';
    },

    fileName: {
      get: function get() {
        return this.dataset.fileName || '';
      },
      set: function set(val) {
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["o" /* DATASET_UPDATE_META */], {
          datasetId: this.datasetId,
          fileName: val,
          emit: true
        });
      }
    }
  },
  mounted: function mounted() {
    if (this.fileName && (this.dataset.records || []).length === 0) {
      this.fetch();
    }
  },

  methods: {
    fetch: function fetch() {
      console.log('[race-result/dataset] fetching data');
      this.errorMessage = null;
      var request = new XMLHttpRequest();
      request.open('GET', this.fileName, true);
      request.onload = function (event) {
        if (!event.target) {
          this.errorMessage = 'Unknown error';
          return;
        }

        if (event.target.status !== 200) {
          this.errorMessage = event.target.statusText;
          return;
        }
        var response = JSON.parse(event.target.response);

        var fields = response.list.Fields.map(function (field) {
          return field.Label.toLowerCase();
        });

        var rows = response.data.map(function (arr, rowIdx) {
          var result = arr.slice(1, arr.length).reduce(function (row, val, idx) {
            if (fields.length > idx) {
              row[fields[idx]] = val;
            }
            return row;
          }, {});
          result['sortorder'] = rowIdx + 1;
          return result;
        });

        var columnMap = {
          'sortorder': 'SORT_ORDER',
          'firstname': 'FIRST NAME',
          'lastname': 'LAST NAME',
          'bibnumber': 'BIB',
          'country': 'COUNTRY',
          'club': 'CLUB',
          'rank': 'RANK',
          'gap': 'SCORE',
          'tp.name': 'SPLIT'
        };

        var records = this.mergeRecords(rows, columnMap);
        var columns = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(columnMap);

        this.$store.commit(__WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["q" /* DATASET_UPDATE_RECORDS */], {
          datasetId: this.datasetId,
          columns: columns,
          records: records.map(function (record) {
            record.recordId = record.recordId || Object(__WEBPACK_IMPORTED_MODULE_3__lib__["e" /* uuid */])();
            return record;
          }),
          emit: true
        });

        // Set timeout to refresh data
        this.setTimeout();
      }.bind(this);
      request.onerror = function (event) {
        console.log('Error:', event);
        this.errorMessage = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(event);
      }.bind(this);
      request.send();
    },
    setTimeout: function setTimeout() {
      this.clearTimeout();
      if (this.refetchSecs > 0) {
        this.timeoutId = window.setTimeout(this.fetch.bind(this), this.refetchSecs * 1000);
      }
    },
    clearTimeout: function clearTimeout() {
      if (this.timeoutId) {
        window.clearTimeout(this.timeoutId);
        this.timeoutId = null;
      }
    },
    mergeRecords: function mergeRecords(rows, columnMap) {
      var records = this.dataset.records || [];
      var maxLaps = 0;
      var newRecords = rows.map(function (row, rowIdx) {
        var record = {};
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(columnMap).forEach(function (key) {
          if (key === 'gap') {
            if (rowIdx === 0) {
              record[columnMap[key]] = row['racetime'];
              maxLaps = Number(row['laps']);
            } else {
              var diffLaps = Number(row['laps']) - maxLaps;
              if (diffLaps) {
                record[columnMap[key]] = diffLaps + 'R';
              } else {
                record[columnMap[key]] = row[key];
              }
            }
          } else {
            record[columnMap[key]] = row[key];
          }
        });
        return record;
      });
      if (optionMergeRecords) {
        newRecords.forEach(function (newRecord) {
          var oldRecord = records.find(function (r) {
            return r.BIB === newRecord.BIB;
          });
          if (!oldRecord) {
            records.push(newRecord);
          } else {
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(newRecord).forEach(function (key) {
              oldRecord[key] = newRecord[key] || oldRecord[key];
            });
          }
        });
        // records.sort((a, b) => a.SORT_ORDER - b.SORT_ORDER)
        return records;
      }
      return newRecords;
    }
  }
});

/***/ }),
/* 1661 */,
/* 1662 */,
/* 1663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('window',{attrs:{"window-id":_vm.windowId}},[_c('window-tab',{attrs:{"title":_vm.windowTitle}},[(_vm.datasetId)?_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('fileName')}},[_vm._v("URL")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.fileName),expression:"fileName",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('fileName')},domProps:{"value":(_vm.fileName)},on:{"change":function($event){_vm.fileName=$event.target.value}}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('div',{staticClass:"col-sm-8 offset-4"},[_c('button',{staticClass:"btn btn-block btn-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.fetch()}}},[_vm._v("Fetch")])])]),_vm._v(" "),(_vm.datasetId)?_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-8 col-form-label",attrs:{"for":_vm.safeId('refetchSecs')}},[_vm._v("Automatic refresh (seconds)")]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.refetchSecs),expression:"refetchSecs",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"number","id":_vm.safeId('refetchSecs')},domProps:{"value":(_vm.refetchSecs)},on:{"change":function($event){_vm.refetchSecs=$event.target.value}}})])]):_vm._e(),_vm._v(" "),(_vm.errorMessage)?_c('div',{staticClass:"alert alert-danger"},[_c('p',[_c('b',[_vm._v("Error:")]),_vm._v(" "+_vm._s(_vm.errorMessage))])]):_vm._e(),_vm._v(" "),_c('dataset-table',{attrs:{"dataset-id":_vm.datasetId}})],1),_vm._v(" "),_c('window-tab',{attrs:{"title":"Settings","icon":"cog"}},[_c('dataset-settings',{attrs:{"window-id":_vm.windowId,"dataset-id":_vm.datasetId}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_uiaa_results_center_dataset_vue__ = __webpack_require__(1665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61741e3a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_uiaa_results_center_dataset_vue__ = __webpack_require__(1666);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_uiaa_results_center_dataset_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61741e3a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_uiaa_results_center_dataset_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_mutation_types__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dataset_settings_vue__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dataset_table_vue__ = __webpack_require__(118);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'uiaa-results-center-dataset',
  components: { DatasetSettings: __WEBPACK_IMPORTED_MODULE_5__dataset_settings_vue__["a" /* default */], DatasetTable: __WEBPACK_IMPORTED_MODULE_6__dataset_table_vue__["a" /* default */] },
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins__["d" /* windowPropsMixin */]],
  data: function data() {
    return {
      errorMessage: null,
      competition: null,
      stage: null,
      round: null,
      groups: null
    };
  },

  computed: {
    datasetId: function datasetId() {
      return this.$store.getters.windowData(this.windowId).contentId;
    },
    dataset: function dataset() {
      return this.$store.getters.dataset(this.datasetId) || {};
    },
    title: function title() {
      return this.dataset.title || 'Unnamed dataset';
    },

    fileName: {
      get: function get() {
        return this.dataset.fileName || '';
      },
      set: function set(val) {
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types__["o" /* DATASET_UPDATE_META */], {
          datasetId: this.datasetId,
          fileName: val,
          emit: true
        });
      }
    },
    group: {
      get: function get() {
        return (this.fileName.match(/[?&]group=([^&$]+)/) || [])[1];
      },
      set: function set(val) {
        var old = this.group;
        var fileName = this.fileName;
        if (fileName.indexOf('group=' + old) < 0) {
          this.fileName = fileName + '?group=' + val;
        } else {
          this.fileName = fileName.replace('group=' + old, 'group=' + val);
        }
      }
    }
  },
  mounted: function mounted() {
    if (this.fileName && (this.dataset.records || []).length === 0) {
      this.fetch();
    }
  },

  methods: {
    fetch: function fetch() {
      console.log('[uiaa/dataset] fetching data');
      this.errorMessage = null;
      var request = new XMLHttpRequest();
      request.open('GET', this.fileName, true);
      request.onload = function (event) {
        if (!event.target) {
          this.errorMessage = 'Unknown error';
          return;
        }

        if (event.target.status !== 200) {
          this.errorMessage = event.target.statusText;
          return;
        }
        var response = JSON.parse(event.target.response);

        this.competition = response['Competition'];
        this.stage = response['Stage'];
        this.round = response['Round'];
        this.groups = response['Groups'];

        var headers = this.getHeaders(response);
        var columns = this.mergeColumns(response, headers);
        var records = this.mergeRecords(response, headers, this.groups, this.group);

        this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types__["q" /* DATASET_UPDATE_RECORDS */], {
          datasetId: this.datasetId,
          columns: columns,
          records: records.map(function (record) {
            record.recordId = record.recordId || Object(__WEBPACK_IMPORTED_MODULE_2__lib__["e" /* uuid */])();
            return record;
          }),
          emit: true
        });
      }.bind(this);
      request.onerror = function (event) {
        console.log(event);
        this.errorMessage = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(event);
      }.bind(this);
      request.send();
    },
    getHeaders: function getHeaders(response) {
      var rules = {
        'COMPETITOR NAME': 'NAME'
      };
      return response['Header'].map(function (group) {
        return group.map(function (each) {
          return rules.hasOwnProperty(each) ? rules[each] : each;
        });
      });
    },
    mergeColumns: function mergeColumns(response, headers) {
      var columns = headers.reduce(function (columns, header) {
        // Concat columns with new headers
        return columns.concat(header.filter(function (each) {
          return columns.indexOf(each) < 0;
        }));
      }, this.dataset.columns || []);
      return columns.concat(['SORT_ORDER', 'GROUP'].filter(function (each) {
        return columns.indexOf(each) < 0;
      }));
    },
    getRecords: function getRecords(response, headers, groups) {
      return response['Data'].reduce(function (result, rows, groupIdx) {
        return result.concat(rows.map(function (raw, rowIdx) {
          var row = {
            'SORT_ORDER': (groupIdx + 1) * 1000 + rowIdx,
            'GROUP': '' + groups[groupIdx]
          };
          headers[groupIdx].forEach(function (name, idx) {
            row[name] = raw[idx];
          });
          return row;
        }));
      }, []);
    },
    mergeRecords: function mergeRecords(response, headers, groups, group) {
      var records = this.dataset.records || [];
      var newRecords = this.getRecords(response, headers, groups);
      newRecords.filter(function (r) {
        return !group || group && r.GROUP === '' + group;
      }).forEach(function (newRecord) {
        var oldRecord = records.find(function (r) {
          return r.BIB === newRecord.BIB && r.GROUP === newRecord.GROUP;
        });
        if (!oldRecord) {
          records.push(newRecord);
        } else {
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(newRecord).forEach(function (key) {
            oldRecord[key] = newRecord[key] || oldRecord[key];
          });
        }
      });
      return records;
    }
  }
});

/***/ }),
/* 1666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('window',{attrs:{"window-id":_vm.windowId}},[_c('window-tab',{attrs:{"title":_vm.windowTitle}},[(_vm.datasetId)?_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('fileName')}},[_vm._v("URL")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('p',[_c('a',{attrs:{"href":"http://results.theuiaa.org/?raw=true","target":"_blank"}},[_vm._v("http://results.theuiaa.org/?raw=true")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.fileName),expression:"fileName",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('fileName')},domProps:{"value":(_vm.fileName)},on:{"change":function($event){_vm.fileName=$event.target.value}}})])]):_vm._e(),_vm._v(" "),(_vm.datasetId)?_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('group')}},[_vm._v("Group")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.group),expression:"group",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('group')},domProps:{"value":(_vm.group)},on:{"change":function($event){_vm.group=$event.target.value}}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('div',{staticClass:"col-sm-8 offset-4"},[_c('button',{staticClass:"btn btn-block btn-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.fetch()}}},[_vm._v("Fetch")])])]),_vm._v(" "),(_vm.errorMessage)?_c('div',{staticClass:"alert alert-danger"},[_c('p',[_c('b',[_vm._v("Error:")]),_vm._v(" "+_vm._s(_vm.errorMessage))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('competition')}},[_vm._v("Competition")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.competition),expression:"competition",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('competition')},domProps:{"value":(_vm.competition)},on:{"change":function($event){_vm.competition=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('stage')}},[_vm._v("Stage")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.stage),expression:"stage",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('stage')},domProps:{"value":(_vm.stage)},on:{"change":function($event){_vm.stage=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('round')}},[_vm._v("Round")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.round),expression:"round",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('round')},domProps:{"value":(_vm.round)},on:{"change":function($event){_vm.round=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('groups')}},[_vm._v("Groups")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.groups),expression:"groups",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('groups')},domProps:{"value":(_vm.groups)},on:{"change":function($event){_vm.groups=$event.target.value}}})])]),_vm._v(" "),_c('dataset-table',{attrs:{"dataset-id":_vm.datasetId}})],1),_vm._v(" "),_c('window-tab',{attrs:{"title":"Settings","icon":"cog"}},[_c('dataset-settings',{attrs:{"window-id":_vm.windowId,"dataset-id":_vm.datasetId}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_producer_window_vue__ = __webpack_require__(1669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ca6d038_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_producer_window_vue__ = __webpack_require__(1670);
function injectStyle (ssrContext) {
  __webpack_require__(1668)
}
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_producer_window_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ca6d038_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_producer_window_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1668 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_action_types__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'producer-window',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["c" /* windowIdMixin */]],
  mounted: function mounted() {
    window.setTimeout(this.adjustIframe.bind(this), 1000);
  },

  computed: {
    src: function src() {
      var baseUrl = this.$env.WEBCG_PRODUCER;
      // Add hostname if there is none
      var idx = baseUrl.indexOf('//:');
      if (idx >= 0) {
        baseUrl = baseUrl.slice(0, idx + 2) + window.location.hostname + baseUrl.slice(idx + 2);
      }
      return baseUrl + '/?channel=' + this.channelId + '&userId=' + this.accountId;
    },
    title: function title() {
      return this.$store.getters.windowTitle(this.windowId);
    },
    channelId: function channelId() {
      return this.$store.getters.windowData(this.windowId).contentId;
    },
    accountId: function accountId() {
      var selectedAccount = this.$store.getters.selectedAccount;
      return selectedAccount ? selectedAccount.accountId : '';
    },
    windowW: function windowW() {
      return this.$store.getters.windowData(this.windowId).w;
    },
    windowH: function windowH() {
      return this.$store.getters.windowData(this.windowId).h;
    }
  },
  watch: {
    windowW: function windowW() {
      this.adjustIframe();
    },
    windowH: function windowH() {
      this.adjustIframe();
    }
  },
  methods: {
    adjustIframe: function adjustIframe() {
      if (!this.$refs.iframe) {
        return;
      }
      var container = this.$refs.iframe.parentElement;
      var containerWidth = container.offsetWidth;
      var containerHeight = container.offsetHeight;

      // Calculate the aspect ratio
      var aspectRatio = 16 / 9;

      // Calculate what the maximum size of the iframe should be
      var iframeWidth = containerWidth;
      var iframeHeight = iframeWidth / aspectRatio;

      // Check if calculated height is too high for the container
      if (iframeHeight > containerHeight) {
        iframeHeight = containerHeight;
        iframeWidth = iframeHeight * aspectRatio;
      }

      // Apply calculated dimensions to the iframe
      var iframe = container.querySelector('iframe');
      iframe.style.width = iframeWidth + 'px';
      iframe.style.height = iframeHeight + 'px';
    },
    clear: function clear() {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_action_types__["h" /* CLEAR_CHANNEL */], { channelId: this.channelId });
    },
    refresh: function refresh() {
      var iframe = this.$refs.iframe;
      // SecurityError: Permission denied to access property "reload" on cross-origin object
      // iframe.contentWindow.location.reload()
      iframe.src += '';
    }
  }
});

/***/ }),
/* 1670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('window',{attrs:{"window-id":_vm.windowId}},[_c('template',{slot:"tabs"},[_c('li',{staticClass:"nav-item",attrs:{"title":"Clear"}},[_c('a',{staticClass:"nav-link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.clear($event)}}},[_c('icon',{attrs:{"name":"bolt"}})],1)]),_vm._v(" "),_c('li',{staticClass:"nav-item",attrs:{"title":"Refresh"}},[_c('a',{staticClass:"nav-link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.refresh($event)}}},[_c('icon',{attrs:{"name":"refresh"}})],1)]),_vm._v(" "),_c('li',{staticClass:"nav-item",attrs:{"title":"Open in new tab/window"}},[_c('a',{staticClass:"nav-link",attrs:{"target":"_blank","href":_vm.src}},[_c('icon',{attrs:{"name":"external-link"}})],1)])]),_vm._v(" "),[_c('window-tab',{staticClass:"window-tab-pane-no-padding window-tab-pane-no-scrollbars",attrs:{"title":_vm.title}},[_c('div',{staticClass:"iframe-container"},[_c('iframe',{ref:"iframe",attrs:{"src":_vm.src + '&background=raster',"scrolling":"no"}})])])]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__athletica_vue__ = __webpack_require__(1672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__boxing_duel_vue__ = __webpack_require__(1675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__clock_control_vue__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__credits_vue__ = __webpack_require__(1680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__custom_bug_vue__ = __webpack_require__(1683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fig_score_card_vue__ = __webpack_require__(1686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fig_score_lower_third_vue__ = __webpack_require__(1689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__fig_team_presentation_vue__ = __webpack_require__(1692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__floorball_scoreboard_vue__ = __webpack_require__(1695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__floorball_scoreboard_penalty_vue__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__football_tactical__ = __webpack_require__(1700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__generic_clock_vue__ = __webpack_require__(1703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__generic_image__ = __webpack_require__(1706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__generic_lower_third_vue__ = __webpack_require__(1709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ifsc_vertical_life_vue__ = __webpack_require__(1712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__lower_third_athlete_vue__ = __webpack_require__(1716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__manager_video_vue__ = __webpack_require__(1719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__match_title_vue__ = __webpack_require__(1722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__uiaa_results_center_vue__ = __webpack_require__(1725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__uiaa_vertical_life_vue__ = __webpack_require__(1730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__uiaa_lead_intermediate_chart_vue__ = __webpack_require__(1734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__uiaa_lead_intermediate_standings_vue__ = __webpack_require__(1737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__uiaa_speed_intermediate_standings_vue__ = __webpack_require__(1740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__knockout_vue__ = __webpack_require__(1743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__loopic_template_vue__ = __webpack_require__(1746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__pdf_presentation_vue__ = __webpack_require__(1749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__polling_results_vue__ = __webpack_require__(1752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__polling_results_list_vue__ = __webpack_require__(1755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__ranking_list_vue__ = __webpack_require__(1758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__sponsors_vue__ = __webpack_require__(1761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__sponsors_auto_vue__ = __webpack_require__(1764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__sstv_bug_vue__ = __webpack_require__(1768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__starting_list_vue__ = __webpack_require__(1771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__swiss_wrestling_duel_vue__ = __webpack_require__(1774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__swiss_wrestling_duel_2024_vue__ = __webpack_require__(1777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__swiss_wrestling_duel_2026_vue__ = __webpack_require__(1780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__swiss_wrestling_matches_vue__ = __webpack_require__(1783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__swiss_wrestling_leaderboard_vue__ = __webpack_require__(1786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__swiss_wrestling_notenblatt_vue__ = __webpack_require__(1789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__swiss_wrestling_result_vue__ = __webpack_require__(1792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__swiss_wrestling_result_2024_vue__ = __webpack_require__(1795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__swiss_wrestling_steckbrief_vue__ = __webpack_require__(1798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__tennis_scoreboard_vue__ = __webpack_require__(1801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__uiaa_lower_third_lead_vue__ = __webpack_require__(1804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__uiaa_lower_third_speed_vue__ = __webpack_require__(1807);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__uiaa_partner_logos_vue__ = __webpack_require__(1810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__uiaa_victory_ceremony_athlete_vue__ = __webpack_require__(1814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__uiaa_victory_ceremony_group_vue__ = __webpack_require__(1817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__volleyball_vue__ = __webpack_require__(1820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__volleyball_scoreboard_vue__ = __webpack_require__(1823);



















































var Templates = {
  install: function install(Vue) {
    Vue.component('athletica', __WEBPACK_IMPORTED_MODULE_0__athletica_vue__["a" /* default */]);
    Vue.component('boxing-duel', __WEBPACK_IMPORTED_MODULE_1__boxing_duel_vue__["a" /* default */]);
    Vue.component('clock-control', __WEBPACK_IMPORTED_MODULE_2__clock_control_vue__["a" /* default */]);
    Vue.component('credits', __WEBPACK_IMPORTED_MODULE_3__credits_vue__["a" /* default */]);
    Vue.component('custom-bug', __WEBPACK_IMPORTED_MODULE_4__custom_bug_vue__["a" /* default */]);
    Vue.component('fig-score-card', __WEBPACK_IMPORTED_MODULE_5__fig_score_card_vue__["a" /* default */]);
    Vue.component('fig-score-lower-third', __WEBPACK_IMPORTED_MODULE_6__fig_score_lower_third_vue__["a" /* default */]);
    Vue.component('fig-team-presentation', __WEBPACK_IMPORTED_MODULE_7__fig_team_presentation_vue__["a" /* default */]);
    Vue.component('floorball-scoreboard', __WEBPACK_IMPORTED_MODULE_8__floorball_scoreboard_vue__["a" /* default */]);
    Vue.component('floorball-scoreboard-penalty', __WEBPACK_IMPORTED_MODULE_9__floorball_scoreboard_penalty_vue__["a" /* default */]);
    Vue.component('football-tactical', __WEBPACK_IMPORTED_MODULE_10__football_tactical__["a" /* default */]);
    Vue.component('generic-clock', __WEBPACK_IMPORTED_MODULE_11__generic_clock_vue__["a" /* default */]);
    Vue.component('generic-image', __WEBPACK_IMPORTED_MODULE_12__generic_image__["a" /* default */]);
    Vue.component('generic-lower-third', __WEBPACK_IMPORTED_MODULE_13__generic_lower_third_vue__["a" /* default */]);
    Vue.component('ifsc-vertical-life', __WEBPACK_IMPORTED_MODULE_14__ifsc_vertical_life_vue__["a" /* default */]);
    Vue.component('lower-third-athlete', __WEBPACK_IMPORTED_MODULE_15__lower_third_athlete_vue__["a" /* default */]);
    Vue.component('manager-video', __WEBPACK_IMPORTED_MODULE_16__manager_video_vue__["a" /* default */]);
    Vue.component('match-title', __WEBPACK_IMPORTED_MODULE_17__match_title_vue__["a" /* default */]);
    Vue.component('uiaa-results-center', __WEBPACK_IMPORTED_MODULE_18__uiaa_results_center_vue__["a" /* default */]);
    Vue.component('uiaa-vertical-life', __WEBPACK_IMPORTED_MODULE_19__uiaa_vertical_life_vue__["a" /* default */]);
    Vue.component('uiaa-lead-intermediate-chart', __WEBPACK_IMPORTED_MODULE_20__uiaa_lead_intermediate_chart_vue__["a" /* default */]);
    Vue.component('uiaa-lead-intermediate-standings', __WEBPACK_IMPORTED_MODULE_21__uiaa_lead_intermediate_standings_vue__["a" /* default */]);
    Vue.component('uiaa-speed-intermediate-standings', __WEBPACK_IMPORTED_MODULE_22__uiaa_speed_intermediate_standings_vue__["a" /* default */]);
    Vue.component('knockout', __WEBPACK_IMPORTED_MODULE_23__knockout_vue__["a" /* default */]);
    Vue.component('loopic-template', __WEBPACK_IMPORTED_MODULE_24__loopic_template_vue__["a" /* default */]);
    Vue.component('pdf-presentation', __WEBPACK_IMPORTED_MODULE_25__pdf_presentation_vue__["a" /* default */]);
    Vue.component('polling-results', __WEBPACK_IMPORTED_MODULE_26__polling_results_vue__["a" /* default */]);
    Vue.component('polling-results-list', __WEBPACK_IMPORTED_MODULE_27__polling_results_list_vue__["a" /* default */]);
    Vue.component('ranking-list', __WEBPACK_IMPORTED_MODULE_28__ranking_list_vue__["a" /* default */]);
    Vue.component('sponsors', __WEBPACK_IMPORTED_MODULE_29__sponsors_vue__["a" /* default */]);
    Vue.component('sponsors-auto', __WEBPACK_IMPORTED_MODULE_30__sponsors_auto_vue__["a" /* default */]);
    Vue.component('sstv-bug', __WEBPACK_IMPORTED_MODULE_31__sstv_bug_vue__["a" /* default */]);
    Vue.component('starting-list', __WEBPACK_IMPORTED_MODULE_32__starting_list_vue__["a" /* default */]);
    Vue.component('swiss-wrestling-duel', __WEBPACK_IMPORTED_MODULE_33__swiss_wrestling_duel_vue__["a" /* default */]);
    Vue.component('swiss-wrestling-duel-2024', __WEBPACK_IMPORTED_MODULE_34__swiss_wrestling_duel_2024_vue__["a" /* default */]);
    Vue.component('swiss-wrestling-duel-2026', __WEBPACK_IMPORTED_MODULE_35__swiss_wrestling_duel_2026_vue__["a" /* default */]);
    Vue.component('swiss-wrestling-matches', __WEBPACK_IMPORTED_MODULE_36__swiss_wrestling_matches_vue__["a" /* default */]);
    Vue.component('swiss-wrestling-leaderboard', __WEBPACK_IMPORTED_MODULE_37__swiss_wrestling_leaderboard_vue__["a" /* default */]);
    Vue.component('swiss-wrestling-notenblatt', __WEBPACK_IMPORTED_MODULE_38__swiss_wrestling_notenblatt_vue__["a" /* default */]);
    Vue.component('swiss-wrestling-result', __WEBPACK_IMPORTED_MODULE_39__swiss_wrestling_result_vue__["a" /* default */]);
    Vue.component('swiss-wrestling-result-2024', __WEBPACK_IMPORTED_MODULE_40__swiss_wrestling_result_2024_vue__["a" /* default */]);
    Vue.component('swiss-wrestling-steckbrief', __WEBPACK_IMPORTED_MODULE_41__swiss_wrestling_steckbrief_vue__["a" /* default */]);
    Vue.component('tennis-scoreboard', __WEBPACK_IMPORTED_MODULE_42__tennis_scoreboard_vue__["a" /* default */]);
    Vue.component('uiaa-lower-third-lead', __WEBPACK_IMPORTED_MODULE_43__uiaa_lower_third_lead_vue__["a" /* default */]);
    Vue.component('uiaa-lower-third-speed', __WEBPACK_IMPORTED_MODULE_44__uiaa_lower_third_speed_vue__["a" /* default */]);
    Vue.component('uiaa-partner-logos', __WEBPACK_IMPORTED_MODULE_45__uiaa_partner_logos_vue__["a" /* default */]);
    Vue.component('uiaa-victory-ceremony-athlete', __WEBPACK_IMPORTED_MODULE_46__uiaa_victory_ceremony_athlete_vue__["a" /* default */]);
    Vue.component('uiaa-victory-ceremony-group', __WEBPACK_IMPORTED_MODULE_47__uiaa_victory_ceremony_group_vue__["a" /* default */]);
    Vue.component('volleyball', __WEBPACK_IMPORTED_MODULE_48__volleyball_vue__["a" /* default */]);
    Vue.component('volleyball-scoreboard', __WEBPACK_IMPORTED_MODULE_49__volleyball_scoreboard_vue__["a" /* default */]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Templates);

/***/ }),
/* 1672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_athletica_vue__ = __webpack_require__(1673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fef3b2c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_athletica_vue__ = __webpack_require__(1674);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_athletica_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fef3b2c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_athletica_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_action_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_index__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_template_definitions_service__ = __webpack_require__(115);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var groupBy = function groupBy(xs, key) {
  return xs.reduce(function (rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'athletica',
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins__["b" /* templateMixin */]],
  data: function data() {
    return {
      errorMessage: null,
      meetings: [],
      competitions: [],
      kategorieId: 0,
      wettkampfId: 0,
      rundeId: 0
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6__utils_index__["g" /* mapTemplateOptions */])({ 'endpoint': { default: 'https://127.0.0.1:9443/' } }), Object(__WEBPACK_IMPORTED_MODULE_6__utils_index__["g" /* mapTemplateOptions */])(['meetingId']), Object(__WEBPACK_IMPORTED_MODULE_6__utils_index__["f" /* mapTemplateData */])(['datasetIds', 'templateIds']), {
    filteredCompetitions: function filteredCompetitions() {
      return this.competitions.filter(function (each) {
        return (this.wettkampfId <= 0 || each.wettkampfId === this.wettkampfId) && (this.kategorieId <= 0 || each.kategorieId === this.kategorieId) && (this.rundeId <= 0 || each.rundeId === this.rundeId);
      }.bind(this));
    },
    optionsKategorie: function optionsKategorie() {
      var options = [{ id: 0, label: '' }];
      var groups = groupBy(this.competitions, 'kategorieId');
      for (var p in groups) {
        if (!groups.hasOwnProperty(p)) continue;
        var group = groups[p][0];
        options.push({
          id: group.kategorieId,
          label: group.kategorieName
        });
      }
      return options;
    },
    optionsWettkampf: function optionsWettkampf() {
      var options = [{ id: 0, label: '' }];
      var competitions = this.competitions.filter(function (each) {
        return this.kategorieId <= 0 || each.kategorieId === this.kategorieId;
      }.bind(this));
      var groups = groupBy(competitions, 'wettkampfId');
      for (var p in groups) {
        if (!groups.hasOwnProperty(p)) continue;
        var group = groups[p][0];
        options.push({
          id: group.wettkampfId,
          label: group.disziplinName
        });
      }
      return options;
    },
    optionsRunde: function optionsRunde() {
      var options = [{ id: 0, label: '' }];
      var competitions = this.competitions.filter(function (each) {
        return (this.wettkampfId <= 0 || each.wettkampfId === this.wettkampfId) && (this.kategorieId <= 0 || each.kategorieId === this.kategorieId);
      }.bind(this));
      var groups = groupBy(competitions, 'rundeId');
      for (var p in groups) {
        if (!groups.hasOwnProperty(p)) continue;
        var group = groups[p][0];
        options.push({
          id: group.rundeId,
          label: group.rundeName
        });
      }
      return options;
    },
    optionsMeeting: function optionsMeeting() {
      return this.meetings.map(function (each) {
        return {
          id: each.meetingId,
          label: each.name + ', ' + each.ort + ', ' + each.datumVon + ' - ' + each.datumBis
        };
      });
    }
  }),
  watch: {
    meetingId: function meetingId() {
      this.loadCompetitions();
    },
    meetings: function meetings(value) {
      if (!this.meetingId && Array.isArray(value) && value[0].meetingId) {
        // Setting the meetingId will trigger the watch method and thus load
        // the competitions.
        this.meetingId = value[0].meetingId;
      } else {
        this.loadCompetitions();
      }
    },
    kategorieId: function kategorieId() {
      this.wettkampfId = 0;
      this.rundeId = 0;
    }
  },
  created: function created() {
    this.templateDefinitionsService = new __WEBPACK_IMPORTED_MODULE_7__services_template_definitions_service__["a" /* default */](this.$keycloak, this.$store);
    if (!this.datasetIds) {
      this.datasetIds = [Object(__WEBPACK_IMPORTED_MODULE_3__lib__["e" /* uuid */])(), Object(__WEBPACK_IMPORTED_MODULE_3__lib__["e" /* uuid */])(), Object(__WEBPACK_IMPORTED_MODULE_3__lib__["e" /* uuid */])()];
    }
    if (!this.templateIds) {
      this.templateIds = [Object(__WEBPACK_IMPORTED_MODULE_3__lib__["e" /* uuid */])(), Object(__WEBPACK_IMPORTED_MODULE_3__lib__["e" /* uuid */])(), Object(__WEBPACK_IMPORTED_MODULE_3__lib__["e" /* uuid */])()];
    }
    this.loadMeetings();
  },

  methods: {
    openCreateLowerThirds: function openCreateLowerThirds(competition) {
      var title = competition.kategorieName + ' ' + competition.disziplinName + ' ' + competition.rundeName + ' ' + competition.serieName;
      var name = 'Athletes ' + title;
      this.openCreate(competition, {
        datasetId: this.datasetIds[0],
        templateId: this.templateIds[0],
        name: name,
        title: title,
        componentType: 'lower-third-athlete',
        url: competition.urlStarting,
        templateData: {
          /* eslint-disable no-template-curly-in-string */
          patternBibNumber: '${bibNumber}',
          patternTitle: '${lastName} ${firstName}',
          patternSubtitle: '${club}',
          patternCountry: '${country}'
          /* eslint-enable no-template-curly-in-string */
        },
        overlayData: {
          title: ''
        }
      });
    },
    openCreateStartingList: function openCreateStartingList(competition) {
      var title = competition.kategorieName + ' ' + competition.disziplinName + ' ' + competition.rundeName + ' ' + competition.serieName;
      var name = 'Starting List ' + title;
      var columnMap = {
        'track': 'track',
        'bibNumber': 'bibNumber',
        'lastName': 'lastName',
        'firstName': 'firstName',
        'country': 'country',
        'club': 'club'
      };
      this.openCreate(competition, {
        datasetId: this.datasetIds[1],
        templateId: this.templateIds[1],
        name: name,
        title: title,
        columnMap: columnMap,
        componentType: 'starting-list',
        url: competition.urlStarting
      });
    },
    openCreateRankingList: function openCreateRankingList(competition) {
      var title = competition.kategorieName + ' ' + competition.disziplinName + ' ' + competition.rundeName + ' ' + competition.serieName;
      var name = 'Ranking List ' + title;
      var columnMap = {
        'bibNumber': 'bibNumber',
        'lastName': 'lastName',
        'firstName': 'firstName',
        'country': 'country',
        'club': 'club',
        'rank': 'rank',
        'score': 'resultFormat',
        'windSpeed': 'seriesWindSpeed'
      };
      this.openCreate(competition, {
        datasetId: this.datasetIds[2],
        templateId: this.templateIds[2],
        name: name,
        columnMap: columnMap,
        title: title,
        componentType: 'ranking-list',
        url: competition.urlRanking
      });
    },
    openCreate: function openCreate(competition, options) {
      var datasetId = options.datasetId || Object(__WEBPACK_IMPORTED_MODULE_3__lib__["e" /* uuid */])();
      console.debug('Creating dataset for competition ' + options.name);
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__store_action_types__["m" /* DATASET_DELETE */], { datasetId: datasetId });
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__store_action_types__["l" /* DATASET_CREATE */], {
        datasetId: datasetId,
        name: 'Dataset ' + options.name,
        dataUrl: options.url
      });
      console.debug('Creating template for competition ' + options.name);
      var template = this.templateDefinitionsService.findTemplateDefinition(options.componentType);
      if (!template) {
        console.error('Could not find template definition with componentType "' + options.componentType + '"');
        return;
      }
      template.templateId = options.templateId || Object(__WEBPACK_IMPORTED_MODULE_3__lib__["e" /* uuid */])();
      template.name = options.name;
      template.data = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, options.templateData, { datasetId: datasetId, columnMap: options.columnMap });
      template.options = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, options.templateOptions);
      template.overlay = { data: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, { title: options.title }, options.overlayData) };
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__store_action_types__["t" /* TEMPLATE_DELETE */], { templateId: template.templateId });
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__store_action_types__["r" /* TEMPLATE_CREATE */], template);
    },
    loadCompetitions: function loadCompetitions() {
      console.debug('Loading competitions for meeting id ' + this.meetingId);
      this.errorMessage = null;
      var request = new XMLHttpRequest();
      var url = this.getUrl('competitions?meetingId=' + this.meetingId);
      request.open('GET', url);
      request.onload = function (event) {
        var _this = this;

        if (!event.target) {
          this.errorMessage = 'Unknown error';
          return;
        }

        if (event.target.status !== 200) {
          this.errorMessage = event.target.statusText;
          return;
        }

        var response = void 0;
        try {
          response = JSON.parse(event.target.response);
        } catch (e) {
          this.errorMessage = e.message;
          return;
        }
        if (response && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(Array.isArray(response))) {
          this.competitions = response.map(function (each) {
            each.urlStarting = _this.getUrl('starting-lists?serieId=' + each.serieId);
            each.urlRanking = _this.getUrl('ranking-lists?serieId=' + each.serieId);
            return each;
          });
        } else {
          this.errorMessage = 'Expected the response to be an array';
        }
      }.bind(this);
      request.onerror = function (event) {
        console.log(event);
        this.errorMessage = 'Network error';
      }.bind(this);
      request.send();
    },
    loadMeetings: function loadMeetings() {
      console.debug('Loading meetings');
      this.errorMessage = null;
      var request = new XMLHttpRequest();
      var url = this.getUrl('meetings');
      request.open('GET', url);
      request.onload = function (event) {
        if (!event.target) {
          this.errorMessage = 'Unknown error';
          return;
        }

        if (event.target.status !== 200) {
          this.errorMessage = event.target.statusText;
          return;
        }

        var response = void 0;
        try {
          response = JSON.parse(event.target.response);
        } catch (e) {
          this.errorMessage = e.message;
          return;
        }
        if (response && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(Array.isArray(response))) {
          this.meetings = response;
        } else {
          this.errorMessage = 'Expected the response to be an array';
        }
      }.bind(this);
      request.onerror = function (event) {
        console.log(event);
        this.errorMessage = 'Network error';
      }.bind(this);
      request.send();
    },
    getUrl: function getUrl(resource) {
      return (this.endpoint + '/').slice(0, -1) + resource;
    }
  }
});

/***/ }),
/* 1674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('window',{attrs:{"window-id":_vm.windowId}},[_c('window-tab',{attrs:{"title":_vm.windowTitle}},[_c('div',{staticClass:"form-group form-row"},[_c('div',{staticClass:"col-sm-3"},[_c('b-form-select',{attrs:{"id":_vm.safeId('kategorieId'),"options":_vm.optionsKategorie,"text-field":"label","value-field":"id"},model:{value:(_vm.kategorieId),callback:function ($$v) {_vm.kategorieId=$$v},expression:"kategorieId"}})],1),_vm._v(" "),_c('div',{staticClass:"col-sm-5"},[_c('b-form-select',{attrs:{"id":_vm.safeId('wettkampfId'),"options":_vm.optionsWettkampf,"text-field":"label","value-field":"id"},model:{value:(_vm.wettkampfId),callback:function ($$v) {_vm.wettkampfId=$$v},expression:"wettkampfId"}})],1),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('b-form-select',{attrs:{"id":_vm.safeId('rundeId'),"options":_vm.optionsRunde,"text-field":"label","value-field":"id"},model:{value:(_vm.rundeId),callback:function ($$v) {_vm.rundeId=$$v},expression:"rundeId"}})],1)]),_vm._v(" "),_c('table',{staticClass:"table table-bordered table-responsive table-hover table-sm"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Kat")]),_vm._v(" "),_c('th',[_vm._v("Wettkampf")]),_vm._v(" "),_c('th',[_vm._v("Runde")]),_vm._v(" "),_c('th',[_vm._v("Serie")]),_vm._v(" "),_c('th')])]),_vm._v(" "),_c('tbody',_vm._l((_vm.filteredCompetitions),function(row){return _c('tr',[_c('td',[_vm._v(_vm._s(row.kategorieName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.disziplinName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.rundeName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.serieName))]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.openCreateLowerThirds(row)}}},[_vm._v("A")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.openCreateStartingList(row)}}},[_vm._v("S")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.openCreateRankingList(row)}}},[_vm._v("R")])])])}))])]),_vm._v(" "),_c('window-tab',{attrs:{"title":"Data","icon":"database"}},[_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('endpoint')}},[_vm._v("Athletica-API")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.endpoint),expression:"endpoint",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('endpoint')},domProps:{"value":(_vm.endpoint)},on:{"change":function($event){_vm.endpoint=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('div',{staticClass:"col-sm-12"},[_c('button',{staticClass:"btn btn-block btn-primary",attrs:{"type":"button"},on:{"click":_vm.loadMeetings}},[_vm._v("Connect")])])]),_vm._v(" "),(_vm.errorMessage)?_c('div',{staticClass:"alert alert-danger"},[_c('p',[_c('b',[_vm._v("Error:")]),_vm._v(" "+_vm._s(_vm.errorMessage))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('meetingId')}},[_vm._v("Meeting")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('b-form-select',{attrs:{"id":_vm.safeId('meetingId'),"options":_vm.optionsMeeting,"text-field":"label","value-field":"id"},model:{value:(_vm.meetingId),callback:function ($$v) {_vm.meetingId=$$v},expression:"meetingId"}})],1)])]),_vm._v(" "),_c('window-tab',{attrs:{"title":"Settings","icon":"cog"}},[_c('template-settings',{attrs:{"template-id":_vm.templateId}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_boxing_duel_vue__ = __webpack_require__(1676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_007533fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_boxing_duel_vue__ = __webpack_require__(1677);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_boxing_duel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_007533fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_boxing_duel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_index__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'swiss-wrestling-duel',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins__["b" /* templateMixin */]],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["c" /* mapOverlayData */])(['color1', 'color2', 'title1', 'title2', 'club1', 'club2']), Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["f" /* mapTemplateData */])(['datasetId', 'recordId1', 'recordId2']), Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["f" /* mapTemplateData */])({
    /* eslint-disable no-template-curly-in-string */
    patternColor: { default: '${COLOR}' },
    patternTitle: { default: '${NAME}' },
    patternClub: { default: '${CLUB}'
      /* eslint-enable no-template-curly-in-string */
    } }), {
    dataset: function dataset() {
      if (!this.datasetId) return null;
      return this.$store.getters.dataset(this.datasetId);
    },
    datasetColumns: function datasetColumns() {
      if (!this.dataset) return;
      return this.dataset.columns || [];
    }
  }),
  watch: {
    recordId1: function recordId1(val) {
      if (!val) return;
      var record = this.$store.getters.dataset(this.datasetId).records.find(function (r) {
        return r.recordId === val;
      });
      if (!record) return;
      record = this.mapRecord(record);
      this.color1 = record.color || this.color1;
      this.title1 = record.title;
      this.club1 = record.club;
    },
    recordId2: function recordId2(val) {
      if (!val) return;
      var record = this.$store.getters.dataset(this.datasetId).records.find(function (r) {
        return r.recordId === val;
      });
      if (!record) return;
      record = this.mapRecord(record);
      this.color2 = record.color || this.color2;
      this.title2 = record.title;
      this.club2 = record.club;
    }
  },
  methods: {
    mapRecord: function mapRecord(record) {
      var result = {};
      var recordMap = {
        color: this.patternColor,
        title: this.patternTitle,
        club: this.patternClub
      };
      for (var k in recordMap) {
        if (!recordMap.hasOwnProperty(k)) continue;
        result[k] = recordMap[k].replace(/\$\{([\w ]+)\}/g, function (match, p1) {
          return record[p1] || '';
        });
      }
      return result;
    }
  }
});

/***/ }),
/* 1677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('window',{attrs:{"window-id":_vm.windowId}},[_c('window-tab',{attrs:{"title":_vm.windowTitle}},[_c('switch-buttons',{attrs:{"template-id":_vm.templateId}}),_vm._v(" "),(_vm.datasetId)?_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('record')}},[_vm._v("Wrestler 1")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('record-select',{attrs:{"id":_vm.safeId('record'),"dataset-id":_vm.datasetId},model:{value:(_vm.recordId1),callback:function ($$v) {_vm.recordId1=$$v},expression:"recordId1"}})],1)]):_vm._e(),_vm._v(" "),_c('color-select-group',{attrs:{"label":'Color 1',"id":_vm.safeId('color1')},model:{value:(_vm.color1),callback:function ($$v) {_vm.color1=$$v},expression:"color1"}}),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('title1')}},[_vm._v("Name 1")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.title1),expression:"title1",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('title1')},domProps:{"value":(_vm.title1)},on:{"change":function($event){_vm.title1=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('club1')}},[_vm._v("Club 1")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.club1),expression:"club1",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('club1')},domProps:{"value":(_vm.club1)},on:{"change":function($event){_vm.club1=$event.target.value}}})])]),_vm._v(" "),(_vm.datasetId)?_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('record')}},[_vm._v("Wrestler 2")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('record-select',{attrs:{"id":_vm.safeId('record'),"dataset-id":_vm.datasetId},model:{value:(_vm.recordId2),callback:function ($$v) {_vm.recordId2=$$v},expression:"recordId2"}})],1)]):_vm._e(),_vm._v(" "),_c('color-select-group',{attrs:{"label":'Color 2',"id":_vm.safeId('color2')},model:{value:(_vm.color2),callback:function ($$v) {_vm.color2=$$v},expression:"color2"}}),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('title2')}},[_vm._v("Name 2")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.title2),expression:"title2",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('title2')},domProps:{"value":(_vm.title2)},on:{"change":function($event){_vm.title2=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('club2')}},[_vm._v("Club 2")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.club2),expression:"club2",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('club2')},domProps:{"value":(_vm.club2)},on:{"change":function($event){_vm.club2=$event.target.value}}})])])],1),_vm._v(" "),_c('window-tab',{attrs:{"title":"Data","icon":"database"}},[_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('datasetId')}},[_vm._v("Dataset")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('dataset-select',{attrs:{"id":_vm.safeId('datasetId')},model:{value:(_vm.datasetId),callback:function ($$v) {_vm.datasetId=$$v},expression:"datasetId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label"},[_vm._v("Fields")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{staticClass:"form-control-plaintext",attrs:{"type":"text","readonly":""},domProps:{"value":_vm.datasetColumns}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternColor')}},[_vm._v("Color")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternColor),expression:"patternColor",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternColor')},domProps:{"value":(_vm.patternColor)},on:{"change":function($event){_vm.patternColor=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternTitle')}},[_vm._v("Title")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternTitle),expression:"patternTitle",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternTitle')},domProps:{"value":(_vm.patternTitle)},on:{"change":function($event){_vm.patternTitle=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternClub')}},[_vm._v("Club")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternClub),expression:"patternClub",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternClub')},domProps:{"value":(_vm.patternClub)},on:{"change":function($event){_vm.patternClub=$event.target.value}}})])])]),_vm._v(" "),_c('window-tab',{attrs:{"title":"Settings","icon":"cog"}},[_c('template-settings',{attrs:{"templateId":_vm.templateId}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_index__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_action_types__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'clock-control',
  props: ['templateId'],
  data: function data() {
    return {
      localCurrentTimeMs: 0,
      localCurrentTimeUtc: 0,
      timeHours: 0,
      timeMins: 0,
      timeSecs: 0,
      timeMillis: 0
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__utils_index__["c" /* mapOverlayData */])({
    'direction': { default: 'up' },
    'isRunning': { default: false },
    'currentTimeMs': { default: 0 }
  }), Object(__WEBPACK_IMPORTED_MODULE_1__utils_index__["g" /* mapTemplateOptions */])({
    'startTimeMs': { default: 0 },
    'endTimeMs': { default: 0 }
  })),
  mounted: function mounted() {
    this.updateTime();
  },
  beforeDestroy: function beforeDestroy() {
    this.clearTimeout();
  },

  watch: {
    isRunning: function isRunning() {
      this.localCurrentTimeUtc = this.direction === 'up' ? Date.now() - this.currentTimeMs : Date.now() + this.currentTimeMs;
      this.updateTime();
    },
    currentTimeMs: function currentTimeMs() {
      this.localCurrentTimeUtc = this.direction === 'up' ? Date.now() - this.currentTimeMs : Date.now() + this.currentTimeMs;
      this.updateTime();
    },
    localCurrentTimeMs: function localCurrentTimeMs(val) {
      var time = new Date(val);
      this.timeHours = time.getUTCHours();
      this.timeMins = time.getMinutes();
      this.timeSecs = time.getSeconds();
      this.timeMillis = time.getMilliseconds();
    }
  },
  methods: {
    toggle: function toggle() {
      if (!this.isRunning) {
        this.start();
      } else {
        this.stop();
      }
    },
    start: function start() {
      var currentTimeMs = this.timeHours * 3600 * 1000 + this.timeMins * 60 * 1000 + this.timeSecs * 1000 + this.timeMillis;
      this.updateData({
        direction: this.direction,
        isRunning: true,
        currentTimeMs: currentTimeMs,
        currentTimeUtc: this.direction === 'up' ? Date.now() - currentTimeMs : Date.now() + currentTimeMs
      });
    },
    stop: function stop(currentTimeMs) {
      if (currentTimeMs === undefined) {
        if (this.direction === 'down') {
          currentTimeMs = this.localCurrentTimeUtc - Date.now();
        } else {
          currentTimeMs = Date.now() - this.localCurrentTimeUtc;
        }
        if (currentTimeMs <= 0) {
          currentTimeMs = 0;
          this.localCurrentTimeUtc = Date.now();
        }
      }
      this.updateData({
        direction: this.direction,
        isRunning: false,
        currentTimeMs: currentTimeMs,
        currentTimeUtc: this.direction === 'up' ? Date.now() - currentTimeMs : Date.now() + currentTimeMs
      });
    },
    reset: function reset() {
      var currentTimeMs = this.startTimeMs;
      this.updateData({
        direction: this.direction,
        isRunning: false,
        currentTimeMs: currentTimeMs,
        currentTimeUtc: this.direction === 'up' ? Date.now() - currentTimeMs : Date.now() + currentTimeMs
      });
    },
    shift: function shift(milliseconds) {
      this.clearTimeout();
      var currentTimeMs = 0;
      if (this.isRunning) {
        if (this.direction === 'down') {
          currentTimeMs = this.localCurrentTimeUtc - Date.now() + milliseconds;
        } else {
          currentTimeMs = Date.now() - this.localCurrentTimeUtc + milliseconds;
        }
      } else {
        currentTimeMs = this.currentTimeMs + milliseconds;
      }
      if (currentTimeMs < 0) currentTimeMs = 0;
      this.updateData({
        direction: this.direction,
        isRunning: this.isRunning,
        currentTimeMs: currentTimeMs,
        currentTimeUtc: this.direction === 'up' ? Date.now() - currentTimeMs : Date.now() + currentTimeMs
      });
    },
    updateTime: function updateTime() {
      this.clearTimeout();
      if (this.isRunning) {
        var newCurrentTimeMs = void 0;
        var timeoutDelay = void 0;
        if (this.direction === 'down') {
          newCurrentTimeMs = this.localCurrentTimeUtc - Date.now();
          timeoutDelay = new Date(newCurrentTimeMs).getMilliseconds();

          if (newCurrentTimeMs < this.endTimeMs) {
            newCurrentTimeMs = this.endTimeMs;
            this.localCurrentTimeMs = newCurrentTimeMs;
            this.stop(newCurrentTimeMs);
          }
        } else {
          newCurrentTimeMs = Date.now() - this.localCurrentTimeUtc;
          timeoutDelay = 1000 - new Date(newCurrentTimeMs).getMilliseconds();

          if (this.endTimeMs > 0 && newCurrentTimeMs >= this.endTimeMs) {
            newCurrentTimeMs = this.endTimeMs;
            this.localCurrentTimeMs = newCurrentTimeMs;
            this.stop(newCurrentTimeMs);
          }
        }

        this.localCurrentTimeMs = newCurrentTimeMs;
        this.timeoutId = window.setTimeout(this.updateTime, timeoutDelay);
      } else {
        this.localCurrentTimeMs = this.currentTimeMs;
      }
    },
    updateData: function updateData(data) {
      data.startTimeMs = this.startTimeMs;
      data.endTimeMs = this.endTimeMs;
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_action_types__["z" /* TEMPLATE_OVERLAY_DATA */], {
        templateId: this.templateId,
        data: data
      });
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_action_types__["p" /* OVERLAY_DATA */], {
        templateId: this.templateId,
        channelIds: ['program', 'preview'],
        data: data
      });
    },
    clearTimeout: function clearTimeout() {
      if (this.timeoutId) {
        window.clearTimeout(this.timeoutId);
        this.timeoutId = null;
      }
    }
  }
});

/***/ }),
/* 1679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"form-row align-items-end"},[_c('div',{staticClass:"col"},[_c('label',{staticClass:"col-form-label",attrs:{"for":_vm.safeId('inputTimeHours')}},[_vm._v("Hours")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.timeHours),expression:"timeHours"}],staticClass:"form-control",attrs:{"type":"number","id":_vm.safeId('inputTimeHours'),"min":"0","max":"99","disabled":_vm.isRunning},domProps:{"value":(_vm.timeHours)},on:{"input":function($event){if($event.target.composing){ return; }_vm.timeHours=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('label',{staticClass:"col-form-label",attrs:{"for":_vm.safeId('inputTimeMins')}},[_vm._v("Mins")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.timeMins),expression:"timeMins"}],staticClass:"form-control",attrs:{"type":"number","id":_vm.safeId('inputTimeMins'),"min":"0","max":"59","disabled":_vm.isRunning},domProps:{"value":(_vm.timeMins)},on:{"input":function($event){if($event.target.composing){ return; }_vm.timeMins=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('label',{staticClass:"col-form-label",attrs:{"for":_vm.safeId('inputTimeSecs')}},[_vm._v("Secs")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.timeSecs),expression:"timeSecs"}],staticClass:"form-control",attrs:{"type":"number","id":_vm.safeId('inputTimeSecs'),"min":"0","max":"59","disabled":_vm.isRunning},domProps:{"value":(_vm.timeSecs)},on:{"input":function($event){if($event.target.composing){ return; }_vm.timeSecs=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('label',{staticClass:"col-form-label",attrs:{"for":_vm.safeId('inputTimeMillis')}},[_vm._v("Ms")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.timeMillis),expression:"timeMillis"}],staticClass:"form-control",attrs:{"type":"number","id":_vm.safeId('inputTimeMillis'),"min":"0","max":"999","disabled":_vm.isRunning},domProps:{"value":(_vm.timeMillis)},on:{"input":function($event){if($event.target.composing){ return; }_vm.timeMillis=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('button',{staticClass:"btn btn-block btn-primary",on:{"click":function($event){_vm.toggle()}}},[(!_vm.isRunning)?_c('icon',{attrs:{"name":"play"}}):_vm._e(),_vm._v(" "),(_vm.isRunning)?_c('icon',{attrs:{"name":"pause"}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('button',{staticClass:"btn btn-block btn-warning",on:{"click":function($event){_vm.reset()}}},[_c('icon',{attrs:{"name":"repeat"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"form-row align-items-end"},[_c('div',{staticClass:"col"},[_c('button',{staticClass:"btn btn-block btn-secondary",on:{"click":function($event){_vm.shift(+1000 * 60)}}},[_vm._v("+1'")])]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('button',{staticClass:"btn btn-block btn-secondary",on:{"click":function($event){_vm.shift(-1000 * 60)}}},[_vm._v("-1'")])]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('button',{staticClass:"btn btn-block btn-secondary",on:{"click":function($event){_vm.shift(+1000)}}},[_vm._v("+1\"")])]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('button',{staticClass:"btn btn-block btn-secondary",on:{"click":function($event){_vm.shift(-1000)}}},[_vm._v("-1\"")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_credits_vue__ = __webpack_require__(1681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_047f41cc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_credits_vue__ = __webpack_require__(1682);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_credits_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_047f41cc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_credits_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_action_types__ = __webpack_require__(5);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'starting-list',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins__["b" /* templateMixin */]],
  data: function data() {
    return {
      columnDefinitions: {
        'field': 'Bereich',
        'name': 'Name'
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3__utils__["c" /* mapOverlayData */])({ 'records': { default: [] } }), Object(__WEBPACK_IMPORTED_MODULE_3__utils__["d" /* mapOverlayOptions */])({ pageIntervalSecs: { default: 0 }, itemsPerPage: { default: 8 } }), Object(__WEBPACK_IMPORTED_MODULE_3__utils__["f" /* mapTemplateData */])(['datasetId']), Object(__WEBPACK_IMPORTED_MODULE_3__utils__["f" /* mapTemplateData */])({ columnMap: { default: {} } }), {
    records: function records() {
      var _this = this;

      var dataset = this.$store.getters.dataset(this.datasetId);
      if (!dataset) return [];
      var records = [].concat(dataset.records);
      records.sort(function (a, b) {
        return parseInt(a.SORT_ORDER) - parseInt(b.SORT_ORDER);
      });
      return records.map(function (record) {
        return _this.mapRecord(record, _this.columnMap);
      });
    }
  }),
  watch: {
    records: function records(val) {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__store_action_types__["z" /* TEMPLATE_OVERLAY_DATA */], {
        templateId: this.templateId,
        data: { records: val }
      });
    }
  },
  methods: {
    mapRecord: function mapRecord(record, columnMap) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(columnMap).reduce(function (result, key) {
        result[key] = record[columnMap[key]];
        return result;
      }, {});
    }
  }
});

/***/ }),
/* 1682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('window',{attrs:{"window-id":_vm.windowId}},[_c('window-tab',{attrs:{"title":_vm.windowTitle}},[_c('switch-buttons',{attrs:{"template-id":_vm.templateId}}),_vm._v(" "),_c('table-edit',{attrs:{"cols":_vm.columnDefinitions,"rows":_vm.records}})],1),_vm._v(" "),_c('window-tab',{attrs:{"title":"Data","icon":"database"}},[_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('datasetId')}},[_vm._v("Dataset")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('dataset-select',{attrs:{"id":_vm.safeId('datasetId')},model:{value:(_vm.datasetId),callback:function ($$v) {_vm.datasetId=$$v},expression:"datasetId"}})],1)]),_vm._v(" "),_vm._l((_vm.columnDefinitions),function(v,k){return _c('div',{key:k,staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId(k)}},[_vm._v(_vm._s(v))]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('column-select',{attrs:{"id":_vm.safeId(k),"value":_vm.columnMap[k],"dataset-id":_vm.datasetId},on:{"input":function (val) {
          _vm.columnMap[k] = val
          _vm.columnMap = _vm.columnMap
        }}})],1)])})],2),_vm._v(" "),_c('window-tab',{attrs:{"title":"Settings","icon":"cog"}},[_c('template-settings',{attrs:{"templateId":_vm.templateId}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_custom_bug_vue__ = __webpack_require__(1684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2165db42_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_custom_bug_vue__ = __webpack_require__(1685);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_custom_bug_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2165db42_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_custom_bug_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_mapOverlayData__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_mapTemplateData__ = __webpack_require__(267);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'station-bug',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins__["b" /* templateMixin */]],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2__utils_mapOverlayData__["a" /* default */])(['picture']), Object(__WEBPACK_IMPORTED_MODULE_3__utils_mapTemplateData__["a" /* default */])(['albumId', 'pictureId'])),
  watch: {
    pictureId: function pictureId(val) {
      this.picture = this.$store.getters.picture(this.albumId, val);
    }
  }
});

/***/ }),
/* 1685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('window',{attrs:{"window-id":_vm.windowId}},[_c('window-tab',{attrs:{"title":_vm.windowTitle}},[_c('switch-buttons',{attrs:{"template-id":_vm.templateId}})],1),_vm._v(" "),_c('window-tab',{attrs:{"title":"Data","icon":"database"}},[_c('album-select-group',{model:{value:(_vm.albumId),callback:function ($$v) {_vm.albumId=$$v},expression:"albumId"}}),_vm._v(" "),_c('picture-select-group',{attrs:{"album-id":_vm.albumId},model:{value:(_vm.pictureId),callback:function ($$v) {_vm.pictureId=$$v},expression:"pictureId"}})],1),_vm._v(" "),_c('window-tab',{attrs:{"title":"Settings","icon":"cog"}},[_c('template-settings',{attrs:{"template-id":_vm.templateId}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_fig_score_card_vue__ = __webpack_require__(1687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71ce203d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_fig_score_card_vue__ = __webpack_require__(1688);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_fig_score_card_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71ce203d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_fig_score_card_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_index__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fig-score-card',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins__["b" /* templateMixin */]],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["c" /* mapOverlayData */])(['rank', 'firstName', 'lastName', 'country', 'score', 'value1', 'value2', 'value3', 'value4', 'value5']), Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["f" /* mapTemplateData */])(['datasetId', 'recordId']), Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["f" /* mapTemplateData */])({
    /* eslint-disable no-template-curly-in-string */
    patternRank: { default: '${rank}' },
    patternFirstName: { default: '${firstName}' },
    patternLastName: { default: '${lastName}' },
    patternCountry: { default: '${country}' },
    patternScore: { default: '${score}' },
    patternValue1: { default: '' },
    patternValue2: { default: '' },
    patternValue3: { default: '' },
    patternValue4: { default: '' },
    patternValue5: { default: ''
      /* eslint-enable no-template-curly-in-string */
    } }), {
    dataset: function dataset() {
      if (!this.datasetId) return null;
      return this.$store.getters.dataset(this.datasetId);
    },
    datasetColumns: function datasetColumns() {
      if (!this.dataset) return;
      return this.dataset.columns || [];
    }
  }),
  watch: {
    recordId: function recordId(val) {
      if (!val) return;
      var record = this.$store.getters.dataset(this.datasetId).records.find(function (r) {
        return r.recordId === val;
      });
      if (!record) return;
      record = this.mapRecord(record);
      this.rank = record.rank;
      this.firstName = record.firstName;
      this.lastName = record.lastName;
      this.country = record.country;
      this.score = record.score;
      this.value1 = record.value1;
      this.value2 = record.value2;
      this.value3 = record.value3;
      this.value4 = record.value4;
      this.value5 = record.value5;
    }
  },
  methods: {
    nextRecord: function nextRecord(prevRecordId, datasetId) {
      var records = this.$store.getters.datasetRecords(datasetId);
      var index = records.findIndex(function (p) {
        return p.recordId === prevRecordId;
      });
      this.recordId = records.length > index + 1 ? records[index + 1].recordId : records[0].recordId;
    },
    mapRecord: function mapRecord(record) {
      var result = {};
      var recordMap = {
        rank: this.patternRank,
        firstName: this.patternFirstName,
        lastName: this.patternLastName,
        country: this.patternCountry,
        score: this.patternScore,
        value1: this.patternValue1,
        value2: this.patternValue2,
        value3: this.patternValue3,
        value4: this.patternValue4,
        value5: this.patternValue5
      };
      for (var k in recordMap) {
        if (!recordMap.hasOwnProperty(k)) continue;
        result[k] = recordMap[k].replace(/\$\{([\w ]+)\}/g, function (match, p1) {
          return record[p1] || '';
        });
      }
      return result;
    }
  }
});

/***/ }),
/* 1688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('window',{attrs:{"window-id":_vm.windowId}},[_c('window-tab',{attrs:{"title":_vm.windowTitle}},[_c('switch-buttons',{attrs:{"template-id":_vm.templateId}}),_vm._v(" "),(_vm.datasetId)?_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('record')}},[_vm._v("Record")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('record-select',{attrs:{"id":_vm.safeId('record'),"dataset-id":_vm.datasetId},model:{value:(_vm.recordId),callback:function ($$v) {_vm.recordId=$$v},expression:"recordId"}})],1)]):_vm._e(),_vm._v(" "),(_vm.datasetId)?_c('div',{staticClass:"form-group form-row"},[_c('div',{staticClass:"col-sm-4"}),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('button',{staticClass:"btn btn-block btn-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.nextRecord(_vm.recordId, _vm.datasetId)}}},[_vm._v("Next")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('rank')}},[_vm._v("Rank")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.rank),expression:"rank",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('rank')},domProps:{"value":(_vm.rank)},on:{"change":function($event){_vm.rank=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('firstName')}},[_vm._v("First name")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.firstName),expression:"firstName",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('firstName')},domProps:{"value":(_vm.firstName)},on:{"change":function($event){_vm.firstName=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('lastName')}},[_vm._v("Last name")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.lastName),expression:"lastName",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('lastName')},domProps:{"value":(_vm.lastName)},on:{"change":function($event){_vm.lastName=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('country')}},[_vm._v("Country")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.country),expression:"country",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('country')},domProps:{"value":(_vm.country)},on:{"change":function($event){_vm.country=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('score')}},[_vm._v("Score")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.score),expression:"score",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('score')},domProps:{"value":(_vm.score)},on:{"change":function($event){_vm.score=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('value1')}},[_vm._v("Value 1")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.value1),expression:"value1",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('value1')},domProps:{"value":(_vm.value1)},on:{"change":function($event){_vm.value1=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('value2')}},[_vm._v("Value 2")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.value2),expression:"value2",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('value2')},domProps:{"value":(_vm.value2)},on:{"change":function($event){_vm.value2=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('value3')}},[_vm._v("Value 3")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.value3),expression:"value3",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('value3')},domProps:{"value":(_vm.value3)},on:{"change":function($event){_vm.value3=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('value4')}},[_vm._v("Value 4")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.value4),expression:"value4",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('value4')},domProps:{"value":(_vm.value4)},on:{"change":function($event){_vm.value4=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('value5')}},[_vm._v("Value 5")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.value5),expression:"value5",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('value5')},domProps:{"value":(_vm.value5)},on:{"change":function($event){_vm.value5=$event.target.value}}})])])],1),_vm._v(" "),_c('window-tab',{attrs:{"title":"Data","icon":"database"}},[_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('datasetId')}},[_vm._v("Dataset")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('dataset-select',{attrs:{"id":_vm.safeId('datasetId')},model:{value:(_vm.datasetId),callback:function ($$v) {_vm.datasetId=$$v},expression:"datasetId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label"},[_vm._v("Fields")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{staticClass:"form-control-plaintext",attrs:{"type":"text","readonly":""},domProps:{"value":_vm.datasetColumns}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternRank')}},[_vm._v("Rank")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternRank),expression:"patternRank",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternRank')},domProps:{"value":(_vm.patternRank)},on:{"change":function($event){_vm.patternRank=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternFirstName')}},[_vm._v("First name")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternFirstName),expression:"patternFirstName",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternFirstName')},domProps:{"value":(_vm.patternFirstName)},on:{"change":function($event){_vm.patternFirstName=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternLastName')}},[_vm._v("Last name")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternLastName),expression:"patternLastName",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternLastName')},domProps:{"value":(_vm.patternLastName)},on:{"change":function($event){_vm.patternLastName=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternCountry')}},[_vm._v("Country")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternCountry),expression:"patternCountry",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternCountry')},domProps:{"value":(_vm.patternCountry)},on:{"change":function($event){_vm.patternCountry=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternScore')}},[_vm._v("Score")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternScore),expression:"patternScore",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternScore')},domProps:{"value":(_vm.patternScore)},on:{"change":function($event){_vm.patternScore=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternValue1')}},[_vm._v("Value 1")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternValue1),expression:"patternValue1",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternValue1')},domProps:{"value":(_vm.patternValue1)},on:{"change":function($event){_vm.patternValue1=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternValue2')}},[_vm._v("Value 2")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternValue2),expression:"patternValue2",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternValue2')},domProps:{"value":(_vm.patternValue2)},on:{"change":function($event){_vm.patternValue2=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternValue3')}},[_vm._v("Value 3")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternValue3),expression:"patternValue3",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternValue3')},domProps:{"value":(_vm.patternValue3)},on:{"change":function($event){_vm.patternValue3=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternValue4')}},[_vm._v("Value 4")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternValue4),expression:"patternValue4",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternValue4')},domProps:{"value":(_vm.patternValue4)},on:{"change":function($event){_vm.patternValue4=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternValue5')}},[_vm._v("Value 5")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternValue5),expression:"patternValue5",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternValue5')},domProps:{"value":(_vm.patternValue5)},on:{"change":function($event){_vm.patternValue5=$event.target.value}}})])])]),_vm._v(" "),_c('window-tab',{attrs:{"title":"Settings","icon":"cog"}},[_c('template-settings',{attrs:{"templateId":_vm.templateId}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_fig_score_lower_third_vue__ = __webpack_require__(1690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c24d8f8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_fig_score_lower_third_vue__ = __webpack_require__(1691);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_fig_score_lower_third_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c24d8f8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_fig_score_lower_third_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_index__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fig-score-card',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins__["b" /* templateMixin */]],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["c" /* mapOverlayData */])(['rank', 'firstName', 'lastName', 'country', 'score', 'discipline', 'subtitle']), Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["f" /* mapTemplateData */])(['datasetId', 'recordId']), Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["f" /* mapTemplateData */])({
    /* eslint-disable no-template-curly-in-string */
    patternRank: { default: '${rank}' },
    patternFirstName: { default: '${firstName}' },
    patternLastName: { default: '${lastName}' },
    patternCountry: { default: '${country}' },
    patternScore: { default: '${score}' },
    patternDiscipline: { default: '${discipline}' },
    patternSubtitle: { default: '${subtitle}'
      /* eslint-enable no-template-curly-in-string */
    } }), {
    dataset: function dataset() {
      if (!this.datasetId) return null;
      return this.$store.getters.dataset(this.datasetId);
    },
    datasetColumns: function datasetColumns() {
      if (!this.dataset) return;
      return this.dataset.columns || [];
    }
  }),
  watch: {
    recordId: function recordId(val) {
      if (!val) return;
      var record = this.$store.getters.dataset(this.datasetId).records.find(function (r) {
        return r.recordId === val;
      });
      if (!record) return;
      record = this.mapRecord(record);
      this.rank = record.rank;
      this.firstName = record.firstName;
      this.lastName = record.lastName;
      this.country = record.country;
      this.score = record.score;
      this.discipline = record.discipline;
      this.subtitle = record.subtitle;
    }
  },
  methods: {
    nextRecord: function nextRecord(prevRecordId, datasetId) {
      var records = this.$store.getters.datasetRecords(datasetId);
      var index = records.findIndex(function (p) {
        return p.recordId === prevRecordId;
      });
      this.recordId = records.length > index + 1 ? records[index + 1].recordId : records[0].recordId;
    },
    mapRecord: function mapRecord(record) {
      var result = {};
      var recordMap = {
        rank: this.patternRank,
        firstName: this.patternFirstName,
        lastName: this.patternLastName,
        country: this.patternCountry,
        score: this.patternScore,
        discipline: this.patternDiscipline,
        subtitle: this.patternSubtitle
      };
      for (var k in recordMap) {
        if (!recordMap.hasOwnProperty(k)) continue;
        result[k] = recordMap[k].replace(/\$\{([\w ]+)\}/g, function (match, p1) {
          return record[p1] || '';
        });
      }
      return result;
    }
  }
});

/***/ }),
/* 1691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('window',{attrs:{"window-id":_vm.windowId}},[_c('window-tab',{attrs:{"title":_vm.windowTitle}},[_c('switch-buttons',{attrs:{"template-id":_vm.templateId}}),_vm._v(" "),(_vm.datasetId)?_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('record')}},[_vm._v("Record")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('record-select',{attrs:{"id":_vm.safeId('record'),"dataset-id":_vm.datasetId},model:{value:(_vm.recordId),callback:function ($$v) {_vm.recordId=$$v},expression:"recordId"}})],1)]):_vm._e(),_vm._v(" "),(_vm.datasetId)?_c('div',{staticClass:"form-group form-row"},[_c('div',{staticClass:"col-sm-4"}),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('button',{staticClass:"btn btn-block btn-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.nextRecord(_vm.recordId, _vm.datasetId)}}},[_vm._v("Next")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('rank')}},[_vm._v("Rank")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.rank),expression:"rank",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('rank')},domProps:{"value":(_vm.rank)},on:{"change":function($event){_vm.rank=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('firstName')}},[_vm._v("First name")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.firstName),expression:"firstName",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('firstName')},domProps:{"value":(_vm.firstName)},on:{"change":function($event){_vm.firstName=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('lastName')}},[_vm._v("Last name")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.lastName),expression:"lastName",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('lastName')},domProps:{"value":(_vm.lastName)},on:{"change":function($event){_vm.lastName=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('country')}},[_vm._v("Country")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.country),expression:"country",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('country')},domProps:{"value":(_vm.country)},on:{"change":function($event){_vm.country=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('score')}},[_vm._v("Score")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.score),expression:"score",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('score')},domProps:{"value":(_vm.score)},on:{"change":function($event){_vm.score=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('discipline')}},[_vm._v("Discipline")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.discipline),expression:"discipline",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('discipline')},domProps:{"value":(_vm.discipline)},on:{"change":function($event){_vm.discipline=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('subtitle')}},[_vm._v("Subtitle")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.subtitle),expression:"subtitle",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('subtitle')},domProps:{"value":(_vm.subtitle)},on:{"change":function($event){_vm.subtitle=$event.target.value}}})])])],1),_vm._v(" "),_c('window-tab',{attrs:{"title":"Data","icon":"database"}},[_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('datasetId')}},[_vm._v("Dataset")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('dataset-select',{attrs:{"id":_vm.safeId('datasetId')},model:{value:(_vm.datasetId),callback:function ($$v) {_vm.datasetId=$$v},expression:"datasetId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label"},[_vm._v("Fields")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{staticClass:"form-control-plaintext",attrs:{"type":"text","readonly":""},domProps:{"value":_vm.datasetColumns}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternRank')}},[_vm._v("Rank")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternRank),expression:"patternRank",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternRank')},domProps:{"value":(_vm.patternRank)},on:{"change":function($event){_vm.patternRank=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternFirstName')}},[_vm._v("First name")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternFirstName),expression:"patternFirstName",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternFirstName')},domProps:{"value":(_vm.patternFirstName)},on:{"change":function($event){_vm.patternFirstName=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternLastName')}},[_vm._v("Last name")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternLastName),expression:"patternLastName",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternLastName')},domProps:{"value":(_vm.patternLastName)},on:{"change":function($event){_vm.patternLastName=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternCountry')}},[_vm._v("Country")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternCountry),expression:"patternCountry",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternCountry')},domProps:{"value":(_vm.patternCountry)},on:{"change":function($event){_vm.patternCountry=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternScore')}},[_vm._v("Score")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternScore),expression:"patternScore",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternScore')},domProps:{"value":(_vm.patternScore)},on:{"change":function($event){_vm.patternScore=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternDiscipline')}},[_vm._v("Discipline")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternDiscipline),expression:"patternDiscipline",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternDiscipline')},domProps:{"value":(_vm.patternDiscipline)},on:{"change":function($event){_vm.patternDiscipline=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternSubtitle')}},[_vm._v("Subtitle")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternSubtitle),expression:"patternSubtitle",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternSubtitle')},domProps:{"value":(_vm.patternSubtitle)},on:{"change":function($event){_vm.patternSubtitle=$event.target.value}}})])])]),_vm._v(" "),_c('window-tab',{attrs:{"title":"Settings","icon":"cog"}},[_c('template-settings',{attrs:{"templateId":_vm.templateId}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_fig_team_presentation_vue__ = __webpack_require__(1693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50d29475_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_fig_team_presentation_vue__ = __webpack_require__(1694);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_fig_team_presentation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50d29475_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_fig_team_presentation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_index__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'lower-third-athlete',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins__["b" /* templateMixin */]],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["c" /* mapOverlayData */])(['teamName', 'country', 'firstName1', 'lastName1', 'firstName2', 'lastName2']), Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["f" /* mapTemplateData */])(['datasetId', 'recordId']), Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["f" /* mapTemplateData */])({
    /* eslint-disable no-template-curly-in-string */
    patternTeamName: { default: '${countryName}' },
    patternCountry: { default: '${country0}' },
    patternFirstName1: { default: '${firstName0}' },
    patternLastName1: { default: '${lastName0}' },
    patternFirstName2: { default: '${firstName1}' },
    patternLastName2: { default: '${lastName1}'
      /* eslint-enable no-template-curly-in-string */
    } }), {
    dataset: function dataset() {
      if (!this.datasetId) return null;
      return this.$store.getters.dataset(this.datasetId);
    },
    datasetColumns: function datasetColumns() {
      if (!this.dataset) return;
      return this.dataset.columns || [];
    }
  }),
  watch: {
    recordId: function recordId(val) {
      if (!val) return;
      var record = this.$store.getters.dataset(this.datasetId).records.find(function (r) {
        return r.recordId === val;
      });
      if (!record) return;
      record = this.mapRecord(record);
      this.teamName = record.teamName;
      this.country = record.country;
      this.firstName1 = record.firstName1;
      this.lastName1 = record.lastName1;
      this.firstName2 = record.firstName2;
      this.lastName2 = record.lastName2;
    }
  },
  methods: {
    nextRecord: function nextRecord(prevRecordId, datasetId) {
      var records = this.$store.getters.datasetRecords(datasetId);
      var index = records.findIndex(function (p) {
        return p.recordId === prevRecordId;
      });
      this.recordId = records.length > index + 1 ? records[index + 1].recordId : records[0].recordId;
    },
    mapRecord: function mapRecord(record) {
      var result = {};
      var recordMap = {
        teamName: this.patternTeamName,
        country: this.patternCountry,
        firstName1: this.patternFirstName1,
        lastName1: this.patternLastName1,
        firstName2: this.patternFirstName2,
        lastName2: this.patternLastName2
      };
      for (var k in recordMap) {
        if (!recordMap.hasOwnProperty(k)) continue;
        result[k] = recordMap[k].replace(/\$\{([\w ]+)\}/g, function (match, p1) {
          return record[p1] || '';
        });
      }
      return result;
    }
  }
});

/***/ }),
/* 1694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('window',{attrs:{"window-id":_vm.windowId}},[_c('window-tab',{attrs:{"title":_vm.windowTitle}},[_c('switch-buttons',{attrs:{"template-id":_vm.templateId}}),_vm._v(" "),(_vm.datasetId)?_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('record')}},[_vm._v("Record")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('record-select',{attrs:{"id":_vm.safeId('record'),"dataset-id":_vm.datasetId},model:{value:(_vm.recordId),callback:function ($$v) {_vm.recordId=$$v},expression:"recordId"}})],1)]):_vm._e(),_vm._v(" "),(_vm.datasetId)?_c('div',{staticClass:"form-group form-row"},[_c('div',{staticClass:"col-sm-4"}),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('button',{staticClass:"btn btn-block btn-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.nextRecord(_vm.recordId, _vm.datasetId)}}},[_vm._v("Next")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('teamName')}},[_vm._v("Team name")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.teamName),expression:"teamName",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('teamName')},domProps:{"value":(_vm.teamName)},on:{"change":function($event){_vm.teamName=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('country')}},[_vm._v("Country")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.country),expression:"country",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('country')},domProps:{"value":(_vm.country)},on:{"change":function($event){_vm.country=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('firstName1')}},[_vm._v("First name 1")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.firstName1),expression:"firstName1",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('firstName1')},domProps:{"value":(_vm.firstName1)},on:{"change":function($event){_vm.firstName1=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('lastName1')}},[_vm._v("Last name 1")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.lastName1),expression:"lastName1",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('lastName1')},domProps:{"value":(_vm.lastName1)},on:{"change":function($event){_vm.lastName1=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('firstName2')}},[_vm._v("First name 2")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.firstName2),expression:"firstName2",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('firstName2')},domProps:{"value":(_vm.firstName2)},on:{"change":function($event){_vm.firstName2=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('lastName2')}},[_vm._v("Last name 2")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.lastName2),expression:"lastName2",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('lastName2')},domProps:{"value":(_vm.lastName2)},on:{"change":function($event){_vm.lastName2=$event.target.value}}})])])],1),_vm._v(" "),_c('window-tab',{attrs:{"title":"Data","icon":"database"}},[_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('datasetId')}},[_vm._v("Dataset")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('dataset-select',{attrs:{"id":_vm.safeId('datasetId')},model:{value:(_vm.datasetId),callback:function ($$v) {_vm.datasetId=$$v},expression:"datasetId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label"},[_vm._v("Fields")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{staticClass:"form-control-plaintext",attrs:{"type":"text","readonly":""},domProps:{"value":_vm.datasetColumns}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternTeamName')}},[_vm._v("Team name")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternTeamName),expression:"patternTeamName",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternTeamName')},domProps:{"value":(_vm.patternTeamName)},on:{"change":function($event){_vm.patternTeamName=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternCountry')}},[_vm._v("Country")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternCountry),expression:"patternCountry",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternCountry')},domProps:{"value":(_vm.patternCountry)},on:{"change":function($event){_vm.patternCountry=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternFirstName1')}},[_vm._v("First name 1")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternFirstName1),expression:"patternFirstName1",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternFirstName1')},domProps:{"value":(_vm.patternFirstName1)},on:{"change":function($event){_vm.patternFirstName1=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternLastName1')}},[_vm._v("Last name 1")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternLastName1),expression:"patternLastName1",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternLastName1')},domProps:{"value":(_vm.patternLastName1)},on:{"change":function($event){_vm.patternLastName1=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternFirstName2')}},[_vm._v("First name 2")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternFirstName2),expression:"patternFirstName2",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternFirstName2')},domProps:{"value":(_vm.patternFirstName2)},on:{"change":function($event){_vm.patternFirstName2=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternLastName2')}},[_vm._v("Last name 2")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternLastName2),expression:"patternLastName2",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternLastName2')},domProps:{"value":(_vm.patternLastName2)},on:{"change":function($event){_vm.patternLastName2=$event.target.value}}})])])]),_vm._v(" "),_c('window-tab',{attrs:{"title":"Settings","icon":"cog"}},[_c('template-settings',{attrs:{"templateId":_vm.templateId}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_floorball_scoreboard_vue__ = __webpack_require__(1696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_177c898b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_floorball_scoreboard_vue__ = __webpack_require__(1699);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_floorball_scoreboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_177c898b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_floorball_scoreboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_index__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__clock_control__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_action_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__floorball_scoreboard_penalty__ = __webpack_require__(281);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'floorball-scoreboard',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins__["b" /* templateMixin */]],
  components: { FloorballScoreboardPenalty: __WEBPACK_IMPORTED_MODULE_5__floorball_scoreboard_penalty__["a" /* default */], clockControl: __WEBPACK_IMPORTED_MODULE_3__clock_control__["a" /* default */] },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["c" /* mapOverlayData */])(['name1', 'name2', 'country1', 'country2', 'period', 'direction']), Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["c" /* mapOverlayData */])({
    'score1': { default: 0 },
    'score2': { default: 0 }
  }), Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["d" /* mapOverlayOptions */])(['displayHours', 'displayMinutes', 'displayTenths', 'displayHundredths']), Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["f" /* mapTemplateData */])(['albumId', 'datasetId', 'teamId1', 'teamId2', 'pictureId1', 'pictureId2']), Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["g" /* mapTemplateOptions */])({
    'startTimeMs': { default: 0 },
    'endTimeMs': { default: 0 }
  }), Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["f" /* mapTemplateData */])({
    /* eslint-disable no-template-curly-in-string */
    patternName: { default: '${NAME}' },
    patternPicture: { default: '${PICTURE}' },
    patternCountry: { default: '${COUNTRY}'
      /* eslint-enable no-template-curly-in-string */
    } }), {
    startHours: {
      get: function get() {
        return Math.floor(this.startTimeMs / 1000 / 3600);
      },
      set: function set(val) {
        this.setStartTimeMs(val, this.startMins, this.startSecs);
      }
    },
    startMins: {
      get: function get() {
        return Math.floor(this.startTimeMs / 1000 / 60 % 60);
      },
      set: function set(val) {
        this.setStartTimeMs(this.startHours, val, this.startSecs);
      }
    },
    startSecs: {
      get: function get() {
        return this.startTimeMs / 1000 % 60;
      },
      set: function set(val) {
        this.setStartTimeMs(this.startHours, this.startMins, val);
      }
    },
    endHours: {
      get: function get() {
        return Math.floor(this.endTimeMs / 1000 / 3600);
      },
      set: function set(val) {
        this.setEndTimeMs(val, this.endMins, this.endSecs);
      }
    },
    endMins: {
      get: function get() {
        return Math.floor(this.endTimeMs / 1000 / 60 % 60);
      },
      set: function set(val) {
        this.setEndTimeMs(this.endHours, val, this.endSecs);
      }
    },
    endSecs: {
      get: function get() {
        return this.endTimeMs / 1000 % 60;
      },
      set: function set(val) {
        this.setEndTimeMs(this.endHours, this.endMins, val);
      }
    },
    formatOptions: function formatOptions() {
      return [{ label: 'Dynamic', value: 0 }, { label: 'Always', value: 1 }, { label: 'Never', value: 2 }];
    }
  }),
  watch: {
    teamId1: function teamId1(val) {
      var record = this.$store.getters.datasetRecord(this.datasetId, val) || null;
      var values = Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["e" /* mapRecord */])(record, {
        name: this.patternName,
        country: this.patternCountry,
        picture: this.patternPicture
      });
      this.name1 = values.name;
      this.country1 = values.country;
      var picture = this.$store.getters.picture(this.albumId, function (p) {
        return p.fileName === values.picture;
      });
      console.log('pictureId1', picture && picture.pictureId);
      this.pictureId1 = picture && picture.pictureId;
    },
    teamId2: function teamId2(val) {
      var record = this.$store.getters.datasetRecord(this.datasetId, val) || null;
      var values = Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["e" /* mapRecord */])(record, {
        name: this.patternName,
        country: this.patternCountry,
        picture: this.patternPicture
      });
      this.name2 = values.name;
      this.country2 = values.country;
      var picture = this.$store.getters.picture(this.albumId, function (p) {
        return p.fileName === values.picture;
      });
      this.pictureId2 = picture && picture.pictureId;
    },
    pictureId1: function pictureId1(val) {
      var picture = this.$store.getters.picture(this.albumId, val) || null;
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__store_action_types__["z" /* TEMPLATE_OVERLAY_DATA */], {
        templateId: this.templateId,
        data: { picture1: picture }
      });
    },
    pictureId2: function pictureId2(val) {
      var picture = this.$store.getters.picture(this.albumId, val) || null;
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__store_action_types__["z" /* TEMPLATE_OVERLAY_DATA */], {
        templateId: this.templateId,
        data: { picture2: picture }
      });
    },
    score1: function score1(val) {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__store_action_types__["p" /* OVERLAY_DATA */], {
        templateId: this.templateId,
        channelIds: ['program', 'preview'],
        data: { score1: val }
      });
    },
    score2: function score2(val) {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__store_action_types__["p" /* OVERLAY_DATA */], {
        templateId: this.templateId,
        channelIds: ['program', 'preview'],
        data: { score2: val }
      });
    }
  },
  methods: {
    setStartTimeMs: function setStartTimeMs(hours, mins, secs) {
      this.startTimeMs = 1000 * (hours * 3600 + mins * 60 + secs * 1);
      this.direction = this.startTimeMs <= this.endTimeMs ? 'up' : 'down';
    },
    setEndTimeMs: function setEndTimeMs(hours, mins, secs) {
      this.endTimeMs = 1000 * (hours * 3600 + mins * 60 + secs * 1);
      this.direction = this.startTimeMs <= this.endTimeMs ? 'up' : 'down';
    },
    shiftHomeScore: function shiftHomeScore(val) {
      this.score1 = Math.max(0, Number(this.score1) + val);
    },
    shiftAwayScore: function shiftAwayScore(val) {
      this.score2 = Math.max(0, Number(this.score2) + val);
    }
  }
});

/***/ }),
/* 1697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_index__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_action_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_time_input_group__ = __webpack_require__(273);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { TimeInputGroup: __WEBPACK_IMPORTED_MODULE_3__ui_time_input_group__["a" /* default */] },
  props: ['templateId'],
  data: function data() {
    return {
      minutes: 2
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__utils_index__["c" /* mapOverlayData */])({
    'direction': { default: 'up' },
    'isRunning': { default: false },
    'currentTimeMs': { default: 0 },
    'homePenalties': { default: [] },
    'awayPenalties': { default: [] }
  }), Object(__WEBPACK_IMPORTED_MODULE_1__utils_index__["g" /* mapTemplateOptions */])({
    'startTimeMs': { default: 0 }
  })),
  watch: {
    isRunning: function isRunning() {
      this.localCurrentTimeUtc = this.direction === 'up' ? Date.now() - this.currentTimeMs : Date.now() + this.currentTimeMs;
    },
    homePenalties: function homePenalties(val) {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_action_types__["p" /* OVERLAY_DATA */], {
        templateId: this.templateId,
        channelIds: ['program', 'preview'],
        data: { homePenalties: val }
      });
    },
    awayPenalties: function awayPenalties(val) {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_action_types__["p" /* OVERLAY_DATA */], {
        templateId: this.templateId,
        channelIds: ['program', 'preview'],
        data: { awayPenalties: val }
      });
    }
  },
  methods: {
    newHomePenalty: function newHomePenalty(duration) {
      duration = duration * 60 * 1000;
      var startTimeMs = this.getCurrentTimeMs();
      var endTimeMs = this.direction === 'up' ? startTimeMs + duration : startTimeMs - duration;
      console.debug('[penalty] adding penalty %d mins from %d to %d', duration / (60 * 1000), startTimeMs, endTimeMs);
      var penalties = [].concat(this.homePenalties).concat({ startTimeMs: startTimeMs, endTimeMs: endTimeMs, duration: duration });
      penalties.sort(function (a, b) {
        return a.startTimeMs - b.startTimeMs || a.endTimeMs - b.endTimeMs;
      });
      this.homePenalties = penalties;
    },
    updateHomePenalty: function updateHomePenalty(penalty) {
      penalty.endTimeMs = this.direction === 'up' ? penalty.startTimeMs + penalty.duration : penalty.startTimeMs - penalty.duration;
      var penalties = [].concat(this.homePenalties);
      penalties.sort(function (a, b) {
        return a.startTimeMs - b.startTimeMs || a.endTimeMs - b.endTimeMs;
      });
      this.homePenalties = penalties;
    },
    removeHomePenalty: function removeHomePenalty(penalty) {
      var idx = this.homePenalties.indexOf(penalty);
      this.homePenalties.splice(idx, 1);
      this.homePenalties = [].concat(this.homePenalties);
    },
    newAwayPenalty: function newAwayPenalty(duration) {
      duration = duration * 60 * 1000;
      var startTimeMs = this.getCurrentTimeMs();
      var endTimeMs = this.direction === 'up' ? startTimeMs + duration : startTimeMs - duration;
      console.debug('[penalty] adding penalty %d mins from %d to %d', duration / (60 * 1000), startTimeMs, endTimeMs);
      var penalties = [].concat(this.awayPenalties).concat({ startTimeMs: startTimeMs, endTimeMs: endTimeMs, duration: duration });
      penalties.sort(function (a, b) {
        return a.startTimeMs - b.startTimeMs || a.endTimeMs - b.endTimeMs;
      });
      this.awayPenalties = penalties;
    },
    updateAwayPenalty: function updateAwayPenalty(penalty) {
      penalty.endTimeMs = this.direction === 'up' ? penalty.startTimeMs + penalty.duration : penalty.startTimeMs - penalty.duration;
      var penalties = [].concat(this.awayPenalties);
      penalties.sort(function (a, b) {
        return a.startTimeMs - b.startTimeMs || a.endTimeMs - b.endTimeMs;
      });
      this.awayPenalties = penalties;
    },
    removeAwayPenalty: function removeAwayPenalty(penalty) {
      var idx = this.awayPenalties.indexOf(penalty);
      this.awayPenalties.splice(idx, 1);
      this.awayPenalties = [].concat(this.awayPenalties);
    },
    getCurrentTimeMs: function getCurrentTimeMs() {
      if (this.isRunning) {
        var newCurrentTimeMs = void 0;
        if (this.direction === 'down') {
          newCurrentTimeMs = this.localCurrentTimeUtc - Date.now();
        } else {
          newCurrentTimeMs = Date.now() - this.localCurrentTimeUtc;
        }
        if (newCurrentTimeMs < 0) {
          newCurrentTimeMs = 0;
        }
        return newCurrentTimeMs;
      } else {
        return this.currentTimeMs;
      }
    }
  }
});

/***/ }),
/* 1698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"form-row"},[_c('label',{staticClass:"col-form-label col-6"},[_vm._v("Home penalties")]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('button',{staticClass:"btn btn-block btn-primary",on:{"click":function($event){_vm.newHomePenalty(2)}}},[_vm._v("2'")])]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('button',{staticClass:"btn btn-block btn-primary",on:{"click":function($event){_vm.newHomePenalty(5)}}},[_vm._v("5'")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},_vm._l((_vm.homePenalties),function(p){return _c('div',{staticClass:"form-row"},[_c('div',{staticClass:"col-3"},[_c('time-input-group',{attrs:{"label":""},model:{value:(p.startTimeMs),callback:function ($$v) {_vm.$set(p, "startTimeMs", $$v)},expression:"p.startTimeMs"}})],1),_vm._v(" "),_c('div',{staticClass:"col-3"},[_c('time-input-group',{attrs:{"label":""},model:{value:(p.duration),callback:function ($$v) {_vm.$set(p, "duration", $$v)},expression:"p.duration"}})],1),_vm._v(" "),_c('div',{staticClass:"col-3"},[_c('button',{staticClass:"btn btn-block btn-primary",on:{"click":function($event){_vm.updateHomePenalty(p)}}},[_vm._v("Update")])]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_c('button',{staticClass:"btn btn-block btn-danger",on:{"click":function($event){_vm.removeHomePenalty(p)}}},[_vm._v("Remove")])])])}))]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"form-row"},[_c('label',{staticClass:"col-form-label col-6"},[_vm._v("Away penalties")]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('button',{staticClass:"btn btn-block btn-primary",on:{"click":function($event){_vm.newAwayPenalty(2)}}},[_vm._v("2'")])]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('button',{staticClass:"btn btn-block btn-primary",on:{"click":function($event){_vm.newAwayPenalty(5)}}},[_vm._v("5'")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},_vm._l((_vm.awayPenalties),function(p){return _c('div',{staticClass:"form-row"},[_c('div',{staticClass:"col-3"},[_c('time-input-group',{attrs:{"label":""},model:{value:(p.startTimeMs),callback:function ($$v) {_vm.$set(p, "startTimeMs", $$v)},expression:"p.startTimeMs"}})],1),_vm._v(" "),_c('div',{staticClass:"col-3"},[_c('time-input-group',{attrs:{"label":""},model:{value:(p.duration),callback:function ($$v) {_vm.$set(p, "duration", $$v)},expression:"p.duration"}})],1),_vm._v(" "),_c('div',{staticClass:"col-3"},[_c('button',{staticClass:"btn btn-block btn-primary",on:{"click":function($event){_vm.updateAwayPenalty(p)}}},[_vm._v("Update")])]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_c('button',{staticClass:"btn btn-block btn-danger",on:{"click":function($event){_vm.removeAwayPenalty(p)}}},[_vm._v("Remove")])])])}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('window',{attrs:{"window-id":_vm.windowId}},[_c('window-tab',{attrs:{"title":_vm.windowTitle}},[_c('switch-buttons',{attrs:{"template-id":_vm.templateId}}),_vm._v(" "),(_vm.datasetId)?_c('record-select-group',{attrs:{"label":"Home team","dataset-id":_vm.datasetId},model:{value:(_vm.teamId1),callback:function ($$v) {_vm.teamId1=$$v},expression:"teamId1"}}):_vm._e(),_vm._v(" "),(_vm.datasetId)?_c('record-select-group',{attrs:{"label":"Away team","dataset-id":_vm.datasetId},model:{value:(_vm.teamId2),callback:function ($$v) {_vm.teamId2=$$v},expression:"teamId2"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('period')}},[_vm._v("Period")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.period),expression:"period",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('period')},domProps:{"value":(_vm.period)},on:{"change":function($event){_vm.period=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label"},[_vm._v("Home score")]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy.number",value:(_vm.score1),expression:"score1",modifiers:{"lazy":true,"number":true}}],staticClass:"form-control",attrs:{"type":"number","id":_vm.safeId('score1'),"min":"0"},domProps:{"value":(_vm.score1)},on:{"change":function($event){_vm.score1=_vm._n($event.target.value)},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('button',{staticClass:"btn btn-block btn-secondary",on:{"click":function($event){_vm.shiftHomeScore(+1)}}},[_vm._v("+1")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('button',{staticClass:"btn btn-block btn-secondary",on:{"click":function($event){_vm.shiftHomeScore(-1)}}},[_vm._v("-1")])])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label"},[_vm._v("Away score")]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy.number",value:(_vm.score2),expression:"score2",modifiers:{"lazy":true,"number":true}}],staticClass:"form-control",attrs:{"type":"number","id":_vm.safeId('score2'),"min":"0"},domProps:{"value":(_vm.score2)},on:{"change":function($event){_vm.score2=_vm._n($event.target.value)},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('button',{staticClass:"btn btn-block btn-secondary",on:{"click":function($event){_vm.shiftAwayScore(+1)}}},[_vm._v("+1")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('button',{staticClass:"btn btn-block btn-secondary",on:{"click":function($event){_vm.shiftAwayScore(-1)}}},[_vm._v("-1")])])]),_vm._v(" "),_c('clock-control',{attrs:{"template-id":_vm.templateId}}),_vm._v(" "),_c('floorball-scoreboard-penalty',{attrs:{"template-id":_vm.templateId}})],1),_vm._v(" "),_c('window-tab',{attrs:{"title":"Data","icon":"database"}},[_c('dataset-select-group',{attrs:{"label":"Teams","show-fields":true},model:{value:(_vm.datasetId),callback:function ($$v) {_vm.datasetId=$$v},expression:"datasetId"}}),_vm._v(" "),_c('text-input-group',{attrs:{"label":"Name"},model:{value:(_vm.patternName),callback:function ($$v) {_vm.patternName=$$v},expression:"patternName"}}),_vm._v(" "),_c('text-input-group',{attrs:{"label":"Country"},model:{value:(_vm.patternCountry),callback:function ($$v) {_vm.patternCountry=$$v},expression:"patternCountry"}}),_vm._v(" "),_c('text-input-group',{attrs:{"label":"Picture"},model:{value:(_vm.patternPicture),callback:function ($$v) {_vm.patternPicture=$$v},expression:"patternPicture"}}),_vm._v(" "),_c('album-select-group',{model:{value:(_vm.albumId),callback:function ($$v) {_vm.albumId=$$v},expression:"albumId"}}),_vm._v(" "),(_vm.datasetId)?_c('record-select-group',{attrs:{"label":"Home team","dataset-id":_vm.datasetId},model:{value:(_vm.teamId1),callback:function ($$v) {_vm.teamId1=$$v},expression:"teamId1"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('name1')}},[_vm._v("Home name")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.name1),expression:"name1",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('name1')},domProps:{"value":(_vm.name1)},on:{"change":function($event){_vm.name1=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('country1')}},[_vm._v("Home country")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.country1),expression:"country1",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('country1')},domProps:{"value":(_vm.country1)},on:{"change":function($event){_vm.country1=$event.target.value}}})])]),_vm._v(" "),_c('picture-select-group',{attrs:{"album-id":_vm.albumId,"label":"Home picture"},model:{value:(_vm.pictureId1),callback:function ($$v) {_vm.pictureId1=$$v},expression:"pictureId1"}}),_vm._v(" "),(_vm.datasetId)?_c('record-select-group',{attrs:{"label":"Away team","dataset-id":_vm.datasetId},model:{value:(_vm.teamId2),callback:function ($$v) {_vm.teamId2=$$v},expression:"teamId2"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('name2')}},[_vm._v("Away name")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.name2),expression:"name2",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('name2')},domProps:{"value":(_vm.name2)},on:{"change":function($event){_vm.name2=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('country2')}},[_vm._v("Away country")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.country2),expression:"country2",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('country2')},domProps:{"value":(_vm.country2)},on:{"change":function($event){_vm.country2=$event.target.value}}})])]),_vm._v(" "),_c('picture-select-group',{attrs:{"album-id":_vm.albumId,"label":"Away picture"},model:{value:(_vm.pictureId2),callback:function ($$v) {_vm.pictureId2=$$v},expression:"pictureId2"}})],1),_vm._v(" "),_c('window-tab',{attrs:{"title":"Settings","icon":"cog"}},[_c('template-settings',{attrs:{"templateId":_vm.templateId}},[_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label"},[_vm._v("Start time")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"form-row align-items-end"},[_c('div',{staticClass:"col"},[_c('label',{staticClass:"col-form-label",attrs:{"for":_vm.safeId('startHours')}},[_vm._v("Hours")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.startHours),expression:"startHours",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","id":_vm.safeId('startHours'),"min":"0","max":"99"},domProps:{"value":(_vm.startHours)},on:{"input":function($event){if($event.target.composing){ return; }_vm.startHours=_vm._n($event.target.value)},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('label',{staticClass:"col-form-label",attrs:{"for":_vm.safeId('startMins')}},[_vm._v("Mins")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.startMins),expression:"startMins",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","id":_vm.safeId('startMins'),"min":"0","max":"59"},domProps:{"value":(_vm.startMins)},on:{"input":function($event){if($event.target.composing){ return; }_vm.startMins=_vm._n($event.target.value)},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('label',{staticClass:"col-form-label",attrs:{"for":_vm.safeId('startSecs')}},[_vm._v("Secs")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.startSecs),expression:"startSecs",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","id":_vm.safeId('startSecs'),"min":"0","max":"59"},domProps:{"value":(_vm.startSecs)},on:{"input":function($event){if($event.target.composing){ return; }_vm.startSecs=_vm._n($event.target.value)},"blur":function($event){_vm.$forceUpdate()}}})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label"},[_vm._v("End time")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"form-row align-items-end"},[_c('div',{staticClass:"col"},[_c('label',{staticClass:"col-form-label",attrs:{"for":_vm.safeId('endHours')}},[_vm._v("Hours")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.endHours),expression:"endHours",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","id":_vm.safeId('endHours'),"min":"0","max":"99"},domProps:{"value":(_vm.endHours)},on:{"input":function($event){if($event.target.composing){ return; }_vm.endHours=_vm._n($event.target.value)},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('label',{staticClass:"col-form-label",attrs:{"for":_vm.safeId('endMins')}},[_vm._v("Mins")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.endMins),expression:"endMins",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","id":_vm.safeId('endMins'),"min":"0","max":"59"},domProps:{"value":(_vm.endMins)},on:{"input":function($event){if($event.target.composing){ return; }_vm.endMins=_vm._n($event.target.value)},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('label',{staticClass:"col-form-label",attrs:{"for":_vm.safeId('endSecs')}},[_vm._v("Secs")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.endSecs),expression:"endSecs",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","id":_vm.safeId('endSecs'),"min":"0","max":"59"},domProps:{"value":(_vm.endSecs)},on:{"input":function($event){if($event.target.composing){ return; }_vm.endSecs=_vm._n($event.target.value)},"blur":function($event){_vm.$forceUpdate()}}})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label"},[_vm._v("Format")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"form-row align-items-end"},[_c('div',{staticClass:"col"},[_c('label',{attrs:{"for":_vm.safeId('hrs')}},[_vm._v("Hours")]),_vm._v(" "),_c('b-form-select',{attrs:{"id":_vm.safeId('hrs'),"options":_vm.formatOptions,"text-field":"label","value-field":"value"},model:{value:(_vm.displayHours),callback:function ($$v) {_vm.displayHours=$$v},expression:"displayHours"}})],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-check form-check-inline"},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.displayMinutes),expression:"displayMinutes"}],staticClass:"form-check-input",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.displayMinutes)?_vm._i(_vm.displayMinutes,null)>-1:(_vm.displayMinutes)},on:{"change":function($event){var $$a=_vm.displayMinutes,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.displayMinutes=$$a.concat([$$v]))}else{$$i>-1&&(_vm.displayMinutes=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.displayMinutes=$$c}}}}),_vm._v("Mins\n                  ")])])]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-check form-check-inline"},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.displayTenths),expression:"displayTenths"}],staticClass:"form-check-input",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.displayTenths)?_vm._i(_vm.displayTenths,null)>-1:(_vm.displayTenths)},on:{"change":function($event){var $$a=_vm.displayTenths,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.displayTenths=$$a.concat([$$v]))}else{$$i>-1&&(_vm.displayTenths=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.displayTenths=$$c}}}}),_vm._v("1/10\n                  ")])])]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-check form-check-inline"},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.displayHundredths),expression:"displayHundredths"}],staticClass:"form-check-input",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.displayHundredths)?_vm._i(_vm.displayHundredths,null)>-1:(_vm.displayHundredths)},on:{"change":function($event){var $$a=_vm.displayHundredths,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.displayHundredths=$$a.concat([$$v]))}else{$$i>-1&&(_vm.displayHundredths=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.displayHundredths=$$c}}}}),_vm._v("1/100\n                  ")])])])])])])])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_football_tactical_vue__ = __webpack_require__(1701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30d37ec2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_football_tactical_vue__ = __webpack_require__(1702);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_football_tactical_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30d37ec2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_football_tactical_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_action_types__ = __webpack_require__(5);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'football-tactical',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins__["b" /* templateMixin */]],
  data: function data() {
    return {
      columnDefinitions: {
        'bibNumber': 'Bib number',
        'name': 'Name',
        'country': 'Country',
        'top': 'Top',
        'left': 'Left'
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3__utils__["c" /* mapOverlayData */])(['title', 'subtitle']), Object(__WEBPACK_IMPORTED_MODULE_3__utils__["c" /* mapOverlayData */])({ 'records': { default: [] } }), Object(__WEBPACK_IMPORTED_MODULE_3__utils__["c" /* mapOverlayData */])(['topLeftImage', 'topRightImage']), Object(__WEBPACK_IMPORTED_MODULE_3__utils__["d" /* mapOverlayOptions */])({ pageIntervalSecs: { default: 0 }, itemsPerPage: { default: 8 } }), Object(__WEBPACK_IMPORTED_MODULE_3__utils__["f" /* mapTemplateData */])(['sponsorsAlbumId', 'datasetId']), Object(__WEBPACK_IMPORTED_MODULE_3__utils__["f" /* mapTemplateData */])(['logosAlbumId', 'topLeftImageId', 'topRightImageId']), Object(__WEBPACK_IMPORTED_MODULE_3__utils__["f" /* mapTemplateData */])({ columnMap: { default: {} } }), {
    records: function records() {
      var _this = this;

      var dataset = this.$store.getters.dataset(this.datasetId);
      if (!dataset) return [];
      var records = [].concat(dataset.records);
      records.sort(function (a, b) {
        return parseInt(a.SORT_ORDER) - parseInt(b.SORT_ORDER);
      });
      return records.map(function (record) {
        return _this.mapRecord(record, _this.columnMap);
      });
    }
  }),
  watch: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
    records: function records(val) {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__store_action_types__["z" /* TEMPLATE_OVERLAY_DATA */], {
        templateId: this.templateId,
        data: { records: val }
      });
    },
    sponsorsAlbumId: function sponsorsAlbumId(val) {
      var album = this.$store.getters.album(val) || {};
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__store_action_types__["z" /* TEMPLATE_OVERLAY_DATA */], {
        templateId: this.templateId,
        data: { sponsors: album.pictures }
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_3__utils__["b" /* mapImageIdToImage */])('logosAlbumId', 'topLeftImageId', 'topLeftImage'), Object(__WEBPACK_IMPORTED_MODULE_3__utils__["b" /* mapImageIdToImage */])('logosAlbumId', 'topRightImageId', 'topRightImage')),
  methods: {
    mapRecord: function mapRecord(record, columnMap) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(columnMap).reduce(function (result, key) {
        result[key] = record[columnMap[key]];
        return result;
      }, {});
    }
  }
});

/***/ }),
/* 1702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('window',{attrs:{"window-id":_vm.windowId}},[_c('window-tab',{attrs:{"title":_vm.windowTitle}},[_c('switch-buttons',{attrs:{"template-id":_vm.templateId}}),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('title')}},[_vm._v("Title")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.title),expression:"title",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('title')},domProps:{"value":(_vm.title)},on:{"change":function($event){_vm.title=$event.target.value}}})])]),_vm._v(" "),_c('table-edit',{attrs:{"cols":_vm.columnDefinitions,"rows":_vm.records}})],1),_vm._v(" "),_c('window-tab',{attrs:{"title":"Data","icon":"database"}},[_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('datasetId')}},[_vm._v("Dataset")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('dataset-select',{attrs:{"id":_vm.safeId('datasetId')},model:{value:(_vm.datasetId),callback:function ($$v) {_vm.datasetId=$$v},expression:"datasetId"}})],1)]),_vm._v(" "),_vm._l((_vm.columnDefinitions),function(v,k){return _c('div',{key:k,staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId(k)}},[_vm._v(_vm._s(v))]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('column-select',{attrs:{"id":_vm.safeId(k),"value":_vm.columnMap[k],"dataset-id":_vm.datasetId},on:{"input":function (val) {
          _vm.columnMap[k] = val
          _vm.columnMap = _vm.columnMap
        }}})],1)])})],2),_vm._v(" "),_c('window-tab',{attrs:{"title":"Settings","icon":"cog"}},[_c('template-settings',{attrs:{"templateId":_vm.templateId}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_generic_clock_vue__ = __webpack_require__(1704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c825d18a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_generic_clock_vue__ = __webpack_require__(1705);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_generic_clock_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c825d18a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_generic_clock_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_index__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__clock_control__ = __webpack_require__(119);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'generic-clock',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins__["b" /* templateMixin */]],
  components: { clockControl: __WEBPACK_IMPORTED_MODULE_3__clock_control__["a" /* default */] },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["c" /* mapOverlayData */])(['title', 'direction']), Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["d" /* mapOverlayOptions */])(['displayHours', 'displayMinutes', 'displayTenths', 'displayHundredths']), Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["d" /* mapOverlayOptions */])({ 'autoHideSecs': { default: 0 } }), Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["g" /* mapTemplateOptions */])({ 'startTimeMs': { default: 0 }, 'endTimeMs': { default: 0 } }), {
    startHours: {
      get: function get() {
        return Math.floor(this.startTimeMs / 1000 / 3600);
      },
      set: function set(val) {
        this.setStartTimeMs(val, this.startMins, this.startSecs);
      }
    },
    startMins: {
      get: function get() {
        return Math.floor(this.startTimeMs / 1000 / 60 % 60);
      },
      set: function set(val) {
        this.setStartTimeMs(this.startHours, val, this.startSecs);
      }
    },
    startSecs: {
      get: function get() {
        return this.startTimeMs / 1000 % 60;
      },
      set: function set(val) {
        this.setStartTimeMs(this.startHours, this.startMins, val);
      }
    },
    endHours: {
      get: function get() {
        return Math.floor(this.endTimeMs / 1000 / 3600);
      },
      set: function set(val) {
        this.setEndTimeMs(val, this.endMins, this.endSecs);
      }
    },
    endMins: {
      get: function get() {
        return Math.floor(this.endTimeMs / 1000 / 60 % 60);
      },
      set: function set(val) {
        this.setEndTimeMs(this.endHours, val, this.endSecs);
      }
    },
    endSecs: {
      get: function get() {
        return this.endTimeMs / 1000 % 60;
      },
      set: function set(val) {
        this.setEndTimeMs(this.endHours, this.endMins, val);
      }
    }
  }),
  methods: {
    setStartTimeMs: function setStartTimeMs(hours, mins, secs) {
      this.startTimeMs = 1000 * (hours * 3600 + mins * 60 + secs * 1);
      this.direction = this.startTimeMs <= this.endTimeMs ? 'up' : 'down';
    },
    setEndTimeMs: function setEndTimeMs(hours, mins, secs) {
      this.endTimeMs = 1000 * (hours * 3600 + mins * 60 + secs * 1);
      this.direction = this.startTimeMs <= this.endTimeMs ? 'up' : 'down';
    }
  }
});

/***/ }),
/* 1705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('window',{attrs:{"window-id":_vm.windowId}},[_c('window-tab',{attrs:{"title":_vm.windowTitle}},[_c('switch-buttons',{attrs:{"template-id":_vm.templateId}}),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('title')}},[_vm._v("Title")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.title),expression:"title",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('title')},domProps:{"value":(_vm.title)},on:{"change":function($event){_vm.title=$event.target.value}}})])]),_vm._v(" "),_c('clock-control',{attrs:{"template-id":_vm.templateId}})],1),_vm._v(" "),_c('window-tab',{attrs:{"title":"Settings","icon":"cog"}},[_c('template-settings',{attrs:{"templateId":_vm.templateId}},[_c('number-input-group',{attrs:{"label":"Autohide (secs)"},model:{value:(_vm.autoHideSecs),callback:function ($$v) {_vm.autoHideSecs=$$v},expression:"autoHideSecs"}}),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label"},[_vm._v("Start time")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"form-row align-items-end"},[_c('div',{staticClass:"col"},[_c('label',{staticClass:"col-form-label",attrs:{"for":_vm.safeId('startHours')}},[_vm._v("Hours")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.startHours),expression:"startHours",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","id":_vm.safeId('startHours'),"min":"0","max":"99"},domProps:{"value":(_vm.startHours)},on:{"input":function($event){if($event.target.composing){ return; }_vm.startHours=_vm._n($event.target.value)},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('label',{staticClass:"col-form-label",attrs:{"for":_vm.safeId('startMins')}},[_vm._v("Mins")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.startMins),expression:"startMins",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","id":_vm.safeId('startMins'),"min":"0","max":"59"},domProps:{"value":(_vm.startMins)},on:{"input":function($event){if($event.target.composing){ return; }_vm.startMins=_vm._n($event.target.value)},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('label',{staticClass:"col-form-label",attrs:{"for":_vm.safeId('startSecs')}},[_vm._v("Secs")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.startSecs),expression:"startSecs",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","id":_vm.safeId('startSecs'),"min":"0","max":"59"},domProps:{"value":(_vm.startSecs)},on:{"input":function($event){if($event.target.composing){ return; }_vm.startSecs=_vm._n($event.target.value)},"blur":function($event){_vm.$forceUpdate()}}})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label"},[_vm._v("End time")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"form-row align-items-end"},[_c('div',{staticClass:"col"},[_c('label',{staticClass:"col-form-label",attrs:{"for":_vm.safeId('endHours')}},[_vm._v("Hours")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.endHours),expression:"endHours",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","id":_vm.safeId('endHours'),"min":"0","max":"99"},domProps:{"value":(_vm.endHours)},on:{"input":function($event){if($event.target.composing){ return; }_vm.endHours=_vm._n($event.target.value)},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('label',{staticClass:"col-form-label",attrs:{"for":_vm.safeId('endMins')}},[_vm._v("Mins")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.endMins),expression:"endMins",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","id":_vm.safeId('endMins'),"min":"0","max":"59"},domProps:{"value":(_vm.endMins)},on:{"input":function($event){if($event.target.composing){ return; }_vm.endMins=_vm._n($event.target.value)},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('label',{staticClass:"col-form-label",attrs:{"for":_vm.safeId('endSecs')}},[_vm._v("Secs")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.endSecs),expression:"endSecs",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","id":_vm.safeId('endSecs'),"min":"0","max":"59"},domProps:{"value":(_vm.endSecs)},on:{"input":function($event){if($event.target.composing){ return; }_vm.endSecs=_vm._n($event.target.value)},"blur":function($event){_vm.$forceUpdate()}}})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label"},[_vm._v("Format")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"form-check form-check-inline"},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.displayHours),expression:"displayHours"}],staticClass:"form-check-input",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.displayHours)?_vm._i(_vm.displayHours,null)>-1:(_vm.displayHours)},on:{"change":function($event){var $$a=_vm.displayHours,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.displayHours=$$a.concat([$$v]))}else{$$i>-1&&(_vm.displayHours=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.displayHours=$$c}}}}),_vm._v("Hrs\n            ")])]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline"},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.displayMinutes),expression:"displayMinutes"}],staticClass:"form-check-input",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.displayMinutes)?_vm._i(_vm.displayMinutes,null)>-1:(_vm.displayMinutes)},on:{"change":function($event){var $$a=_vm.displayMinutes,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.displayMinutes=$$a.concat([$$v]))}else{$$i>-1&&(_vm.displayMinutes=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.displayMinutes=$$c}}}}),_vm._v("Mins\n            ")])]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline"},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.displayTenths),expression:"displayTenths"}],staticClass:"form-check-input",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.displayTenths)?_vm._i(_vm.displayTenths,null)>-1:(_vm.displayTenths)},on:{"change":function($event){var $$a=_vm.displayTenths,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.displayTenths=$$a.concat([$$v]))}else{$$i>-1&&(_vm.displayTenths=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.displayTenths=$$c}}}}),_vm._v("1/10\n            ")])]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline"},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.displayHundredths),expression:"displayHundredths"}],staticClass:"form-check-input",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.displayHundredths)?_vm._i(_vm.displayHundredths,null)>-1:(_vm.displayHundredths)},on:{"change":function($event){var $$a=_vm.displayHundredths,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.displayHundredths=$$a.concat([$$v]))}else{$$i>-1&&(_vm.displayHundredths=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.displayHundredths=$$c}}}}),_vm._v("1/100\n            ")])])])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_generic_image_vue__ = __webpack_require__(1707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36bd09fd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_generic_image_vue__ = __webpack_require__(1708);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_generic_image_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36bd09fd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_generic_image_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_index__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'generic-image',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins__["b" /* templateMixin */]],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["c" /* mapOverlayData */])(['image']), Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["f" /* mapTemplateData */])(['albumId', 'imageId'])),
  watch: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["b" /* mapImageIdToImage */])('albumId', 'imageId', 'image'))
});

/***/ }),
/* 1708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('window',{attrs:{"window-id":_vm.windowId}},[_c('window-tab',{attrs:{"title":_vm.windowTitle}},[_c('switch-buttons',{attrs:{"template-id":_vm.templateId}}),_vm._v(" "),_c('album-select-group',{attrs:{"label":"Album"},model:{value:(_vm.albumId),callback:function ($$v) {_vm.albumId=$$v},expression:"albumId"}}),_vm._v(" "),_c('picture-select-group',{attrs:{"album-id":_vm.albumId,"label":"Image"},model:{value:(_vm.imageId),callback:function ($$v) {_vm.imageId=$$v},expression:"imageId"}})],1),_vm._v(" "),_c('window-tab',{attrs:{"title":"Settings","icon":"cog"}},[_c('template-settings',{attrs:{"templateId":_vm.templateId}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_generic_lower_third_vue__ = __webpack_require__(1710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24ac9a9e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_generic_lower_third_vue__ = __webpack_require__(1711);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_generic_lower_third_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24ac9a9e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_generic_lower_third_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_index__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_action_types__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'generic-lower-third',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins__["b" /* templateMixin */]],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["c" /* mapOverlayData */])(['title', 'subtitle', 'extraInfo', 'bottomLeftImage', 'bottomRightImage']), Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["f" /* mapTemplateData */])(['sponsorsAlbumId', 'datasetId', 'recordId']), Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["f" /* mapTemplateData */])(['logosAlbumId', 'bottomLeftImageId', 'bottomRightImageId']), Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["f" /* mapTemplateData */])({
    /* eslint-disable no-template-curly-in-string */
    patternTitle: { default: '${PLACE}' },
    patternSubtitle: { default: '${DATE}' },
    patternExtraInfo: { default: ''
      /* eslint-enable no-template-curly-in-string */
    } }), Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["g" /* mapTemplateOptions */])(['hasExtraInfo']), {
    dataset: function dataset() {
      if (!this.datasetId) return null;
      return this.$store.getters.dataset(this.datasetId);
    },
    datasetColumns: function datasetColumns() {
      if (!this.dataset) return;
      return this.dataset.columns || [];
    }
  }),
  watch: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    sponsorsAlbumId: function sponsorsAlbumId(val) {
      var album = this.$store.getters.album(val) || {};
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__store_action_types__["z" /* TEMPLATE_OVERLAY_DATA */], {
        templateId: this.templateId,
        data: { sponsors: album.pictures }
      });
    },
    recordId: function recordId(val) {
      if (!val) return;
      var record = this.$store.getters.dataset(this.datasetId).records.find(function (r) {
        return r.recordId === val;
      });
      if (!record) return;
      record = this.mapRecord(record);
      this.title = record.title;
      this.subtitle = record.subtitle;
      this.extraInfo = record.extraInfo;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["b" /* mapImageIdToImage */])('logosAlbumId', 'bottomLeftImageId', 'bottomLeftImage'), Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["b" /* mapImageIdToImage */])('logosAlbumId', 'bottomRightImageId', 'bottomRightImage')),
  methods: {
    mapRecord: function mapRecord(record) {
      var result = {};
      var recordMap = {
        title: this.patternTitle,
        subtitle: this.patternSubtitle,
        extraInfo: this.patternExtraInfo
      };
      for (var k in recordMap) {
        if (!recordMap.hasOwnProperty(k)) continue;
        result[k] = recordMap[k].replace(/\$\{([\w ]+)\}/g, function (match, p1) {
          return record[p1] || '';
        });
      }
      return result;
    }
  }
});

/***/ }),
/* 1711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('window',{attrs:{"window-id":_vm.windowId}},[_c('window-tab',{attrs:{"title":_vm.windowTitle}},[_c('switch-buttons',{attrs:{"template-id":_vm.templateId}}),_vm._v(" "),(_vm.datasetId)?_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('record')}},[_vm._v("Record")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('record-select',{attrs:{"id":_vm.safeId('record'),"dataset-id":_vm.datasetId},model:{value:(_vm.recordId),callback:function ($$v) {_vm.recordId=$$v},expression:"recordId"}})],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('title')}},[_vm._v("Title")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.title),expression:"title",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('title')},domProps:{"value":(_vm.title)},on:{"change":function($event){_vm.title=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('subtitle')}},[_vm._v("Subtitle")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.subtitle),expression:"subtitle",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('subtitle')},domProps:{"value":(_vm.subtitle)},on:{"change":function($event){_vm.subtitle=$event.target.value}}})])]),_vm._v(" "),(_vm.hasExtraInfo)?_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('extraInfo')}},[_vm._v("Extra info")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.extraInfo),expression:"extraInfo",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('extraInfo')},domProps:{"value":(_vm.extraInfo)},on:{"change":function($event){_vm.extraInfo=$event.target.value}}})])]):_vm._e()],1),_vm._v(" "),_c('window-tab',{attrs:{"title":"Data","icon":"database"}},[_c('album-select-group',{attrs:{"label":"Sponsors"},model:{value:(_vm.sponsorsAlbumId),callback:function ($$v) {_vm.sponsorsAlbumId=$$v},expression:"sponsorsAlbumId"}}),_vm._v(" "),_c('album-select-group',{attrs:{"label":"Logos"},model:{value:(_vm.logosAlbumId),callback:function ($$v) {_vm.logosAlbumId=$$v},expression:"logosAlbumId"}}),_vm._v(" "),_c('picture-select-group',{attrs:{"album-id":_vm.logosAlbumId,"label":"Bottom left image"},model:{value:(_vm.bottomLeftImageId),callback:function ($$v) {_vm.bottomLeftImageId=$$v},expression:"bottomLeftImageId"}}),_vm._v(" "),_c('picture-select-group',{attrs:{"album-id":_vm.logosAlbumId,"label":"Bottom right image"},model:{value:(_vm.bottomRightImageId),callback:function ($$v) {_vm.bottomRightImageId=$$v},expression:"bottomRightImageId"}}),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('datasetId')}},[_vm._v("Dataset")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('dataset-select',{attrs:{"id":_vm.safeId('datasetId')},model:{value:(_vm.datasetId),callback:function ($$v) {_vm.datasetId=$$v},expression:"datasetId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label"},[_vm._v("Fields")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{staticClass:"form-control-plaintext",attrs:{"type":"text","readonly":""},domProps:{"value":_vm.datasetColumns}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternTitle')}},[_vm._v("Title")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternTitle),expression:"patternTitle",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternTitle')},domProps:{"value":(_vm.patternTitle)},on:{"change":function($event){_vm.patternTitle=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternSubtitle')}},[_vm._v("Subtitle")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternSubtitle),expression:"patternSubtitle",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternSubtitle')},domProps:{"value":(_vm.patternSubtitle)},on:{"change":function($event){_vm.patternSubtitle=$event.target.value}}})])]),_vm._v(" "),(_vm.hasExtraInfo)?_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternExtraInfo')}},[_vm._v("Extra info")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternExtraInfo),expression:"patternExtraInfo",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternExtraInfo')},domProps:{"value":(_vm.patternExtraInfo)},on:{"change":function($event){_vm.patternExtraInfo=$event.target.value}}})])]):_vm._e()],1),_vm._v(" "),_c('window-tab',{attrs:{"title":"Settings","icon":"cog"}},[_c('template-settings',{attrs:{"templateId":_vm.templateId}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ifsc_vertical_life_vue__ = __webpack_require__(1714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2582854c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ifsc_vertical_life_vue__ = __webpack_require__(1715);
function injectStyle (ssrContext) {
  __webpack_require__(1713)
}
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2582854c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ifsc_vertical_life_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2582854c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ifsc_vertical_life_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1713 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_index__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_VerticalLifeApi__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_AppService__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_mutation_types__ = __webpack_require__(14);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ifsc-vertical-life',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins__["b" /* templateMixin */]],
  data: function data() {
    return {
      errorMessage: null,
      leagues: [],
      events: [],
      stages: [],
      rounds: [],
      group: 0
    };
  },
  created: function created() {
    this.verticalLifeApi = new __WEBPACK_IMPORTED_MODULE_4__api_VerticalLifeApi__["a" /* default */]({
      baseUrl: 'https://ifsc.results.info',
      // TODO: This does not update the auth token in vertical-life-dataset.vue
      authToken: '395b55a1b4de895f0e17cdd4e18e7b947cc0c0fd'
    });
    this.appService = new __WEBPACK_IMPORTED_MODULE_5__api_AppService__["a" /* default */](this.$store, this.$keycloak);
  },
  mounted: function mounted() {
    var _this = this;

    this.fetchLeagues().then(function () {
      if (_this.leagueId) {
        _this.fetchEvents(_this.leagueId).then(function () {
          if (_this.eventId) {
            _this.fetchStages(_this.eventId).then(function () {
              if (_this.stageId) {
                _this.fetchRounds(_this.eventId, _this.stageId);
              }
            });
          }
        });
      }
    });
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3__utils_index__["g" /* mapTemplateOptions */])(['leagueId', 'eventId', 'stageId', 'routeId']), {
    optionsLeagues: function optionsLeagues() {
      return [{ name: '', id: null }].concat(this.leagues || []);
    },
    optionsEvents: function optionsEvents() {
      return [{ event: '', event_id: null }].concat(this.events || []);
    },
    optionsStages: function optionsStages() {
      return [{ dcat_name: '', dcat_id: null }].concat(this.stages || []);
    }
  }),
  watch: {
    leagueId: function leagueId(val) {
      console.debug('[ifsc] watched leagueId', val);
      this.fetchEvents(val);
    },
    eventId: function eventId(val) {
      console.debug('[ifsc] watched eventId ' + val);
      this.fetchStages(val);
    },
    stageId: function stageId(val) {
      console.debug('[ifsc] watched stageId ' + val);
      this.fetchRounds(this.eventId, val);
    }
  },
  methods: {
    openCreateLowerThirds: function openCreateLowerThirds(round, type) {
      var componentTypes = {
        'lead': 'lower-third-athlete',
        'speed': 'lower-third-athlete'
      };
      var stage = this.getStage();
      var url = this.api().getStartingListUrl(round);
      var datasetId = this.appService.openCreateDataset({
        datasetId: Object(__WEBPACK_IMPORTED_MODULE_1__lib__["e" /* uuid */])(),
        name: stage.dcat_name + ' ' + round.name + ' Starting List',
        url: url
      }, 'vertical-life-dataset-window');
      this.appService.openCreateTemplate({
        templateId: Object(__WEBPACK_IMPORTED_MODULE_1__lib__["e" /* uuid */])(),
        name: 'Lower Thirds ' + stage.dcat_name + ' ' + round.name,
        componentType: componentTypes[type],
        templateData: {
          datasetId: datasetId,
          // eslint-disable-next-line no-template-curly-in-string
          patternTitle: '${LAST NAME} ${FIRST NAME}'
        },
        templateOptions: {},
        overlayData: {},
        columnMap: {}
      });
    },
    openCreateStartingList: function openCreateStartingList(round) {
      var event = this.getEvent();
      console.log('event', event);
      var stage = this.getStage();
      var url = this.api().getStartingListUrl(round);
      var datasetId = this.appService.openCreateDataset({
        datasetId: Object(__WEBPACK_IMPORTED_MODULE_1__lib__["e" /* uuid */])(),
        name: stage.dcat_name + ' ' + round.name + ' Starting List',
        url: url
      }, 'vertical-life-dataset-window');
      this.appService.openCreateTemplate({
        templateId: Object(__WEBPACK_IMPORTED_MODULE_1__lib__["e" /* uuid */])(),
        name: 'Starting List ' + stage.dcat_name + ' ' + round.name,
        componentType: 'starting-list',
        templateData: { datasetId: datasetId },
        templateOptions: {},
        overlayData: {
          title: ('STARTING LIST ' + stage.dcat_name + ' ' + round.name).toUpperCase(),
          subtitle: event.event || event.cup_name
        },
        columnMap: {
          'bibNumber': 'BIB',
          'lastName': 'LAST NAME',
          'firstName': 'FIRST NAME',
          'country': 'COUNTRY'
        }
      });
    },
    openCreateLeadIntermediate: function openCreateLeadIntermediate(round) {
      var stage = this.getStage();
      var url = this.api().getStartingListUrl(round);
      var datasetId = this.appService.openCreateDataset({
        datasetId: Object(__WEBPACK_IMPORTED_MODULE_1__lib__["e" /* uuid */])(),
        name: stage.dcat_name + ' ' + round.name + ' Intermediates',
        url: url,
        columns: ['TIME']
      }, 'vertical-life-dataset-window');
      window.setTimeout(function () {
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_6__store_mutation_types__["o" /* DATASET_UPDATE_META */], {
          datasetId: datasetId,
          fileName: this.api().getRankingListUrl(round),
          emit: true
        });
      }.bind(this), 1000);
      this.appService.openCreateTemplate({
        templateId: Object(__WEBPACK_IMPORTED_MODULE_1__lib__["e" /* uuid */])(),
        name: 'Intermediates ' + stage.dcat_name + ' ' + round.name,
        componentType: 'ranking-list',
        templateData: { datasetId: datasetId },
        templateOptions: {},
        columnMap: {
          'bibNumber': 'BIB',
          'lastName': 'LAST NAME',
          'firstName': 'FIRST NAME',
          'country': 'COUNTRY',
          'score': 'SCORE',
          'endTime': 'ENDTIME'
        }
      });
    },
    openCreateRankingListProvisional: function openCreateRankingListProvisional(round) {
      this.openCreateRankingList(round, true);
    },
    openCreateRankingListResults: function openCreateRankingListResults(round) {
      this.openCreateRankingList(round, false);
    },
    openCreateRankingList: function openCreateRankingList(round, provisional) {
      var event = this.getEvent();
      var stage = this.getStage();
      var url = this.api().getRankingListUrl(round);
      var datasetId = this.appService.openCreateDataset({
        datasetId: Object(__WEBPACK_IMPORTED_MODULE_1__lib__["e" /* uuid */])(),
        name: stage.dcat_name + ' ' + round.name + ' Ranking List',
        url: url
      }, 'vertical-life-dataset-window');
      this.appService.openCreateTemplate({
        templateId: Object(__WEBPACK_IMPORTED_MODULE_1__lib__["e" /* uuid */])(),
        name: 'Ranking List ' + (provisional ? 'w/o' : 'w/') + ' Results ' + stage.dcat_name + ' ' + round.name,
        componentType: 'ranking-list',
        templateData: { datasetId: datasetId },
        templateOptions: {},
        overlayData: {
          title: ((provisional ? 'PROVISIONAL ' : '') + 'RANKINGS ' + stage.dcat_name + ' ' + round.name).toUpperCase(),
          subtitle: event.event || event.cup_name
        },
        columnMap: {
          'bibNumber': 'BIB',
          'lastName': 'LAST NAME',
          'firstName': 'FIRST NAME',
          'country': 'COUNTRY',
          'rank': 'RANK',
          'score': 'SCORE',
          'qualified': 'QUALIFIED'
        }
      });
    },
    openCreateVictoryCeremonyAthlete: function openCreateVictoryCeremonyAthlete(round) {
      var stage = this.getStage();
      var url = this.api().getRankingListUrl(round);
      var datasetId = this.appService.openCreateDataset({
        datasetId: Object(__WEBPACK_IMPORTED_MODULE_1__lib__["e" /* uuid */])(),
        name: stage.dcat_name + ' ' + round.name + ' Ranking List',
        url: url
      }, 'vertical-life-dataset-window');
      this.appService.openCreateTemplate({
        templateId: Object(__WEBPACK_IMPORTED_MODULE_1__lib__["e" /* uuid */])(),
        name: 'Victory Ceremony Athlete ' + stage.dcat_name + ' ' + round.name,
        componentType: 'lower-third-athlete',
        templateData: {
          datasetId: datasetId,
          // eslint-disable-next-line no-template-curly-in-string
          patternTitle: '${LAST NAME} ${FIRST NAME}',
          patternSubtitle: 'Gold Medal ' + stage.dcat_name
        },
        templateOptions: {},
        overlayData: {
          title: stage.dcat_name.toUpperCase()
        }
      });
    },
    openCreateVictoryCeremonyGroup: function openCreateVictoryCeremonyGroup(round) {
      var stage = this.getStage();
      var url = this.api().getRankingListUrl(round);
      var datasetId = this.appService.openCreateDataset({
        datasetId: Object(__WEBPACK_IMPORTED_MODULE_1__lib__["e" /* uuid */])(),
        name: stage.dcat_name + ' ' + round.name + ' Ranking List',
        url: url
      }, 'vertical-life-dataset-window');
      this.appService.openCreateTemplate({
        templateId: Object(__WEBPACK_IMPORTED_MODULE_1__lib__["e" /* uuid */])(),
        name: 'Victory Ceremony Group ' + stage.dcat_name + ' ' + round.name,
        componentType: 'uiaa-victory-ceremony-group',
        templateData: { datasetId: datasetId },
        templateOptions: {},
        overlayData: {
          title: stage.dcat_name.toUpperCase()
        }
      });
    },
    fetchLeagues: function fetchLeagues() {
      var _this2 = this;

      this.errorMessage = null;
      return this.api().fetchLeagues().then(function (leagues) {
        console.log('[ifsc] fetched ' + leagues.length + ' leagues');
        _this2.leagues = leagues;
      }).catch(function (err) {
        console.error('[ifsc] error fetching leagues', err);
        _this2.errorMessage = err.message;
      });
    },
    fetchEvents: function fetchEvents(leagueId) {
      var _this3 = this;

      this.errorMessage = null;
      return this.api().fetchEvents(leagueId).then(function (events) {
        console.log('[ifsc] fetched ' + events.length + ' events');
        _this3.events = events;
      }).catch(function (err) {
        console.error('[ifsc] error fetching events', err);
        _this3.errorMessage = err.message;
      });
    },
    fetchStages: function fetchStages(eventId) {
      var _this4 = this;

      this.errorMessage = null;
      console.log('[ifsc] fetching stages for event ' + eventId);
      return this.api().fetchStages(eventId).then(function (stages) {
        console.log('[ifsc] fetched ' + stages.length + ' stages');
        _this4.stages = stages;
      }).catch(function (err) {
        console.error('[ifsc] error fetching stages', err);
        _this4.errorMessage = err.message;
      });
    },
    fetchRounds: function fetchRounds(eventId, stageId) {
      var _this5 = this;

      this.errorMessage = null;
      console.log('[ifsc] fetching rounds for event ' + eventId + ', stage ' + stageId);
      this.api().fetchRounds(eventId, stageId).then(function (rounds) {
        console.log('[ifsc] fetched ' + rounds.length + ' rounds');
        _this5.rounds = rounds;
      }).catch(function (err) {
        console.error('[ifsc] error fetching rounds', err);
        _this5.errorMessage = err.message;
      });
    },
    getEvent: function getEvent() {
      var _this6 = this;

      return this.events.find(function (p) {
        return p.event_id === _this6.eventId;
      });
    },
    getStage: function getStage() {
      var _this7 = this;

      return this.stages.find(function (p) {
        return p.dcat_id === _this7.stageId;
      });
    },
    api: function api() {
      return this.verticalLifeApi;
    }
  }
});

/***/ }),
/* 1715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('window',{attrs:{"window-id":_vm.windowId}},[_c('window-tab',{attrs:{"title":_vm.windowTitle}},[(_vm.errorMessage)?_c('div',{staticClass:"alert alert-danger"},[_c('p',[_c('b',[_vm._v("Error:")]),_vm._v(" "+_vm._s(_vm.errorMessage))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('stageId')}},[_vm._v("Stage")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('b-form-select',{attrs:{"id":_vm.safeId('stageId'),"options":_vm.optionsStages,"text-field":"dcat_name","value-field":"dcat_id"},model:{value:(_vm.stageId),callback:function ($$v) {_vm.stageId=$$v},expression:"stageId"}})],1)]),_vm._v(" "),(_vm.rounds && _vm.rounds.length)?_c('table',{staticClass:"table table-bordered table-responsive table-hover table-sm"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Round")]),_vm._v(" "),_c('th',[_vm._v("Templates")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.rounds),function(row){return _c('tr',[_c('td',[_vm._v(_vm._s(row.name))]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"button","title":"Lower Thirds Lead"},on:{"click":function($event){_vm.openCreateLowerThirds(row, 'lead')}}},[_vm._v("LTL\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"button","title":"Lower Thirds Speed"},on:{"click":function($event){_vm.openCreateLowerThirds(row, 'speed')}}},[_vm._v("LTS\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"button","title":"Starting List"},on:{"click":function($event){_vm.openCreateStartingList(row)}}},[_vm._v("SL\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"button","title":"Lead Intermediate"},on:{"click":function($event){_vm.openCreateLeadIntermediate(row)}}},[_vm._v("LI\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"button","title":"Ranking List Provisional"},on:{"click":function($event){_vm.openCreateRankingListProvisional(row)}}},[_vm._v("RP\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"button","title":"Ranking List Results"},on:{"click":function($event){_vm.openCreateRankingListResults(row)}}},[_vm._v("RR\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"button","title":"Victory Ceremony Athlete"},on:{"click":function($event){_vm.openCreateVictoryCeremonyAthlete(row)}}},[_vm._v("VCA\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"button","title":"Victory Ceremony Group"},on:{"click":function($event){_vm.openCreateVictoryCeremonyGroup(row)}}},[_vm._v("VCG\n          ")])])])}))]):_vm._e()]),_vm._v(" "),_c('window-tab',{attrs:{"title":"Data","icon":"database"}},[(_vm.errorMessage)?_c('div',{staticClass:"alert alert-danger"},[_c('p',[_c('b',[_vm._v("Error:")]),_vm._v(" "+_vm._s(_vm.errorMessage))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('div',{staticClass:"col-sm-12"},[_c('button',{staticClass:"btn btn-block btn-primary",attrs:{"type":"button"},on:{"click":_vm.fetchLeagues}},[_vm._v("Fetch")])])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('leagueId')}},[_vm._v("League")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('b-form-select',{attrs:{"id":_vm.safeId('leagueId'),"options":_vm.optionsLeagues,"text-field":"name","value-field":"id"},model:{value:(_vm.leagueId),callback:function ($$v) {_vm.leagueId=$$v},expression:"leagueId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('eventId')}},[_vm._v("Event")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('b-form-select',{attrs:{"id":_vm.safeId('eventId'),"options":_vm.optionsEvents,"text-field":"event","value-field":"event_id"},model:{value:(_vm.eventId),callback:function ($$v) {_vm.eventId=$$v},expression:"eventId"}})],1)])]),_vm._v(" "),_c('window-tab',{attrs:{"title":"Settings","icon":"cog"}},[_c('template-settings',{attrs:{"templateId":_vm.templateId}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_lower_third_athlete_vue__ = __webpack_require__(1717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fe7985f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_lower_third_athlete_vue__ = __webpack_require__(1718);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_lower_third_athlete_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fe7985f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_lower_third_athlete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_index__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_action_types__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'lower-third-athlete',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins__["b" /* templateMixin */]],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["c" /* mapOverlayData */])(['type', 'bibNumber', 'title', 'subtitle', 'country', 'extraInfo', 'bottomLeftImage', 'bottomRightImage']), Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["f" /* mapTemplateData */])(['sponsorsAlbumId', 'datasetId', 'recordId']), Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["f" /* mapTemplateData */])(['logosAlbumId', 'bottomLeftImageId', 'bottomRightImageId']), Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["f" /* mapTemplateData */])({
    /* eslint-disable no-template-curly-in-string */
    patternBibNumber: { default: '${BIB}' },
    patternTitle: { default: '${NAME}' },
    patternSubtitle: { default: '${CLUB}' },
    patternCountry: { default: '${COUNTRY}' },
    patternExtraInfo: { default: ''
      /* eslint-enable no-template-curly-in-string */
    } }), {
    dataset: function dataset() {
      if (!this.datasetId) return null;
      return this.$store.getters.dataset(this.datasetId);
    },
    datasetColumns: function datasetColumns() {
      if (!this.dataset) return;
      return this.dataset.columns || [];
    }
  }),
  watch: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    sponsorsAlbumId: function sponsorsAlbumId(val) {
      var album = this.$store.getters.album(val) || {};
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__store_action_types__["z" /* TEMPLATE_OVERLAY_DATA */], {
        templateId: this.templateId,
        data: { sponsors: album.pictures }
      });
    },
    recordId: function recordId(val) {
      if (!val) return;
      var record = this.$store.getters.dataset(this.datasetId).records.find(function (r) {
        return r.recordId === val;
      });
      if (!record) return;
      record = this.mapRecord(record);
      this.bibNumber = record.bibNumber;
      this.title = record.title;
      this.subtitle = record.subtitle;
      this.country = record.country;
      this.extraInfo = record.extraInfo;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["b" /* mapImageIdToImage */])('logosAlbumId', 'bottomLeftImageId', 'bottomLeftImage'), Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["b" /* mapImageIdToImage */])('logosAlbumId', 'bottomRightImageId', 'bottomRightImage')),
  methods: {
    nextRecord: function nextRecord(prevRecordId, datasetId) {
      var records = this.$store.getters.datasetRecords(datasetId);
      var index = records.findIndex(function (p) {
        return p.recordId === prevRecordId;
      });
      this.recordId = records.length > index + 1 ? records[index + 1].recordId : records[0].recordId;
    },
    mapRecord: function mapRecord(record) {
      var result = {};
      var recordMap = {
        bibNumber: this.patternBibNumber,
        title: this.patternTitle,
        subtitle: this.patternSubtitle,
        country: this.patternCountry,
        extraInfo: this.patternExtraInfo
      };
      for (var k in recordMap) {
        if (!recordMap.hasOwnProperty(k)) continue;
        result[k] = recordMap[k].replace(/\$\{([\w ]+)\}/g, function (match, p1) {
          return record[p1] || '';
        });
      }
      return result;
    }
  }
});

/***/ }),
/* 1718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('window',{attrs:{"window-id":_vm.windowId}},[_c('window-tab',{attrs:{"title":_vm.windowTitle}},[_c('switch-buttons',{attrs:{"template-id":_vm.templateId}}),_vm._v(" "),(_vm.datasetId)?_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('record')}},[_vm._v("Record")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('record-select',{attrs:{"id":_vm.safeId('record'),"dataset-id":_vm.datasetId},model:{value:(_vm.recordId),callback:function ($$v) {_vm.recordId=$$v},expression:"recordId"}})],1)]):_vm._e(),_vm._v(" "),(_vm.datasetId)?_c('div',{staticClass:"form-group form-row"},[_c('div',{staticClass:"col-sm-4"}),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('button',{staticClass:"btn btn-block btn-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.nextRecord(_vm.recordId, _vm.datasetId)}}},[_vm._v("Next")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('type')}},[_vm._v("Type")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('b-form-select',{attrs:{"id":_vm.safeId('type'),"options":[{label:'', value:'extraInfo'},{label:'Yellow card', value:'yellowCard'},{label:'Red card', value:'redCard'},{label: 'Yellow red card', value:'yellowRedCard'}],"text-field":"label","value-field":"value"},model:{value:(_vm.type),callback:function ($$v) {_vm.type=$$v},expression:"type"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('bibNumber')}},[_vm._v("Bib number")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.bibNumber),expression:"bibNumber",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('bibNumber')},domProps:{"value":(_vm.bibNumber)},on:{"change":function($event){_vm.bibNumber=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('title')}},[_vm._v("Title")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.title),expression:"title",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('title')},domProps:{"value":(_vm.title)},on:{"change":function($event){_vm.title=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('subtitle')}},[_vm._v("Subtitle")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.subtitle),expression:"subtitle",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('subtitle')},domProps:{"value":(_vm.subtitle)},on:{"change":function($event){_vm.subtitle=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('country')}},[_vm._v("Country")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.country),expression:"country",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('country')},domProps:{"value":(_vm.country)},on:{"change":function($event){_vm.country=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('extraInfo')}},[_vm._v("Extra info")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.extraInfo),expression:"extraInfo",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('extraInfo')},domProps:{"value":(_vm.extraInfo)},on:{"change":function($event){_vm.extraInfo=$event.target.value}}})])])],1),_vm._v(" "),_c('window-tab',{attrs:{"title":"Data","icon":"database"}},[_c('album-select-group',{attrs:{"label":"Sponsors"},model:{value:(_vm.sponsorsAlbumId),callback:function ($$v) {_vm.sponsorsAlbumId=$$v},expression:"sponsorsAlbumId"}}),_vm._v(" "),_c('album-select-group',{attrs:{"label":"Logos"},model:{value:(_vm.logosAlbumId),callback:function ($$v) {_vm.logosAlbumId=$$v},expression:"logosAlbumId"}}),_vm._v(" "),_c('picture-select-group',{attrs:{"album-id":_vm.logosAlbumId,"label":"Bottom left image"},model:{value:(_vm.bottomLeftImageId),callback:function ($$v) {_vm.bottomLeftImageId=$$v},expression:"bottomLeftImageId"}}),_vm._v(" "),_c('picture-select-group',{attrs:{"album-id":_vm.logosAlbumId,"label":"Bottom right image"},model:{value:(_vm.bottomRightImageId),callback:function ($$v) {_vm.bottomRightImageId=$$v},expression:"bottomRightImageId"}}),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('datasetId')}},[_vm._v("Dataset")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('dataset-select',{attrs:{"id":_vm.safeId('datasetId')},model:{value:(_vm.datasetId),callback:function ($$v) {_vm.datasetId=$$v},expression:"datasetId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label"},[_vm._v("Fields")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{staticClass:"form-control-plaintext",attrs:{"type":"text","readonly":""},domProps:{"value":_vm.datasetColumns}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternBibNumber')}},[_vm._v("Bib number")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternBibNumber),expression:"patternBibNumber",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternBibNumber')},domProps:{"value":(_vm.patternBibNumber)},on:{"change":function($event){_vm.patternBibNumber=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternTitle')}},[_vm._v("Title")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternTitle),expression:"patternTitle",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternTitle')},domProps:{"value":(_vm.patternTitle)},on:{"change":function($event){_vm.patternTitle=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternSubtitle')}},[_vm._v("Subtitle")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternSubtitle),expression:"patternSubtitle",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternSubtitle')},domProps:{"value":(_vm.patternSubtitle)},on:{"change":function($event){_vm.patternSubtitle=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternCountry')}},[_vm._v("Country")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternCountry),expression:"patternCountry",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternCountry')},domProps:{"value":(_vm.patternCountry)},on:{"change":function($event){_vm.patternCountry=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternExtraInfo')}},[_vm._v("Extra info")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternExtraInfo),expression:"patternExtraInfo",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternExtraInfo')},domProps:{"value":(_vm.patternExtraInfo)},on:{"change":function($event){_vm.patternExtraInfo=$event.target.value}}})])])],1),_vm._v(" "),_c('window-tab',{attrs:{"title":"Settings","icon":"cog"}},[_c('template-settings',{attrs:{"templateId":_vm.templateId}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_manager_video_vue__ = __webpack_require__(1720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a78819f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_manager_video_vue__ = __webpack_require__(1721);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_manager_video_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a78819f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_manager_video_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_index__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'manager-video',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins__["b" /* templateMixin */]],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["c" /* mapOverlayData */])(['videoUrl', 'userId', 'videoId', 'muted'])),
  created: function created() {
    if (!this.userId) {
      this.userId = this.$keycloak.subject || 'a01eea58-fecc-468e-9f4e-13ef2873bf62'; // Demo user account
    }
  }
});

/***/ }),
/* 1721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('window',{attrs:{"window-id":_vm.windowId}},[_c('window-tab',{attrs:{"title":_vm.windowTitle}},[_c('switch-buttons',{attrs:{"template-id":_vm.templateId}}),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('videoUrl')}},[_vm._v("Video URL")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.videoUrl),expression:"videoUrl",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('videoUrl')},domProps:{"value":(_vm.videoUrl)},on:{"change":function($event){_vm.videoUrl=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('userId')}},[_vm._v("User ID (deprecated)")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.userId),expression:"userId",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('userId')},domProps:{"value":(_vm.userId)},on:{"change":function($event){_vm.userId=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('videoId')}},[_vm._v("Video ID (deprecated)")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.videoId),expression:"videoId",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('videoId')},domProps:{"value":(_vm.videoId)},on:{"change":function($event){_vm.videoId=$event.target.value}}})])]),_vm._v(" "),_c('checkbox-input-group',{attrs:{"label":"Muted","text":"Play video without sound"},model:{value:(_vm.muted),callback:function ($$v) {_vm.muted=$$v},expression:"muted"}})],1),_vm._v(" "),_c('window-tab',{attrs:{"title":"Settings","icon":"cog"}},[_c('template-settings',{attrs:{"templateId":_vm.templateId}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_match_title_vue__ = __webpack_require__(1723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35cb6471_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_match_title_vue__ = __webpack_require__(1724);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_match_title_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35cb6471_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_match_title_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_index__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'match-title',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins__["b" /* templateMixin */]],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["c" /* mapOverlayData */])(['name1', 'name2']), Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["c" /* mapOverlayData */])(['topLeftText', 'topRightText', 'bottomLeftText', 'bottomRightText']), Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["f" /* mapTemplateData */])(['topLeftImageId', 'topRightImageId', 'bottomLeftImageId', 'bottomRightImageId']), Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["f" /* mapTemplateData */])(['albumId', 'datasetId', 'teamId1', 'teamId2', 'teamImageId1', 'teamImageId2']), Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["f" /* mapTemplateData */])({
    /* eslint-disable no-template-curly-in-string */
    patternName: { default: '${NAME}' },
    patternPicture: { default: '${PICTURE}'
      /* eslint-enable no-template-curly-in-string */
    } })),
  watch: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    teamId1: function teamId1(val) {
      var record = this.$store.getters.datasetRecord(this.datasetId, val) || null;
      var values = Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["e" /* mapRecord */])(record, { name: this.patternName, picture: this.patternPicture });
      this.name1 = values.name;
      var picture = this.$store.getters.picture(this.albumId, function (p) {
        return p.fileName === values.picture;
      });
      this.teamImageId1 = picture && picture.pictureId;
    },
    teamId2: function teamId2(val) {
      var record = this.$store.getters.datasetRecord(this.datasetId, val) || null;
      var values = Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["e" /* mapRecord */])(record, { name: this.patternName, picture: this.patternPicture });
      this.name2 = values.name;
      var picture = this.$store.getters.picture(this.albumId, function (p) {
        return p.fileName === values.picture;
      });
      this.teamImageId2 = picture && picture.pictureId;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["b" /* mapImageIdToImage */])('albumId', 'teamImageId1', 'teamImage1'), Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["b" /* mapImageIdToImage */])('albumId', 'teamImageId2', 'teamImage2'), Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["b" /* mapImageIdToImage */])('albumId', 'topLeftImageId', 'topLeftImage'), Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["b" /* mapImageIdToImage */])('albumId', 'topRightImageId', 'topRightImage'), Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["b" /* mapImageIdToImage */])('albumId', 'bottomLeftImageId', 'bottomLeftImage'), Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["b" /* mapImageIdToImage */])('albumId', 'bottomRightImageId', 'bottomRightImage'))
});

/***/ }),
/* 1724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('window',{attrs:{"window-id":_vm.windowId}},[_c('window-tab',{attrs:{"title":_vm.windowTitle}},[_c('switch-buttons',{attrs:{"template-id":_vm.templateId}}),_vm._v(" "),(_vm.datasetId)?_c('record-select-group',{attrs:{"label":"Home team","dataset-id":_vm.datasetId},model:{value:(_vm.teamId1),callback:function ($$v) {_vm.teamId1=$$v},expression:"teamId1"}}):_vm._e(),_vm._v(" "),_c('text-input-group',{attrs:{"label":"Home name"},model:{value:(_vm.name1),callback:function ($$v) {_vm.name1=$$v},expression:"name1"}}),_vm._v(" "),_c('picture-select-group',{attrs:{"album-id":_vm.albumId,"label":"Home logo"},model:{value:(_vm.teamImageId1),callback:function ($$v) {_vm.teamImageId1=$$v},expression:"teamImageId1"}}),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.datasetId)?_c('record-select-group',{attrs:{"label":"Away team","dataset-id":_vm.datasetId},model:{value:(_vm.teamId2),callback:function ($$v) {_vm.teamId2=$$v},expression:"teamId2"}}):_vm._e(),_vm._v(" "),_c('text-input-group',{attrs:{"label":"Away name"},model:{value:(_vm.name2),callback:function ($$v) {_vm.name2=$$v},expression:"name2"}}),_vm._v(" "),_c('picture-select-group',{attrs:{"album-id":_vm.albumId,"label":"Away logo"},model:{value:(_vm.teamImageId2),callback:function ($$v) {_vm.teamImageId2=$$v},expression:"teamImageId2"}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('text-input-group',{attrs:{"label":"Top left text"},model:{value:(_vm.topLeftText),callback:function ($$v) {_vm.topLeftText=$$v},expression:"topLeftText"}}),_vm._v(" "),_c('picture-select-group',{attrs:{"album-id":_vm.albumId,"label":"Top left image"},model:{value:(_vm.topLeftImageId),callback:function ($$v) {_vm.topLeftImageId=$$v},expression:"topLeftImageId"}}),_vm._v(" "),_c('text-input-group',{attrs:{"label":"Top right"},model:{value:(_vm.topRightText),callback:function ($$v) {_vm.topRightText=$$v},expression:"topRightText"}}),_vm._v(" "),_c('picture-select-group',{attrs:{"album-id":_vm.albumId,"label":"Top right image"},model:{value:(_vm.topRightImageId),callback:function ($$v) {_vm.topRightImageId=$$v},expression:"topRightImageId"}}),_vm._v(" "),_c('text-input-group',{attrs:{"label":"Bottom left"},model:{value:(_vm.bottomLeftText),callback:function ($$v) {_vm.bottomLeftText=$$v},expression:"bottomLeftText"}}),_vm._v(" "),_c('picture-select-group',{attrs:{"album-id":_vm.albumId,"label":"Bottom left image"},model:{value:(_vm.bottomLeftImageId),callback:function ($$v) {_vm.bottomLeftImageId=$$v},expression:"bottomLeftImageId"}}),_vm._v(" "),_c('text-input-group',{attrs:{"label":"Bottom right"},model:{value:(_vm.bottomRightText),callback:function ($$v) {_vm.bottomRightText=$$v},expression:"bottomRightText"}}),_vm._v(" "),_c('picture-select-group',{attrs:{"album-id":_vm.albumId,"label":"Bottom right image"},model:{value:(_vm.bottomRightImageId),callback:function ($$v) {_vm.bottomRightImageId=$$v},expression:"bottomRightImageId"}})],1),_vm._v(" "),_c('window-tab',{attrs:{"title":"Data","icon":"database"}},[_c('dataset-select-group',{attrs:{"label":"Teams","show-fields":true},model:{value:(_vm.datasetId),callback:function ($$v) {_vm.datasetId=$$v},expression:"datasetId"}}),_vm._v(" "),_c('text-input-group',{attrs:{"label":"Name"},model:{value:(_vm.patternName),callback:function ($$v) {_vm.patternName=$$v},expression:"patternName"}}),_vm._v(" "),_c('text-input-group',{attrs:{"label":"Picture"},model:{value:(_vm.patternPicture),callback:function ($$v) {_vm.patternPicture=$$v},expression:"patternPicture"}}),_vm._v(" "),_c('album-select-group',{attrs:{"label":"Pictures"},model:{value:(_vm.albumId),callback:function ($$v) {_vm.albumId=$$v},expression:"albumId"}})],1),_vm._v(" "),_c('window-tab',{attrs:{"title":"Settings","icon":"cog"}},[_c('template-settings',{attrs:{"templateId":_vm.templateId}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_uiaa_results_center_vue__ = __webpack_require__(1727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d171e58_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_uiaa_results_center_vue__ = __webpack_require__(1729);
function injectStyle (ssrContext) {
  __webpack_require__(1726)
}
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6d171e58"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_uiaa_results_center_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d171e58_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_uiaa_results_center_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1726 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_index__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_UiaaApi__ = __webpack_require__(1728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_AppService__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_mutation_types__ = __webpack_require__(14);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'uiaa',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins__["b" /* templateMixin */]],
  data: function data() {
    return {
      errorMessage: null,
      competitions: [],
      stages: [],
      rounds: [],
      group: 0
    };
  },
  created: function created() {
    this.uiaaApi = new __WEBPACK_IMPORTED_MODULE_4__api_UiaaApi__["a" /* default */]();
    this.appService = new __WEBPACK_IMPORTED_MODULE_5__api_AppService__["a" /* default */](this.$store, this.$keycloak);
  },
  mounted: function mounted() {
    var _this = this;

    this.fetchCompetitions().then(function () {
      if (_this.competitionId) {
        return _this.fetchStages(_this.competitionId).then(function () {
          if (_this.stageId) {
            _this.fetchRounds(_this.competitionId, _this.stageId);
          }
        });
      }
    });
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3__utils_index__["g" /* mapTemplateOptions */])({ 'baseUrl': { default: 'https://results.theuiaa.org' } }), Object(__WEBPACK_IMPORTED_MODULE_3__utils_index__["g" /* mapTemplateOptions */])(['competitionId', 'stageId']), {
    optionsCompetitions: function optionsCompetitions() {
      return [{ text: '', value: null }].concat(this.competitions.map(function (each) {
        return {
          text: each.name + ' / ' + each.date + ' / ' + each.location,
          value: each.id
        };
      }));
    },
    optionsStages: function optionsStages() {
      return [{ text: '', value: null }].concat(this.stages.map(function (each) {
        return {
          text: each.name,
          value: each.id
        };
      }));
    }
  }),
  watch: {
    competitionId: function competitionId(val) {
      console.debug('[uiaa] watched competitionId ' + val);
      this.fetchStages(val);
    },
    stageId: function stageId(val) {
      console.debug('[uiaa] watched stageId ' + val);
      this.fetchRounds(this.competitionId, val);
    }
  },
  methods: {
    openCreateLowerThirds: function openCreateLowerThirds(round, type) {
      var componentTypes = {
        'lead': 'uiaa-lower-third-lead',
        'speed': 'uiaa-lower-third-speed'
      };
      var stage = this.getStage();
      var url = this.api().getStartingListUrl(round.competitionId, round.stageId, round.id, this.group);
      var datasetId = this.appService.openCreateDataset({
        datasetId: Object(__WEBPACK_IMPORTED_MODULE_1__lib__["e" /* uuid */])(),
        name: stage.name + ' ' + round.name + ' Starting List',
        url: url
      }, 'uiaa-dataset-window');
      this.appService.openCreateTemplate({
        templateId: Object(__WEBPACK_IMPORTED_MODULE_1__lib__["e" /* uuid */])(),
        name: 'Lower Thirds ' + stage.name + ' ' + round.name,
        componentType: componentTypes[type],
        templateData: { datasetId: datasetId },
        templateOptions: {},
        overlayData: {},
        columnMap: {}
      });
    },
    openCreateStartingList: function openCreateStartingList(round) {
      var stage = this.getStage();
      var url = this.api().getStartingListUrl(round.competitionId, round.stageId, round.id, this.group);
      var datasetId = this.appService.openCreateDataset({
        datasetId: Object(__WEBPACK_IMPORTED_MODULE_1__lib__["e" /* uuid */])(),
        name: stage.name + ' ' + round.name + ' Starting List',
        url: url
      }, 'uiaa-dataset-window');
      this.appService.openCreateTemplate({
        templateId: Object(__WEBPACK_IMPORTED_MODULE_1__lib__["e" /* uuid */])(),
        name: 'Starting List ' + stage.name + ' ' + round.name,
        componentType: 'starting-list',
        templateData: { datasetId: datasetId },
        templateOptions: {},
        overlayData: {
          title: ('STARTING LIST ' + stage.name + ' ' + round.name).toUpperCase(),
          subtitle: (this.getCompetition() || {}).destination
        },
        columnMap: {
          'bibNumber': 'BIB',
          'lastName': 'LAST NAME',
          'firstName': 'FIRST NAME',
          'country': 'COUNTRY'
        }
      });
    },
    openCreateLeadIntermediate: function openCreateLeadIntermediate(round) {
      var stage = this.getStage();
      var url = this.api().getStartingListUrl(round.competitionId, round.stageId, round.id, this.group);
      var datasetId = this.appService.openCreateDataset({
        datasetId: Object(__WEBPACK_IMPORTED_MODULE_1__lib__["e" /* uuid */])(),
        name: stage.name + ' ' + round.name + ' Intermediates',
        url: url,
        columns: ['TIME']
      }, 'uiaa-dataset-window');
      window.setTimeout(function () {
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_6__store_mutation_types__["o" /* DATASET_UPDATE_META */], {
          datasetId: datasetId,
          fileName: this.api().getRankingListUrl(round.competitionId, round.stageId, round.id, this.group),
          emit: true
        });
      }.bind(this), 1000);
      this.appService.openCreateTemplate({
        templateId: Object(__WEBPACK_IMPORTED_MODULE_1__lib__["e" /* uuid */])(),
        name: 'Intermediates ' + stage.name + ' ' + round.name,
        componentType: 'uiaa-lead-intermediate-standings',
        templateData: { datasetId: datasetId },
        templateOptions: {},
        columnMap: {
          'bibNumber': 'BIB',
          'lastName': 'LAST NAME',
          'firstName': 'FIRST NAME',
          'country': 'COUNTRY',
          'score': 'Route 1',
          'endTime': 'ENDTIME'
        }
      });
    },
    openCreateRankingListProvisional: function openCreateRankingListProvisional(round) {
      this.openCreateRankingList(round, true);
    },
    openCreateRankingListResults: function openCreateRankingListResults(round) {
      this.openCreateRankingList(round, false);
    },
    openCreateRankingList: function openCreateRankingList(round, provisional) {
      var stage = this.getStage();
      var url = this.api().getRankingListUrl(round.competitionId, round.stageId, round.id, this.group);
      var datasetId = this.appService.openCreateDataset({
        datasetId: Object(__WEBPACK_IMPORTED_MODULE_1__lib__["e" /* uuid */])(),
        name: stage.name + ' ' + round.name + ' Ranking List',
        url: url
      }, 'uiaa-dataset-window');
      this.appService.openCreateTemplate({
        templateId: Object(__WEBPACK_IMPORTED_MODULE_1__lib__["e" /* uuid */])(),
        name: 'Ranking List ' + (provisional ? 'w/o' : 'w/') + ' Results ' + stage.name + ' ' + round.name,
        componentType: 'ranking-list',
        templateData: { datasetId: datasetId },
        templateOptions: {},
        overlayData: {
          title: ('PROVISIONAL RANKINGS ' + stage.name + ' ' + round.name).toUpperCase(),
          subtitle: (this.getCompetition() || {}).destination
        },
        columnMap: {
          'bibNumber': 'BIB',
          'lastName': 'LAST NAME',
          'firstName': 'FIRST NAME',
          'country': 'COUNTRY',
          'rank': 'RANK',
          'score': 'Route 1',
          'qualified': 'Qualified'
        },
        overlays: [provisional ? 'uiaa/ranking-list-without-results.vue' : 'uiaa/ranking-list-with-results.vue']
      });
    },
    openCreateVictoryCeremonyAthlete: function openCreateVictoryCeremonyAthlete(round) {
      var stage = this.getStage();
      var url = this.api().getRankingListUrl(round.competitionId, round.stageId, round.id, this.group);
      var datasetId = this.appService.openCreateDataset({
        datasetId: Object(__WEBPACK_IMPORTED_MODULE_1__lib__["e" /* uuid */])(),
        name: stage.name + ' ' + round.name + ' Ranking List',
        url: url
      }, 'uiaa-dataset-window');
      this.appService.openCreateTemplate({
        templateId: Object(__WEBPACK_IMPORTED_MODULE_1__lib__["e" /* uuid */])(),
        name: 'Victory Ceremony Athlete ' + stage.name + ' ' + round.name,
        componentType: 'uiaa-victory-ceremony-athlete',
        templateData: { datasetId: datasetId },
        templateOptions: {},
        overlayData: {
          title: stage.name.toUpperCase()
        }
      });
    },
    openCreateVictoryCeremonyGroup: function openCreateVictoryCeremonyGroup(round) {
      var stage = this.getStage();
      var url = this.api().getRankingListUrl(round.competitionId, round.stageId, round.id, this.group);
      var datasetId = this.appService.openCreateDataset({
        datasetId: Object(__WEBPACK_IMPORTED_MODULE_1__lib__["e" /* uuid */])(),
        name: stage.name + ' ' + round.name + ' Ranking List',
        url: url
      }, 'uiaa-dataset-window');
      this.appService.openCreateTemplate({
        templateId: Object(__WEBPACK_IMPORTED_MODULE_1__lib__["e" /* uuid */])(),
        name: 'Victory Ceremony Group ' + stage.name + ' ' + round.name,
        componentType: 'uiaa-victory-ceremony-group',
        templateData: { datasetId: datasetId },
        templateOptions: {},
        overlayData: {
          title: stage.name.toUpperCase()
        }
      });
    },
    fetchCompetitions: function fetchCompetitions() {
      var _this2 = this;

      this.errorMessage = null;
      return this.api().fetchCompetitions().then(function (competitions) {
        console.log('[uiaa] fetched ' + competitions.length + ' competitions');
        _this2.competitions = competitions;
      }).catch(function (err) {
        console.error('[uiaa] error fetching competitions', err);
        _this2.errorMessage = err.message;
      });
    },
    fetchStages: function fetchStages(competitionId) {
      var _this3 = this;

      this.errorMessage = null;
      console.log('[uiaa] fetching stages for competition ' + competitionId);
      return this.api().fetchStages(competitionId).then(function (stages) {
        console.log('[uiaa] fetched ' + stages.length + ' stages');
        _this3.stages = stages;
      }).catch(function (err) {
        console.error('[uiaa] error fetching stages', err);
        _this3.errorMessage = err.message;
      });
    },
    fetchRounds: function fetchRounds(competitionId, stageId) {
      var _this4 = this;

      this.errorMessage = null;
      console.log('[uiaa] fetching rounds for competition ' + competitionId + ', stage ' + stageId);
      this.api().fetchRounds(competitionId, stageId).then(function (rounds) {
        console.log('[uiaa] fetched ' + rounds.length + ' rounds');
        _this4.rounds = rounds;
      }).catch(function (err) {
        console.error('[uiaa] error fetching rounds', err);
        _this4.errorMessage = err.message;
      });
    },
    getCompetition: function getCompetition() {
      var _this5 = this;

      return this.competitions.find(function (p) {
        return p.id === _this5.competitionId;
      });
    },
    getStage: function getStage() {
      var _this6 = this;

      return this.stages.find(function (p) {
        return p.id === _this6.stageId;
      });
    },
    api: function api() {
      return this.uiaaApi.setBaseUrl(this.baseUrl);
    }
  }
});

/***/ }),
/* 1728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);





var EUROPEAN_CUP_BERN_2019_ID = 68;

var countryNames = {
  'CHN': 'China',
  'FIN': 'Finland',
  'FRA': 'France',
  'ITA': 'Italy',
  'KOR': 'South Korea',
  'RUS': 'Russia',
  'SUI': 'Switzerland',
  'USA': 'USA'
};

var UiaaApi = function () {
  function UiaaApi() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, UiaaApi);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(UiaaApi, [{
    key: 'setBaseUrl',
    value: function setBaseUrl(baseUrl) {
      this.baseUrl = baseUrl + '/ajax/';
      return this;
    }
  }, {
    key: 'getUrl',
    value: function getUrl(name, competitionId, stageId, roundId) {
      var result = this.baseUrl + 'Get' + name + '.php';
      if (competitionId) {
        result += '?Competition=' + competitionId;
        if (stageId) {
          result += '&Stage=' + stageId;
          if (roundId) {
            result += '&Round=' + roundId;
          }
        }
      }
      return result;
    }
  }, {
    key: 'fetchCompetitions',
    value: function fetchCompetitions() {
      return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(this.getUrl('Competitions')).catch(function (err) {
        console.error('[uiaa/api] error fetching competitions', err);
        return { data: null };
      }).then(function (_ref) {
        var data = _ref.data;

        return (data && data.Competitions[0] || []).concat([{
          id: EUROPEAN_CUP_BERN_2019_ID,
          name: '2019 UIAA European Cup',
          date: '23 Nov',
          location: 'Bern (SUI)',
          shortname: 'Bern'
        }, {
          id: 69,
          name: '2018 UIAA Ice Climbing World Cup',
          date: '02 - 04 Mar',
          location: 'Kirov (RUS)',
          shortname: 'Kirov'
        }]).map(function (each) {
          var country = each.location.match(/\((.*)\)/)[1];
          return {
            id: each.id,
            name: each.name,
            date: each.date,
            location: each.location,
            city: each.shortname,
            country: countryNames[country],
            destination: each.shortname + ', ' + countryNames[country]
          };
        });
      });
    }
  }, {
    key: 'fetchStages',
    value: function fetchStages(competitionId) {
      if (competitionId === EUROPEAN_CUP_BERN_2019_ID) {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
          resolve([{ id: 1, name: 'Men Lead', competitionId: competitionId }, { id: 2, name: 'Women Lead', competitionId: competitionId }]);
        });
      }
      return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(this.getUrl('Competitions', competitionId)).then(function (_ref2) {
        var data = _ref2.data;

        return (data.CompetitionStages[0] || []).map(function (each) {
          each.competitionId = competitionId;
          return each;
        });
      });
    }
  }, {
    key: 'fetchRounds',
    value: function fetchRounds(competitionId, stageId) {
      if (competitionId === EUROPEAN_CUP_BERN_2019_ID) {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
          if (stageId === 1) {
            resolve([{ id: 84, name: 'Qualification', competitionId: competitionId, stageId: stageId }, { id: 86, name: 'Final', competitionId: competitionId, stageId: stageId }]);
          } else if (stageId === 2) {
            resolve([{ id: 85, name: 'Qualification', competitionId: competitionId, stageId: stageId }, { id: 87, name: 'Final', competitionId: competitionId, stageId: stageId }]);
          } else {
            resolve([]);
          }
        });
      }
      return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(this.getUrl('Competitions', competitionId, stageId)).then(function (_ref3) {
        var data = _ref3.data;

        return (data.Rounds[0] || []).map(function (each) {
          each.competitionId = competitionId;
          each.stageId = stageId;
          return each;
        });
      });
    }
  }, {
    key: 'getStartingListUrl',
    value: function getStartingListUrl(competitionId, stageId, roundId, group) {
      if (competitionId === EUROPEAN_CUP_BERN_2019_ID) {
        return 'https://uiaa.result.site/api/uiaa/category_rounds/' + roundId + '/startlist';
      }
      return this.baseUrl + ('GetStartingLists.php?competition=' + competitionId + '&stage=' + stageId + '&round=' + roundId + '&group=' + group);
    }
  }, {
    key: 'getRankingListUrl',
    value: function getRankingListUrl(competitionId, stageId, roundId, group) {
      if (competitionId === EUROPEAN_CUP_BERN_2019_ID) {
        return 'https://uiaa.result.site/api/uiaa/category_rounds/' + roundId + '/results';
      }
      return this.baseUrl + ('GetResults.php?competition=' + competitionId + '&stage=' + stageId + '&round=' + roundId + '&group=' + group);
    }
  }]);

  return UiaaApi;
}();

/* harmony default export */ __webpack_exports__["a"] = (UiaaApi);

/***/ }),
/* 1729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('window',{attrs:{"window-id":_vm.windowId}},[_c('window-tab',{attrs:{"title":_vm.windowTitle}},[(_vm.errorMessage)?_c('div',{staticClass:"alert alert-danger"},[_c('p',[_c('b',[_vm._v("Error:")]),_vm._v(" "+_vm._s(_vm.errorMessage))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('stageId')}},[_vm._v("Stage")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('b-form-select',{attrs:{"id":_vm.safeId('stageId'),"options":_vm.optionsStages,"text-field":"text","value-field":"value"},model:{value:(_vm.stageId),callback:function ($$v) {_vm.stageId=$$v},expression:"stageId"}})],1)]),_vm._v(" "),_c('number-input-group',{attrs:{"label":"Group"},model:{value:(_vm.group),callback:function ($$v) {_vm.group=$$v},expression:"group"}}),_vm._v(" "),(_vm.rounds && _vm.rounds.length)?_c('table',{staticClass:"table table-bordered table-responsive table-hover table-sm"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Round")]),_vm._v(" "),_c('th',[_vm._v("Templates")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.rounds),function(row){return _c('tr',[_c('td',[_vm._v(_vm._s(row.name))]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"button","title":"Lower Thirds Lead"},on:{"click":function($event){_vm.openCreateLowerThirds(row, 'lead')}}},[_vm._v("LTL\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"button","title":"Lower Thirds Speed"},on:{"click":function($event){_vm.openCreateLowerThirds(row, 'speed')}}},[_vm._v("LTS\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"button","title":"Starting List"},on:{"click":function($event){_vm.openCreateStartingList(row)}}},[_vm._v("SL\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"button","title":"Lead Intermediate"},on:{"click":function($event){_vm.openCreateLeadIntermediate(row)}}},[_vm._v("LI\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"button","title":"Ranking List Provisional"},on:{"click":function($event){_vm.openCreateRankingListProvisional(row)}}},[_vm._v("RP\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"button","title":"Ranking List Results"},on:{"click":function($event){_vm.openCreateRankingListResults(row)}}},[_vm._v("RR\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"button","title":"Victory Ceremony Athlete"},on:{"click":function($event){_vm.openCreateVictoryCeremonyAthlete(row)}}},[_vm._v("VCA\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"button","title":"Victory Ceremony Group"},on:{"click":function($event){_vm.openCreateVictoryCeremonyGroup(row)}}},[_vm._v("VCG\n          ")])])])}))]):_vm._e()],1),_vm._v(" "),_c('window-tab',{attrs:{"title":"Data","icon":"database"}},[(_vm.errorMessage)?_c('div',{staticClass:"alert alert-danger"},[_c('p',[_c('b',[_vm._v("Error:")]),_vm._v(" "+_vm._s(_vm.errorMessage))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('baseUrl')}},[_vm._v("Results-API")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.baseUrl),expression:"baseUrl",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('baseUrl')},domProps:{"value":(_vm.baseUrl)},on:{"change":function($event){_vm.baseUrl=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('div',{staticClass:"col-sm-12"},[_c('button',{staticClass:"btn btn-block btn-primary",attrs:{"type":"button"},on:{"click":_vm.fetchCompetitions}},[_vm._v("Fetch")])])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('competitionId')}},[_vm._v("Competition")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('b-form-select',{attrs:{"id":_vm.safeId('competitionId'),"options":_vm.optionsCompetitions,"text-field":"text","value-field":"value"},model:{value:(_vm.competitionId),callback:function ($$v) {_vm.competitionId=$$v},expression:"competitionId"}})],1)])]),_vm._v(" "),_c('window-tab',{attrs:{"title":"Settings","icon":"cog"}},[_c('template-settings',{attrs:{"templateId":_vm.templateId}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_uiaa_vertical_life_vue__ = __webpack_require__(1732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a33681f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_uiaa_vertical_life_vue__ = __webpack_require__(1733);
function injectStyle (ssrContext) {
  __webpack_require__(1731)
}
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0a33681f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_uiaa_vertical_life_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a33681f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_uiaa_vertical_life_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1731 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_index__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_VerticalLifeApi__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_AppService__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_mutation_types__ = __webpack_require__(14);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'uiaa-vertical-life',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins__["b" /* templateMixin */]],
  data: function data() {
    return {
      errorMessage: null,
      leagues: [],
      events: [],
      stages: [],
      rounds: [],
      group: 0
    };
  },
  created: function created() {
    this.verticalLifeApi = new __WEBPACK_IMPORTED_MODULE_4__api_VerticalLifeApi__["a" /* default */]({
      baseUrl: 'https://uiaa.results.info',
      // TODO: This does not update the auth token in vertical-life-dataset.vue
      authToken: '63b0083436935fc8492e16de93cfa929485a5ce3'
    });
    this.appService = new __WEBPACK_IMPORTED_MODULE_5__api_AppService__["a" /* default */](this.$store, this.$keycloak);
  },
  mounted: function mounted() {
    var _this = this;

    this.fetchLeagues().then(function () {
      if (_this.leagueId) {
        _this.fetchEvents(_this.leagueId).then(function () {
          if (_this.eventId) {
            _this.fetchStages(_this.eventId).then(function () {
              if (_this.stageId) {
                _this.fetchRounds(_this.eventId, _this.stageId);
              }
            });
          }
        });
      }
    });
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3__utils_index__["g" /* mapTemplateOptions */])(['leagueId', 'eventId', 'stageId', 'routeId']), {
    optionsLeagues: function optionsLeagues() {
      return [{ name: '', id: null }].concat(this.leagues || []);
    },
    optionsEvents: function optionsEvents() {
      return [{ event: '', event_id: null }].concat(this.events || []);
    },
    optionsStages: function optionsStages() {
      return [{ dcat_name: '', dcat_id: null }].concat(this.stages || []);
    }
  }),
  watch: {
    leagueId: function leagueId(val) {
      console.debug('[uiaa] watched leagueId', val);
      this.fetchEvents(val);
    },
    eventId: function eventId(val) {
      console.debug('[uiaa] watched eventId ' + val);
      this.fetchStages(val);
    },
    stageId: function stageId(val) {
      console.debug('[uiaa] watched stageId ' + val);
      this.fetchRounds(this.eventId, val);
    }
  },
  methods: {
    openCreateLowerThirds: function openCreateLowerThirds(round, type) {
      var componentTypes = {
        'lead': 'uiaa-lower-third-lead',
        'speed': 'uiaa-lower-third-speed'
      };
      var stage = this.getStage();
      var url = this.api().getStartingListUrl(round);
      var datasetId = this.appService.openCreateDataset({
        datasetId: Object(__WEBPACK_IMPORTED_MODULE_1__lib__["e" /* uuid */])(),
        name: stage.dcat_name + ' ' + round.name + ' Starting List',
        url: url
      }, 'vertical-life-dataset-window');
      this.appService.openCreateTemplate({
        templateId: Object(__WEBPACK_IMPORTED_MODULE_1__lib__["e" /* uuid */])(),
        name: 'Lower Thirds ' + stage.dcat_name + ' ' + round.name,
        componentType: componentTypes[type],
        templateData: { datasetId: datasetId },
        templateOptions: {},
        overlayData: {},
        columnMap: {}
      });
    },
    openCreateStartingList: function openCreateStartingList(round) {
      var stage = this.getStage();
      var url = this.api().getStartingListUrl(round);
      var datasetId = this.appService.openCreateDataset({
        datasetId: Object(__WEBPACK_IMPORTED_MODULE_1__lib__["e" /* uuid */])(),
        name: stage.dcat_name + ' ' + round.name + ' Starting List',
        url: url
      }, 'vertical-life-dataset-window');
      this.appService.openCreateTemplate({
        templateId: Object(__WEBPACK_IMPORTED_MODULE_1__lib__["e" /* uuid */])(),
        name: 'Starting List ' + stage.dcat_name + ' ' + round.name,
        componentType: 'starting-list',
        templateData: { datasetId: datasetId },
        templateOptions: {},
        overlayData: {
          title: ('STARTING LIST ' + stage.dcat_name + ' ' + round.name).toUpperCase(),
          subtitle: (this.getEvent() || {}).destination
        },
        columnMap: {
          'bibNumber': 'BIB',
          'lastName': 'LAST NAME',
          'firstName': 'FIRST NAME',
          'country': 'COUNTRY'
        }
      });
    },
    openCreateLeadIntermediate: function openCreateLeadIntermediate(round) {
      var stage = this.getStage();
      var url = this.api().getStartingListUrl(round);
      var datasetId = this.appService.openCreateDataset({
        datasetId: Object(__WEBPACK_IMPORTED_MODULE_1__lib__["e" /* uuid */])(),
        name: stage.dcat_name + ' ' + round.name + ' Intermediates',
        url: url,
        columns: ['TIME']
      }, 'vertical-life-dataset-window');
      window.setTimeout(function () {
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_6__store_mutation_types__["o" /* DATASET_UPDATE_META */], {
          datasetId: datasetId,
          fileName: this.api().getRankingListUrl(round),
          emit: true
        });
      }.bind(this), 1000);
      this.appService.openCreateTemplate({
        templateId: Object(__WEBPACK_IMPORTED_MODULE_1__lib__["e" /* uuid */])(),
        name: 'Intermediates ' + stage.dcat_name + ' ' + round.name,
        componentType: 'uiaa-lead-intermediate-standings',
        templateData: { datasetId: datasetId },
        templateOptions: {},
        columnMap: {
          'bibNumber': 'BIB',
          'lastName': 'LAST NAME',
          'firstName': 'FIRST NAME',
          'country': 'COUNTRY',
          'score': 'SCORE',
          'endTime': 'ENDTIME'
        }
      });
    },
    openCreateRankingListProvisional: function openCreateRankingListProvisional(round) {
      this.openCreateRankingList(round, true);
    },
    openCreateRankingListResults: function openCreateRankingListResults(round) {
      this.openCreateRankingList(round, false);
    },
    openCreateRankingList: function openCreateRankingList(round, provisional) {
      var stage = this.getStage();
      var url = this.api().getRankingListUrl(round);
      var datasetId = this.appService.openCreateDataset({
        datasetId: Object(__WEBPACK_IMPORTED_MODULE_1__lib__["e" /* uuid */])(),
        name: stage.dcat_name + ' ' + round.name + ' Ranking List',
        url: url
      }, 'vertical-life-dataset-window');
      this.appService.openCreateTemplate({
        templateId: Object(__WEBPACK_IMPORTED_MODULE_1__lib__["e" /* uuid */])(),
        name: 'Ranking List ' + (provisional ? 'w/o' : 'w/') + ' Results ' + stage.dcat_name + ' ' + round.name,
        componentType: 'ranking-list',
        templateData: { datasetId: datasetId },
        templateOptions: {},
        overlayData: {
          title: ('PROVISIONAL RANKINGS ' + stage.dcat_name + ' ' + round.name).toUpperCase(),
          subtitle: (this.getEvent() || {}).destination
        },
        columnMap: {
          'bibNumber': 'BIB',
          'lastName': 'LAST NAME',
          'firstName': 'FIRST NAME',
          'country': 'COUNTRY',
          'rank': 'RANK',
          'score': 'SCORE',
          'qualified': 'QUALIFIED'
        },
        overlays: [provisional ? 'uiaa/ranking-list-without-results.vue' : 'uiaa/ranking-list-with-results.vue']
      });
    },
    openCreateVictoryCeremonyAthlete: function openCreateVictoryCeremonyAthlete(round) {
      var stage = this.getStage();
      var url = this.api().getRankingListUrl(round);
      var datasetId = this.appService.openCreateDataset({
        datasetId: Object(__WEBPACK_IMPORTED_MODULE_1__lib__["e" /* uuid */])(),
        name: stage.dcat_name + ' ' + round.name + ' Ranking List',
        url: url
      }, 'vertical-life-dataset-window');
      this.appService.openCreateTemplate({
        templateId: Object(__WEBPACK_IMPORTED_MODULE_1__lib__["e" /* uuid */])(),
        name: 'Victory Ceremony Athlete ' + stage.dcat_name + ' ' + round.name,
        componentType: 'uiaa-victory-ceremony-athlete',
        templateData: { datasetId: datasetId },
        templateOptions: {},
        overlayData: {
          title: stage.dcat_name.toUpperCase()
        }
      });
    },
    openCreateVictoryCeremonyGroup: function openCreateVictoryCeremonyGroup(round) {
      var stage = this.getStage();
      var url = this.api().getRankingListUrl(round);
      var datasetId = this.appService.openCreateDataset({
        datasetId: Object(__WEBPACK_IMPORTED_MODULE_1__lib__["e" /* uuid */])(),
        name: stage.dcat_name + ' ' + round.name + ' Ranking List',
        url: url
      }, 'vertical-life-dataset-window');
      this.appService.openCreateTemplate({
        templateId: Object(__WEBPACK_IMPORTED_MODULE_1__lib__["e" /* uuid */])(),
        name: 'Victory Ceremony Group ' + stage.dcat_name + ' ' + round.name,
        componentType: 'uiaa-victory-ceremony-group',
        templateData: { datasetId: datasetId },
        templateOptions: {},
        overlayData: {
          title: stage.dcat_name.toUpperCase()
        }
      });
    },
    fetchLeagues: function fetchLeagues() {
      var _this2 = this;

      this.errorMessage = null;
      return this.api().fetchLeagues().then(function (leagues) {
        console.log('[uiaa] fetched ' + leagues.length + ' leagues');
        _this2.leagues = leagues;
      }).catch(function (err) {
        console.error('[uiaa] error fetching leagues', err);
        _this2.errorMessage = err.message;
      });
    },
    fetchEvents: function fetchEvents(leagueId) {
      var _this3 = this;

      this.errorMessage = null;
      return this.api().fetchEvents(leagueId).then(function (events) {
        console.log('[uiaa] fetched ' + events.length + ' events');
        _this3.events = events;
      }).catch(function (err) {
        console.error('[uiaa] error fetching events', err);
        _this3.errorMessage = err.message;
      });
    },
    fetchStages: function fetchStages(eventId) {
      var _this4 = this;

      this.errorMessage = null;
      console.log('[uiaa] fetching stages for event ' + eventId);
      return this.api().fetchStages(eventId).then(function (stages) {
        console.log('[uiaa] fetched ' + stages.length + ' stages');
        _this4.stages = stages;
      }).catch(function (err) {
        console.error('[uiaa] error fetching stages', err);
        _this4.errorMessage = err.message;
      });
    },
    fetchRounds: function fetchRounds(eventId, stageId) {
      var _this5 = this;

      this.errorMessage = null;
      console.log('[uiaa] fetching rounds for event ' + eventId + ', stage ' + stageId);
      this.api().fetchRounds(eventId, stageId).then(function (rounds) {
        console.log('[uiaa] fetched ' + rounds.length + ' rounds');
        _this5.rounds = rounds;
      }).catch(function (err) {
        console.error('[uiaa] error fetching rounds', err);
        _this5.errorMessage = err.message;
      });
    },
    getEvent: function getEvent() {
      var _this6 = this;

      return this.events.find(function (p) {
        return p.id === _this6.eventId;
      });
    },
    getStage: function getStage() {
      var _this7 = this;

      return this.stages.find(function (p) {
        return p.dcat_id === _this7.stageId;
      });
    },
    api: function api() {
      return this.verticalLifeApi;
    }
  }
});

/***/ }),
/* 1733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('window',{attrs:{"window-id":_vm.windowId}},[_c('window-tab',{attrs:{"title":_vm.windowTitle}},[(_vm.errorMessage)?_c('div',{staticClass:"alert alert-danger"},[_c('p',[_c('b',[_vm._v("Error:")]),_vm._v(" "+_vm._s(_vm.errorMessage))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('stageId')}},[_vm._v("Stage")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('b-form-select',{attrs:{"id":_vm.safeId('stageId'),"options":_vm.optionsStages,"text-field":"dcat_name","value-field":"dcat_id"},model:{value:(_vm.stageId),callback:function ($$v) {_vm.stageId=$$v},expression:"stageId"}})],1)]),_vm._v(" "),(_vm.rounds && _vm.rounds.length)?_c('table',{staticClass:"table table-bordered table-responsive table-hover table-sm"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Round")]),_vm._v(" "),_c('th',[_vm._v("Templates")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.rounds),function(row){return _c('tr',[_c('td',[_vm._v(_vm._s(row.name))]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"button","title":"Lower Thirds Lead"},on:{"click":function($event){_vm.openCreateLowerThirds(row, 'lead')}}},[_vm._v("LTL\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"button","title":"Lower Thirds Speed"},on:{"click":function($event){_vm.openCreateLowerThirds(row, 'speed')}}},[_vm._v("LTS\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"button","title":"Starting List"},on:{"click":function($event){_vm.openCreateStartingList(row)}}},[_vm._v("SL\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"button","title":"Lead Intermediate"},on:{"click":function($event){_vm.openCreateLeadIntermediate(row)}}},[_vm._v("LI\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"button","title":"Ranking List Provisional"},on:{"click":function($event){_vm.openCreateRankingListProvisional(row)}}},[_vm._v("RP\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"button","title":"Ranking List Results"},on:{"click":function($event){_vm.openCreateRankingListResults(row)}}},[_vm._v("RR\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"button","title":"Victory Ceremony Athlete"},on:{"click":function($event){_vm.openCreateVictoryCeremonyAthlete(row)}}},[_vm._v("VCA\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"button","title":"Victory Ceremony Group"},on:{"click":function($event){_vm.openCreateVictoryCeremonyGroup(row)}}},[_vm._v("VCG\n          ")])])])}))]):_vm._e()]),_vm._v(" "),_c('window-tab',{attrs:{"title":"Data","icon":"database"}},[(_vm.errorMessage)?_c('div',{staticClass:"alert alert-danger"},[_c('p',[_c('b',[_vm._v("Error:")]),_vm._v(" "+_vm._s(_vm.errorMessage))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('div',{staticClass:"col-sm-12"},[_c('button',{staticClass:"btn btn-block btn-primary",attrs:{"type":"button"},on:{"click":_vm.fetchLeagues}},[_vm._v("Fetch")])])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('leagueId')}},[_vm._v("League")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('b-form-select',{attrs:{"id":_vm.safeId('leagueId'),"options":_vm.optionsLeagues,"text-field":"name","value-field":"id"},model:{value:(_vm.leagueId),callback:function ($$v) {_vm.leagueId=$$v},expression:"leagueId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('eventId')}},[_vm._v("Event")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('b-form-select',{attrs:{"id":_vm.safeId('eventId'),"options":_vm.optionsEvents,"text-field":"event","value-field":"event_id"},model:{value:(_vm.eventId),callback:function ($$v) {_vm.eventId=$$v},expression:"eventId"}})],1)])]),_vm._v(" "),_c('window-tab',{attrs:{"title":"Settings","icon":"cog"}},[_c('template-settings',{attrs:{"templateId":_vm.templateId}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_uiaa_lead_intermediate_chart_vue__ = __webpack_require__(1735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0653486c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_uiaa_lead_intermediate_chart_vue__ = __webpack_require__(1736);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_uiaa_lead_intermediate_chart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0653486c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_uiaa_lead_intermediate_chart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_action_types__ = __webpack_require__(5);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'intermediate-chart',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins__["b" /* templateMixin */]],
  data: function data() {
    return {
      localTop: 15,
      localMinutes: 10,
      columnDefinitions: {
        'bibNumber': 'Bib number',
        'lastName': 'Last name',
        'firstName': 'First name',
        'country': 'Country',
        'score': 'Score',
        'endTime': 'Time'
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3__utils__["c" /* mapOverlayData */])(['title']), Object(__WEBPACK_IMPORTED_MODULE_3__utils__["c" /* mapOverlayData */])({
    'records': { default: [] },
    'minutes': { default: 10 },
    'top': { default: 15 }
  }), Object(__WEBPACK_IMPORTED_MODULE_3__utils__["f" /* mapTemplateData */])({
    'albumId': {},
    'datasetId': {},
    'recordId': {},
    'columnMap': { default: {} },
    'bibs': { default: '' }
  }), {
    dataset: function dataset() {
      if (!this.datasetId) return null;
      return this.$store.getters.dataset(this.datasetId);
    },
    filtered: function filtered() {
      var _this = this;

      var dataset = this.dataset;
      if (!dataset) return [];
      var bibs = this.bibs.split(',');
      return dataset.records.filter(function (r) {
        return r.recordId === _this.recordId || bibs.length === 0 || bibs.find(function (bib) {
          return bib === r[_this.columnMap['bibNumber']];
        });
      });
    },
    records: function records() {
      var _this2 = this;

      var records = [].concat(this.filtered.reduce(function (result, record) {
        var mapped = _this2.mapRecord(record, _this2.columnMap);
        var data = [{ y: 0, x: 0 }];
        for (var i = 1; i <= _this2.localTop; i++) {
          var key = '' + i;
          if (record.hasOwnProperty(key) || record[key]) {
            var values = record[key].split(':');
            var value = parseInt(values[0]) * 60 + parseInt(values[1]);
            if (value) {
              data.push({ y: i, x: value });
            }
          }
        }
        mapped.active = record.recordId === _this2.recordId;
        if (mapped.score && mapped.score.indexOf('TOP') >= 0) {
          var m = mapped.score.match(/TOP\((.+)\)/);
          if (m) {
            var timeLeftParts = m[1].split('.');
            var x = _this2.localMinutes * 60 - parseInt(timeLeftParts[0]) * 60 - parseInt(timeLeftParts[1]);
            var point = { y: _this2.localTop, x: x };
            data.push(point);
          }
        } else if (mapped.endTime) {
          var endTimeParts = mapped.endTime.split(':');
          var _x = parseInt(endTimeParts[0]) * 60 + parseInt(endTimeParts[1]);
          var _point = { y: parseFloat(mapped.score), x: _x };
          data.push(_point);
        }
        mapped.data = data;
        result.push(mapped);
        return result;
      }, [])).filter(function (record) {
        return record.score;
      });
      records.sort(function (a, b) {
        return __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* compare */].uiaaLeadScore(a['score'], b['score']);
      });
      records.forEach(Object(__WEBPACK_IMPORTED_MODULE_3__utils__["j" /* rank */])('rank', 'score'));
      // console.log(JSON.stringify(records))
      return records.slice(0, 16);
    }
  }),
  mounted: function mounted() {
    this.localTop = this.top;
    this.localMinutes = this.minutes;
  },

  watch: {
    top: function top(val) {
      this.localTop = val;
    },
    minutes: function minutes(val) {
      this.localMinutes = val;
    },
    records: function records(val) {
      // console.log('chart: watched records, dispatching template_overlay_data', val)
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__store_action_types__["z" /* TEMPLATE_OVERLAY_DATA */], {
        templateId: this.templateId,
        data: { records: val }
      });
    },
    albumId: function albumId(val) {
      var album = this.$store.getters.album(this.albumId) || {};
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__store_action_types__["z" /* TEMPLATE_OVERLAY_DATA */], {
        templateId: this.templateId,
        data: { sponsors: album.pictures }
      });
    }
  },
  methods: {
    mapRecord: function mapRecord(record, columnMap) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(columnMap).reduce(function (result, key) {
        result[key] = record[columnMap[key]];
        return result;
      }, {});
    }
  }
});

/***/ }),
/* 1736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('window',{attrs:{"window-id":_vm.windowId}},[_c('window-tab',{attrs:{"title":_vm.windowTitle}},[_c('switch-buttons',{attrs:{"template-id":_vm.templateId}}),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('title')}},[_vm._v("Title")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.title),expression:"title",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('title')},domProps:{"value":(_vm.title)},on:{"change":function($event){_vm.title=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('top')}},[_vm._v("TOP")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.number.lazy",value:(_vm.top),expression:"top",modifiers:{"number":true,"lazy":true}}],staticClass:"form-control",attrs:{"type":"number","id":_vm.safeId('top')},domProps:{"value":(_vm.top)},on:{"change":function($event){_vm.top=_vm._n($event.target.value)},"blur":function($event){_vm.$forceUpdate()}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('minutes')}},[_vm._v("Minutes")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.number.lazy",value:(_vm.minutes),expression:"minutes",modifiers:{"number":true,"lazy":true}}],staticClass:"form-control",attrs:{"type":"number","id":_vm.safeId('minutes')},domProps:{"value":(_vm.minutes)},on:{"change":function($event){_vm.minutes=_vm._n($event.target.value)},"blur":function($event){_vm.$forceUpdate()}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('record')}},[_vm._v("Athlete")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('record-select',{attrs:{"id":_vm.safeId('record'),"dataset-id":_vm.datasetId},model:{value:(_vm.recordId),callback:function ($$v) {_vm.recordId=$$v},expression:"recordId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('bibs')}},[_vm._v("BIBs")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.bibs),expression:"bibs",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('bibs')},domProps:{"value":(_vm.bibs)},on:{"change":function($event){_vm.bibs=$event.target.value}}})])])],1),_vm._v(" "),_c('window-tab',{attrs:{"title":"Data","icon":"database"}},[_c('album-select-group',{model:{value:(_vm.albumId),callback:function ($$v) {_vm.albumId=$$v},expression:"albumId"}}),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('datasetId')}},[_vm._v("Dataset")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('dataset-select',{attrs:{"id":_vm.safeId('datasetId')},model:{value:(_vm.datasetId),callback:function ($$v) {_vm.datasetId=$$v},expression:"datasetId"}})],1)]),_vm._v(" "),_vm._l((_vm.columnDefinitions),function(v,k){return _c('div',{key:k,staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId(k)}},[_vm._v(_vm._s(v))]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('column-select',{attrs:{"id":_vm.safeId(k),"value":_vm.columnMap[k],"dataset-id":_vm.datasetId},on:{"input":function (val) {
          _vm.columnMap[k] = val
          _vm.columnMap = _vm.columnMap
        }}})],1)])})],2),_vm._v(" "),_c('window-tab',{attrs:{"title":"Settings","icon":"cog"}},[_c('template-settings',{attrs:{"templateId":_vm.templateId}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_uiaa_lead_intermediate_standings_vue__ = __webpack_require__(1738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05c76f46_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_uiaa_lead_intermediate_standings_vue__ = __webpack_require__(1739);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_uiaa_lead_intermediate_standings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05c76f46_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_uiaa_lead_intermediate_standings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_action_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_mutation_types__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ui_record_select__ = __webpack_require__(171);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: { RecordSelect: __WEBPACK_IMPORTED_MODULE_7__ui_record_select__["a" /* default */] },
  name: 'uiaa-intermediate-standings',
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins__["b" /* templateMixin */]],
  data: function data() {
    return {
      localShow: 'time',
      columnDefinitions: {
        'bibNumber': 'Bib number',
        'lastName': 'Last name',
        'firstName': 'First name',
        'country': 'Country',
        'score': 'Score'
        // 'endTime': 'Time'
      },
      intermediateTimeMs: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$shortcut.bind('ctrl + i', function () {
      return _this.takeIm();
    });
    this.$shortcut.bind('ctrl + e', function () {
      return _this.takeEnd();
    });
    this.$shortcut.bind('ctrl + t', function () {
      return _this.takeTop();
    });
    this.$shortcut.bind('ctrl + c', function () {
      return _this.clear();
    });
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4__utils__["c" /* mapOverlayData */])({ 'titleTime': { default: 'CLIP' }, 'titleScore': { default: 'STANDINGS' } }), Object(__WEBPACK_IMPORTED_MODULE_4__utils__["c" /* mapOverlayData */])({ 'show': { default: 'time' } }), Object(__WEBPACK_IMPORTED_MODULE_4__utils__["c" /* mapOverlayData */])({ 'timeRecords': { default: [] }, 'rankRecords': { default: [] } }), Object(__WEBPACK_IMPORTED_MODULE_4__utils__["f" /* mapTemplateData */])(['clockId', 'datasetId', 'recordId', 'intermediateColumn']), Object(__WEBPACK_IMPORTED_MODULE_4__utils__["f" /* mapTemplateData */])({ 'titleTimeFormat': { default: 'CLIP #${IM} OF X' } }), Object(__WEBPACK_IMPORTED_MODULE_4__utils__["f" /* mapTemplateData */])({ columnMap: { default: {} } }), Object(__WEBPACK_IMPORTED_MODULE_4__utils__["g" /* mapTemplateOptions */])({ 'maxRecords': { type: Number, default: 12 } }), {
    score: {
      get: function get() {
        var _this2 = this;

        if (!this.dataset || !this.recordId) return null;
        var record = this.dataset.records.find(function (r) {
          return r.recordId === _this2.recordId;
        });
        if (!record) return null;
        return record[this.columnMap['score']];
      },
      set: function set(val) {
        this.updateCell(this.columnMap['score'], val);
      }
    },
    intermediateTime: function intermediateTime() {
      var _this3 = this;

      if (!this.dataset || !this.recordId) return null;
      var record = this.dataset.records.find(function (r) {
        return r.recordId === _this3.recordId;
      });
      if (!record) return null;
      return record[this.intermediateColumn];
    },
    dataset: function dataset() {
      if (!this.datasetId) return null;
      return this.$store.getters.dataset(this.datasetId);
    },
    records: function records() {
      var _this4 = this;

      var dataset = this.dataset;
      if (!dataset) return [];
      return [].concat(dataset.records.map(function (record) {
        var result = _this4.mapRecord(record, _this4.columnMap);
        // Map recordId to find current record after sorting and ranking
        result.recordId = record.recordId;
        // Map rawTime for further calculations
        result.rawTime = __WEBPACK_IMPORTED_MODULE_2__lib__["d" /* timeStrToInt */](result.time);
        result.timeDiff = result.time;
        result.active = record.recordId === _this4.recordId;
        return result;
      }));
    },
    timeRecords: function timeRecords() {
      var _this5 = this;

      var records = this.records.filter(function (each) {
        return each['time'];
      });
      records.sort(function (a, b) {
        return a.rawTime - b.rawTime;
      });
      // Calculate time diff to leader
      var leader = records.find(function (r) {
        return r.recordId !== _this5.recordId;
      });
      if (leader) {
        var baseRawTime = leader.rawTime;
        leader.timeDiff = leader.time;
        records.forEach(function (each) {
          if (each.recordId === leader.recordId) return each;
          each.timeDiff = __WEBPACK_IMPORTED_MODULE_2__lib__["b" /* formatTimeDiff */](each.rawTime - baseRawTime);
        });
      }
      return this.sliceRecords(records, this.recordId);
    },
    rankRecords: function rankRecords() {
      var records = this.records.filter(function (each) {
        return each['score'];
      });
      records.sort(function (a, b) {
        return __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* compare */].uiaaLeadScore(a['score'], b['score']);
      });

      // Rank records according to score
      records.forEach(Object(__WEBPACK_IMPORTED_MODULE_4__utils__["j" /* rank */])('rank', 'score'));
      return this.sliceRecords(records, this.recordId);
    },
    datasetColumns: function datasetColumns() {
      if (!this.dataset) return;
      return this.dataset.columns || [];
    }
  }),
  watch: {
    intermediateColumn: function intermediateColumn() {
      this.titleTime = this.titleTimeFormat.replace(/\${IM}/ig, this.intermediateColumn);
      this.show = 'time';
    },
    show: function show(val) {
      this.localShow = val;
    },
    timeRecords: function timeRecords(val) {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_5__store_action_types__["z" /* TEMPLATE_OVERLAY_DATA */], {
        templateId: this.templateId,
        data: { timeRecords: val }
      });
    },
    rankRecords: function rankRecords(val) {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_5__store_action_types__["z" /* TEMPLATE_OVERLAY_DATA */], {
        templateId: this.templateId,
        data: { rankRecords: val }
      });
    }
  },
  methods: {
    mapRecord: function mapRecord(record, columnMap) {
      columnMap['time'] = this.intermediateColumn;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(columnMap).reduce(function (result, key) {
        result[key] = record[columnMap[key]];
        return result;
      }, {});
    },
    takeIm: function takeIm() {
      this.show = 'time';
      this.updateIntermediate(this.getStopwatch(), this.intermediateColumn + '.000');
    },
    takeEnd: function takeEnd() {
      this.show = 'score';
      this.updateEnd(this.getStopwatch());
    },
    takeTop: function takeTop() {
      this.show = 'score';
      this.updateTop(this.getStopwatch());
    },
    clear: function clear() {
      this.updateCell(this.intermediateColumn, '');
    },
    getStopwatch: function getStopwatch() {
      var data = this.$store.getters.overlayData(this.clockId);
      if (!data || data === {}) return console.warn('[intermediate-standings] clock overlay data is empty');
      return new __WEBPACK_IMPORTED_MODULE_2__lib__["a" /* Stopwatch */](data);
    },
    updateIntermediate: function updateIntermediate(stopwatch, score) {
      var time = null;
      if (stopwatch) {
        var elapsed = new Date(stopwatch.elapsedMs);
        time = ('0' + elapsed.getMinutes()).slice(-2) + ':' + ('0' + elapsed.getSeconds()).slice(-2);
      }
      this.updateCell(this.intermediateColumn, time);
      // this.updateCell(this.columnMap['endTime'], time)
      this.updateCell('ENDTIME', time);
      this.updateCell(this.columnMap['score'], score);
    },
    updateEnd: function updateEnd(stopwatch) {
      if (!stopwatch) return;
      var elapsed = new Date(stopwatch.elapsedMs);
      var endTime = ('0' + elapsed.getMinutes()).slice(-2) + ':' + ('0' + elapsed.getSeconds()).slice(-2);
      // this.updateCell(this.columnMap['endTime'], endTime)
      this.updateCell('ENDTIME', endTime);
    },
    updateTop: function updateTop(stopwatch) {
      if (!stopwatch) return;
      var elapsed = new Date(stopwatch.elapsedMs);
      var endTime = ('0' + elapsed.getMinutes()).slice(-2) + ':' + ('0' + elapsed.getSeconds()).slice(-2);
      var score = 'TOP(' + elapsed.getMinutes() + '.' + ('0' + elapsed.getSeconds()).slice(-2) + ')';
      // this.updateCell(this.columnMap['endTime'], endTime)
      this.updateCell('ENDTIME', endTime);
      this.updateCell(this.columnMap['score'], score);
    },
    updateCell: function updateCell(column, value) {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_6__store_mutation_types__["r" /* DATASET_UPDATE_VALUE */], {
        datasetId: this.datasetId,
        recordId: this.recordId,
        column: column,
        value: value,
        emit: true
      });
    },
    sliceRecords: function sliceRecords(records, recordId) {
      var maxRecords = this.maxRecords;
      // Save index of current athlete
      var idx = records.findIndex(function (each) {
        return each.recordId === recordId;
      });

      // If current athlete is in top (maxRecords), return top (maxRecords)
      if (idx < maxRecords) {
        return records.slice(0, maxRecords);
      }

      // Otherwise return top (maxRecords - 1) with current athlete at the end
      var record = records[idx];
      records = records.slice(0, maxRecords - 1);
      records.push(record);
      return records;
    }
  }
});

/***/ }),
/* 1739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('window',{attrs:{"window-id":_vm.windowId}},[_c('window-tab',{attrs:{"title":_vm.windowTitle}},[_c('switch-buttons',{attrs:{"template-id":_vm.templateId}}),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('titleTimeFormat')}},[_vm._v("Title time")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.titleTimeFormat),expression:"titleTimeFormat",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('titleTimeFormat')},domProps:{"value":(_vm.titleTimeFormat)},on:{"change":function($event){_vm.titleTimeFormat=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('titleScore')}},[_vm._v("Title score")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.titleScore),expression:"titleScore",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('titleScore')},domProps:{"value":(_vm.titleScore)},on:{"change":function($event){_vm.titleScore=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('record')}},[_vm._v("Athlete")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('record-select',{attrs:{"id":_vm.safeId('record'),"dataset-id":_vm.datasetId},model:{value:(_vm.recordId),callback:function ($$v) {_vm.recordId=$$v},expression:"recordId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('intermediateColumn')}},[_vm._v("Intermediate")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy.number",value:(_vm.intermediateColumn),expression:"intermediateColumn",modifiers:{"lazy":true,"number":true}}],staticClass:"form-control",attrs:{"type":"number","id":_vm.safeId('intermediateColumn'),"min":"1"},domProps:{"value":(_vm.intermediateColumn)},on:{"change":function($event){_vm.intermediateColumn=_vm._n($event.target.value)},"blur":function($event){_vm.$forceUpdate()}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label"},[_vm._v("Time")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"mt-1 btn-group btn-group-justified"},[_c('button',{staticClass:"btn btn-primary",attrs:{"title":"Ctrl + I"},on:{"click":function($event){_vm.takeIm()}}},[_vm._v("IM\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"title":"Ctrl + E"},on:{"click":function($event){_vm.takeEnd()}}},[_vm._v("END\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",attrs:{"title":"Ctrl + T"},on:{"click":function($event){_vm.takeTop()}}},[_vm._v("TOP\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-warning",attrs:{"title":"Ctrl + C"},on:{"click":function($event){_vm.clear()}}},[_vm._v("CLR\n          ")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label"},[_vm._v("IM: "+_vm._s(_vm.intermediateColumn || 'IM?'))]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{staticClass:"form-control-plaintext",attrs:{"type":"text","readonly":""},domProps:{"value":_vm.intermediateTime}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label"},[_vm._v("Score")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.score),expression:"score",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.score)},on:{"change":function($event){_vm.score=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label"},[_vm._v("Show")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.show),expression:"show"}],staticClass:"form-check-input",attrs:{"type":"radio","name":_vm.safeId('show'),"value":"time"},domProps:{"checked":_vm._q(_vm.show,"time")},on:{"change":function($event){_vm.show="time"}}}),_vm._v("Time")])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.show),expression:"show"}],staticClass:"form-check-input",attrs:{"type":"radio","name":_vm.safeId('show'),"value":"score"},domProps:{"checked":_vm._q(_vm.show,"score")},on:{"change":function($event){_vm.show="score"}}}),_vm._v("Score")])])])])],1),_vm._v(" "),_c('window-tab',{attrs:{"title":"Data","icon":"database"}},[_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('clockId')}},[_vm._v("Clock")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('template-select',{attrs:{"id":_vm.safeId('clockId')},model:{value:(_vm.clockId),callback:function ($$v) {_vm.clockId=$$v},expression:"clockId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('datasetId')}},[_vm._v("Dataset")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('dataset-select',{attrs:{"id":_vm.safeId('datasetId')},model:{value:(_vm.datasetId),callback:function ($$v) {_vm.datasetId=$$v},expression:"datasetId"}})],1)]),_vm._v(" "),_vm._l((_vm.columnDefinitions),function(v,k){return _c('div',{key:k,staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId(k)}},[_vm._v(_vm._s(v))]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('column-select',{attrs:{"id":_vm.safeId(k),"value":_vm.columnMap[k],"dataset-id":_vm.datasetId},on:{"input":function (val) {
          _vm.columnMap[k] = val
          _vm.columnMap = _vm.columnMap
        }}})],1)])})],2),_vm._v(" "),_c('window-tab',{attrs:{"title":"Settings","icon":"cog"}},[_c('template-settings',{attrs:{"templateId":_vm.templateId}},[_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('maxRecords')}},[_vm._v("Max records")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.maxRecords),expression:"maxRecords",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"number","id":_vm.safeId('maxRecords')},domProps:{"value":(_vm.maxRecords)},on:{"change":function($event){_vm.maxRecords=$event.target.value}}})])])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_uiaa_speed_intermediate_standings_vue__ = __webpack_require__(1741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60329d2a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_uiaa_speed_intermediate_standings_vue__ = __webpack_require__(1742);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_uiaa_speed_intermediate_standings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60329d2a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_uiaa_speed_intermediate_standings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_max_safe_integer__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_max_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_max_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_action_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_mutation_types__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ui_record_select__ = __webpack_require__(171);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








function formatTimeDiff(ms) {
  var time = ms < 0 ? new Date(-ms) : new Date(ms);
  var result = '';
  if (time.getMinutes() > 0) {
    result = time.getMinutes() + ':' + ('0' + time.getSeconds()).slice(-2);
  } else {
    result = time.getSeconds() + '.' + ('00' + time.getMilliseconds()).slice(-3, -1);
  }
  result = (ms < 0 ? '-' : '+') + result;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  components: { RecordSelect: __WEBPACK_IMPORTED_MODULE_8__ui_record_select__["a" /* default */] },
  name: 'uiaa-speed-intermediate-standings',
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins__["b" /* templateMixin */]],
  data: function data() {
    return {
      columnDefinitions: {
        'bibNumber': 'Bib number',
        'lastName': 'Name',
        'country': 'Country',
        'attempt1': 'Attempt 1',
        'attempt2': 'Attempt 2',
        'attempt3': 'Attempt 3',
        'best': 'Best'
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5__utils__["c" /* mapOverlayData */])(['title']), Object(__WEBPACK_IMPORTED_MODULE_5__utils__["c" /* mapOverlayData */])({ 'records': { default: [] } }), Object(__WEBPACK_IMPORTED_MODULE_5__utils__["f" /* mapTemplateData */])(['clockId', 'datasetId', 'recordId']), Object(__WEBPACK_IMPORTED_MODULE_5__utils__["f" /* mapTemplateData */])({ columnMap: { default: {} } }), Object(__WEBPACK_IMPORTED_MODULE_5__utils__["g" /* mapTemplateOptions */])({ 'maxRecords': { type: Number, default: 12 } }), {
    dataset: function dataset() {
      if (!this.datasetId) return null;
      return this.$store.getters.dataset(this.datasetId);
    },
    records: function records() {
      var _this = this;

      var dataset = this.dataset;
      if (!dataset) return [];
      return [].concat(dataset.records.map(function (record) {
        var result = _this.mapRecord(record, _this.columnMap);
        // Map recordId to find current record after sorting and ranking
        result.recordId = record.recordId;
        // Map rawTime for further calculations
        result.rawTime = __WEBPACK_IMPORTED_MODULE_3__lib__["d" /* timeStrToInt */](result.best) || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_max_safe_integer___default.a;
        result.timeDiff = result.best;
        result.active = record.recordId === _this.recordId;
        return result;
      }));
    },
    timeRecords: function timeRecords() {
      var _this2 = this;

      var records = this.records.filter(function (each) {
        return each.attempt1;
      });
      records.sort(function (a, b) {
        return a.rawTime - b.rawTime;
      });
      // Calculate time diff to leader
      var leader = records.find(function (r) {
        return r.recordId !== _this2.recordId;
      });
      if (leader) {
        var baseRawTime = leader.rawTime;
        leader.timeDiff = leader.best;
        records.forEach(function (each) {
          if (each.recordId === leader.recordId) return each;
          if (each.rawTime === __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_max_safe_integer___default.a) {
            each.timeDiff = 'DNF';
          } else {
            each.timeDiff = formatTimeDiff(each.rawTime - baseRawTime);
          }
        });
      }
      // Rank records according to score
      records.forEach(Object(__WEBPACK_IMPORTED_MODULE_5__utils__["j" /* rank */])('rank', 'rawTime'));
      return this.sliceRecords(records, this.recordId);
    },
    record: function record() {
      var _this3 = this;

      if (!this.dataset || !this.recordId) return null;
      return this.dataset.records.find(function (r) {
        return r.recordId === _this3.recordId;
      });
    },

    attempt1: {
      get: function get() {
        if (!this.record) return null;
        return this.record[this.columnMap['attempt1']];
      },
      set: function set(val) {
        this.updateCell(this.columnMap['attempt1'], val);
        this.setBest(val, this.attempt2, this.attempt3);
      }
    },
    attempt2: {
      get: function get() {
        if (!this.record) return null;
        return this.record[this.columnMap['attempt2']];
      },
      set: function set(val) {
        this.updateCell(this.columnMap['attempt2'], val);
        this.setBest(this.attempt1, val, this.attempt3);
      }
    },
    attempt3: {
      get: function get() {
        if (!this.record) return null;
        return this.record[this.columnMap['attempt3']];
      },
      set: function set(val) {
        this.updateCell(this.columnMap['attempt3'], val);
        this.setBest(this.attempt1, this.attempt2, val);
      }
    },
    best: {
      get: function get() {
        if (!this.record) return null;
        return this.record[this.columnMap['best']];
      },
      set: function set(val) {
        this.updateCell(this.columnMap['best'], val);
      }
    }
  }),
  watch: {
    timeRecords: function timeRecords(val) {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_6__store_action_types__["z" /* TEMPLATE_OVERLAY_DATA */], {
        templateId: this.templateId,
        data: { records: val }
      });
    }
  },
  methods: {
    formatTime: function formatTime(ms) {
      console.log('formatTime', ms);
      if (ms <= 0 || ms === __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_max_safe_integer___default.a) return 'DNF';
      var date = new Date(ms);
      if (date.getMinutes() > 0) {
        return date.getMinutes() + ':' + ('0' + date.getSeconds()).slice(-2) + '.' + ('00' + date.getMilliseconds()).slice(-3, -1);
      } else {
        return date.getSeconds() + '.' + ('00' + date.getMilliseconds()).slice(-3, -1);
      }
    },
    take: function take(attempt) {
      this['attempt' + attempt] = this.formatTime(this.getElapsedMs());
    },
    dnf: function dnf(attempt) {
      this['attempt' + attempt] = '-';
    },
    clr: function clr(attempt) {
      this['attempt' + attempt] = '';
    },
    setBest: function setBest(a1, a2, a3) {
      a1 = __WEBPACK_IMPORTED_MODULE_3__lib__["d" /* timeStrToInt */](a1) || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_max_safe_integer___default.a;
      a2 = __WEBPACK_IMPORTED_MODULE_3__lib__["d" /* timeStrToInt */](a2) || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_max_safe_integer___default.a;
      a3 = __WEBPACK_IMPORTED_MODULE_3__lib__["d" /* timeStrToInt */](a3) || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_max_safe_integer___default.a;
      var best = Math.min(a1, Math.min(a2, a3));
      this.best = this.formatTime(best);
    },
    getElapsedMs: function getElapsedMs() {
      var data = this.$store.getters.overlayData(this.clockId);
      if (!data || data === {}) return console.warn('[intermediate-standings] clock overlay data is empty');
      var stopwatch = new __WEBPACK_IMPORTED_MODULE_3__lib__["a" /* Stopwatch */](data);
      return stopwatch.elapsedMs;
    },
    mapRecord: function mapRecord(record, columnMap) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(columnMap).reduce(function (result, key) {
        result[key] = record[columnMap[key]];
        return result;
      }, {});
    },
    updateCell: function updateCell(column, value) {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_7__store_mutation_types__["r" /* DATASET_UPDATE_VALUE */], {
        datasetId: this.datasetId,
        recordId: this.recordId,
        column: column,
        value: value,
        emit: true
      });
    },
    sliceRecords: function sliceRecords(records, recordId) {
      var maxRecords = this.maxRecords;
      // Save index of current athlete
      var idx = records.findIndex(function (each) {
        return each.recordId === recordId;
      });

      // If current athlete is in top (maxRecords), return top (maxRecords)
      if (idx < maxRecords) {
        return records.slice(0, maxRecords);
      }

      // Otherwise return top (maxRecords - 1) with current athlete at the end
      var record = records[idx];
      records = records.slice(0, maxRecords - 1);
      records.push(record);
      return records;
    }
  }
});

/***/ }),
/* 1742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('window',{attrs:{"window-id":_vm.windowId}},[_c('window-tab',{attrs:{"title":_vm.windowTitle}},[_c('switch-buttons',{attrs:{"template-id":_vm.templateId}}),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('title')}},[_vm._v("Title")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.title),expression:"title",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('title')},domProps:{"value":(_vm.title)},on:{"change":function($event){_vm.title=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('record')}},[_vm._v("Athlete")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('record-select',{attrs:{"id":_vm.safeId('record'),"dataset-id":_vm.datasetId},model:{value:(_vm.recordId),callback:function ($$v) {_vm.recordId=$$v},expression:"recordId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('attempt1')}},[_vm._v("Attempt 1")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.attempt1),expression:"attempt1",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('attempt1')},domProps:{"value":(_vm.attempt1)},on:{"change":function($event){_vm.attempt1=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"mt-1 btn-group btn-group-justified"},[_c('button',{staticClass:"btn btn-success",on:{"click":function($event){_vm.take(1)}}},[_vm._v("TAKE")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",on:{"click":function($event){_vm.dnf(1)}}},[_vm._v("DNF")]),_vm._v(" "),_c('button',{staticClass:"btn btn-warning",on:{"click":function($event){_vm.clr(1)}}},[_vm._v("CLR")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('attempt2')}},[_vm._v("Attempt 1")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.attempt2),expression:"attempt2",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('attempt2')},domProps:{"value":(_vm.attempt2)},on:{"change":function($event){_vm.attempt2=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"mt-1 btn-group btn-group-justified"},[_c('button',{staticClass:"btn btn-success",on:{"click":function($event){_vm.take(2)}}},[_vm._v("TAKE")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",on:{"click":function($event){_vm.dnf(2)}}},[_vm._v("DNF")]),_vm._v(" "),_c('button',{staticClass:"btn btn-warning",on:{"click":function($event){_vm.clr(2)}}},[_vm._v("CLR")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('attempt3')}},[_vm._v("Attempt 1")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.attempt3),expression:"attempt3",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('attempt3')},domProps:{"value":(_vm.attempt3)},on:{"change":function($event){_vm.attempt3=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"mt-1 btn-group btn-group-justified"},[_c('button',{staticClass:"btn btn-success",on:{"click":function($event){_vm.take(3)}}},[_vm._v("TAKE")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",on:{"click":function($event){_vm.dnf(3)}}},[_vm._v("DNF")]),_vm._v(" "),_c('button',{staticClass:"btn btn-warning",on:{"click":function($event){_vm.clr(3)}}},[_vm._v("CLR")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('best')}},[_vm._v("Best")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.best),expression:"best",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('best')},domProps:{"value":(_vm.best)},on:{"change":function($event){_vm.best=$event.target.value}}})])])],1),_vm._v(" "),_c('window-tab',{attrs:{"title":"Data","icon":"database"}},[_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('clockId')}},[_vm._v("Clock")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('template-select',{attrs:{"id":_vm.safeId('clockId')},model:{value:(_vm.clockId),callback:function ($$v) {_vm.clockId=$$v},expression:"clockId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('datasetId')}},[_vm._v("Dataset")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('dataset-select',{attrs:{"id":_vm.safeId('datasetId')},model:{value:(_vm.datasetId),callback:function ($$v) {_vm.datasetId=$$v},expression:"datasetId"}})],1)]),_vm._v(" "),_vm._l((_vm.columnDefinitions),function(v,k){return _c('div',{key:k,staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId(k)}},[_vm._v(_vm._s(v))]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('column-select',{attrs:{"id":_vm.safeId(k),"value":_vm.columnMap[k],"dataset-id":_vm.datasetId},on:{"input":function (val) {
          _vm.columnMap[k] = val
          _vm.columnMap = _vm.columnMap
        }}})],1)])})],2),_vm._v(" "),_c('window-tab',{attrs:{"title":"Settings","icon":"cog"}},[_c('template-settings',{attrs:{"templateId":_vm.templateId}},[_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('maxRecords')}},[_vm._v("Max records")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.maxRecords),expression:"maxRecords",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"number","id":_vm.safeId('maxRecords')},domProps:{"value":(_vm.maxRecords)},on:{"change":function($event){_vm.maxRecords=$event.target.value}}})])])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_knockout_vue__ = __webpack_require__(1744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_412b3c32_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_knockout_vue__ = __webpack_require__(1745);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_knockout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_412b3c32_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_knockout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_action_types__ = __webpack_require__(5);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'knockout',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins__["b" /* templateMixin */]],
  data: function data() {
    return {
      columnDefinitions: {
        'round': 'Runde',
        'group': 'Group',
        'bibNumber': 'Startnummer',
        'lastName': 'Nachname',
        'firstName': 'Vorname',
        'country': 'Country',
        'rank': 'Rang',
        'score': 'Wertung'
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3__utils__["c" /* mapOverlayData */])(['title', 'rounds']), Object(__WEBPACK_IMPORTED_MODULE_3__utils__["c" /* mapOverlayData */])({ 'records': { default: [] } }), Object(__WEBPACK_IMPORTED_MODULE_3__utils__["f" /* mapTemplateData */])(['albumId', 'datasetId']), Object(__WEBPACK_IMPORTED_MODULE_3__utils__["f" /* mapTemplateData */])({ columnMap: { default: {} } }), {
    records: function records() {
      var _this = this;

      var dataset = this.$store.getters.dataset(this.datasetId);
      if (!dataset) return [];
      return dataset.records.map(function (record) {
        return _this.mapRecord(record, _this.columnMap);
      });
    }
  }),
  watch: {
    records: function records(val) {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__store_action_types__["z" /* TEMPLATE_OVERLAY_DATA */], {
        templateId: this.templateId,
        data: { records: val }
      });
    },
    albumId: function albumId(val) {
      var album = this.$store.getters.album(this.albumId) || {};
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__store_action_types__["z" /* TEMPLATE_OVERLAY_DATA */], {
        templateId: this.templateId,
        data: { sponsors: album.pictures }
      });
    }
  },
  methods: {
    mapRecord: function mapRecord(record, columnMap) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(columnMap).reduce(function (result, key) {
        result[key] = record[columnMap[key]];
        return result;
      }, {});
    }
  }
});

/***/ }),
/* 1745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('window',{attrs:{"window-id":_vm.windowId}},[_c('window-tab',{attrs:{"title":_vm.windowTitle}},[_c('switch-buttons',{attrs:{"template-id":_vm.templateId}}),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('title')}},[_vm._v("Title")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.title),expression:"title",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('title')},domProps:{"value":(_vm.title)},on:{"change":function($event){_vm.title=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('rounds')}},[_vm._v("Rounds")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.rounds),expression:"rounds",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"number","id":_vm.safeId('rounds')},domProps:{"value":(_vm.rounds)},on:{"change":function($event){_vm.rounds=$event.target.value}}})])]),_vm._v(" "),_c('table-edit',{attrs:{"cols":_vm.columnDefinitions,"rows":_vm.records}})],1),_vm._v(" "),_c('window-tab',{attrs:{"title":"Data","icon":"database"}},[_c('album-select-group',{model:{value:(_vm.albumId),callback:function ($$v) {_vm.albumId=$$v},expression:"albumId"}}),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('datasetId')}},[_vm._v("Dataset")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('dataset-select',{attrs:{"id":_vm.safeId('datasetId')},model:{value:(_vm.datasetId),callback:function ($$v) {_vm.datasetId=$$v},expression:"datasetId"}})],1)]),_vm._v(" "),_vm._l((_vm.columnDefinitions),function(v,k){return _c('div',{key:k,staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId(k)}},[_vm._v(_vm._s(v))]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('column-select',{attrs:{"id":_vm.safeId(k),"value":_vm.columnMap[k],"dataset-id":_vm.datasetId},on:{"input":function (val) {
          _vm.columnMap[k] = val
          _vm.columnMap = _vm.columnMap
        }}})],1)])})],2),_vm._v(" "),_c('window-tab',{attrs:{"title":"Settings","icon":"cog"}},[_c('template-settings',{attrs:{"templateId":_vm.templateId}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loopic_template_vue__ = __webpack_require__(1747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_93ad7ff6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_loopic_template_vue__ = __webpack_require__(1748);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loopic_template_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_93ad7ff6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_loopic_template_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_action_types__ = __webpack_require__(5);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'loopic-template',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins__["b" /* templateMixin */]],
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3__utils__["f" /* mapTemplateData */])({ data: { default: {} } }), Object(__WEBPACK_IMPORTED_MODULE_3__utils__["g" /* mapTemplateOptions */])(['schema']), {
    properties: function properties() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.schema.properties).map(function (key) {
        return {
          _key: key,
          label: _this.schema.properties[key].label,
          type: _this.schema.properties[key].type,
          description: _this.schema.properties[key].description,
          default: _this.schema.properties[key].default,
          gddType: _this.schema.properties[key].gddType
        };
      });
    }
  }),
  watch: {},
  methods: {
    updateProperty: function updateProperty(key) {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__store_action_types__["s" /* TEMPLATE_DATA */], {
        templateId: this.templateId,
        data: { data: this.data }
      });
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__store_action_types__["z" /* TEMPLATE_OVERLAY_DATA */], {
        templateId: this.templateId,
        data: this.data
      });
    }
  }
});

/***/ }),
/* 1748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('window',{attrs:{"window-id":_vm.windowId}},[_c('window-tab',{attrs:{"title":_vm.windowTitle}},[_c('switch-buttons',{attrs:{"template-id":_vm.templateId}}),_vm._v(" "),_vm._l((_vm.properties),function(property,index){return _c('div',{key:property._key,staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId(property._key)}},[_vm._v(_vm._s(property.label))]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.data[property._key]),expression:"data[property._key]",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId(property._key)},domProps:{"value":(_vm.data[property._key])},on:{"change":[function($event){_vm.$set(_vm.data, property._key, $event.target.value)},function($event){_vm.updateProperty(property._key)}]}})])])})],2),_vm._v(" "),_c('window-tab',{attrs:{"title":"Data","icon":"database"}}),_vm._v(" "),_c('window-tab',{attrs:{"title":"Settings","icon":"cog"}},[_c('template-settings',{attrs:{"template-id":_vm.templateId}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pdf_presentation_vue__ = __webpack_require__(1750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1dce5fdc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pdf_presentation_vue__ = __webpack_require__(1751);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pdf_presentation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1dce5fdc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pdf_presentation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_action_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_index__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'pdf-presentation',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins__["b" /* templateMixin */]],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3__utils_index__["c" /* mapOverlayData */])(['url']), Object(__WEBPACK_IMPORTED_MODULE_3__utils_index__["f" /* mapTemplateData */])(['albumId', 'imageId']), {
    accountId: function accountId() {
      var selectedAccount = this.$store.getters.selectedAccount;
      return selectedAccount ? selectedAccount.accountId : '';
    },
    presenterUrl: function presenterUrl() {
      var baseUrl = (this.$env.WEBCG_API || '').replace(/ws(s)?:\/\//, 'http$1://');
      var layer = this.$store.getters.template(this.templateId).layer || 0;
      return baseUrl + '/presenter/' + this.accountId + '/' + layer;
    }
  }),
  watch: {
    imageId: function imageId() {
      var image = this.$store.getters.picture(this.albumId, this.imageId) || null;
      if (!image) return;
      var baseUrl = (this.$env.WEBCG_API || '').replace(/ws(s)?:\/\//, 'http$1://');
      this.url = baseUrl + '/v0/users/' + this.accountId + '/files/' + image.pictureId;
    }
  },
  methods: {
    first: function first() {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_action_types__["i" /* COMMAND_INVOKE */], {
        templateId: this.templateId,
        channelId: 'program',
        func: 'first()'
      });
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_action_types__["i" /* COMMAND_INVOKE */], {
        templateId: this.templateId,
        channelId: 'preview',
        func: 'first()'
      });
    },
    prev: function prev() {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_action_types__["i" /* COMMAND_INVOKE */], { templateId: this.templateId, channelId: 'program', func: 'prev()' });
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_action_types__["i" /* COMMAND_INVOKE */], { templateId: this.templateId, channelId: 'preview', func: 'prev()' });
    },
    next: function next() {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_action_types__["j" /* COMMAND_NEXT */], { templateId: this.templateId, channelId: 'program' });
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_action_types__["j" /* COMMAND_NEXT */], { templateId: this.templateId, channelId: 'preview' });
    },
    last: function last() {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_action_types__["i" /* COMMAND_INVOKE */], { templateId: this.templateId, channelId: 'program', func: 'last()' });
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_action_types__["i" /* COMMAND_INVOKE */], { templateId: this.templateId, channelId: 'preview', func: 'last()' });
    }
  }
});

/***/ }),
/* 1751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('window',{attrs:{"window-id":_vm.windowId}},[_c('window-tab',{attrs:{"title":_vm.windowTitle}},[_c('switch-buttons',{attrs:{"template-id":_vm.templateId}}),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"btn-group btn-group-justified"},[_c('button',{staticClass:"btn btn-outline-secondary",attrs:{"type":"button"},on:{"click":_vm.prev}},[_vm._v("Prev")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":_vm.next}},[_vm._v("Next")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"btn-group btn-group-justified"},[_c('button',{staticClass:"btn btn-outline-secondary",attrs:{"type":"button"},on:{"click":_vm.first}},[_vm._v("First")]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-secondary",attrs:{"type":"button"},on:{"click":_vm.last}},[_vm._v("Last")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('div',{staticClass:"col-12"},[_c('p',{staticStyle:{"text-align":"center"}},[_vm._v("Presenter: "),_c('a',{attrs:{"href":_vm.presenterUrl,"target":"_blank"}},[_vm._v(_vm._s(_vm.presenterUrl))])])])])],1),_vm._v(" "),_c('window-tab',{attrs:{"title":"Data","icon":"database"}},[_c('album-select-group',{attrs:{"label":"Album"},model:{value:(_vm.albumId),callback:function ($$v) {_vm.albumId=$$v},expression:"albumId"}}),_vm._v(" "),_c('picture-select-group',{attrs:{"album-id":_vm.albumId,"label":"PDF"},model:{value:(_vm.imageId),callback:function ($$v) {_vm.imageId=$$v},expression:"imageId"}}),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('url')}},[_vm._v("URL")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.url),expression:"url",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('url')},domProps:{"value":(_vm.url)},on:{"change":function($event){_vm.url=$event.target.value}}})])])],1),_vm._v(" "),_c('window-tab',{attrs:{"title":"Settings","icon":"cog"}},[_c('template-settings',{attrs:{"templateId":_vm.templateId}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_polling_results_vue__ = __webpack_require__(1753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e7baf34_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_polling_results_vue__ = __webpack_require__(1754);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_polling_results_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e7baf34_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_polling_results_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_action_types__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'polling-results',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins__["b" /* templateMixin */]],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2__utils__["c" /* mapOverlayData */])(['pollId', 'title']), Object(__WEBPACK_IMPORTED_MODULE_2__utils__["c" /* mapOverlayData */])({
    'labels': { type: Array, default: [] },
    'colors': { type: Array, default: [] }
  })),
  methods: {
    updateLabels: function updateLabels() {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__store_action_types__["z" /* TEMPLATE_OVERLAY_DATA */], {
        templateId: this.templateId,
        data: {
          labels: this.labels
        }
      });
    },
    updateColors: function updateColors() {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__store_action_types__["z" /* TEMPLATE_OVERLAY_DATA */], {
        templateId: this.templateId,
        data: {
          colors: this.colors
        }
      });
    }
  }
});

/***/ }),
/* 1754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('window',{attrs:{"window-id":_vm.windowId}},[_c('window-tab',{attrs:{"title":_vm.windowTitle}},[_c('switch-buttons',{attrs:{"template-id":_vm.templateId}}),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('pollId')}},[_vm._v("Poll ID")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.pollId),expression:"pollId",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('pollId')},domProps:{"value":(_vm.pollId)},on:{"change":function($event){_vm.pollId=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('title')}},[_vm._v("Title")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.title),expression:"title",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('title')},domProps:{"value":(_vm.title)},on:{"change":function($event){_vm.title=$event.target.value}}})])]),_vm._v(" "),_vm._l((10),function(n){return _c('div',{key:n},[_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('label' + (n - 1))}},[_vm._v("Label "+_vm._s(n))]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.labels[n - 1]),expression:"labels[n - 1]"}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('label' + (n - 1))},domProps:{"value":(_vm.labels[n - 1])},on:{"change":function($event){_vm.updateLabels()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.labels, n - 1, $event.target.value)}}})])]),_vm._v(" "),_c('color-select-group',{attrs:{"label":'Color ' + n},on:{"change":function($event){_vm.updateColors()}},model:{value:(_vm.colors[n - 1]),callback:function ($$v) {_vm.$set(_vm.colors, n - 1, $$v)},expression:"colors[n - 1]"}})],1)})],2),_vm._v(" "),_c('window-tab',{attrs:{"title":"Settings","icon":"cog"}},[_c('template-settings',{attrs:{"template-id":_vm.templateId}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_polling_results_list_vue__ = __webpack_require__(1756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ac971d4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_polling_results_list_vue__ = __webpack_require__(1757);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_polling_results_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ac971d4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_polling_results_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'polling-results-list',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins__["b" /* templateMixin */]],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2__utils__["c" /* mapOverlayData */])(['pollId', 'title']))
});

/***/ }),
/* 1757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('window',{attrs:{"window-id":_vm.windowId}},[_c('window-tab',{attrs:{"title":_vm.windowTitle}},[_c('switch-buttons',{attrs:{"template-id":_vm.templateId}}),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('pollId')}},[_vm._v("Poll ID")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.pollId),expression:"pollId",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('pollId')},domProps:{"value":(_vm.pollId)},on:{"change":function($event){_vm.pollId=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('title')}},[_vm._v("Title")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.title),expression:"title",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('title')},domProps:{"value":(_vm.title)},on:{"change":function($event){_vm.title=$event.target.value}}})])])],1),_vm._v(" "),_c('window-tab',{attrs:{"title":"Settings","icon":"cog"}},[_c('template-settings',{attrs:{"template-id":_vm.templateId}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ranking_list_vue__ = __webpack_require__(1759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d0c225d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ranking_list_vue__ = __webpack_require__(1760);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ranking_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d0c225d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ranking_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_action_types__ = __webpack_require__(5);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





function filterNegativeResults(enabled) {
  return function (record) {
    return !enabled || !String(record.score).match('-.+');
  };
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ranking-list',
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins__["b" /* templateMixin */]],
  data: function data() {
    return {
      columnDefinitions: {
        'bibNumber': 'Bib number',
        'lastName': 'Last name',
        'firstName': 'First name',
        'country': 'Country',
        'club': 'Club',
        'rank': 'Rank',
        'score': 'Score',
        'diff': 'Diff',
        'qualified': 'Qualified',
        'windSpeed': 'Wind speed'
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4__utils__["c" /* mapOverlayData */])(['title', 'subtitle']), Object(__WEBPACK_IMPORTED_MODULE_4__utils__["c" /* mapOverlayData */])({ 'records': { default: [] } }), Object(__WEBPACK_IMPORTED_MODULE_4__utils__["c" /* mapOverlayData */])(['topLeftImage', 'topRightImage']), Object(__WEBPACK_IMPORTED_MODULE_4__utils__["d" /* mapOverlayOptions */])({
    pageIntervalSecs: { default: 0 },
    itemsPerPage: { default: 8 },
    filterOutOfOrderRanks: { default: true },
    autoDispatch: { default: false }
  }), Object(__WEBPACK_IMPORTED_MODULE_4__utils__["f" /* mapTemplateData */])(['sponsorsAlbumId', 'datasetId']), Object(__WEBPACK_IMPORTED_MODULE_4__utils__["f" /* mapTemplateData */])(['logosAlbumId', 'topLeftImageId', 'topRightImageId']), Object(__WEBPACK_IMPORTED_MODULE_4__utils__["f" /* mapTemplateData */])({ columnMap: { default: {} } }), Object(__WEBPACK_IMPORTED_MODULE_4__utils__["g" /* mapTemplateOptions */])(['filterNegativeResults']), {
    records: function records() {
      var _this = this;

      var dataset = this.$store.getters.dataset(this.datasetId);
      if (!dataset) return [];
      var records = [].concat(dataset.records);
      records.sort(function (a, b) {
        return parseInt(a.SORT_ORDER) - parseInt(b.SORT_ORDER);
      });
      return records.map(function (record) {
        return _this.mapRecord(record, _this.columnMap);
      }).filter(filterNegativeResults(this.filterNegativeResults));
    }
  }),
  watch: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    records: function records(val) {
      var records = val.map(function (record, idx) {
        record = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, record);
        while (('' + record['score']).startsWith('00:')) {
          record['score'] = ('' + record['score']).substring(3);
        }
        if (idx > 0) {
          if (record['diff']) {
            var firstChar = record['diff'][0];
            record['score'] = (['+', '-', '.'].indexOf(firstChar) < 0 ? '+' : '') + record['diff'];
          }
        }
        return record;
      });
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_5__store_action_types__["z" /* TEMPLATE_OVERLAY_DATA */], {
        templateId: this.templateId,
        data: { records: records }
      });
      if (this.autoDispatch) {
        this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_5__store_action_types__["k" /* COMMAND_UPDATE */], {
          templateId: this.templateId, channelId: 'program'
        });
      }
    },
    sponsorsAlbumId: function sponsorsAlbumId(val) {
      var album = this.$store.getters.album(val) || {};
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_5__store_action_types__["z" /* TEMPLATE_OVERLAY_DATA */], {
        templateId: this.templateId,
        data: { sponsors: album.pictures }
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_4__utils__["b" /* mapImageIdToImage */])('logosAlbumId', 'topLeftImageId', 'topLeftImage'), Object(__WEBPACK_IMPORTED_MODULE_4__utils__["b" /* mapImageIdToImage */])('logosAlbumId', 'topRightImageId', 'topRightImage')),
  methods: {
    mapRecord: function mapRecord(record, columnMap) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(columnMap).reduce(function (result, key) {
        result[key] = record[columnMap[key]];
        return result;
      }, {});
    }
  }
});

/***/ }),
/* 1760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('window',{attrs:{"window-id":_vm.windowId}},[_c('window-tab',{attrs:{"title":_vm.windowTitle}},[_c('switch-buttons',{attrs:{"template-id":_vm.templateId}}),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('title')}},[_vm._v("Title")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.title),expression:"title",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('title')},domProps:{"value":(_vm.title)},on:{"change":function($event){_vm.title=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('subtitle')}},[_vm._v("Subtitle")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.subtitle),expression:"subtitle",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('subtitle')},domProps:{"value":(_vm.subtitle)},on:{"change":function($event){_vm.subtitle=$event.target.value}}})])]),_vm._v(" "),_c('table-edit',{attrs:{"cols":_vm.columnDefinitions,"rows":_vm.records}})],1),_vm._v(" "),_c('window-tab',{attrs:{"title":"Data","icon":"database"}},[_c('album-select-group',{model:{value:(_vm.sponsorsAlbumId),callback:function ($$v) {_vm.sponsorsAlbumId=$$v},expression:"sponsorsAlbumId"}}),_vm._v(" "),_c('album-select-group',{attrs:{"label":"Logos"},model:{value:(_vm.logosAlbumId),callback:function ($$v) {_vm.logosAlbumId=$$v},expression:"logosAlbumId"}}),_vm._v(" "),_c('picture-select-group',{attrs:{"album-id":_vm.logosAlbumId,"label":"Top left image"},model:{value:(_vm.topLeftImageId),callback:function ($$v) {_vm.topLeftImageId=$$v},expression:"topLeftImageId"}}),_vm._v(" "),_c('picture-select-group',{attrs:{"album-id":_vm.logosAlbumId,"label":"Top right image"},model:{value:(_vm.topRightImageId),callback:function ($$v) {_vm.topRightImageId=$$v},expression:"topRightImageId"}}),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('datasetId')}},[_vm._v("Dataset")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('dataset-select',{attrs:{"id":_vm.safeId('datasetId')},model:{value:(_vm.datasetId),callback:function ($$v) {_vm.datasetId=$$v},expression:"datasetId"}})],1)]),_vm._v(" "),_vm._l((_vm.columnDefinitions),function(v,k){return _c('div',{key:k,staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId(k)}},[_vm._v(_vm._s(v))]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('column-select',{attrs:{"id":_vm.safeId(k),"value":_vm.columnMap[k],"dataset-id":_vm.datasetId},on:{"input":function (val) {
          _vm.columnMap[k] = val
          _vm.columnMap = _vm.columnMap
        }}})],1)])})],2),_vm._v(" "),_c('window-tab',{attrs:{"title":"Settings","icon":"cog"}},[_c('template-settings',{attrs:{"templateId":_vm.templateId}},[_c('number-input-group',{attrs:{"label":"Page interval (s)"},model:{value:(_vm.pageIntervalSecs),callback:function ($$v) {_vm.pageIntervalSecs=$$v},expression:"pageIntervalSecs"}}),_vm._v(" "),_c('number-input-group',{attrs:{"label":"Items per page"},model:{value:(_vm.itemsPerPage),callback:function ($$v) {_vm.itemsPerPage=$$v},expression:"itemsPerPage"}}),_vm._v(" "),_c('checkbox-input-group',{attrs:{"label":"Filter","text":"Filter negative results"},model:{value:(_vm.filterNegativeResults),callback:function ($$v) {_vm.filterNegativeResults=$$v},expression:"filterNegativeResults"}}),_vm._v(" "),_c('checkbox-input-group',{attrs:{"text":"Filter out of order ranks"},model:{value:(_vm.filterOutOfOrderRanks),callback:function ($$v) {_vm.filterOutOfOrderRanks=$$v},expression:"filterOutOfOrderRanks"}}),_vm._v(" "),_c('checkbox-input-group',{attrs:{"text":"Auto dispatch"},model:{value:(_vm.autoDispatch),callback:function ($$v) {_vm.autoDispatch=$$v},expression:"autoDispatch"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sponsors_vue__ = __webpack_require__(1762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fda7d262_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sponsors_vue__ = __webpack_require__(1763);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sponsors_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fda7d262_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sponsors_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_index__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sponsors',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins__["b" /* templateMixin */]],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["f" /* mapTemplateData */])(['albumId', 'pictureId']), Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["c" /* mapOverlayData */])(['title', 'imageUrl']), {
    album: function album() {
      return this.$store.getters.album(this.albumId) || {};
    },
    pictures: function pictures() {
      return this.album.pictures || [];
    }
  }),
  watch: {
    pictureId: function pictureId(val) {
      this.imageUrl = (this.pictures.find(function (p) {
        return p.pictureId === val;
      }) || {}).image;
    }
  }
});

/***/ }),
/* 1763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('window',{attrs:{"window-id":_vm.windowId}},[_c('window-tab',{attrs:{"title":_vm.windowTitle}},[_c('switch-buttons',{attrs:{"template-id":_vm.templateId}}),_vm._v(" "),_c('album-select-group',{model:{value:(_vm.albumId),callback:function ($$v) {_vm.albumId=$$v},expression:"albumId"}}),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('pictureId')}},[_vm._v("Picture")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('b-form-select',{attrs:{"id":_vm.safeId('pictureId'),"options":_vm.pictures,"text-field":"fileName","value-field":"pictureId"},model:{value:(_vm.pictureId),callback:function ($$v) {_vm.pictureId=$$v},expression:"pictureId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('title')}},[_vm._v("Title")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.title),expression:"title",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('title')},domProps:{"value":(_vm.title)},on:{"change":function($event){_vm.title=$event.target.value}}})])])],1),_vm._v(" "),_c('window-tab',{attrs:{"title":"Settings","icon":"cog"}},[_c('template-settings',{attrs:{"template-id":_vm.templateId}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sponsors_auto_vue__ = __webpack_require__(1766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b68cfac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sponsors_auto_vue__ = __webpack_require__(1767);
function injectStyle (ssrContext) {
  __webpack_require__(1765)
}
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2b68cfac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sponsors_auto_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b68cfac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sponsors_auto_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1765 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_index__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_action_types__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sponsors-auto',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins__["b" /* templateMixin */]],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["f" /* mapTemplateData */])(['albumId']), Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["f" /* mapTemplateData */])({
    'titles': { type: Object, default: {} },
    'orders': { type: Object, default: {} },
    'frequencies': { type: Object, default: {} }
  }), Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["d" /* mapOverlayOptions */])({
    'interval': { type: Number, default: 55 },
    'duration': { type: Number, default: 5 }
  }), Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["c" /* mapOverlayData */])(['title', 'imageUrl']), {
    album: function album() {
      return this.$store.getters.album(this.albumId) || {};
    },
    pictures: function pictures() {
      return this.album.pictures || [];
    }
  }),
  methods: {
    updateRecords: function updateRecords() {
      var _this = this;

      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__store_action_types__["s" /* TEMPLATE_DATA */], {
        templateId: this.templateId,
        data: {
          titles: this.titles,
          orders: this.orders,
          frequencies: this.frequencies
        }
      });
      var data = {
        pictures: this.pictures.map(function (p) {
          return {
            frequency: _this.frequencies[p.pictureId] || 0,
            order: _this.orders[p.pictureId] || 10001,
            title: _this.titles[p.pictureId],
            imageUrl: p.image
          };
        })
      };
      data.pictures.sort(function (a, b) {
        return a.order - b.order;
      });
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__store_action_types__["z" /* TEMPLATE_OVERLAY_DATA */], {
        templateId: this.templateId,
        data: data
      });
    }
  }
});

/***/ }),
/* 1767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('window',{attrs:{"window-id":_vm.windowId}},[_c('window-tab',{attrs:{"title":_vm.windowTitle}},[_c('switch-buttons',{attrs:{"template-id":_vm.templateId}})],1),_vm._v(" "),_c('window-tab',{attrs:{"title":"Data","icon":"database"}},[_c('album-select-group',{model:{value:(_vm.albumId),callback:function ($$v) {_vm.albumId=$$v},expression:"albumId"}}),_vm._v(" "),(_vm.pictures && _vm.pictures.length)?_c('table',{staticClass:"table table-bordered table-responsive table-hover table-sm"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Image")]),_vm._v(" "),_c('th',[_vm._v("Title")]),_vm._v(" "),_c('th',[_vm._v("Order")]),_vm._v(" "),_c('th',[_vm._v("Frequency")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.pictures),function(picture){return _c('tr',[_c('td',[_c('img',{attrs:{"src":picture.image,"title":picture.fileName}})]),_vm._v(" "),_c('td',{staticClass:"inline-edit"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.titles[picture.pictureId]),expression:"titles[picture.pictureId]",modifiers:{"lazy":true}}],staticClass:"inline-input form-control",attrs:{"type":"text"},domProps:{"value":(_vm.titles[picture.pictureId])},on:{"change":[function($event){_vm.$set(_vm.titles, picture.pictureId, $event.target.value)},_vm.updateRecords]}})]),_vm._v(" "),_c('td',{staticClass:"inline-edit"},[_c('input',{directives:[{name:"model",rawName:"v-model.number.lazy",value:(_vm.orders[picture.pictureId]),expression:"orders[picture.pictureId]",modifiers:{"number":true,"lazy":true}}],staticClass:"inline-input form-control",attrs:{"type":"number","min":"-10000","max":"10000"},domProps:{"value":(_vm.orders[picture.pictureId])},on:{"change":[function($event){_vm.$set(_vm.orders, picture.pictureId, _vm._n($event.target.value))},_vm.updateRecords],"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('td',{staticClass:"inline-edit"},[_c('input',{directives:[{name:"model",rawName:"v-model.number.lazy",value:(_vm.frequencies[picture.pictureId]),expression:"frequencies[picture.pictureId]",modifiers:{"number":true,"lazy":true}}],staticClass:"inline-input form-control",attrs:{"type":"number","min":"0","max":"100"},domProps:{"value":(_vm.frequencies[picture.pictureId])},on:{"change":[function($event){_vm.$set(_vm.frequencies, picture.pictureId, _vm._n($event.target.value))},_vm.updateRecords],"blur":function($event){_vm.$forceUpdate()}}})])])}))]):_vm._e()],1),_vm._v(" "),_c('window-tab',{attrs:{"title":"Settings","icon":"cog"}},[_c('template-settings',{attrs:{"templateId":_vm.templateId}},[_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('interval')}},[_vm._v("Interval")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.number.lazy",value:(_vm.interval),expression:"interval",modifiers:{"number":true,"lazy":true}}],staticClass:"form-control",attrs:{"type":"number","id":_vm.safeId('interval')},domProps:{"value":(_vm.interval)},on:{"change":function($event){_vm.interval=_vm._n($event.target.value)},"blur":function($event){_vm.$forceUpdate()}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('duration')}},[_vm._v("Duration")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.number.lazy",value:(_vm.duration),expression:"duration",modifiers:{"number":true,"lazy":true}}],staticClass:"form-control",attrs:{"type":"number","id":_vm.safeId('duration')},domProps:{"value":(_vm.duration)},on:{"change":function($event){_vm.duration=_vm._n($event.target.value)},"blur":function($event){_vm.$forceUpdate()}}})])])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sstv_bug_vue__ = __webpack_require__(1769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e12e678_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sstv_bug_vue__ = __webpack_require__(1770);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sstv_bug_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e12e678_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sstv_bug_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'station-bug',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["b" /* templateMixin */]]
});

/***/ }),
/* 1770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('window',{attrs:{"window-id":_vm.windowId}},[_c('window-tab',{attrs:{"title":_vm.windowTitle}},[_c('switch-buttons',{attrs:{"template-id":_vm.templateId}})],1),_vm._v(" "),_c('window-tab',{attrs:{"title":"Settings","icon":"cog"}},[_c('template-settings',{attrs:{"template-id":_vm.templateId}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_starting_list_vue__ = __webpack_require__(1772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b6f42b3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_starting_list_vue__ = __webpack_require__(1773);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_starting_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b6f42b3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_starting_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_action_types__ = __webpack_require__(5);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'starting-list',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins__["b" /* templateMixin */]],
  data: function data() {
    return {
      columnDefinitions: {
        'track': 'Track',
        'bibNumber': 'Bib number',
        'lastName': 'Last name',
        'firstName': 'First name',
        'country': 'Country',
        'club': 'Club'
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3__utils__["c" /* mapOverlayData */])(['title', 'subtitle']), Object(__WEBPACK_IMPORTED_MODULE_3__utils__["c" /* mapOverlayData */])({ 'records': { default: [] } }), Object(__WEBPACK_IMPORTED_MODULE_3__utils__["c" /* mapOverlayData */])(['topLeftImage', 'topRightImage']), Object(__WEBPACK_IMPORTED_MODULE_3__utils__["d" /* mapOverlayOptions */])({ pageIntervalSecs: { default: 0 }, itemsPerPage: { default: 8 } }), Object(__WEBPACK_IMPORTED_MODULE_3__utils__["f" /* mapTemplateData */])(['sponsorsAlbumId', 'datasetId']), Object(__WEBPACK_IMPORTED_MODULE_3__utils__["f" /* mapTemplateData */])(['logosAlbumId', 'topLeftImageId', 'topRightImageId']), Object(__WEBPACK_IMPORTED_MODULE_3__utils__["f" /* mapTemplateData */])({ columnMap: { default: {} } }), {
    records: function records() {
      var _this = this;

      var dataset = this.$store.getters.dataset(this.datasetId);
      if (!dataset) return [];
      var records = [].concat(dataset.records);
      records.sort(function (a, b) {
        return parseInt(a.SORT_ORDER) - parseInt(b.SORT_ORDER);
      });
      return records.map(function (record) {
        return _this.mapRecord(record, _this.columnMap);
      });
    }
  }),
  watch: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
    records: function records(val) {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__store_action_types__["z" /* TEMPLATE_OVERLAY_DATA */], {
        templateId: this.templateId,
        data: { records: val }
      });
    },
    sponsorsAlbumId: function sponsorsAlbumId(val) {
      var album = this.$store.getters.album(val) || {};
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__store_action_types__["z" /* TEMPLATE_OVERLAY_DATA */], {
        templateId: this.templateId,
        data: { sponsors: album.pictures }
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_3__utils__["b" /* mapImageIdToImage */])('logosAlbumId', 'topLeftImageId', 'topLeftImage'), Object(__WEBPACK_IMPORTED_MODULE_3__utils__["b" /* mapImageIdToImage */])('logosAlbumId', 'topRightImageId', 'topRightImage')),
  methods: {
    mapRecord: function mapRecord(record, columnMap) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(columnMap).reduce(function (result, key) {
        result[key] = record[columnMap[key]];
        return result;
      }, {});
    }
  }
});

/***/ }),
/* 1773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('window',{attrs:{"window-id":_vm.windowId}},[_c('window-tab',{attrs:{"title":_vm.windowTitle}},[_c('switch-buttons',{attrs:{"template-id":_vm.templateId}}),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('title')}},[_vm._v("Title")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.title),expression:"title",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('title')},domProps:{"value":(_vm.title)},on:{"change":function($event){_vm.title=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('subtitle')}},[_vm._v("Subtitle")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.subtitle),expression:"subtitle",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('subtitle')},domProps:{"value":(_vm.subtitle)},on:{"change":function($event){_vm.subtitle=$event.target.value}}})])]),_vm._v(" "),_c('table-edit',{attrs:{"cols":_vm.columnDefinitions,"rows":_vm.records}})],1),_vm._v(" "),_c('window-tab',{attrs:{"title":"Data","icon":"database"}},[_c('album-select-group',{model:{value:(_vm.sponsorsAlbumId),callback:function ($$v) {_vm.sponsorsAlbumId=$$v},expression:"sponsorsAlbumId"}}),_vm._v(" "),_c('album-select-group',{attrs:{"label":"Logos"},model:{value:(_vm.logosAlbumId),callback:function ($$v) {_vm.logosAlbumId=$$v},expression:"logosAlbumId"}}),_vm._v(" "),_c('picture-select-group',{attrs:{"album-id":_vm.logosAlbumId,"label":"Top left image"},model:{value:(_vm.topLeftImageId),callback:function ($$v) {_vm.topLeftImageId=$$v},expression:"topLeftImageId"}}),_vm._v(" "),_c('picture-select-group',{attrs:{"album-id":_vm.logosAlbumId,"label":"Top right image"},model:{value:(_vm.topRightImageId),callback:function ($$v) {_vm.topRightImageId=$$v},expression:"topRightImageId"}}),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('datasetId')}},[_vm._v("Dataset")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('dataset-select',{attrs:{"id":_vm.safeId('datasetId')},model:{value:(_vm.datasetId),callback:function ($$v) {_vm.datasetId=$$v},expression:"datasetId"}})],1)]),_vm._v(" "),_vm._l((_vm.columnDefinitions),function(v,k){return _c('div',{key:k,staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId(k)}},[_vm._v(_vm._s(v))]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('column-select',{attrs:{"id":_vm.safeId(k),"value":_vm.columnMap[k],"dataset-id":_vm.datasetId},on:{"input":function (val) {
          _vm.columnMap[k] = val
          _vm.columnMap = _vm.columnMap
        }}})],1)])})],2),_vm._v(" "),_c('window-tab',{attrs:{"title":"Settings","icon":"cog"}},[_c('template-settings',{attrs:{"templateId":_vm.templateId}},[_c('number-input-group',{attrs:{"label":"Page interval (s)"},model:{value:(_vm.pageIntervalSecs),callback:function ($$v) {_vm.pageIntervalSecs=$$v},expression:"pageIntervalSecs"}}),_vm._v(" "),_c('number-input-group',{attrs:{"label":"Items per page"},model:{value:(_vm.itemsPerPage),callback:function ($$v) {_vm.itemsPerPage=$$v},expression:"itemsPerPage"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_swiss_wrestling_duel_vue__ = __webpack_require__(1775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39ea841e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_swiss_wrestling_duel_vue__ = __webpack_require__(1776);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_swiss_wrestling_duel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39ea841e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_swiss_wrestling_duel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_index__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'swiss-wrestling-duel',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins__["b" /* templateMixin */]],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["c" /* mapOverlayData */])(['color1', 'color2', 'title1', 'title2', 'club1', 'club2']), Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["f" /* mapTemplateData */])(['datasetId', 'recordId1', 'recordId2']), Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["f" /* mapTemplateData */])({
    /* eslint-disable no-template-curly-in-string */
    patternColor: { default: '${COLOR}' },
    patternTitle: { default: '${NAME}' },
    patternClub: { default: '${CLUB}'
      /* eslint-enable no-template-curly-in-string */
    } }), Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["g" /* mapTemplateOptions */])({ 'allowSameColor': false }), {
    dataset: function dataset() {
      if (!this.datasetId) return null;
      return this.$store.getters.dataset(this.datasetId);
    },
    datasetColumns: function datasetColumns() {
      if (!this.dataset) return;
      return this.dataset.columns || [];
    },
    colorOptions: function colorOptions() {
      return { 'hell': 'Hell', 'dunkel': 'Dunkel' };
    }
  }),
  watch: {
    recordId1: function recordId1(val) {
      if (!val) return;
      var record = this.$store.getters.dataset(this.datasetId).records.find(function (r) {
        return r.recordId === val;
      });
      if (!record) return;
      record = this.mapRecord(record);
      this.color1 = record.color;
      this.title1 = record.title;
      this.club1 = record.club;
    },
    recordId2: function recordId2(val) {
      if (!val) return;
      var record = this.$store.getters.dataset(this.datasetId).records.find(function (r) {
        return r.recordId === val;
      });
      if (!record) return;
      record = this.mapRecord(record);
      this.color2 = record.color;
      this.title2 = record.title;
      this.club2 = record.club;
    },
    color1: function color1(val) {
      if (!this.allowSameColor) {
        this.color2 = val === 'hell' ? 'dunkel' : 'hell';
      }
    },
    color2: function color2(val) {
      if (!this.allowSameColor) {
        this.color1 = val === 'hell' ? 'dunkel' : 'hell';
      }
    }
  },
  methods: {
    mapRecord: function mapRecord(record) {
      var result = {};
      var recordMap = {
        color: this.patternColor,
        title: this.patternTitle,
        club: this.patternClub
      };
      for (var k in recordMap) {
        if (!recordMap.hasOwnProperty(k)) continue;
        result[k] = recordMap[k].replace(/\$\{([\w ]+)\}/g, function (match, p1) {
          return record[p1] || '';
        });
      }
      return result;
    }
  }
});

/***/ }),
/* 1776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('window',{attrs:{"window-id":_vm.windowId}},[_c('window-tab',{attrs:{"title":_vm.windowTitle}},[_c('switch-buttons',{attrs:{"template-id":_vm.templateId}}),_vm._v(" "),(_vm.datasetId)?_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('record')}},[_vm._v("Wrestler 1")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('record-select',{attrs:{"id":_vm.safeId('record'),"dataset-id":_vm.datasetId},model:{value:(_vm.recordId1),callback:function ($$v) {_vm.recordId1=$$v},expression:"recordId1"}})],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('color1')}},[_vm._v("Color 1")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('b-form-select',{attrs:{"id":_vm.safeId('color1'),"options":_vm.colorOptions},model:{value:(_vm.color1),callback:function ($$v) {_vm.color1=$$v},expression:"color1"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('title1')}},[_vm._v("Name 1")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.title1),expression:"title1",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('title1')},domProps:{"value":(_vm.title1)},on:{"change":function($event){_vm.title1=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('club1')}},[_vm._v("Club 1")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.club1),expression:"club1",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('club1')},domProps:{"value":(_vm.club1)},on:{"change":function($event){_vm.club1=$event.target.value}}})])]),_vm._v(" "),(_vm.datasetId)?_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('record')}},[_vm._v("Wrestler 2")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('record-select',{attrs:{"id":_vm.safeId('record'),"dataset-id":_vm.datasetId},model:{value:(_vm.recordId2),callback:function ($$v) {_vm.recordId2=$$v},expression:"recordId2"}})],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('color2')}},[_vm._v("Color 2")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('b-form-select',{attrs:{"id":_vm.safeId('color2'),"options":_vm.colorOptions},model:{value:(_vm.color2),callback:function ($$v) {_vm.color2=$$v},expression:"color2"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('title2')}},[_vm._v("Name 2")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.title2),expression:"title2",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('title2')},domProps:{"value":(_vm.title2)},on:{"change":function($event){_vm.title2=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('club2')}},[_vm._v("Club 2")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.club2),expression:"club2",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('club2')},domProps:{"value":(_vm.club2)},on:{"change":function($event){_vm.club2=$event.target.value}}})])])],1),_vm._v(" "),_c('window-tab',{attrs:{"title":"Data","icon":"database"}},[_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('datasetId')}},[_vm._v("Dataset")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('dataset-select',{attrs:{"id":_vm.safeId('datasetId')},model:{value:(_vm.datasetId),callback:function ($$v) {_vm.datasetId=$$v},expression:"datasetId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label"},[_vm._v("Fields")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{staticClass:"form-control-plaintext",attrs:{"type":"text","readonly":""},domProps:{"value":_vm.datasetColumns}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternTitle')}},[_vm._v("Title")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternTitle),expression:"patternTitle",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternTitle')},domProps:{"value":(_vm.patternTitle)},on:{"change":function($event){_vm.patternTitle=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternClub')}},[_vm._v("Club")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternClub),expression:"patternClub",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternClub')},domProps:{"value":(_vm.patternClub)},on:{"change":function($event){_vm.patternClub=$event.target.value}}})])])]),_vm._v(" "),_c('window-tab',{attrs:{"title":"Settings","icon":"cog"}},[_c('template-settings',{attrs:{"templateId":_vm.templateId}},[_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('allowSameColor')}},[_vm._v("Allow same color")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8",staticStyle:{"padding-top":"5px"}},[_c('b-form-checkbox',{attrs:{"id":_vm.safeId('allowSameColor')},model:{value:(_vm.allowSameColor),callback:function ($$v) {_vm.allowSameColor=$$v},expression:"allowSameColor"}})],1)])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_swiss_wrestling_duel_2024_vue__ = __webpack_require__(1778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_686afcc5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_swiss_wrestling_duel_2024_vue__ = __webpack_require__(1779);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_swiss_wrestling_duel_2024_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_686afcc5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_swiss_wrestling_duel_2024_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_index__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_mutation_types__ = __webpack_require__(14);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'swiss-wrestling-duel-2024',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins__["b" /* templateMixin */]],
  data: function data() {
    return {
      rinkOptions: new Array(10).fill(null).map(function (v, i) {
        return { label: '' + (i + 1), value: i + 1 };
      })
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["c" /* mapOverlayData */])(['color1', 'color2', 'title1', 'title2', 'club1', 'club2']), Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["f" /* mapTemplateData */])(['rink', 'datasetId', 'recordId']), Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["f" /* mapTemplateData */])({
    /* eslint-disable no-template-curly-in-string */
    patternColor1: { default: '${p1_a_farbe}' },
    patternTitle1: { default: '${p1_lastName} ${p1_firstName} ${p1_a_sterne}' },
    patternClub1: { default: '${p1_a_verband}, ${p1_a_wohnort}' },
    patternColor2: { default: '${p2_a_farbe}' },
    patternTitle2: { default: '${p2_lastName} ${p2_firstName} ${p2_a_sterne}' },
    patternClub2: { default: '${p2_a_verband}, ${p2_a_wohnort}'
      /* eslint-enable no-template-curly-in-string */
    } }), Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["g" /* mapTemplateOptions */])({ 'allowSameColor': false }), {
    dataset: function dataset() {
      if (!this.datasetId) return null;
      return this.$store.getters.dataset(this.datasetId);
    },
    datasetColumns: function datasetColumns() {
      if (!this.dataset) return;
      return this.dataset.columns || [];
    },
    colorOptions: function colorOptions() {
      return { 'hell': 'Hell', 'dunkel': 'Dunkel' };
    }
  }),
  watch: {
    rink: function rink(val) {
      var dataset = this.$store.getters.dataset(this.datasetId);
      if (!dataset || !dataset.fileName) return;

      var fileName = dataset.fileName;
      var queryStringIndex = fileName.indexOf('?');

      if (queryStringIndex !== -1) {
        var baseUrl = fileName.substring(0, queryStringIndex); // Extract base URL
        var queryString = fileName.substring(queryStringIndex); // Extract query string

        // Use regex to find and replace attributes.platz with the new value
        var updatedQueryString = queryString.replace(/(attributes\.platz=)\d+/, '$1' + val);

        // Rebuild the fileName string with updated query parameters
        fileName = baseUrl + updatedQueryString;

        // Check if fileName has changed
        if (fileName !== dataset.fileName) {
          // Commit the updated fileName to the store
          this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types__["o" /* DATASET_UPDATE_META */], {
            datasetId: dataset.datasetId,
            fileName: fileName,
            emit: true
          });
        }
      }
    },
    recordId: function recordId(val) {
      if (!val) return;
      var record = this.$store.getters.dataset(this.datasetId).records.find(function (r) {
        return r.recordId === val;
      });
      if (!record) return;
      record = this.mapRecord(record);
      this.color1 = record.color1;
      this.title1 = record.title1;
      this.club1 = record.club1;
      this.color2 = record.color2;
      this.title2 = record.title2;
      this.club2 = record.club2;
    },
    color1: function color1(val) {
      if (!this.allowSameColor) {
        this.color2 = val === 'hell' ? 'dunkel' : 'hell';
      }
    },
    color2: function color2(val) {
      if (!this.allowSameColor) {
        this.color1 = val === 'hell' ? 'dunkel' : 'hell';
      }
    }
  },
  methods: {
    labelFn: function labelFn(record) {
      return [record['p1_bibNumber'] || record['p1_a_startnummer'] || '', record['p1_lastName'] || '', record['p1_firstName'] || '', record['p1_a_note'] || '', '-', record['p2_bibNumber'] || record['p2_a_startnummer'] || '', record['p2_lastName'] || '', record['p2_firstName'] || '', record['p2_a_note'] || '', '-', record['a_status']].join(' ');
    },
    mapRecord: function mapRecord(record) {
      var result = {};
      var recordMap = {
        color1: this.patternColor1,
        title1: this.patternTitle1,
        club1: this.patternClub1,
        color2: this.patternColor2,
        title2: this.patternTitle2,
        club2: this.patternClub2
      };
      for (var k in recordMap) {
        if (!recordMap.hasOwnProperty(k)) continue;
        result[k] = recordMap[k].replace(/\$\{([\w ]+)\}/g, function (match, p1) {
          return record[p1] || '';
        });
      }
      return result;
    }
  }
});

/***/ }),
/* 1779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('window',{attrs:{"window-id":_vm.windowId}},[_c('window-tab',{attrs:{"title":_vm.windowTitle}},[_c('switch-buttons',{attrs:{"template-id":_vm.templateId}}),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('rink')}},[_vm._v("Platz")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('b-form-select',{attrs:{"id":_vm.safeId('rink'),"options":_vm.rinkOptions,"text-field":"label","value-field":"value"},model:{value:(_vm.rink),callback:function ($$v) {_vm.rink=$$v},expression:"rink"}})],1)]),_vm._v(" "),(_vm.datasetId)?_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('record')}},[_vm._v("Paarung")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('record-select',{attrs:{"id":_vm.safeId('record'),"dataset-id":_vm.datasetId,"label-fn":_vm.labelFn},model:{value:(_vm.recordId),callback:function ($$v) {_vm.recordId=$$v},expression:"recordId"}})],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('color1')}},[_vm._v("Color 1")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('b-form-select',{attrs:{"id":_vm.safeId('color1'),"options":_vm.colorOptions},model:{value:(_vm.color1),callback:function ($$v) {_vm.color1=$$v},expression:"color1"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('title1')}},[_vm._v("Name 1")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.title1),expression:"title1",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('title1')},domProps:{"value":(_vm.title1)},on:{"change":function($event){_vm.title1=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('club1')}},[_vm._v("Club 1")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.club1),expression:"club1",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('club1')},domProps:{"value":(_vm.club1)},on:{"change":function($event){_vm.club1=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('color2')}},[_vm._v("Color 2")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('b-form-select',{attrs:{"id":_vm.safeId('color2'),"options":_vm.colorOptions},model:{value:(_vm.color2),callback:function ($$v) {_vm.color2=$$v},expression:"color2"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('title2')}},[_vm._v("Name 2")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.title2),expression:"title2",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('title2')},domProps:{"value":(_vm.title2)},on:{"change":function($event){_vm.title2=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('club2')}},[_vm._v("Club 2")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.club2),expression:"club2",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('club2')},domProps:{"value":(_vm.club2)},on:{"change":function($event){_vm.club2=$event.target.value}}})])])],1),_vm._v(" "),_c('window-tab',{attrs:{"title":"Data","icon":"database"}},[_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('datasetId')}},[_vm._v("Dataset")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('dataset-select',{attrs:{"id":_vm.safeId('datasetId')},model:{value:(_vm.datasetId),callback:function ($$v) {_vm.datasetId=$$v},expression:"datasetId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label"},[_vm._v("Fields")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{staticClass:"form-control-plaintext",attrs:{"type":"text","readonly":""},domProps:{"value":_vm.datasetColumns}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternColor1')}},[_vm._v("Color 1")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternColor1),expression:"patternColor1",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternColor1')},domProps:{"value":(_vm.patternColor1)},on:{"change":function($event){_vm.patternColor1=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternTitle1')}},[_vm._v("Title 1")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternTitle1),expression:"patternTitle1",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternTitle1')},domProps:{"value":(_vm.patternTitle1)},on:{"change":function($event){_vm.patternTitle1=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternClub1')}},[_vm._v("Club 1")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternClub1),expression:"patternClub1",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternClub1')},domProps:{"value":(_vm.patternClub1)},on:{"change":function($event){_vm.patternClub1=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternColor2')}},[_vm._v("Color 2")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternColor2),expression:"patternColor2",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternColor2')},domProps:{"value":(_vm.patternColor2)},on:{"change":function($event){_vm.patternColor2=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternTitle2')}},[_vm._v("Title 2")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternTitle2),expression:"patternTitle2",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternTitle2')},domProps:{"value":(_vm.patternTitle2)},on:{"change":function($event){_vm.patternTitle2=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternClub2')}},[_vm._v("Club 2")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternClub2),expression:"patternClub2",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternClub2')},domProps:{"value":(_vm.patternClub2)},on:{"change":function($event){_vm.patternClub2=$event.target.value}}})])])]),_vm._v(" "),_c('window-tab',{attrs:{"title":"Settings","icon":"cog"}},[_c('template-settings',{attrs:{"templateId":_vm.templateId}},[_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('allowSameColor')}},[_vm._v("Allow same color")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8",staticStyle:{"padding-top":"5px"}},[_c('b-form-checkbox',{attrs:{"id":_vm.safeId('allowSameColor')},model:{value:(_vm.allowSameColor),callback:function ($$v) {_vm.allowSameColor=$$v},expression:"allowSameColor"}})],1)])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_swiss_wrestling_duel_2026_vue__ = __webpack_require__(1781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_074e9eaf_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_swiss_wrestling_duel_2026_vue__ = __webpack_require__(1782);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_swiss_wrestling_duel_2026_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_074e9eaf_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_swiss_wrestling_duel_2026_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_index__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_mutation_types__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_action_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__clock_control_vue__ = __webpack_require__(119);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'swiss-wrestling-duel-2026',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins__["b" /* templateMixin */]],
  components: { clockControl: __WEBPACK_IMPORTED_MODULE_6__clock_control_vue__["a" /* default */] },
  data: function data() {
    return {
      rinkOptions: new Array(10).fill(null).map(function (v, i) {
        return { label: '' + (i + 1), value: i + 1 };
      })
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3__utils_index__["c" /* mapOverlayData */])(['gang', 'farbe1', 'farbe2', 'name1', 'name2', 'info1', 'info2', 'note1', 'note2']), Object(__WEBPACK_IMPORTED_MODULE_3__utils_index__["c" /* mapOverlayData */])({ 'recordsNotenblatt1': { default: [] } }), Object(__WEBPACK_IMPORTED_MODULE_3__utils_index__["c" /* mapOverlayData */])({ 'recordsNotenblatt2': { default: [] } }), Object(__WEBPACK_IMPORTED_MODULE_3__utils_index__["f" /* mapTemplateData */])(['rink', 'datasetId1', 'recordId1', 'datasetId2', 'datasetId3']), Object(__WEBPACK_IMPORTED_MODULE_3__utils_index__["f" /* mapTemplateData */])({
    /* eslint-disable no-template-curly-in-string */
    patternFarbe1: { default: '${p1_a_farbe}' },
    patternName1: { default: '${p1_lastName} ${p1_firstName} ${p1_a_sterne}' },
    patternInfo1: { default: '${p1_a_verband}, ${p1_a_wohnort}' },
    patternNote1: { default: '${p1_a_note}' },
    patternFarbe2: { default: '${p2_a_farbe}' },
    patternName2: { default: '${p2_lastName} ${p2_firstName} ${p2_a_sterne}' },
    patternInfo2: { default: '${p2_a_verband}, ${p2_a_wohnort}' },
    patternNote2: { default: '${p2_a_note}'
      /* eslint-enable no-template-curly-in-string */
    } }), Object(__WEBPACK_IMPORTED_MODULE_3__utils_index__["g" /* mapTemplateOptions */])({ 'allowSameColor': false }), {
    dataset1: function dataset1() {
      if (!this.datasetId1) return null;
      return this.$store.getters.dataset(this.datasetId1);
    },
    dataset1Columns: function dataset1Columns() {
      if (!this.dataset1) return;
      return this.dataset1.columns || [];
    },
    dataset2: function dataset2() {
      if (!this.datasetId2) return null;
      return this.$store.getters.dataset(this.datasetId2);
    },
    dataset3: function dataset3() {
      if (!this.datasetId3) return null;
      return this.$store.getters.dataset(this.datasetId3);
    },
    colorOptions: function colorOptions() {
      return { 'hell': 'Hell', 'dunkel': 'Dunkel' };
    },
    recordsNotenblatt1: function recordsNotenblatt1() {
      var dataset = this.$store.getters.dataset(this.datasetId2);
      if (!dataset) return [];
      var records = [].concat(dataset.records);
      records.sort(function (a, b) {
        return parseInt(a.SORT_ORDER) - parseInt(b.SORT_ORDER);
      });
      return records.map(function (record) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, record);
      });
    },
    recordsNotenblatt2: function recordsNotenblatt2() {
      var dataset = this.$store.getters.dataset(this.datasetId3);
      if (!dataset) return [];
      var records = [].concat(dataset.records);
      records.sort(function (a, b) {
        return parseInt(a.SORT_ORDER) - parseInt(b.SORT_ORDER);
      });
      return records.map(function (record) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, record);
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_3__utils_index__["c" /* mapOverlayData */])(['direction']), Object(__WEBPACK_IMPORTED_MODULE_3__utils_index__["d" /* mapOverlayOptions */])(['displayHours', 'displayMinutes', 'displayTenths', 'displayHundredths']), Object(__WEBPACK_IMPORTED_MODULE_3__utils_index__["d" /* mapOverlayOptions */])({ 'autoHideSecs': { default: 0 } }), Object(__WEBPACK_IMPORTED_MODULE_3__utils_index__["g" /* mapTemplateOptions */])({ 'startTimeMs': { default: 0 }, 'endTimeMs': { default: 0 } }), {
    startHours: {
      get: function get() {
        return Math.floor(this.startTimeMs / 1000 / 3600);
      },
      set: function set(val) {
        this.setStartTimeMs(val, this.startMins, this.startSecs);
      }
    },
    startMins: {
      get: function get() {
        return Math.floor(this.startTimeMs / 1000 / 60 % 60);
      },
      set: function set(val) {
        this.setStartTimeMs(this.startHours, val, this.startSecs);
      }
    },
    startSecs: {
      get: function get() {
        return this.startTimeMs / 1000 % 60;
      },
      set: function set(val) {
        this.setStartTimeMs(this.startHours, this.startMins, val);
      }
    },
    endHours: {
      get: function get() {
        return Math.floor(this.endTimeMs / 1000 / 3600);
      },
      set: function set(val) {
        this.setEndTimeMs(val, this.endMins, this.endSecs);
      }
    },
    endMins: {
      get: function get() {
        return Math.floor(this.endTimeMs / 1000 / 60 % 60);
      },
      set: function set(val) {
        this.setEndTimeMs(this.endHours, val, this.endSecs);
      }
    },
    endSecs: {
      get: function get() {
        return this.endTimeMs / 1000 % 60;
      },
      set: function set(val) {
        this.setEndTimeMs(this.endHours, this.endMins, val);
      }
    }
  }),
  watch: {
    rink: function rink(val) {
      var dataset = this.$store.getters.dataset(this.datasetId1);
      if (!dataset || !dataset.fileName) return;

      var fileName = dataset.fileName;
      var queryStringIndex = fileName.indexOf('?');

      if (queryStringIndex !== -1) {
        var baseUrl = fileName.substring(0, queryStringIndex); // Extract base URL
        var queryString = fileName.substring(queryStringIndex); // Extract query string

        // Use regex to find and replace attributes.platz with the new value
        var updatedQueryString = queryString.replace(/(attributes\.platz=)\d+/, '$1' + val);

        // Rebuild the fileName string with updated query parameters
        fileName = baseUrl + updatedQueryString;

        // Check if fileName has changed
        if (fileName !== dataset.fileName) {
          // Commit the updated fileName to the store
          this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types__["o" /* DATASET_UPDATE_META */], {
            datasetId: dataset.datasetId,
            fileName: fileName,
            emit: true
          });
        }
      }
    },
    recordId1: function recordId1(val) {
      if (!val) return;
      var datasetRecord = this.$store.getters.dataset(this.datasetId1).records.find(function (r) {
        return r.recordId === val;
      });
      if (!datasetRecord) return;
      var record = this.mapRecord(datasetRecord);
      this.farbe1 = record.farbe1;
      this.name1 = record.name1;
      this.info1 = record.info1;
      this.note1 = record.note1;
      this.farbe2 = record.farbe2;
      this.name2 = record.name2;
      this.info2 = record.info2;
      this.note2 = record.note2;
      this._cmd = null;
      this.bibNumber1 = datasetRecord['p1_bibNumber'];
      this.bibNumber2 = datasetRecord['p2_bibNumber'];

      this.updateNotenblatt(datasetRecord['p1_bibNumber'], this.datasetId2);
      this.updateNotenblatt(datasetRecord['p2_bibNumber'], this.datasetId3);
    },
    farbe1: function farbe1(val) {
      if (!this.allowSameColor) {
        this.farbe2 = val === 'hell' ? 'dunkel' : 'hell';
      }
    },
    farbe2: function farbe2(val) {
      if (!this.allowSameColor) {
        this.farbe1 = val === 'hell' ? 'dunkel' : 'hell';
      }
    },
    recordsNotenblatt1: function recordsNotenblatt1(val) {
      var _this = this;

      var data = {};
      for (var idx = 0; idx < 8; idx++) {
        data['notenblatt1.zeile' + (idx + 1) + '.name'] = '';
        data['notenblatt1.zeile' + (idx + 1) + '.note'] = '';
        data['notenblatt1.zeile' + (idx + 1) + '.resultat'] = '';
      }
      data = val.reduce(function (result, record, idx) {
        if (_this.bibNumber1 === record['p1_bibNumber']) {
          result['notenblatt1.zeile' + (idx + 1) + '.name'] = record['p2_lastName'] + ' ' + record['p2_firstName'] + ' ' + record['p2_a_sterne'];
          result['notenblatt1.zeile' + (idx + 1) + '.note'] = record['p2_a_note'];
          result['notenblatt1.zeile' + (idx + 1) + '.resultat'] = record['p2_a_resultat'];
        } else {
          result['notenblatt1.zeile' + (idx + 1) + '.name'] = record['p1_lastName'] + ' ' + record['p1_firstName'] + ' ' + record['p1_a_sterne'];
          result['notenblatt1.zeile' + (idx + 1) + '.note'] = record['p1_a_note'];
          result['notenblatt1.zeile' + (idx + 1) + '.resultat'] = record['p1_a_resultat'];
        }
        return result;
      }, data);
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_5__store_action_types__["z" /* TEMPLATE_OVERLAY_DATA */], {
        templateId: this.templateId,
        data: data
      });
    },
    recordsNotenblatt2: function recordsNotenblatt2(val) {
      var _this2 = this;

      var data = {};
      for (var idx = 0; idx < 8; idx++) {
        data['notenblatt2.zeile' + (idx + 1) + '.name'] = '';
        data['notenblatt2.zeile' + (idx + 1) + '.note'] = '';
        data['notenblatt2.zeile' + (idx + 1) + '.resultat'] = '';
      }
      data = val.reduce(function (result, record, idx) {
        if (_this2.bibNumber2 === record['p1_bibNumber']) {
          result['notenblatt2.zeile' + (idx + 1) + '.name'] = record['p2_lastName'] + ' ' + record['p2_firstName'] + ' ' + record['p2_a_sterne'];
          result['notenblatt2.zeile' + (idx + 1) + '.note'] = record['p2_a_note'];
          result['notenblatt2.zeile' + (idx + 1) + '.resultat'] = record['p2_a_resultat'];
        } else {
          result['notenblatt2.zeile' + (idx + 1) + '.name'] = record['p1_lastName'] + ' ' + record['p1_firstName'] + ' ' + record['p1_a_sterne'];
          result['notenblatt2.zeile' + (idx + 1) + '.note'] = record['p1_a_note'];
          result['notenblatt2.zeile' + (idx + 1) + '.resultat'] = record['p1_a_resultat'];
        }
        return result;
      }, data);
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_5__store_action_types__["z" /* TEMPLATE_OVERLAY_DATA */], {
        templateId: this.templateId,
        data: data
      });
    }
  },
  methods: {
    labelFn: function labelFn(record) {
      return [record['p1_bibNumber'] || record['p1_a_startnummer'] || '', record['p1_lastName'] || '', record['p1_firstName'] || '', record['p1_a_note'] || '', '-', record['p2_bibNumber'] || record['p2_a_startnummer'] || '', record['p2_lastName'] || '', record['p2_firstName'] || '', record['p2_a_note'] || '', '-', record['a_status']].join(' ');
    },
    mapRecord: function mapRecord(record) {
      var result = {};
      var recordMap = {
        farbe1: this.patternFarbe1,
        name1: this.patternName1,
        info1: this.patternInfo1,
        note1: this.patternNote1,
        farbe2: this.patternFarbe2,
        name2: this.patternName2,
        info2: this.patternInfo2,
        note2: this.patternNote2
      };
      for (var k in recordMap) {
        if (!recordMap.hasOwnProperty(k)) continue;
        result[k] = recordMap[k].replace(/\$\{([\w ]+)\}/g, function (match, p1) {
          return record[p1] || '';
        });
      }
      return result;
    },
    updateNotenblatt: function updateNotenblatt(bibNumber, datasetId) {
      var dataset = this.$store.getters.dataset(datasetId);
      if (!dataset || !dataset.fileName) return;

      var fileName = dataset.fileName;
      var queryStringIndex = fileName.indexOf('?');

      if (queryStringIndex !== -1) {
        var baseUrl = fileName.substring(0, queryStringIndex); // Extract base URL
        var queryString = fileName.substring(queryStringIndex); // Extract query string

        // Use regex to find and replace participants.bibNumber with the new value
        var updatedQueryString = queryString.replace(/(participants\.bibNumber=)\d+/, '$1' + bibNumber);

        // Rebuild the fileName string with updated query parameters
        fileName = baseUrl + updatedQueryString;

        // Check if fileName has changed
        if (fileName !== dataset.fileName) {
          // Commit the updated fileName to the store
          this.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types__["o" /* DATASET_UPDATE_META */], {
            datasetId: dataset.datasetId,
            fileName: fileName,
            emit: true
          });
        }
      }
    },
    toggleGang: function toggleGang() {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_5__store_action_types__["p" /* OVERLAY_DATA */], {
        templateId: this.templateId,
        channelIds: ['program', 'preview'],
        data: { '_cmd': 'gang:' + new Date().getTime() }
      });
    },
    toggleNoten: function toggleNoten() {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_5__store_action_types__["p" /* OVERLAY_DATA */], {
        templateId: this.templateId,
        channelIds: ['program', 'preview'],
        data: { '_cmd': 'noten:' + new Date().getTime() }
      });
    },
    toggleNotenblatt: function toggleNotenblatt() {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_5__store_action_types__["p" /* OVERLAY_DATA */], {
        templateId: this.templateId,
        channelIds: ['program', 'preview'],
        data: { '_cmd': 'notenblatt:' + new Date().getTime() }
      });
    },
    toggleZeit: function toggleZeit() {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_5__store_action_types__["p" /* OVERLAY_DATA */], {
        templateId: this.templateId,
        channelIds: ['program', 'preview'],
        data: { '_cmd': 'zeit:' + new Date().getTime() }
      });
    },

    // CLOCK
    setStartTimeMs: function setStartTimeMs(hours, mins, secs) {
      this.startTimeMs = 1000 * (hours * 3600 + mins * 60 + secs * 1);
      this.direction = this.startTimeMs <= this.endTimeMs ? 'up' : 'down';
    },
    setEndTimeMs: function setEndTimeMs(hours, mins, secs) {
      this.endTimeMs = 1000 * (hours * 3600 + mins * 60 + secs * 1);
      this.direction = this.startTimeMs <= this.endTimeMs ? 'up' : 'down';
    }
  }
});

/***/ }),
/* 1782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('window',{attrs:{"window-id":_vm.windowId}},[_c('window-tab',{attrs:{"title":_vm.windowTitle}},[_c('switch-buttons',{attrs:{"template-id":_vm.templateId}}),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('gang')}},[_vm._v("Gang")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.gang),expression:"gang",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('gang')},domProps:{"value":(_vm.gang)},on:{"change":function($event){_vm.gang=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('rink')}},[_vm._v("Platz")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('b-form-select',{attrs:{"id":_vm.safeId('rink'),"options":_vm.rinkOptions,"text-field":"label","value-field":"value"},model:{value:(_vm.rink),callback:function ($$v) {_vm.rink=$$v},expression:"rink"}})],1)]),_vm._v(" "),(_vm.datasetId1)?_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('record')}},[_vm._v("Paarung")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('record-select',{attrs:{"id":_vm.safeId('record'),"dataset-id":_vm.datasetId1,"label-fn":_vm.labelFn},model:{value:(_vm.recordId1),callback:function ($$v) {_vm.recordId1=$$v},expression:"recordId1"}})],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('farbe1')}},[_vm._v("Farbe 1")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('b-form-select',{attrs:{"id":_vm.safeId('farbe1'),"options":_vm.colorOptions},model:{value:(_vm.farbe1),callback:function ($$v) {_vm.farbe1=$$v},expression:"farbe1"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('name1')}},[_vm._v("Name 1")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.name1),expression:"name1",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('name1')},domProps:{"value":(_vm.name1)},on:{"change":function($event){_vm.name1=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('info1')}},[_vm._v("Info 1")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.info1),expression:"info1",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('info1')},domProps:{"value":(_vm.info1)},on:{"change":function($event){_vm.info1=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('note1')}},[_vm._v("Note 1")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.note1),expression:"note1",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('note1')},domProps:{"value":(_vm.note1)},on:{"change":function($event){_vm.note1=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('farbe2')}},[_vm._v("Farbe 2")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('b-form-select',{attrs:{"id":_vm.safeId('farbe2'),"options":_vm.colorOptions},model:{value:(_vm.farbe2),callback:function ($$v) {_vm.farbe2=$$v},expression:"farbe2"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('name2')}},[_vm._v("Name 2")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.name2),expression:"name2",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('name2')},domProps:{"value":(_vm.name2)},on:{"change":function($event){_vm.name2=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('info2')}},[_vm._v("Info 2")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.info2),expression:"info2",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('info2')},domProps:{"value":(_vm.info2)},on:{"change":function($event){_vm.info2=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('note1')}},[_vm._v("Note 2")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.note1),expression:"note1",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('note1')},domProps:{"value":(_vm.note1)},on:{"change":function($event){_vm.note1=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('div',{staticClass:"col-sm-8 offset-sm-4"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":_vm.toggleGang}},[_vm._v("Gang")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":_vm.toggleNotenblatt}},[_vm._v("Notenblatt")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":_vm.toggleNoten}},[_vm._v("Noten")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":_vm.toggleZeit}},[_vm._v("Zeit")])])]),_vm._v(" "),_c('clock-control',{attrs:{"template-id":_vm.templateId}})],1),_vm._v(" "),_c('window-tab',{attrs:{"title":"Data","icon":"database"}},[_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('datasetId1')}},[_vm._v("Paarungen")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('dataset-select',{attrs:{"id":_vm.safeId('datasetId1')},model:{value:(_vm.datasetId1),callback:function ($$v) {_vm.datasetId1=$$v},expression:"datasetId1"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label"}),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{staticClass:"form-control-plaintext",attrs:{"type":"text","readonly":""},domProps:{"value":_vm.dataset1Columns}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternFarbe1')}},[_vm._v("Farbe 1")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternFarbe1),expression:"patternFarbe1",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternFarbe1')},domProps:{"value":(_vm.patternFarbe1)},on:{"change":function($event){_vm.patternFarbe1=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternName1')}},[_vm._v("Title 1")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternName1),expression:"patternName1",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternName1')},domProps:{"value":(_vm.patternName1)},on:{"change":function($event){_vm.patternName1=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternInfo1')}},[_vm._v("Info 1")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternInfo1),expression:"patternInfo1",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternInfo1')},domProps:{"value":(_vm.patternInfo1)},on:{"change":function($event){_vm.patternInfo1=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternNote1')}},[_vm._v("Note 1")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternNote1),expression:"patternNote1",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternNote1')},domProps:{"value":(_vm.patternNote1)},on:{"change":function($event){_vm.patternNote1=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternFarbe2')}},[_vm._v("Farbe 2")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternFarbe2),expression:"patternFarbe2",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternFarbe2')},domProps:{"value":(_vm.patternFarbe2)},on:{"change":function($event){_vm.patternFarbe2=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternName2')}},[_vm._v("Title 2")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternName2),expression:"patternName2",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternName2')},domProps:{"value":(_vm.patternName2)},on:{"change":function($event){_vm.patternName2=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternInfo2')}},[_vm._v("Info 2")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternInfo2),expression:"patternInfo2",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternInfo2')},domProps:{"value":(_vm.patternInfo2)},on:{"change":function($event){_vm.patternInfo2=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternNote2')}},[_vm._v("Note 2")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternNote2),expression:"patternNote2",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternNote2')},domProps:{"value":(_vm.patternNote2)},on:{"change":function($event){_vm.patternNote2=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('datasetId2')}},[_vm._v("Notenblatt 1")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('dataset-select',{attrs:{"id":_vm.safeId('datasetId2')},model:{value:(_vm.datasetId2),callback:function ($$v) {_vm.datasetId2=$$v},expression:"datasetId2"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('datasetId3')}},[_vm._v("Notenblatt 2")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('dataset-select',{attrs:{"id":_vm.safeId('datasetId3')},model:{value:(_vm.datasetId3),callback:function ($$v) {_vm.datasetId3=$$v},expression:"datasetId3"}})],1)])]),_vm._v(" "),_c('window-tab',{attrs:{"title":"Settings","icon":"cog"}},[_c('template-settings',{attrs:{"templateId":_vm.templateId}},[_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('allowSameColor')}},[_vm._v("Allow same color")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8",staticStyle:{"padding-top":"5px"}},[_c('b-form-checkbox',{attrs:{"id":_vm.safeId('allowSameColor')},model:{value:(_vm.allowSameColor),callback:function ($$v) {_vm.allowSameColor=$$v},expression:"allowSameColor"}})],1)]),_vm._v(" "),_c('number-input-group',{attrs:{"label":"Autohide (secs)"},model:{value:(_vm.autoHideSecs),callback:function ($$v) {_vm.autoHideSecs=$$v},expression:"autoHideSecs"}}),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label"},[_vm._v("Start time")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"form-row align-items-end"},[_c('div',{staticClass:"col"},[_c('label',{staticClass:"col-form-label",attrs:{"for":_vm.safeId('startHours')}},[_vm._v("Hours")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.startHours),expression:"startHours",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","id":_vm.safeId('startHours'),"min":"0","max":"99"},domProps:{"value":(_vm.startHours)},on:{"input":function($event){if($event.target.composing){ return; }_vm.startHours=_vm._n($event.target.value)},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('label',{staticClass:"col-form-label",attrs:{"for":_vm.safeId('startMins')}},[_vm._v("Mins")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.startMins),expression:"startMins",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","id":_vm.safeId('startMins'),"min":"0","max":"59"},domProps:{"value":(_vm.startMins)},on:{"input":function($event){if($event.target.composing){ return; }_vm.startMins=_vm._n($event.target.value)},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('label',{staticClass:"col-form-label",attrs:{"for":_vm.safeId('startSecs')}},[_vm._v("Secs")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.startSecs),expression:"startSecs",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","id":_vm.safeId('startSecs'),"min":"0","max":"59"},domProps:{"value":(_vm.startSecs)},on:{"input":function($event){if($event.target.composing){ return; }_vm.startSecs=_vm._n($event.target.value)},"blur":function($event){_vm.$forceUpdate()}}})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label"},[_vm._v("End time")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"form-row align-items-end"},[_c('div',{staticClass:"col"},[_c('label',{staticClass:"col-form-label",attrs:{"for":_vm.safeId('endHours')}},[_vm._v("Hours")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.endHours),expression:"endHours",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","id":_vm.safeId('endHours'),"min":"0","max":"99"},domProps:{"value":(_vm.endHours)},on:{"input":function($event){if($event.target.composing){ return; }_vm.endHours=_vm._n($event.target.value)},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('label',{staticClass:"col-form-label",attrs:{"for":_vm.safeId('endMins')}},[_vm._v("Mins")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.endMins),expression:"endMins",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","id":_vm.safeId('endMins'),"min":"0","max":"59"},domProps:{"value":(_vm.endMins)},on:{"input":function($event){if($event.target.composing){ return; }_vm.endMins=_vm._n($event.target.value)},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('label',{staticClass:"col-form-label",attrs:{"for":_vm.safeId('endSecs')}},[_vm._v("Secs")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.endSecs),expression:"endSecs",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","id":_vm.safeId('endSecs'),"min":"0","max":"59"},domProps:{"value":(_vm.endSecs)},on:{"input":function($event){if($event.target.composing){ return; }_vm.endSecs=_vm._n($event.target.value)},"blur":function($event){_vm.$forceUpdate()}}})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label"},[_vm._v("Format")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"form-check form-check-inline"},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.displayHours),expression:"displayHours"}],staticClass:"form-check-input",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.displayHours)?_vm._i(_vm.displayHours,null)>-1:(_vm.displayHours)},on:{"change":function($event){var $$a=_vm.displayHours,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.displayHours=$$a.concat([$$v]))}else{$$i>-1&&(_vm.displayHours=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.displayHours=$$c}}}}),_vm._v("Hrs\n            ")])]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline"},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.displayMinutes),expression:"displayMinutes"}],staticClass:"form-check-input",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.displayMinutes)?_vm._i(_vm.displayMinutes,null)>-1:(_vm.displayMinutes)},on:{"change":function($event){var $$a=_vm.displayMinutes,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.displayMinutes=$$a.concat([$$v]))}else{$$i>-1&&(_vm.displayMinutes=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.displayMinutes=$$c}}}}),_vm._v("Mins\n            ")])]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline"},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.displayTenths),expression:"displayTenths"}],staticClass:"form-check-input",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.displayTenths)?_vm._i(_vm.displayTenths,null)>-1:(_vm.displayTenths)},on:{"change":function($event){var $$a=_vm.displayTenths,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.displayTenths=$$a.concat([$$v]))}else{$$i>-1&&(_vm.displayTenths=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.displayTenths=$$c}}}}),_vm._v("1/10\n            ")])]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline"},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.displayHundredths),expression:"displayHundredths"}],staticClass:"form-check-input",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.displayHundredths)?_vm._i(_vm.displayHundredths,null)>-1:(_vm.displayHundredths)},on:{"change":function($event){var $$a=_vm.displayHundredths,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.displayHundredths=$$a.concat([$$v]))}else{$$i>-1&&(_vm.displayHundredths=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.displayHundredths=$$c}}}}),_vm._v("1/100\n            ")])])])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_swiss_wrestling_matches_vue__ = __webpack_require__(1784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_136e78b5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_swiss_wrestling_matches_vue__ = __webpack_require__(1785);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_swiss_wrestling_matches_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_136e78b5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_swiss_wrestling_matches_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_action_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__ = __webpack_require__(14);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'swiss-wrestling-matches',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins__["b" /* templateMixin */]],
  data: function data() {
    return {
      gangOptions: new Array(6).fill(null).map(function (v, i) {
        return { label: i + 1 + '. Gang', value: i + 1 };
      }),
      columnDefinitions: {
        'nachname1': 'Nachname 1',
        'vorname1': 'Vorname 1',
        'sterne1': 'Sterne 1',
        'verband1': 'Verband 1',
        'nachname2': 'Nachname 2',
        'vorname2': 'Vorname 2',
        'sterne2': 'Sterne 2',
        'verband2': 'Verband 2'
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3__utils__["c" /* mapOverlayData */])(['title', 'subtitle']), Object(__WEBPACK_IMPORTED_MODULE_3__utils__["c" /* mapOverlayData */])({ 'records': { default: [] } }), Object(__WEBPACK_IMPORTED_MODULE_3__utils__["d" /* mapOverlayOptions */])({ pageIntervalSecs: { default: 0 }, itemsPerPage: { default: 6 } }), Object(__WEBPACK_IMPORTED_MODULE_3__utils__["f" /* mapTemplateData */])(['datasetId', 'gang']), Object(__WEBPACK_IMPORTED_MODULE_3__utils__["f" /* mapTemplateData */])({ columnMap: { default: {} } }), {
    records: function records() {
      var _this = this;

      var dataset = this.$store.getters.dataset(this.datasetId);
      if (!dataset) return [];
      var records = [].concat(dataset.records);
      records.sort(function (a, b) {
        return parseInt(a.SORT_ORDER) - parseInt(b.SORT_ORDER);
      });
      return records.map(function (record) {
        return _this.mapRecord(record, _this.columnMap);
      });
    }
  }),
  watch: {
    gang: function gang(val) {
      var dataset = this.$store.getters.dataset(this.datasetId);
      if (!dataset || !dataset.fileName) return;

      var fileName = dataset.fileName;
      var queryStringIndex = fileName.indexOf('?');

      if (queryStringIndex !== -1) {
        var baseUrl = fileName.substring(0, queryStringIndex); // Extract base URL
        var queryString = fileName.substring(queryStringIndex); // Extract query string

        // Use regex to find and replace attributes.gang with the new value
        var updatedQueryString = queryString.replace(/(attributes\.gang=)\d+/, '$1' + val);

        // Rebuild the fileName string with updated query parameters
        fileName = baseUrl + updatedQueryString;

        // Check if fileName has changed
        if (fileName !== dataset.fileName) {
          // Commit the updated fileName to the store
          this.$store.commit(__WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["o" /* DATASET_UPDATE_META */], {
            datasetId: dataset.datasetId,
            fileName: fileName,
            emit: true
          });
        }
      }
    },
    records: function records(val) {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__store_action_types__["z" /* TEMPLATE_OVERLAY_DATA */], {
        templateId: this.templateId,
        data: { records: val }
      });
    }
  },
  methods: {
    mapRecord: function mapRecord(record, columnMap) {
      var each = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(columnMap).reduce(function (result, key) {
        result[key] = record[columnMap[key]];
        return result;
      }, {});
      each.name = [each.nachname1, each.vorname1, each.sterne1, '-', each.nachname2, each.vorname2, each.sterne2].join(' ');
      return each;
    }
  }
});

/***/ }),
/* 1785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('window',{attrs:{"window-id":_vm.windowId}},[_c('window-tab',{attrs:{"title":_vm.windowTitle}},[_c('switch-buttons',{attrs:{"template-id":_vm.templateId}}),_vm._v(" "),_c('text-input-group',{attrs:{"label":"Title"},model:{value:(_vm.title),callback:function ($$v) {_vm.title=$$v},expression:"title"}}),_vm._v(" "),_c('text-input-group',{attrs:{"label":"Subtitle"},model:{value:(_vm.subtitle),callback:function ($$v) {_vm.subtitle=$$v},expression:"subtitle"}}),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('gang')}},[_vm._v("Gang")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('b-form-select',{attrs:{"id":_vm.safeId('gang'),"options":_vm.gangOptions,"text-field":"label","value-field":"value"},model:{value:(_vm.gang),callback:function ($$v) {_vm.gang=$$v},expression:"gang"}})],1)]),_vm._v(" "),_c('table-edit',{attrs:{"cols":_vm.columnDefinitions,"rows":_vm.records}})],1),_vm._v(" "),_c('window-tab',{attrs:{"title":"Data","icon":"database"}},[_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('datasetId')}},[_vm._v("Dataset")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('dataset-select',{attrs:{"id":_vm.safeId('datasetId')},model:{value:(_vm.datasetId),callback:function ($$v) {_vm.datasetId=$$v},expression:"datasetId"}})],1)]),_vm._v(" "),_vm._l((_vm.columnDefinitions),function(v,k){return _c('div',{key:k,staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId(k)}},[_vm._v(_vm._s(v))]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('column-select',{attrs:{"id":_vm.safeId(k),"value":_vm.columnMap[k],"dataset-id":_vm.datasetId},on:{"input":function (val) {
          _vm.columnMap[k] = val
          _vm.columnMap = _vm.columnMap
        }}})],1)])})],2),_vm._v(" "),_c('window-tab',{attrs:{"title":"Settings","icon":"cog"}},[_c('template-settings',{attrs:{"templateId":_vm.templateId}},[_c('number-input-group',{attrs:{"label":"Page interval (s)"},model:{value:(_vm.pageIntervalSecs),callback:function ($$v) {_vm.pageIntervalSecs=$$v},expression:"pageIntervalSecs"}}),_vm._v(" "),_c('number-input-group',{attrs:{"label":"Items per page"},model:{value:(_vm.itemsPerPage),callback:function ($$v) {_vm.itemsPerPage=$$v},expression:"itemsPerPage"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_swiss_wrestling_leaderboard_vue__ = __webpack_require__(1787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73da3502_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_swiss_wrestling_leaderboard_vue__ = __webpack_require__(1788);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_swiss_wrestling_leaderboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73da3502_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_swiss_wrestling_leaderboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_action_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_mutation_types__ = __webpack_require__(14);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'swiss-wrestling-leaderboard',
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins__["b" /* templateMixin */]],
  data: function data() {
    return {
      gangOptions: new Array(6).fill(null).map(function (v, i) {
        return { label: i + 1 + '. Gang', value: i + 1 };
      }),
      columnDefinitions: {
        'bibNumber': 'Bib number',
        'lastName': 'Last name',
        'firstName': 'First name',
        'country': 'Country',
        'club': 'Club',
        'rank': 'Rank',
        'score': 'Score',
        'diff': 'Diff',
        'qualified': 'Qualified',
        'windSpeed': 'Wind speed'
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4__utils__["c" /* mapOverlayData */])(['title', 'subtitle']), Object(__WEBPACK_IMPORTED_MODULE_4__utils__["c" /* mapOverlayData */])({ 'records': { default: [] } }), Object(__WEBPACK_IMPORTED_MODULE_4__utils__["d" /* mapOverlayOptions */])({
    pageIntervalSecs: { default: 0 },
    itemsPerPage: { default: 8 }
  }), Object(__WEBPACK_IMPORTED_MODULE_4__utils__["f" /* mapTemplateData */])(['datasetId', 'gang']), Object(__WEBPACK_IMPORTED_MODULE_4__utils__["f" /* mapTemplateData */])({ columnMap: { default: {} } }), {
    records: function records() {
      var _this = this;

      var dataset = this.$store.getters.dataset(this.datasetId);
      if (!dataset) return [];
      var records = [].concat(dataset.records);
      records.sort(function (a, b) {
        return parseInt(a.SORT_ORDER) - parseInt(b.SORT_ORDER);
      });
      return records.map(function (record) {
        return _this.mapRecord(record, _this.columnMap);
      });
    }
  }),
  watch: {
    gang: function gang(val) {
      var dataset = this.$store.getters.dataset(this.datasetId);
      if (!dataset || !dataset.fileName) return;

      var fileName = dataset.fileName;
      var queryStringIndex = fileName.indexOf('?');

      if (queryStringIndex !== -1) {
        var baseUrl = fileName.substring(0, queryStringIndex); // Extract base URL
        var queryString = fileName.substring(queryStringIndex); // Extract query string

        // Use regex to find and replace attributes.gang with the new value
        var updatedQueryString = queryString.replace(/(attributes\.gang=)\d+/, '$1' + val);

        // Rebuild the fileName string with updated query parameters
        fileName = baseUrl + updatedQueryString;

        // Check if fileName has changed
        if (fileName !== dataset.fileName) {
          // Commit the updated fileName to the store
          this.$store.commit(__WEBPACK_IMPORTED_MODULE_6__store_mutation_types__["o" /* DATASET_UPDATE_META */], {
            datasetId: dataset.datasetId,
            fileName: fileName,
            emit: true
          });
        }
      }
    },
    records: function records(val) {
      var records = val.map(function (record, idx) {
        record = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, record);
        while (record['score'].startsWith('00:')) {
          record['score'] = record['score'].substring(3);
        }
        if (idx > 0) {
          if (record['diff']) {
            var firstChar = record['diff'][0];
            record['score'] = (['+', '-', '.'].indexOf(firstChar) < 0 ? '+' : '') + record['diff'];
          }
        }
        return record;
      });
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_5__store_action_types__["z" /* TEMPLATE_OVERLAY_DATA */], {
        templateId: this.templateId,
        data: { records: records }
      });
    }
  },
  methods: {
    mapRecord: function mapRecord(record, columnMap) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(columnMap).reduce(function (result, key) {
        result[key] = record[columnMap[key]];
        return result;
      }, {});
    }
  }
});

/***/ }),
/* 1788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('window',{attrs:{"window-id":_vm.windowId}},[_c('window-tab',{attrs:{"title":_vm.windowTitle}},[_c('switch-buttons',{attrs:{"template-id":_vm.templateId}}),_vm._v(" "),_c('text-input-group',{attrs:{"label":"Title"},model:{value:(_vm.title),callback:function ($$v) {_vm.title=$$v},expression:"title"}}),_vm._v(" "),_c('text-input-group',{attrs:{"label":"Subtitle"},model:{value:(_vm.subtitle),callback:function ($$v) {_vm.subtitle=$$v},expression:"subtitle"}}),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('gang')}},[_vm._v("Gang")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('b-form-select',{attrs:{"id":_vm.safeId('gang'),"options":_vm.gangOptions,"text-field":"label","value-field":"value"},model:{value:(_vm.gang),callback:function ($$v) {_vm.gang=$$v},expression:"gang"}})],1)]),_vm._v(" "),_c('table-edit',{attrs:{"cols":_vm.columnDefinitions,"rows":_vm.records}})],1),_vm._v(" "),_c('window-tab',{attrs:{"title":"Data","icon":"database"}},[_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('datasetId')}},[_vm._v("Dataset")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('dataset-select',{attrs:{"id":_vm.safeId('datasetId')},model:{value:(_vm.datasetId),callback:function ($$v) {_vm.datasetId=$$v},expression:"datasetId"}})],1)]),_vm._v(" "),_vm._l((_vm.columnDefinitions),function(v,k){return _c('div',{key:k,staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId(k)}},[_vm._v(_vm._s(v))]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('column-select',{attrs:{"id":_vm.safeId(k),"value":_vm.columnMap[k],"dataset-id":_vm.datasetId},on:{"input":function (val) {
          _vm.columnMap[k] = val
          _vm.columnMap = _vm.columnMap
        }}})],1)])})],2),_vm._v(" "),_c('window-tab',{attrs:{"title":"Settings","icon":"cog"}},[_c('template-settings',{attrs:{"templateId":_vm.templateId}},[_c('number-input-group',{attrs:{"label":"Page interval (s)"},model:{value:(_vm.pageIntervalSecs),callback:function ($$v) {_vm.pageIntervalSecs=$$v},expression:"pageIntervalSecs"}}),_vm._v(" "),_c('number-input-group',{attrs:{"label":"Items per page"},model:{value:(_vm.itemsPerPage),callback:function ($$v) {_vm.itemsPerPage=$$v},expression:"itemsPerPage"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_swiss_wrestling_notenblatt_vue__ = __webpack_require__(1790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a658044_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_swiss_wrestling_notenblatt_vue__ = __webpack_require__(1791);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_swiss_wrestling_notenblatt_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a658044_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_swiss_wrestling_notenblatt_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_action_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__ = __webpack_require__(14);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'swiss-wrestling-notenblatt',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins__["b" /* templateMixin */]],
  data: function data() {
    return {
      gangOptions: new Array(6).fill(null).map(function (v, i) {
        return { label: i + 1 + '. Gang', value: i + 1 };
      }),
      columnDefinitions: {
        'bibNumber1': 'Startnummer 1',
        'lastName1': 'Nachname 1',
        'firstName1': 'Vorname 1',
        'stars1': 'Sterne 1',
        'result1': 'Resultat 1',
        'score1': 'Punkte 1',
        'bibNumber2': 'Startnummer 2',
        'lastName2': 'Nachname 2',
        'firstName2': 'Vorname 2',
        'stars2': 'Sterne 2',
        'result2': 'Resultat 2',
        'score2': 'Punkte 2'
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3__utils__["c" /* mapOverlayData */])(['athlete', 'rank', 'score', 'bibNumber']), Object(__WEBPACK_IMPORTED_MODULE_3__utils__["c" /* mapOverlayData */])({ 'records': { default: [] } }), Object(__WEBPACK_IMPORTED_MODULE_3__utils__["d" /* mapOverlayOptions */])({ pageIntervalSecs: { default: 0 }, itemsPerPage: { default: 6 } }), Object(__WEBPACK_IMPORTED_MODULE_3__utils__["f" /* mapTemplateData */])(['sponsorsAlbumId', 'datasetId']), Object(__WEBPACK_IMPORTED_MODULE_3__utils__["f" /* mapTemplateData */])({ columnMap: { default: {} } }), {
    records: function records() {
      var _this = this;

      var dataset = this.$store.getters.dataset(this.datasetId);
      if (!dataset) return [];
      var records = [].concat(dataset.records);
      records.sort(function (a, b) {
        return parseInt(a.SORT_ORDER) - parseInt(b.SORT_ORDER);
      });
      return records.map(function (record) {
        return _this.mapRecord(record, _this.columnMap);
      });
    }
  }),
  watch: {
    bibNumber: function bibNumber(val) {
      var dataset = this.$store.getters.dataset(this.datasetId);
      if (!dataset || !dataset.fileName) return;

      var fileName = dataset.fileName;
      var queryStringIndex = fileName.indexOf('?');

      if (queryStringIndex !== -1) {
        var baseUrl = fileName.substring(0, queryStringIndex); // Extract base URL
        var queryString = fileName.substring(queryStringIndex); // Extract query string

        // Use regex to find and replace participants.bibNumber with the new value
        var updatedQueryString = queryString.replace(/(participants\.bibNumber=)\d+/, '$1' + val);

        // Rebuild the fileName string with updated query parameters
        fileName = baseUrl + updatedQueryString;

        // Check if fileName has changed
        if (fileName !== dataset.fileName) {
          // Commit the updated fileName to the store
          this.$store.commit(__WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["o" /* DATASET_UPDATE_META */], {
            datasetId: dataset.datasetId,
            fileName: fileName,
            emit: true
          });
        }
      }
    },
    records: function records(val) {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__store_action_types__["z" /* TEMPLATE_OVERLAY_DATA */], {
        templateId: this.templateId,
        data: { records: val }
      });
    },
    sponsorsAlbumId: function sponsorsAlbumId(val) {
      var album = this.$store.getters.album(val) || {};
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__store_action_types__["z" /* TEMPLATE_OVERLAY_DATA */], {
        templateId: this.templateId,
        data: { sponsors: album.pictures }
      });
    }
  },
  methods: {
    mapRecord: function mapRecord(record, columnMap) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(columnMap).reduce(function (result, key) {
        result[key] = record[columnMap[key]];
        return result;
      }, {});
    }
  }
});

/***/ }),
/* 1791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('window',{attrs:{"window-id":_vm.windowId}},[_c('window-tab',{attrs:{"title":_vm.windowTitle}},[_c('switch-buttons',{attrs:{"template-id":_vm.templateId}}),_vm._v(" "),_c('text-input-group',{attrs:{"label":"Bib Number"},model:{value:(_vm.bibNumber),callback:function ($$v) {_vm.bibNumber=$$v},expression:"bibNumber"}}),_vm._v(" "),_c('table-edit',{attrs:{"cols":_vm.columnDefinitions,"rows":_vm.records}})],1),_vm._v(" "),_c('window-tab',{attrs:{"title":"Data","icon":"database"}},[_c('album-select-group',{model:{value:(_vm.sponsorsAlbumId),callback:function ($$v) {_vm.sponsorsAlbumId=$$v},expression:"sponsorsAlbumId"}}),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('datasetId')}},[_vm._v("Dataset")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('dataset-select',{attrs:{"id":_vm.safeId('datasetId')},model:{value:(_vm.datasetId),callback:function ($$v) {_vm.datasetId=$$v},expression:"datasetId"}})],1)]),_vm._v(" "),_vm._l((_vm.columnDefinitions),function(v,k){return _c('div',{key:k,staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId(k)}},[_vm._v(_vm._s(v))]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('column-select',{attrs:{"id":_vm.safeId(k),"value":_vm.columnMap[k],"dataset-id":_vm.datasetId},on:{"input":function (val) {
          _vm.columnMap[k] = val
          _vm.columnMap = _vm.columnMap
        }}})],1)])})],2),_vm._v(" "),_c('window-tab',{attrs:{"title":"Settings","icon":"cog"}},[_c('template-settings',{attrs:{"templateId":_vm.templateId}},[_c('number-input-group',{attrs:{"label":"Page interval (s)"},model:{value:(_vm.pageIntervalSecs),callback:function ($$v) {_vm.pageIntervalSecs=$$v},expression:"pageIntervalSecs"}}),_vm._v(" "),_c('number-input-group',{attrs:{"label":"Items per page"},model:{value:(_vm.itemsPerPage),callback:function ($$v) {_vm.itemsPerPage=$$v},expression:"itemsPerPage"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_swiss_wrestling_result_vue__ = __webpack_require__(1793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47c5ed11_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_swiss_wrestling_result_vue__ = __webpack_require__(1794);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_swiss_wrestling_result_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47c5ed11_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_swiss_wrestling_result_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_index__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'swiss-wrestling-result',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins__["b" /* templateMixin */]],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["c" /* mapOverlayData */])(['color1', 'color2', 'title1', 'title2', 'score1', 'score2', 'club1', 'club2']), Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["f" /* mapTemplateData */])(['datasetId', 'recordId1', 'recordId2']), Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["f" /* mapTemplateData */])({
    /* eslint-disable no-template-curly-in-string */
    patternColor: { default: '${COLOR}' },
    patternTitle: { default: '${NAME}' },
    patternScore: { default: '${NOTE}' },
    patternClub: { default: '${CLUB}'
      /* eslint-enable no-template-curly-in-string */
    } }), Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["g" /* mapTemplateOptions */])({ 'allowSameColor': false }), {
    dataset: function dataset() {
      if (!this.datasetId) return null;
      return this.$store.getters.dataset(this.datasetId);
    },
    datasetColumns: function datasetColumns() {
      if (!this.dataset) return;
      return this.dataset.columns || [];
    },
    colorOptions: function colorOptions() {
      return { 'hell': 'Hell', 'dunkel': 'Dunkel' };
    },
    scoreOptions: function scoreOptions() {
      return ['', '10.00', '9.75', '9.00', '8.75', '8.50'];
    }
  }),
  watch: {
    recordId1: function recordId1(val) {
      if (!val) return;
      var record = this.$store.getters.dataset(this.datasetId).records.find(function (r) {
        return r.recordId === val;
      });
      if (!record) return;
      record = this.mapRecord(record);
      this.color1 = record.color;
      this.title1 = record.title;
      this.score1 = record.score;
      this.club1 = record.club;
    },
    recordId2: function recordId2(val) {
      if (!val) return;
      var record = this.$store.getters.dataset(this.datasetId).records.find(function (r) {
        return r.recordId === val;
      });
      if (!record) return;
      record = this.mapRecord(record);
      this.color2 = record.color;
      this.title2 = record.title;
      this.score2 = record.score;
      this.club2 = record.club;
    },
    color1: function color1(val) {
      if (!this.allowSameColor) {
        this.color2 = val === 'hell' ? 'dunkel' : 'hell';
      }
    },
    color2: function color2(val) {
      if (!this.allowSameColor) {
        this.color1 = val === 'hell' ? 'dunkel' : 'hell';
      }
    }
  },
  methods: {
    mapRecord: function mapRecord(record) {
      var result = {};
      var recordMap = {
        color: this.patternColor,
        title: this.patternTitle,
        score: this.patternScore,
        club: this.patternClub
      };
      for (var k in recordMap) {
        if (!recordMap.hasOwnProperty(k)) continue;
        result[k] = recordMap[k].replace(/\$\{([\w ]+)\}/g, function (match, p1) {
          return record[p1] || '';
        });
      }
      return result;
    }
  }
});

/***/ }),
/* 1794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('window',{attrs:{"window-id":_vm.windowId}},[_c('window-tab',{attrs:{"title":_vm.windowTitle}},[_c('switch-buttons',{attrs:{"template-id":_vm.templateId}}),_vm._v(" "),(_vm.datasetId)?_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('record')}},[_vm._v("Wrestler 1")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('record-select',{attrs:{"id":_vm.safeId('record'),"dataset-id":_vm.datasetId},model:{value:(_vm.recordId1),callback:function ($$v) {_vm.recordId1=$$v},expression:"recordId1"}})],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('color1')}},[_vm._v("Color 1")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('b-form-select',{attrs:{"id":_vm.safeId('color1'),"options":_vm.colorOptions},model:{value:(_vm.color1),callback:function ($$v) {_vm.color1=$$v},expression:"color1"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('title1')}},[_vm._v("Name 1")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.title1),expression:"title1",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('title1')},domProps:{"value":(_vm.title1)},on:{"change":function($event){_vm.title1=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('score1')}},[_vm._v("Score 1")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('b-form-select',{attrs:{"id":_vm.safeId('score1'),"options":_vm.scoreOptions},model:{value:(_vm.score1),callback:function ($$v) {_vm.score1=$$v},expression:"score1"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('club1')}},[_vm._v("Club 1")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.club1),expression:"club1",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('club1')},domProps:{"value":(_vm.club1)},on:{"change":function($event){_vm.club1=$event.target.value}}})])]),_vm._v(" "),(_vm.datasetId)?_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('record')}},[_vm._v("Wrestler 2")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('record-select',{attrs:{"id":_vm.safeId('record'),"dataset-id":_vm.datasetId},model:{value:(_vm.recordId2),callback:function ($$v) {_vm.recordId2=$$v},expression:"recordId2"}})],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('color2')}},[_vm._v("Color 2")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('b-form-select',{attrs:{"id":_vm.safeId('color2'),"options":_vm.colorOptions},model:{value:(_vm.color2),callback:function ($$v) {_vm.color2=$$v},expression:"color2"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('title2')}},[_vm._v("Name 2")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.title2),expression:"title2",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('title2')},domProps:{"value":(_vm.title2)},on:{"change":function($event){_vm.title2=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('score2')}},[_vm._v("Score 2")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('b-form-select',{attrs:{"id":_vm.safeId('score2'),"options":_vm.scoreOptions},model:{value:(_vm.score2),callback:function ($$v) {_vm.score2=$$v},expression:"score2"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('club2')}},[_vm._v("Club 2")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.club2),expression:"club2",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('club2')},domProps:{"value":(_vm.club2)},on:{"change":function($event){_vm.club2=$event.target.value}}})])])],1),_vm._v(" "),_c('window-tab',{attrs:{"title":"Data","icon":"database"}},[_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('datasetId')}},[_vm._v("Dataset")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('dataset-select',{attrs:{"id":_vm.safeId('datasetId')},model:{value:(_vm.datasetId),callback:function ($$v) {_vm.datasetId=$$v},expression:"datasetId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label"},[_vm._v("Fields")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{staticClass:"form-control-plaintext",attrs:{"type":"text","readonly":""},domProps:{"value":_vm.datasetColumns}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternTitle')}},[_vm._v("Name")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternTitle),expression:"patternTitle",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternTitle')},domProps:{"value":(_vm.patternTitle)},on:{"change":function($event){_vm.patternTitle=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternScore')}},[_vm._v("Score")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternScore),expression:"patternScore",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternScore')},domProps:{"value":(_vm.patternScore)},on:{"change":function($event){_vm.patternScore=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternClub')}},[_vm._v("Club")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternClub),expression:"patternClub",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternClub')},domProps:{"value":(_vm.patternClub)},on:{"change":function($event){_vm.patternClub=$event.target.value}}})])])]),_vm._v(" "),_c('window-tab',{attrs:{"title":"Settings","icon":"cog"}},[_c('template-settings',{attrs:{"templateId":_vm.templateId}},[_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('allowSameColor')}},[_vm._v("Allow same color")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8",staticStyle:{"padding-top":"5px"}},[_c('b-form-checkbox',{attrs:{"id":_vm.safeId('allowSameColor')},model:{value:(_vm.allowSameColor),callback:function ($$v) {_vm.allowSameColor=$$v},expression:"allowSameColor"}})],1)])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_swiss_wrestling_result_2024_vue__ = __webpack_require__(1796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e1926990_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_swiss_wrestling_result_2024_vue__ = __webpack_require__(1797);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_swiss_wrestling_result_2024_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e1926990_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_swiss_wrestling_result_2024_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_index__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_mutation_types__ = __webpack_require__(14);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'swiss-wrestling-result-2024',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins__["b" /* templateMixin */]],
  data: function data() {
    return {
      rinkOptions: new Array(10).fill(null).map(function (v, i) {
        return { label: '' + (i + 1), value: i + 1 };
      })
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["c" /* mapOverlayData */])(['color1', 'color2', 'title1', 'title2', 'score1', 'score2', 'club1', 'club2']), Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["f" /* mapTemplateData */])(['rink', 'datasetId', 'recordId']), Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["f" /* mapTemplateData */])({
    /* eslint-disable no-template-curly-in-string */
    patternColor1: { default: '${p1_a_farbe}' },
    patternTitle1: { default: '${p1_lastName} ${p1_firstName} ${p1_a_sterne}' },
    patternClub1: { default: '${p1_a_verband}, ${p1_a_wohnort}' },
    patternScore1: { default: '${p1_a_note}' },
    patternColor2: { default: '${p2_a_farbe}' },
    patternTitle2: { default: '${p2_lastName} ${p2_firstName} ${p2_a_sterne}' },
    patternClub2: { default: '${p2_a_verband}, ${p2_a_wohnort}' },
    patternScore2: { default: '${p2_a_note}'
      /* eslint-enable no-template-curly-in-string */
    } }), Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["g" /* mapTemplateOptions */])({ 'allowSameColor': false }), {
    dataset: function dataset() {
      if (!this.datasetId) return null;
      return this.$store.getters.dataset(this.datasetId);
    },
    datasetColumns: function datasetColumns() {
      if (!this.dataset) return;
      return this.dataset.columns || [];
    },
    colorOptions: function colorOptions() {
      return { 'hell': 'Hell', 'dunkel': 'Dunkel' };
    },
    scoreOptions: function scoreOptions() {
      return ['', '10.00', '9.75', '9.00', '8.75', '8.50'];
    }
  }),
  watch: {
    rink: function rink(val) {
      var dataset = this.$store.getters.dataset(this.datasetId);
      if (!dataset || !dataset.fileName) return;

      var fileName = dataset.fileName;
      var queryStringIndex = fileName.indexOf('?');

      if (queryStringIndex !== -1) {
        var baseUrl = fileName.substring(0, queryStringIndex); // Extract base URL
        var queryString = fileName.substring(queryStringIndex); // Extract query string

        // Use regex to find and replace attributes.platz with the new value
        var updatedQueryString = queryString.replace(/(attributes\.platz=)\d+/, '$1' + val);

        // Rebuild the fileName string with updated query parameters
        fileName = baseUrl + updatedQueryString;

        // Check if fileName has changed
        if (fileName !== dataset.fileName) {
          // Commit the updated fileName to the store
          this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types__["o" /* DATASET_UPDATE_META */], {
            datasetId: dataset.datasetId,
            fileName: fileName,
            emit: true
          });
        }
      }
    },
    recordId: function recordId(val) {
      if (!val) return;
      var record = this.$store.getters.dataset(this.datasetId).records.find(function (r) {
        return r.recordId === val;
      });
      if (!record) return;
      record = this.mapRecord(record);
      this.color1 = record.color1;
      this.title1 = record.title1;
      this.club1 = record.club1;
      this.score1 = record.score1;
      this.color2 = record.color2;
      this.title2 = record.title2;
      this.club2 = record.club2;
      this.color2 = record.color2;
      this.score2 = record.score2;
    },
    color1: function color1(val) {
      if (!this.allowSameColor) {
        this.color2 = val === 'hell' ? 'dunkel' : 'hell';
      }
    },
    color2: function color2(val) {
      if (!this.allowSameColor) {
        this.color1 = val === 'hell' ? 'dunkel' : 'hell';
      }
    }
  },
  methods: {
    labelFn: function labelFn(record) {
      return [record['p1_bibNumber'] || record['p1_a_startnummer'] || '', record['p1_lastName'] || '', record['p1_firstName'] || '', record['p1_a_note'] || '', '-', record['p2_bibNumber'] || record['p2_a_startnummer'] || '', record['p2_lastName'] || '', record['p2_firstName'] || '', record['p2_a_note'] || '', '-', record['a_status']].join(' ');
    },
    mapRecord: function mapRecord(record) {
      var result = {};
      var recordMap = {
        color1: this.patternColor1,
        title1: this.patternTitle1,
        club1: this.patternClub1,
        score1: this.patternScore1,
        color2: this.patternColor2,
        title2: this.patternTitle2,
        club2: this.patternClub2,
        score2: this.patternScore2
      };
      for (var k in recordMap) {
        if (!recordMap.hasOwnProperty(k)) continue;
        result[k] = recordMap[k].replace(/\$\{([\w ]+)\}/g, function (match, p1) {
          return record[p1] || '';
        });
      }
      return result;
    }
  }
});

/***/ }),
/* 1797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('window',{attrs:{"window-id":_vm.windowId}},[_c('window-tab',{attrs:{"title":_vm.windowTitle}},[_c('switch-buttons',{attrs:{"template-id":_vm.templateId}}),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('rink')}},[_vm._v("Platz")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('b-form-select',{attrs:{"id":_vm.safeId('rink'),"options":_vm.rinkOptions,"text-field":"label","value-field":"value"},model:{value:(_vm.rink),callback:function ($$v) {_vm.rink=$$v},expression:"rink"}})],1)]),_vm._v(" "),(_vm.datasetId)?_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('record')}},[_vm._v("Paarung")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('record-select',{attrs:{"id":_vm.safeId('record'),"dataset-id":_vm.datasetId,"label-fn":_vm.labelFn},model:{value:(_vm.recordId),callback:function ($$v) {_vm.recordId=$$v},expression:"recordId"}})],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('color1')}},[_vm._v("Color 1")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('b-form-select',{attrs:{"id":_vm.safeId('color1'),"options":_vm.colorOptions},model:{value:(_vm.color1),callback:function ($$v) {_vm.color1=$$v},expression:"color1"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('title1')}},[_vm._v("Name 1")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.title1),expression:"title1",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('title1')},domProps:{"value":(_vm.title1)},on:{"change":function($event){_vm.title1=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('club1')}},[_vm._v("Club 1")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.club1),expression:"club1",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('club1')},domProps:{"value":(_vm.club1)},on:{"change":function($event){_vm.club1=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('score1')}},[_vm._v("Score 1")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('b-form-select',{attrs:{"id":_vm.safeId('score1'),"options":_vm.scoreOptions},model:{value:(_vm.score1),callback:function ($$v) {_vm.score1=$$v},expression:"score1"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('color2')}},[_vm._v("Color 2")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('b-form-select',{attrs:{"id":_vm.safeId('color2'),"options":_vm.colorOptions},model:{value:(_vm.color2),callback:function ($$v) {_vm.color2=$$v},expression:"color2"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('title2')}},[_vm._v("Name 2")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.title2),expression:"title2",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('title2')},domProps:{"value":(_vm.title2)},on:{"change":function($event){_vm.title2=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('club2')}},[_vm._v("Club 2")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.club2),expression:"club2",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('club2')},domProps:{"value":(_vm.club2)},on:{"change":function($event){_vm.club2=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('score2')}},[_vm._v("Score 2")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('b-form-select',{attrs:{"id":_vm.safeId('score2'),"options":_vm.scoreOptions},model:{value:(_vm.score2),callback:function ($$v) {_vm.score2=$$v},expression:"score2"}})],1)])],1),_vm._v(" "),_c('window-tab',{attrs:{"title":"Data","icon":"database"}},[_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('datasetId')}},[_vm._v("Dataset")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('dataset-select',{attrs:{"id":_vm.safeId('datasetId')},model:{value:(_vm.datasetId),callback:function ($$v) {_vm.datasetId=$$v},expression:"datasetId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label"},[_vm._v("Fields")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{staticClass:"form-control-plaintext",attrs:{"type":"text","readonly":""},domProps:{"value":_vm.datasetColumns}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternColor1')}},[_vm._v("Color 1")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternColor1),expression:"patternColor1",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternColor1')},domProps:{"value":(_vm.patternColor1)},on:{"change":function($event){_vm.patternColor1=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternTitle1')}},[_vm._v("Title 1")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternTitle1),expression:"patternTitle1",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternTitle1')},domProps:{"value":(_vm.patternTitle1)},on:{"change":function($event){_vm.patternTitle1=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternClub1')}},[_vm._v("Club 1")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternClub1),expression:"patternClub1",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternClub1')},domProps:{"value":(_vm.patternClub1)},on:{"change":function($event){_vm.patternClub1=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternScore1')}},[_vm._v("Score 1")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternScore1),expression:"patternScore1",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternScore1')},domProps:{"value":(_vm.patternScore1)},on:{"change":function($event){_vm.patternScore1=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternColor2')}},[_vm._v("Color 2")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternColor2),expression:"patternColor2",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternColor2')},domProps:{"value":(_vm.patternColor2)},on:{"change":function($event){_vm.patternColor2=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternTitle2')}},[_vm._v("Title 2")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternTitle2),expression:"patternTitle2",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternTitle2')},domProps:{"value":(_vm.patternTitle2)},on:{"change":function($event){_vm.patternTitle2=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternClub2')}},[_vm._v("Club 2")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternClub2),expression:"patternClub2",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternClub2')},domProps:{"value":(_vm.patternClub2)},on:{"change":function($event){_vm.patternClub2=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternScore2')}},[_vm._v("Score 2")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternScore2),expression:"patternScore2",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternScore2')},domProps:{"value":(_vm.patternScore2)},on:{"change":function($event){_vm.patternScore2=$event.target.value}}})])])]),_vm._v(" "),_c('window-tab',{attrs:{"title":"Settings","icon":"cog"}},[_c('template-settings',{attrs:{"templateId":_vm.templateId}},[_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('allowSameColor')}},[_vm._v("Allow same color")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8",staticStyle:{"padding-top":"5px"}},[_c('b-form-checkbox',{attrs:{"id":_vm.safeId('allowSameColor')},model:{value:(_vm.allowSameColor),callback:function ($$v) {_vm.allowSameColor=$$v},expression:"allowSameColor"}})],1)])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_swiss_wrestling_steckbrief_vue__ = __webpack_require__(1799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_86e56f92_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_swiss_wrestling_steckbrief_vue__ = __webpack_require__(1800);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_swiss_wrestling_steckbrief_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_86e56f92_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_swiss_wrestling_steckbrief_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_index__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_action_types__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'swiss-wrestling-steckbrief',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins__["b" /* templateMixin */]],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["c" /* mapOverlayData */])(['title', 'alter', 'groesse', 'gewicht', 'beruf', 'wohnort', 'totalKraenze']), Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["f" /* mapTemplateData */])(['datasetId', 'recordId']), Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["f" /* mapTemplateData */])({
    /* eslint-disable no-template-curly-in-string */
    patternTitle: { default: '${lastName} ${firstName} ${a_sterne} ${a_verband}' },
    patternAlter: { default: '${birthdate}' },
    patternGroesse: { default: '${a_groesse}' },
    patternGewicht: { default: '${a_gewicht}' },
    patternBeruf: { default: '${a_beruf}' },
    patternWohnort: { default: '${a_wohnort}' },
    patternTotalKraenze: { default: '${a_totalKraenze}'
      /* eslint-enable no-template-curly-in-string */
    } }), {
    dataset: function dataset() {
      if (!this.datasetId) return null;
      return this.$store.getters.dataset(this.datasetId);
    },
    datasetColumns: function datasetColumns() {
      if (!this.dataset) return;
      return this.dataset.columns || [];
    }
  }),
  watch: {
    sponsorsAlbumId: function sponsorsAlbumId(val) {
      var album = this.$store.getters.album(val) || {};
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__store_action_types__["z" /* TEMPLATE_OVERLAY_DATA */], {
        templateId: this.templateId,
        data: { sponsors: album.pictures }
      });
    },
    recordId: function recordId(val) {
      if (!val) return;
      var record = this.$store.getters.dataset(this.datasetId).records.find(function (r) {
        return r.recordId === val;
      });
      if (!record) return;
      record = this.mapRecord(record);
      this.title = record.title;
      this.alter = record.alter;
      this.groesse = record.groesse;
      this.gewicht = record.gewicht;
      this.beruf = record.beruf;
      this.wohnort = record.wohnort;
      this.totalKraenze = record.totalKraenze;
    }
  },
  methods: {
    nextRecord: function nextRecord(prevRecordId, datasetId) {
      var records = this.$store.getters.datasetRecords(datasetId);
      var index = records.findIndex(function (p) {
        return p.recordId === prevRecordId;
      });
      this.recordId = records.length > index + 1 ? records[index + 1].recordId : records[0].recordId;
    },
    mapRecord: function mapRecord(record) {
      var result = {};
      var recordMap = {
        title: this.patternTitle,
        alter: this.patternAlter,
        groesse: this.patternGroesse,
        gewicht: this.patternGewicht,
        beruf: this.patternBeruf,
        wohnort: this.patternWohnort,
        totalKraenze: this.patternTotalKraenze
      };
      for (var k in recordMap) {
        if (!recordMap.hasOwnProperty(k)) continue;
        result[k] = recordMap[k].replace(/\$\{([\w ]+)\}/g, function (match, p1) {
          return record[p1] || '';
        });
      }
      return result;
    }
  }
});

/***/ }),
/* 1800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('window',{attrs:{"window-id":_vm.windowId}},[_c('window-tab',{attrs:{"title":_vm.windowTitle}},[_c('switch-buttons',{attrs:{"template-id":_vm.templateId}}),_vm._v(" "),(_vm.datasetId)?_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('record')}},[_vm._v("Record")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('record-select',{attrs:{"id":_vm.safeId('record'),"dataset-id":_vm.datasetId},model:{value:(_vm.recordId),callback:function ($$v) {_vm.recordId=$$v},expression:"recordId"}})],1)]):_vm._e(),_vm._v(" "),(_vm.datasetId)?_c('div',{staticClass:"form-group form-row"},[_c('div',{staticClass:"col-sm-4"}),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('button',{staticClass:"btn btn-block btn-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.nextRecord(_vm.recordId, _vm.datasetId)}}},[_vm._v("Next")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('title')}},[_vm._v("Titel")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.title),expression:"title",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('title')},domProps:{"value":(_vm.title)},on:{"change":function($event){_vm.title=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('alter')}},[_vm._v("Alter")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.alter),expression:"alter",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('alter')},domProps:{"value":(_vm.alter)},on:{"change":function($event){_vm.alter=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('groesse')}},[_vm._v("Grösse")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.groesse),expression:"groesse",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('groesse')},domProps:{"value":(_vm.groesse)},on:{"change":function($event){_vm.groesse=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('gewicht')}},[_vm._v("Gewicht")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.gewicht),expression:"gewicht",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('gewicht')},domProps:{"value":(_vm.gewicht)},on:{"change":function($event){_vm.gewicht=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('beruf')}},[_vm._v("Beruf")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.beruf),expression:"beruf",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('beruf')},domProps:{"value":(_vm.beruf)},on:{"change":function($event){_vm.beruf=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('wohnort')}},[_vm._v("Wohnort")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.wohnort),expression:"wohnort",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('wohnort')},domProps:{"value":(_vm.wohnort)},on:{"change":function($event){_vm.wohnort=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('totalKraenze')}},[_vm._v("Total Kränze")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.totalKraenze),expression:"totalKraenze",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('totalKraenze')},domProps:{"value":(_vm.totalKraenze)},on:{"change":function($event){_vm.totalKraenze=$event.target.value}}})])])],1),_vm._v(" "),_c('window-tab',{attrs:{"title":"Data","icon":"database"}},[_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('datasetId')}},[_vm._v("Dataset")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('dataset-select',{attrs:{"id":_vm.safeId('datasetId')},model:{value:(_vm.datasetId),callback:function ($$v) {_vm.datasetId=$$v},expression:"datasetId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label"},[_vm._v("Fields")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{staticClass:"form-control-plaintext",attrs:{"type":"text","readonly":""},domProps:{"value":_vm.datasetColumns}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternTitle')}},[_vm._v("Titel")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternTitle),expression:"patternTitle",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternTitle')},domProps:{"value":(_vm.patternTitle)},on:{"change":function($event){_vm.patternTitle=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternAlter')}},[_vm._v("Alter")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternAlter),expression:"patternAlter",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternAlter')},domProps:{"value":(_vm.patternAlter)},on:{"change":function($event){_vm.patternAlter=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternGroesse')}},[_vm._v("Grösse")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternGroesse),expression:"patternGroesse",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternGroesse')},domProps:{"value":(_vm.patternGroesse)},on:{"change":function($event){_vm.patternGroesse=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternGewicht')}},[_vm._v("Gewicht")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternGewicht),expression:"patternGewicht",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternGewicht')},domProps:{"value":(_vm.patternGewicht)},on:{"change":function($event){_vm.patternGewicht=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternBeruf')}},[_vm._v("Beruf")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternBeruf),expression:"patternBeruf",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternBeruf')},domProps:{"value":(_vm.patternBeruf)},on:{"change":function($event){_vm.patternBeruf=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternWohnort')}},[_vm._v("Wohnort")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternWohnort),expression:"patternWohnort",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternWohnort')},domProps:{"value":(_vm.patternWohnort)},on:{"change":function($event){_vm.patternWohnort=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternTotalKraenze')}},[_vm._v("Total Kränze")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternTotalKraenze),expression:"patternTotalKraenze",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternTotalKraenze')},domProps:{"value":(_vm.patternTotalKraenze)},on:{"change":function($event){_vm.patternTotalKraenze=$event.target.value}}})])])]),_vm._v(" "),_c('window-tab',{attrs:{"title":"Settings","icon":"cog"}},[_c('template-settings',{attrs:{"templateId":_vm.templateId}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tennis_scoreboard_vue__ = __webpack_require__(1802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_036c015b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tennis_scoreboard_vue__ = __webpack_require__(1803);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tennis_scoreboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_036c015b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tennis_scoreboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_index__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_action_types__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'tennis-scoreboard',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins__["b" /* templateMixin */]],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["c" /* mapOverlayData */])(['title1', 'title2', 'sets1', 'sets2', 'games1', 'games2', 'points1', 'points2', 'tiebreak', 'service'])),
  methods: {
    addSets: function addSets(id, value) {
      this.games1 = '0';
      this.games2 = '0';
      this.points1 = '0';
      this.points2 = '0';
      this.tiebreak = '0';
      this.add(id, value, { games1: 0, games2: 0, points1: 0, points2: 0, tiebreak: 0 });
    },
    addGames: function addGames(id, value) {
      this.points1 = '0';
      this.points2 = '0';
      this.tiebreak = '0';
      this.add(id, value, { points1: 0, points2: 0, tiebreak: 0 });
    },
    add: function add(id, value, data) {
      this[id] = '' + ((parseInt(this[id]) || 0) + value);
      data = data || {};
      data[id] = this[id];
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__store_action_types__["p" /* OVERLAY_DATA */], {
        templateId: this.templateId,
        channelIds: ['program', 'preview'],
        data: data
      });
    },
    setTiebreak: function setTiebreak(value) {
      this.points1 = '0';
      this.points2 = '0';
      this.tiebreak = value;
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__store_action_types__["p" /* OVERLAY_DATA */], {
        templateId: this.templateId,
        channelIds: ['program', 'preview'],
        data: { 'points1': 0, 'points2': 0, 'tiebreak': value }
      });
    },
    setService: function setService(value) {
      this.service = value;
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__store_action_types__["p" /* OVERLAY_DATA */], {
        templateId: this.templateId,
        channelIds: ['program', 'preview'],
        data: { 'service': value }
      });
    }
  }
});

/***/ }),
/* 1803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('window',{attrs:{"window-id":_vm.windowId}},[_c('window-tab',{attrs:{"title":_vm.windowTitle}},[_c('switch-buttons',{attrs:{"template-id":_vm.templateId}}),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('title1')}},[_vm._v("Team 1")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.title1),expression:"title1",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('title1')},domProps:{"value":(_vm.title1)},on:{"change":function($event){_vm.title1=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('title2')}},[_vm._v("Team 2")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.title2),expression:"title2",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('title2')},domProps:{"value":(_vm.title2)},on:{"change":function($event){_vm.title2=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('sets1')}},[_vm._v("Sets 1")]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.sets1),expression:"sets1",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"number","id":_vm.safeId('sets1')},domProps:{"value":(_vm.sets1)},on:{"change":function($event){_vm.sets1=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"btn btn-primary btn-block",on:{"click":function($event){_vm.addSets('sets1', -1)}}},[_vm._v("-")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"btn btn-primary btn-block",on:{"click":function($event){_vm.addSets('sets1', 1)}}},[_vm._v("+")])])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('sets2')}},[_vm._v("Sets 2")]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.sets2),expression:"sets2",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"number","id":_vm.safeId('sets2')},domProps:{"value":(_vm.sets2)},on:{"change":function($event){_vm.sets2=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"btn btn-primary btn-block",on:{"click":function($event){_vm.addSets('sets2', -1)}}},[_vm._v("-")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"btn btn-primary btn-block",on:{"click":function($event){_vm.addSets('sets2', 1)}}},[_vm._v("+")])])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('games1')}},[_vm._v("Games 1")]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.games1),expression:"games1",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"number","id":_vm.safeId('games1')},domProps:{"value":(_vm.games1)},on:{"change":function($event){_vm.games1=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"btn btn-primary btn-block",on:{"click":function($event){_vm.addGames('games1', -1)}}},[_vm._v("-")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"btn btn-primary btn-block",on:{"click":function($event){_vm.addGames('games1', 1)}}},[_vm._v("+")])])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('games2')}},[_vm._v("Games 2")]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.games2),expression:"games2",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"number","id":_vm.safeId('games2')},domProps:{"value":(_vm.games2)},on:{"change":function($event){_vm.games2=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"btn btn-primary btn-block",on:{"click":function($event){_vm.addGames('games2', -1)}}},[_vm._v("-")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"btn btn-primary btn-block",on:{"click":function($event){_vm.addGames('games2', 1)}}},[_vm._v("+")])])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-6 col-form-label",attrs:{"for":_vm.safeId('points2')}},[_vm._v("Game / Tiebreak")]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('button',{staticClass:"btn btn-block",class:[_vm.tiebreak !== '1' ? 'btn-warning' : 'btn-secondary'],on:{"click":function($event){_vm.setTiebreak('0')}}},[_vm._v("Game\n        ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('button',{staticClass:"btn btn-block",class:[_vm.tiebreak === '1' ? 'btn-danger' : 'btn-secondary'],on:{"click":function($event){_vm.setTiebreak('1')}}},[_vm._v("Tiebreak\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('points1')}},[_vm._v("Points 1")]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.points1),expression:"points1",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"number","id":_vm.safeId('points1')},domProps:{"value":(_vm.points1)},on:{"change":function($event){_vm.points1=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"btn btn-primary btn-block",on:{"click":function($event){_vm.add('points1', -1)}}},[_vm._v("-")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"btn btn-primary btn-block",on:{"click":function($event){_vm.add('points1', 1)}}},[_vm._v("+")])])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('points2')}},[_vm._v("Points 2")]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.points2),expression:"points2",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"number","id":_vm.safeId('points2')},domProps:{"value":(_vm.points2)},on:{"change":function($event){_vm.points2=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"btn btn-primary btn-block",on:{"click":function($event){_vm.add('points2', -1)}}},[_vm._v("-")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"btn btn-primary btn-block",on:{"click":function($event){_vm.add('points2', 1)}}},[_vm._v("+")])])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-6 col-form-label",attrs:{"for":_vm.safeId('points2')}},[_vm._v("Service")]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"btn btn-block",class:[_vm.service === '0' ? 'btn-primary' : 'btn-secondary'],on:{"click":function($event){_vm.setService('0')}}},[_vm._v("0\n        ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"btn btn-block",class:[_vm.service === '1' ? 'btn-primary' : 'btn-secondary'],on:{"click":function($event){_vm.setService('1')}}},[_vm._v("1\n        ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"btn btn-block",class:[_vm.service === '2' ? 'btn-primary' : 'btn-secondary'],on:{"click":function($event){_vm.setService('2')}}},[_vm._v("2\n        ")])])])],1),_vm._v(" "),_c('window-tab',{attrs:{"title":"Settings","icon":"cog"}},[_c('template-settings',{attrs:{"templateId":_vm.templateId}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_uiaa_lower_third_lead_vue__ = __webpack_require__(1805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59ee878a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_uiaa_lower_third_lead_vue__ = __webpack_require__(1806);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_uiaa_lower_third_lead_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59ee878a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_uiaa_lower_third_lead_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_index__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'uiaa-lower-third-lead',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins__["b" /* templateMixin */]],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["c" /* mapOverlayData */])(['bibNumber', 'name', 'country', 'subtitle']), Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["f" /* mapTemplateData */])(['datasetId', 'recordId', 'albumId', 'portraitId']), Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["f" /* mapTemplateData */])({
    /* eslint-disable no-template-curly-in-string */
    patternBibNumber: { default: '${BIB}' },
    patternName: { default: '${LAST NAME} ${FIRST NAME}' },
    patternCountry: { default: '${COUNTRY}' },
    patternSubtitle: { default: '${SUBTITLE}' },
    patternPortrait: { default: '${BIB}.png'
      /* eslint-enable no-template-curly-in-string */
    } }), {
    dataset: function dataset() {
      if (!this.datasetId) return null;
      return this.$store.getters.dataset(this.datasetId);
    },
    datasetColumns: function datasetColumns() {
      if (!this.dataset) return;
      return this.dataset.columns || [];
    }
  }),
  watch: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    recordId: function recordId(val) {
      if (!val) return;
      var record = this.$store.getters.dataset(this.datasetId).records.find(function (r) {
        return r.recordId === val;
      });
      if (!record) return;
      record = this.mapRecord(record);
      this.bibNumber = record.bibNumber;
      this.name = record.name;
      this.country = record.country;
      this.subtitle = record.subtitle;
      console.log('record', record);
      var portrait = this.$store.getters.picture(this.albumId, function (p) {
        return p.fileName === record.portrait;
      });
      this.portraitId = portrait && portrait.pictureId;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["b" /* mapImageIdToImage */])('albumId', 'portraitId', 'portrait')),
  methods: {
    mapRecord: function mapRecord(record) {
      var result = {};
      var recordMap = {
        bibNumber: this.patternBibNumber,
        name: this.patternName,
        country: this.patternCountry,
        subtitle: this.patternSubtitle,
        portrait: this.patternPortrait
      };
      for (var k in recordMap) {
        if (!recordMap.hasOwnProperty(k)) continue;
        result[k] = recordMap[k].replace(/\$\{([\w ]+)\}/g, function (match, p1) {
          return record[p1] || '';
        });
      }
      return result;
    }
  }
});

/***/ }),
/* 1806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('window',{attrs:{"window-id":_vm.windowId}},[_c('window-tab',{attrs:{"title":_vm.windowTitle}},[_c('switch-buttons',{attrs:{"template-id":_vm.templateId}}),_vm._v(" "),(_vm.datasetId)?_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('record')}},[_vm._v("Record")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('record-select',{attrs:{"id":_vm.safeId('record'),"dataset-id":_vm.datasetId},model:{value:(_vm.recordId),callback:function ($$v) {_vm.recordId=$$v},expression:"recordId"}})],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('bibNumber')}},[_vm._v("Bib number")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.bibNumber),expression:"bibNumber",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('bibNumber')},domProps:{"value":(_vm.bibNumber)},on:{"change":function($event){_vm.bibNumber=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('name')}},[_vm._v("Name")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.name),expression:"name",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('name')},domProps:{"value":(_vm.name)},on:{"change":function($event){_vm.name=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('country')}},[_vm._v("Country")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.country),expression:"country",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('country')},domProps:{"value":(_vm.country)},on:{"change":function($event){_vm.country=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('subtitle')}},[_vm._v("Subtitle")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.subtitle),expression:"subtitle",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('subtitle')},domProps:{"value":(_vm.subtitle)},on:{"change":function($event){_vm.subtitle=$event.target.value}}})])]),_vm._v(" "),_c('picture-select-group',{attrs:{"album-id":_vm.albumId,"label":"Portrait"},model:{value:(_vm.portraitId),callback:function ($$v) {_vm.portraitId=$$v},expression:"portraitId"}})],1),_vm._v(" "),_c('window-tab',{attrs:{"title":"Data","icon":"database"}},[_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('datasetId')}},[_vm._v("Dataset")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('dataset-select',{attrs:{"id":_vm.safeId('datasetId')},model:{value:(_vm.datasetId),callback:function ($$v) {_vm.datasetId=$$v},expression:"datasetId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label"},[_vm._v("Fields")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{staticClass:"form-control-plaintext",attrs:{"type":"text","readonly":""},domProps:{"value":_vm.datasetColumns}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternBibNumber')}},[_vm._v("Bib number")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternBibNumber),expression:"patternBibNumber",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternBibNumber')},domProps:{"value":(_vm.patternBibNumber)},on:{"change":function($event){_vm.patternBibNumber=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternName')}},[_vm._v("Name")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternName),expression:"patternName",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternName')},domProps:{"value":(_vm.patternName)},on:{"change":function($event){_vm.patternName=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternCountry')}},[_vm._v("Country")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternCountry),expression:"patternCountry",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternCountry')},domProps:{"value":(_vm.patternCountry)},on:{"change":function($event){_vm.patternCountry=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternSubtitle')}},[_vm._v("Subtitle")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternSubtitle),expression:"patternSubtitle",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternSubtitle')},domProps:{"value":(_vm.patternSubtitle)},on:{"change":function($event){_vm.patternSubtitle=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternPortrait')}},[_vm._v("Portrait")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternPortrait),expression:"patternPortrait",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternPortrait')},domProps:{"value":(_vm.patternPortrait)},on:{"change":function($event){_vm.patternPortrait=$event.target.value}}})])]),_vm._v(" "),_c('album-select-group',{attrs:{"label":"Portraits"},model:{value:(_vm.albumId),callback:function ($$v) {_vm.albumId=$$v},expression:"albumId"}})],1),_vm._v(" "),_c('window-tab',{attrs:{"title":"Settings","icon":"cog"}},[_c('template-settings',{attrs:{"templateId":_vm.templateId}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_uiaa_lower_third_speed_vue__ = __webpack_require__(1808);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_668c089e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_uiaa_lower_third_speed_vue__ = __webpack_require__(1809);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_uiaa_lower_third_speed_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_668c089e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_uiaa_lower_third_speed_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_index__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'lower-third-athlet',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins__["b" /* templateMixin */]],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["c" /* mapOverlayData */])(['playing1', 'bibNumber1', 'name1', 'country1', 'subtitle1']), Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["c" /* mapOverlayData */])(['playing2', 'bibNumber2', 'name2', 'country2', 'subtitle2']), Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["f" /* mapTemplateData */])(['datasetId', 'recordId1', 'recordId2']), Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["f" /* mapTemplateData */])({
    /* eslint-disable no-template-curly-in-string */
    patternBibNumber: { default: '${BIB}' },
    patternName: { default: '${LAST NAME} ${FIRST NAME}' },
    patternCountry: { default: '${COUNTRY}' },
    patternSubtitle: { default: ''
      /* eslint-enable no-template-curly-in-string */
    } }), {
    dataset: function dataset() {
      if (!this.datasetId) return null;
      return this.$store.getters.dataset(this.datasetId);
    },
    datasetColumns: function datasetColumns() {
      if (!this.dataset) return;
      return this.dataset.columns || [];
    }
  }),
  watch: {
    recordId1: function recordId1(val) {
      if (!val) {
        this.bibNumber1 = '';
        this.name1 = '';
        this.country1 = '';
        this.subtitle1 = '';
        return;
      }
      var record = this.$store.getters.dataset(this.datasetId).records.find(function (r) {
        return r.recordId === val;
      });
      if (!record) return;
      record = this.mapRecord(record);
      this.bibNumber1 = record.bibNumber;
      this.name1 = record.name;
      this.country1 = record.country;
      this.subtitle1 = record.subtitle;
    },
    recordId2: function recordId2(val) {
      if (!val) {
        this.bibNumber2 = '';
        this.name2 = '';
        this.country2 = '';
        this.subtitle2 = '';
        return;
      }
      var record = this.$store.getters.dataset(this.datasetId).records.find(function (r) {
        return r.recordId === val;
      });
      if (!record) return;
      record = this.mapRecord(record);
      this.bibNumber2 = record.bibNumber;
      this.name2 = record.name;
      this.country2 = record.country;
      this.subtitle2 = record.subtitle;
    }
  },
  methods: {
    mapRecord: function mapRecord(record) {
      var result = {};
      var recordMap = {
        bibNumber: this.patternBibNumber,
        name: this.patternName,
        country: this.patternCountry,
        subtitle: this.patternSubtitle
      };
      for (var k in recordMap) {
        if (!recordMap.hasOwnProperty(k)) continue;
        result[k] = recordMap[k].replace(/\$\{([\w ]+)\}/g, function (match, p1) {
          return record[p1] || '';
        });
      }
      return result;
    },
    switchAthletes: function switchAthletes() {
      var temp = this.recordId2;
      this.recordId2 = this.recordId1;
      this.recordId1 = temp;
    }
  }
});

/***/ }),
/* 1809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('window',{attrs:{"window-id":_vm.windowId}},[_c('window-tab',{attrs:{"title":_vm.windowTitle}},[_c('switch-buttons',{attrs:{"template-id":_vm.templateId}}),_vm._v(" "),(_vm.datasetId)?_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('record1')}},[_vm._v("Athlete 1")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('record-select',{attrs:{"id":_vm.safeId('record1'),"dataset-id":_vm.datasetId},model:{value:(_vm.recordId1),callback:function ($$v) {_vm.recordId1=$$v},expression:"recordId1"}})],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('div',{staticClass:"col-sm-8 offset-4"},[_c('div',{staticClass:"form-check form-check-inline"},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.playing1),expression:"playing1"}],staticClass:"form-check-input",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.playing1)?_vm._i(_vm.playing1,null)>-1:(_vm.playing1)},on:{"change":function($event){var $$a=_vm.playing1,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.playing1=$$a.concat([$$v]))}else{$$i>-1&&(_vm.playing1=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.playing1=$$c}}}}),_vm._v("Playing\n          ")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('bibNumber1')}},[_vm._v("Bib number")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.bibNumber1),expression:"bibNumber1",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('bibNumber1')},domProps:{"value":(_vm.bibNumber1)},on:{"change":function($event){_vm.bibNumber1=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('name1')}},[_vm._v("Name")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.name1),expression:"name1",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('name1')},domProps:{"value":(_vm.name1)},on:{"change":function($event){_vm.name1=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('country1')}},[_vm._v("Country")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.country1),expression:"country1",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('country1')},domProps:{"value":(_vm.country1)},on:{"change":function($event){_vm.country1=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('subtitle1')}},[_vm._v("Subtitle")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.subtitle1),expression:"subtitle1",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('subtitle1')},domProps:{"value":(_vm.subtitle1)},on:{"change":function($event){_vm.subtitle1=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('div',{staticClass:"col-sm-12"},[_c('button',{staticClass:"btn btn-block btn-primary",attrs:{"type":"button"},on:{"click":_vm.switchAthletes}},[_vm._v("Switch")])])]),_vm._v(" "),(_vm.datasetId)?_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('record2')}},[_vm._v("Athlete 2")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('record-select',{attrs:{"id":_vm.safeId('record2'),"dataset-id":_vm.datasetId},model:{value:(_vm.recordId2),callback:function ($$v) {_vm.recordId2=$$v},expression:"recordId2"}})],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('div',{staticClass:"col-sm-8 offset-4"},[_c('div',{staticClass:"form-check form-check-inline"},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.playing2),expression:"playing2"}],staticClass:"form-check-input",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.playing2)?_vm._i(_vm.playing2,null)>-1:(_vm.playing2)},on:{"change":function($event){var $$a=_vm.playing2,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.playing2=$$a.concat([$$v]))}else{$$i>-1&&(_vm.playing2=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.playing2=$$c}}}}),_vm._v("Playing\n          ")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('bibNumber2')}},[_vm._v("Bib number")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.bibNumber2),expression:"bibNumber2",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('bibNumber2')},domProps:{"value":(_vm.bibNumber2)},on:{"change":function($event){_vm.bibNumber2=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('name2')}},[_vm._v("Name")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.name2),expression:"name2",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('name2')},domProps:{"value":(_vm.name2)},on:{"change":function($event){_vm.name2=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('country2')}},[_vm._v("Country")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.country2),expression:"country2",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('country2')},domProps:{"value":(_vm.country2)},on:{"change":function($event){_vm.country2=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('subtitle2')}},[_vm._v("Subtitle")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.subtitle2),expression:"subtitle2",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('subtitle2')},domProps:{"value":(_vm.subtitle2)},on:{"change":function($event){_vm.subtitle2=$event.target.value}}})])])],1),_vm._v(" "),_c('window-tab',{attrs:{"title":"Data","icon":"database"}},[_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('datasetId')}},[_vm._v("Dataset")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('dataset-select',{attrs:{"id":_vm.safeId('datasetId')},model:{value:(_vm.datasetId),callback:function ($$v) {_vm.datasetId=$$v},expression:"datasetId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label"},[_vm._v("Fields")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{staticClass:"form-control-plaintext",attrs:{"type":"text","readonly":""},domProps:{"value":_vm.datasetColumns}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternBibNumber')}},[_vm._v("Bib number")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternBibNumber),expression:"patternBibNumber",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternBibNumber')},domProps:{"value":(_vm.patternBibNumber)},on:{"change":function($event){_vm.patternBibNumber=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternName')}},[_vm._v("Name")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternName),expression:"patternName",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternName')},domProps:{"value":(_vm.patternName)},on:{"change":function($event){_vm.patternName=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternCountry')}},[_vm._v("Country")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternCountry),expression:"patternCountry",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternCountry')},domProps:{"value":(_vm.patternCountry)},on:{"change":function($event){_vm.patternCountry=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternSubtitle')}},[_vm._v("Subtitle")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternSubtitle),expression:"patternSubtitle",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternSubtitle')},domProps:{"value":(_vm.patternSubtitle)},on:{"change":function($event){_vm.patternSubtitle=$event.target.value}}})])])]),_vm._v(" "),_c('window-tab',{attrs:{"title":"Settings","icon":"cog"}},[_c('template-settings',{attrs:{"templateId":_vm.templateId}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_uiaa_partner_logos_vue__ = __webpack_require__(1812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7eda4afa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_uiaa_partner_logos_vue__ = __webpack_require__(1813);
function injectStyle (ssrContext) {
  __webpack_require__(1811)
}
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7eda4afa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_uiaa_partner_logos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7eda4afa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_uiaa_partner_logos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1811 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_action_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_album_select_group__ = __webpack_require__(272);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: { AlbumSelectGroup: __WEBPACK_IMPORTED_MODULE_4__ui_album_select_group__["a" /* default */] },
  name: 'uiaa-partner-logos',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins__["b" /* templateMixin */]],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2__utils__["f" /* mapTemplateData */])(['albumId']), Object(__WEBPACK_IMPORTED_MODULE_2__utils__["f" /* mapTemplateData */])({
    'orders': { type: Object, default: {} }
  }), {
    album: function album() {
      return this.$store.getters.album(this.albumId) || {};
    },
    pictures: function pictures() {
      return this.album.pictures || [];
    }
  }),
  methods: {
    updateRecords: function updateRecords() {
      var _this = this;

      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__store_action_types__["s" /* TEMPLATE_DATA */], {
        templateId: this.templateId,
        data: {
          orders: this.orders
        }
      });
      var data = {
        pictures: this.pictures.map(function (p) {
          return {
            order: _this.orders[p.pictureId] || 0,
            imageUrl: p.image
          };
        })
      };
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__store_action_types__["z" /* TEMPLATE_OVERLAY_DATA */], {
        templateId: this.templateId,
        data: data
      });
    }
  }
});

/***/ }),
/* 1813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('window',{attrs:{"window-id":_vm.windowId}},[_c('window-tab',{attrs:{"title":_vm.windowTitle}},[_c('switch-buttons',{attrs:{"template-id":_vm.templateId}})],1),_vm._v(" "),_c('window-tab',{attrs:{"title":"Data","icon":"database"}},[_c('album-select-group',{model:{value:(_vm.albumId),callback:function ($$v) {_vm.albumId=$$v},expression:"albumId"}}),_vm._v(" "),(_vm.pictures && _vm.pictures.length)?_c('table',{staticClass:"table table-bordered table-responsive table-hover table-sm"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Image")]),_vm._v(" "),_c('th',[_vm._v("Order")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.pictures),function(picture){return _c('tr',[_c('td',[_c('img',{attrs:{"src":picture.image,"title":picture.fileName}})]),_vm._v(" "),_c('td',{staticClass:"inline-edit"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.orders[picture.pictureId]),expression:"orders[picture.pictureId]",modifiers:{"lazy":true}}],staticClass:"inline-input form-control",attrs:{"type":"text"},domProps:{"value":(_vm.orders[picture.pictureId])},on:{"change":[function($event){_vm.$set(_vm.orders, picture.pictureId, $event.target.value)},_vm.updateRecords]}})])])}))]):_vm._e()],1),_vm._v(" "),_c('window-tab',{attrs:{"title":"Settings","icon":"cog"}},[_c('template-settings',{attrs:{"template-id":_vm.templateId}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_uiaa_victory_ceremony_athlete_vue__ = __webpack_require__(1815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e0e55b3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_uiaa_victory_ceremony_athlete_vue__ = __webpack_require__(1816);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_uiaa_victory_ceremony_athlete_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e0e55b3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_uiaa_victory_ceremony_athlete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'uiaa-victory-ceremony-athlete',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins__["b" /* templateMixin */]],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2__utils__["c" /* mapOverlayData */])(['title', 'bibNumber', 'rank', 'name', 'country', 'score']), Object(__WEBPACK_IMPORTED_MODULE_2__utils__["f" /* mapTemplateData */])(['datasetId', 'recordId']), {
    record: function record() {
      var record = this.$store.getters.datasetRecord(this.datasetId, this.recordId);
      return Object(__WEBPACK_IMPORTED_MODULE_2__utils__["e" /* mapRecord */])(record, this.patterns);
    },
    fields: function fields() {
      return this.$store.getters.datasetColumns(this.datasetId);
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_2__utils__["f" /* mapTemplateData */])({
    /* eslint-disable no-template-curly-in-string */
    'patternBibNumber': { default: '${BIB}' },
    'patternRank': { default: '${RANK}' },
    'patternName': { default: '${LAST NAME} ${FIRST NAME}' },
    'patternCountry': { default: '${COUNTRY}' },
    'patternScore': { default: '${SCORE}${Route 1}'
      /* eslint-enable no-template-curly-in-string */
    } }), {
    patterns: function patterns() {
      return {
        'bibNumber': this.patternBibNumber,
        'rank': this.patternRank,
        'name': this.patternName,
        'country': this.patternCountry,
        'score': this.patternScore
      };
    }
  }),
  watch: {
    record: function record(_record) {
      this.bibNumber = _record.bibNumber;
      this.name = _record.name;
      this.country = _record.country;
      this.rank = _record.rank;
      this.score = _record.score;
    }
  }
});

/***/ }),
/* 1816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('window',{attrs:{"window-id":_vm.windowId}},[_c('window-tab',{attrs:{"title":_vm.windowTitle}},[_c('switch-buttons',{attrs:{"template-id":_vm.templateId}}),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('title')}},[_vm._v("Title")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.title),expression:"title",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('title')},domProps:{"value":(_vm.title)},on:{"change":function($event){_vm.title=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('record')}},[_vm._v("Record")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('record-select',{attrs:{"dataset-id":_vm.datasetId},model:{value:(_vm.recordId),callback:function ($$v) {_vm.recordId=$$v},expression:"recordId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('bibNumber')}},[_vm._v("Bib number")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.bibNumber),expression:"bibNumber",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('bibNumber')},domProps:{"value":(_vm.bibNumber)},on:{"change":function($event){_vm.bibNumber=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('name')}},[_vm._v("Name")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.name),expression:"name",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('name')},domProps:{"value":(_vm.name)},on:{"change":function($event){_vm.name=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('country')}},[_vm._v("Country")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.country),expression:"country",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('country')},domProps:{"value":(_vm.country)},on:{"change":function($event){_vm.country=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('rank')}},[_vm._v("Rank")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.rank),expression:"rank",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('rank')},domProps:{"value":(_vm.rank)},on:{"change":function($event){_vm.rank=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('score')}},[_vm._v("Score")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.score),expression:"score",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('score')},domProps:{"value":(_vm.score)},on:{"change":function($event){_vm.score=$event.target.value}}})])])],1),_vm._v(" "),_c('window-tab',{attrs:{"title":"Data","icon":"database"}},[_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('datasetId')}},[_vm._v("Dataset")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('dataset-select',{attrs:{"id":_vm.safeId('datasetId')},model:{value:(_vm.datasetId),callback:function ($$v) {_vm.datasetId=$$v},expression:"datasetId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-4 col-form-label"},[_vm._v("Fields")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{staticClass:"form-control-plaintext",attrs:{"type":"text","readonly":""},domProps:{"value":_vm.fields}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternBibNumber')}},[_vm._v("Bib number")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternBibNumber),expression:"patternBibNumber",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternBibNumber')},domProps:{"value":(_vm.patternBibNumber)},on:{"change":function($event){_vm.patternBibNumber=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternName')}},[_vm._v("Name")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternName),expression:"patternName",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternName')},domProps:{"value":(_vm.patternName)},on:{"change":function($event){_vm.patternName=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternCountry')}},[_vm._v("Country")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternCountry),expression:"patternCountry",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternCountry')},domProps:{"value":(_vm.patternCountry)},on:{"change":function($event){_vm.patternCountry=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternRank')}},[_vm._v("Rank")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternRank),expression:"patternRank",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternRank')},domProps:{"value":(_vm.patternRank)},on:{"change":function($event){_vm.patternRank=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternScore')}},[_vm._v("Score")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternScore),expression:"patternScore",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternScore')},domProps:{"value":(_vm.patternScore)},on:{"change":function($event){_vm.patternScore=$event.target.value}}})])])]),_vm._v(" "),_c('window-tab',{attrs:{"title":"Settings","icon":"cog"}},[_c('template-settings',{attrs:{"templateId":_vm.templateId}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_uiaa_victory_ceremony_group_vue__ = __webpack_require__(1818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49333262_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_uiaa_victory_ceremony_group_vue__ = __webpack_require__(1819);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_uiaa_victory_ceremony_group_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49333262_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_uiaa_victory_ceremony_group_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_action_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'uiaa-victory-ceremony-athlete',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins__["b" /* templateMixin */]],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3__utils__["c" /* mapOverlayData */])(['title']), Object(__WEBPACK_IMPORTED_MODULE_3__utils__["f" /* mapTemplateData */])(['datasetId', 'recordId1', 'recordId2', 'recordId3']), {
    records: function records() {
      return [Object(__WEBPACK_IMPORTED_MODULE_3__utils__["e" /* mapRecord */])(this.$store.getters.datasetRecord(this.datasetId, this.recordId1), this.patterns), Object(__WEBPACK_IMPORTED_MODULE_3__utils__["e" /* mapRecord */])(this.$store.getters.datasetRecord(this.datasetId, this.recordId2), this.patterns), Object(__WEBPACK_IMPORTED_MODULE_3__utils__["e" /* mapRecord */])(this.$store.getters.datasetRecord(this.datasetId, this.recordId3), this.patterns)];
    },
    fields: function fields() {
      return this.$store.getters.datasetColumns(this.datasetId);
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_3__utils__["f" /* mapTemplateData */])({
    /* eslint-disable no-template-curly-in-string */
    'patternBibNumber': { default: '${BIB}' },
    'patternRank': { default: '${RANK}' },
    'patternName': { default: '${LAST NAME} ${FIRST NAME}' },
    'patternCountry': { default: '${COUNTRY}' },
    'patternScore': { default: '${SCORE}${Route 1}'
      /* eslint-enable no-template-curly-in-string */
    } }), {
    patterns: function patterns() {
      return {
        'bibNumber': this.patternBibNumber,
        'rank': this.patternRank,
        'name': this.patternName,
        'country': this.patternCountry,
        'score': this.patternScore
      };
    }
  }),
  watch: {
    records: function records(val) {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_action_types__["z" /* TEMPLATE_OVERLAY_DATA */], {
        templateId: this.templateId,
        data: { records: val }
      });
    }
  }
});

/***/ }),
/* 1819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('window',{attrs:{"window-id":_vm.windowId}},[_c('window-tab',{attrs:{"title":_vm.windowTitle}},[_c('switch-buttons',{attrs:{"template-id":_vm.templateId}}),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('title')}},[_vm._v("Title")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.title),expression:"title",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('title')},domProps:{"value":(_vm.title)},on:{"change":function($event){_vm.title=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('record1')}},[_vm._v("Gold")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('record-select',{attrs:{"dataset-id":_vm.datasetId},model:{value:(_vm.recordId1),callback:function ($$v) {_vm.recordId1=$$v},expression:"recordId1"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('record2')}},[_vm._v("Silver")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('record-select',{attrs:{"dataset-id":_vm.datasetId},model:{value:(_vm.recordId2),callback:function ($$v) {_vm.recordId2=$$v},expression:"recordId2"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('record3')}},[_vm._v("Bronze")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('record-select',{attrs:{"dataset-id":_vm.datasetId},model:{value:(_vm.recordId3),callback:function ($$v) {_vm.recordId3=$$v},expression:"recordId3"}})],1)])],1),_vm._v(" "),_c('window-tab',{attrs:{"title":"Data","icon":"database"}},[_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('datasetId')}},[_vm._v("Dataset")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('dataset-select',{attrs:{"id":_vm.safeId('datasetId')},model:{value:(_vm.datasetId),callback:function ($$v) {_vm.datasetId=$$v},expression:"datasetId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-4 col-form-label"},[_vm._v("Fields")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{staticClass:"form-control-plaintext",attrs:{"type":"text","readonly":""},domProps:{"value":_vm.fields}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternBibNumber')}},[_vm._v("Bib number")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternBibNumber),expression:"patternBibNumber",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternBibNumber')},domProps:{"value":(_vm.patternBibNumber)},on:{"change":function($event){_vm.patternBibNumber=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternName')}},[_vm._v("Name")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternName),expression:"patternName",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternName')},domProps:{"value":(_vm.patternName)},on:{"change":function($event){_vm.patternName=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternCountry')}},[_vm._v("Country")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternCountry),expression:"patternCountry",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternCountry')},domProps:{"value":(_vm.patternCountry)},on:{"change":function($event){_vm.patternCountry=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternRank')}},[_vm._v("Rank")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternRank),expression:"patternRank",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternRank')},domProps:{"value":(_vm.patternRank)},on:{"change":function($event){_vm.patternRank=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('patternScore')}},[_vm._v("Score")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.patternScore),expression:"patternScore",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('patternScore')},domProps:{"value":(_vm.patternScore)},on:{"change":function($event){_vm.patternScore=$event.target.value}}})])])]),_vm._v(" "),_c('window-tab',{attrs:{"title":"Settings","icon":"cog"}},[_c('template-settings',{attrs:{"templateId":_vm.templateId}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_volleyball_vue__ = __webpack_require__(1821);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_374101ba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_volleyball_vue__ = __webpack_require__(1822);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_volleyball_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_374101ba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_volleyball_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_action_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_mapTemplateOptions__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_template_definitions_service__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_VolleyballApi__ = __webpack_require__(283);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var AUTH_TOKEN = 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsIng1dCI6ImEzck1VZ01Gdjl0UGNsTGE2eUYzekFrZnF1RSIsImtpZCI6ImEzck1VZ01Gdjl0UGNsTGE2eUYzekFrZnF1RSJ9.eyJpc3MiOiJodHRwczovL2RhdGFwcm9qZWN0aWRlbnRpdHlzZXJ2ZXIuYXp1cmV3ZWJzaXRlcy5uZXQvY29yZSIsImF1ZCI6Imh0dHBzOi8vZGF0YXByb2plY3RpZGVudGl0eXNlcnZlci5henVyZXdlYnNpdGVzLm5ldC9jb3JlL3Jlc291cmNlcyIsImV4cCI6MTU2NDQ4MTE5OSwibmJmIjoxNTMyOTQ1MTk5LCJjbGllbnRfaWQiOiJ3ZWJhcHAiLCJzY29wZSI6WyJvcGVuaWQiLCJwcm9maWxlIiwiZW1haWwiLCJkcGNsb3Vkc2VydmljZSIsIndjbWFwaXNlcnZpY2UiXSwic3ViIjoiYjYwOTgzYzMtOGNjNy00ZmM0LTkwMTYtZmI3NDk0NTQwNzhkIiwiYXV0aF90aW1lIjoxNTMyOTQ1MTkxLCJpZHAiOiJpZHNydiIsInByZWZlcnJlZF91c2VybmFtZSI6IkNIX1R2c2VydmljZXNAZGF0YXByb2plY3QuY29tIiwiYW1yIjpbInBhc3N3b3JkIl19.Yf-hhKp6EZ1Wnfgg5aBWkKiRWpZYFIBSy5HGenWLKAMNIi0FaxSJaztPU-_w5_ja9YC7R7RKE62iyQnfCZn4ORsycrvcdxvzwlCF59wN2gojO9C2wrA3T1Ms2LHgcOwqmk4UW2fCFy-GqSChXl-yDT4nttqDSU4CP5f8e9EfEMt_O7b7dtzfPHvd43aL00A3G8UwJTTMJWu6kUzw10VqSa7PTr4orJO68eWCPjHtSQCA1U2Vq44d09AxEPDO7c_XAUq788O_NdufpD51nfZdJv1uDdufNbkxy-TS7jnuhgiysX61XjxUd4yhxqtzTzNR3o1Ha0REm1MzCdDTo8fMSw';

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'volleyball',
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins__["b" /* templateMixin */]],
  data: function data() {
    return {
      errorMessage: null,
      matches: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5__utils_mapTemplateOptions__["a" /* default */])({ 'federationCode': { default: 'SWI' } }), Object(__WEBPACK_IMPORTED_MODULE_5__utils_mapTemplateOptions__["a" /* default */])({ 'authToken': { default: AUTH_TOKEN } }), Object(__WEBPACK_IMPORTED_MODULE_5__utils_mapTemplateOptions__["a" /* default */])(['matchId']), {
    optionsMatch: function optionsMatch() {
      return this.matches.map(function (each) {
        var date = new Date(each.MDT);
        return {
          id: each.FedID,
          label: each.HName + ' - ' + each.GName + ' (' + date.toLocaleString() + ')'
        };
      });
    },
    isMatchSelected: function isMatchSelected() {
      return !!(this.matchId && this.getMatch(this.matchId));
    }
  }),
  created: function created() {
    this.templateDefinitionsService = new __WEBPACK_IMPORTED_MODULE_6__services_template_definitions_service__["a" /* default */](this.$keycloak, this.$store);
    this.api = new __WEBPACK_IMPORTED_MODULE_7__api_VolleyballApi__["a" /* default */](this.$env);
  },
  methods: {
    getApi: function getApi() {
      return this.api.setFederationCode(this.federationCode).setAuthToken(this.authToken);
    },
    fetchMatches: function fetchMatches() {
      var _this = this;

      this.errorMessage = null;
      this.getApi().getMatchList().then(function (response) {
        _this.matches = response.data;
      }).catch(function (error) {
        _this.errorMessage = error.message;
      });
    },
    getMatch: function getMatch(matchId) {
      if (!this.matches) return null;
      return this.matches.find(function (p) {
        return p.FedID === matchId;
      });
    },
    openScoreboard: function openScoreboard() {
      var match = this.getMatch(this.matchId);
      if (!match) return;
      this.openCreate(match, {
        componentType: 'volleyball-scoreboard',
        name: 'Scoreboard',
        overlayData: {
          title1: match.HTTXN || match.HName,
          title2: match.GTTXN || match.GName
        },
        templateOptions: {
          federationCode: this.federationCode,
          authToken: this.authToken,
          matchId: match.FedID
        }
      });
    },
    openReferees: function openReferees() {
      var match = this.getMatch(this.matchId);
      if (!match) return;
      this.openCreate(match, {
        componentType: 'generic-lower-third',
        name: 'Referees',
        overlayData: {
          title: [[match.Ref1_N, match.Ref1_SR].join(' '), [match.Ref2_N, match.Ref2_SR].join(' ')].join(' / '),
          subtitle: 'Referees'
        }
      });
    },
    openHomeTeam: function openHomeTeam() {
      this.openTeam('H');
    },
    openGuestTeam: function openGuestTeam() {
      this.openTeam('G');
    },
    openTeam: function openTeam(key) {
      var _this2 = this;

      var match = this.getMatch(this.matchId);
      if (!match) return;
      this.errorMessage = null;
      this.getApi().getRoster(match.FedID).then(function (response) {
        var teamName = match[key + 'Name'];
        var datasetId = Object(__WEBPACK_IMPORTED_MODULE_2__lib__["e" /* uuid */])();
        var records = response.data['R' + key].map(function (each) {
          return {
            recordId: Object(__WEBPACK_IMPORTED_MODULE_2__lib__["e" /* uuid */])(),
            bibNumber: each.N,
            firstName: each.NM,
            lastName: each.SR,
            libero: each.L,
            captain: each.K
          };
        });
        var columns = ['bibNumber', 'firstName', 'lastName', 'libero', 'captain'];
        _this2.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__store_action_types__["l" /* DATASET_CREATE */], {
          datasetId: datasetId,
          name: 'Dataset Roster ' + teamName,
          columns: columns,
          records: records
        });
        console.log('datasetId', datasetId);
        _this2.openCreate(match, {
          datasetId: datasetId,
          name: 'Lower Thirds ' + teamName,
          componentType: 'lower-third-athlete',
          templateData: {
            /* eslint-disable no-template-curly-in-string */
            patternBibNumber: '${bibNumber}',
            patternTitle: '${lastName} ${firstName}',
            patternSubtitle: teamName,
            patternCountry: ''
            /* eslint-enable no-template-curly-in-string */
          },
          overlayData: {
            subtitle: teamName
          }
        });
      }).catch(function (error) {
        _this2.errorMessage = error.message;
      });
    },
    openCreate: function openCreate(match, options) {
      var template = this.templateDefinitionsService.findTemplateDefinition(options.componentType);
      if (!template) {
        console.error('Could not find template definition with componentType "' + options.componentType + '"');
        return;
      }
      template.templateId = options.templateId || Object(__WEBPACK_IMPORTED_MODULE_2__lib__["e" /* uuid */])();
      template.name = options.name;
      template.data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, options.templateData, {
        datasetId: options.datasetId,
        columnMap: options.columnMap
      });
      template.options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, options.templateOptions);
      template.overlay = { data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, { title: options.title }, options.overlayData) };
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__store_action_types__["t" /* TEMPLATE_DELETE */], { templateId: template.templateId });
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__store_action_types__["r" /* TEMPLATE_CREATE */], template);
    }
  }
});

/***/ }),
/* 1822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('window',{attrs:{"window-id":_vm.windowId}},[_c('window-tab',{attrs:{"title":_vm.windowTitle}},[_c('div',{staticClass:"form-group form-row"},[_c('div',{staticClass:"col-sm-12"},[_c('button',{staticClass:"btn btn-block btn-primary",attrs:{"type":"button"},on:{"click":_vm.fetchMatches}},[_vm._v("Load Matches")])])]),_vm._v(" "),(_vm.errorMessage)?_c('div',{staticClass:"alert alert-danger"},[_c('p',[_c('b',[_vm._v("Error:")]),_vm._v(" "+_vm._s(_vm.errorMessage))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('matchId')}},[_vm._v("Match")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('b-form-select',{attrs:{"id":_vm.safeId('matchId'),"options":_vm.optionsMatch,"text-field":"label","value-field":"id"},model:{value:(_vm.matchId),callback:function ($$v) {_vm.matchId=$$v},expression:"matchId"}})],1)]),_vm._v(" "),(_vm.isMatchSelected)?_c('div',[_c('div',{staticClass:"form-group form-row"},[_c('div',{staticClass:"col-sm-12"},[_c('button',{staticClass:"btn btn-block btn-secondary",attrs:{"type":"button"},on:{"click":_vm.openScoreboard}},[_vm._v("Scoreboard")])])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('div',{staticClass:"col-sm-12"},[_c('button',{staticClass:"btn btn-block btn-secondary",attrs:{"type":"button"},on:{"click":_vm.openReferees}},[_vm._v("Referees")])])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('div',{staticClass:"col-sm-12"},[_c('button',{staticClass:"btn btn-block btn-secondary",attrs:{"type":"button"},on:{"click":_vm.openHomeTeam}},[_vm._v("Home Team")])])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('div',{staticClass:"col-sm-12"},[_c('button',{staticClass:"btn btn-block btn-secondary",attrs:{"type":"button"},on:{"click":_vm.openGuestTeam}},[_vm._v("Guest Team")])])])]):_vm._e()]),_vm._v(" "),_c('window-tab',{attrs:{"title":"Data","icon":"database"}},[_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('federationCode')}},[_vm._v("Federation code")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.federationCode),expression:"federationCode",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('federationCode')},domProps:{"value":(_vm.federationCode)},on:{"change":function($event){_vm.federationCode=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('authToken')}},[_vm._v("Authorization")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.authToken),expression:"authToken",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('authToken')},domProps:{"value":(_vm.authToken)},on:{"change":function($event){_vm.authToken=$event.target.value}}})])])]),_vm._v(" "),_c('window-tab',{attrs:{"title":"Settings","icon":"cog"}},[_c('template-settings',{attrs:{"templateId":_vm.templateId}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_volleyball_scoreboard_vue__ = __webpack_require__(1824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_640611a3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_volleyball_scoreboard_vue__ = __webpack_require__(1825);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_volleyball_scoreboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_640611a3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_volleyball_scoreboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_index__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_action_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_VolleyballApi__ = __webpack_require__(283);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var DEFAULT_FETCH_INTERVAL_MS = 5000;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'volleyball-scoreboard',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins__["b" /* templateMixin */]],
  data: function data() {
    return {
      autoFetch: false,
      errorMessage: null
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["c" /* mapOverlayData */])(['title1', 'title2', 'sets1', 'sets2', 'points1', 'points2', 'service']), Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["g" /* mapTemplateOptions */])(['federationCode', 'authToken', 'matchId']), Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["g" /* mapTemplateOptions */])({ fetchIntervalMs: { default: DEFAULT_FETCH_INTERVAL_MS } }), {
    autoFetchButtonText: function autoFetchButtonText() {
      return this.autoFetch ? 'Stop Fetching' : 'Start Fetching';
    }
  }),
  created: function created() {
    this.api = new __WEBPACK_IMPORTED_MODULE_4__api_VolleyballApi__["a" /* default */](this.$env);
  },
  methods: {
    add: function add(id, value) {
      this[id] = '' + ((parseInt(this[id]) || 0) + value);
      var data = {};
      data[id] = this[id];
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__store_action_types__["p" /* OVERLAY_DATA */], {
        templateId: this.templateId,
        channelIds: ['program', 'preview'],
        data: data
      });
    },
    setService: function setService(value) {
      this.service = value;
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__store_action_types__["p" /* OVERLAY_DATA */], {
        templateId: this.templateId,
        channelIds: ['program', 'preview'],
        data: { 'service': value }
      });
    },
    toggleAutoFetch: function toggleAutoFetch() {
      this.autoFetch = !this.autoFetch;
      this.errorMessage = null;
      if (this.autoFetch && !this.timeoutId) {
        this.fetchData();
      } else if (!this.autoFetch && this.timeoutId) {
        window.clearTimeout(this.timeoutId);
        this.timeoutId = null;
      }
    },
    fetchData: function fetchData() {
      var _this = this;

      this.errorMessage = null;
      this.getApi().getMatchFullInfo(this.matchId).then(function (response) {
        _this.updateData(response);
        _this.scheduleFetch();
      }).catch(function (error) {
        _this.autoFetch = false;
        _this.errorMessage = error.message || error;
      });
    },
    getApi: function getApi() {
      return this.api.setFederationCode(this.federationCode).setAuthToken(this.authToken);
    },
    updateData: function updateData(_ref) {
      var data = _ref.data;

      this.title1 = this.title1 || '' + data.HTN;
      this.title2 = this.title2 || '' + data.GTN;
      this.sets1 = '' + data.WSH;
      this.sets2 = '' + data.WSG;
      this.points1 = '' + data.CHP;
      this.points2 = '' + data.CGP;
      if (data.CR) {
        this.service = data.CR.WinHG ? '1' : '2';
      } else {
        this.service = '0';
      }
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__store_action_types__["k" /* COMMAND_UPDATE */], {
        templateId: this.templateId, channelId: 'program'
      });
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__store_action_types__["k" /* COMMAND_UPDATE */], {
        templateId: this.templateId, channelId: 'preview'
      });
    },
    scheduleFetch: function scheduleFetch() {
      if (this.timeoutId) {
        window.clearTimeout(this.timeoutId);
        this.timeoutId = null;
      }
      this.timeoutId = window.setTimeout(this.fetchData.bind(this), this.fetchIntervalMs || DEFAULT_FETCH_INTERVAL_MS);
    }
  }
});

/***/ }),
/* 1825 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('window',{attrs:{"window-id":_vm.windowId}},[_c('window-tab',{attrs:{"title":_vm.windowTitle}},[_c('switch-buttons',{attrs:{"template-id":_vm.templateId}}),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('div',{staticClass:"col-sm-12"},[_c('button',{staticClass:"btn btn-block btn-primary",attrs:{"type":"button"},on:{"click":_vm.toggleAutoFetch}},[_vm._v(_vm._s(_vm.autoFetchButtonText)+"\n        ")])])]),_vm._v(" "),(_vm.errorMessage)?_c('div',{staticClass:"alert alert-danger"},[_c('p',[_c('b',[_vm._v("Error:")]),_vm._v(" "+_vm._s(_vm.errorMessage))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('title1')}},[_vm._v("Team 1")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.title1),expression:"title1",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('title1')},domProps:{"value":(_vm.title1)},on:{"change":function($event){_vm.title1=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('title2')}},[_vm._v("Team 2")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.title2),expression:"title2",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('title2')},domProps:{"value":(_vm.title2)},on:{"change":function($event){_vm.title2=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('sets1')}},[_vm._v("Sets 1")]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.sets1),expression:"sets1",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"number","id":_vm.safeId('sets1')},domProps:{"value":(_vm.sets1)},on:{"change":function($event){_vm.sets1=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"btn btn-primary btn-block",on:{"click":function($event){_vm.add('sets1', -1)}}},[_vm._v("-")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"btn btn-primary btn-block",on:{"click":function($event){_vm.add('sets1', 1)}}},[_vm._v("+")])])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('sets2')}},[_vm._v("Sets 2")]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.sets2),expression:"sets2",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"number","id":_vm.safeId('sets2')},domProps:{"value":(_vm.sets2)},on:{"change":function($event){_vm.sets2=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"btn btn-primary btn-block",on:{"click":function($event){_vm.add('sets2', -1)}}},[_vm._v("-")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"btn btn-primary btn-block",on:{"click":function($event){_vm.add('sets2', 1)}}},[_vm._v("+")])])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('points1')}},[_vm._v("Points 1")]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.points1),expression:"points1",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"number","id":_vm.safeId('points1')},domProps:{"value":(_vm.points1)},on:{"change":function($event){_vm.points1=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"btn btn-primary btn-block",on:{"click":function($event){_vm.add('points1', -1)}}},[_vm._v("-")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"btn btn-primary btn-block",on:{"click":function($event){_vm.add('points1', 1)}}},[_vm._v("+")])])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('points2')}},[_vm._v("Points 2")]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.points2),expression:"points2",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"number","id":_vm.safeId('points2')},domProps:{"value":(_vm.points2)},on:{"change":function($event){_vm.points2=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"btn btn-primary btn-block",on:{"click":function($event){_vm.add('points2', -1)}}},[_vm._v("-")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"btn btn-primary btn-block",on:{"click":function($event){_vm.add('points2', 1)}}},[_vm._v("+")])])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-6 col-form-label",attrs:{"for":_vm.safeId('points2')}},[_vm._v("Service")]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"btn btn-block",class:[_vm.service === '0' ? 'btn-primary' : 'btn-secondary'],on:{"click":function($event){_vm.setService('0')}}},[_vm._v("0\n        ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"btn btn-block",class:[_vm.service === '1' ? 'btn-primary' : 'btn-secondary'],on:{"click":function($event){_vm.setService('1')}}},[_vm._v("1\n        ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"btn btn-block",class:[_vm.service === '2' ? 'btn-primary' : 'btn-secondary'],on:{"click":function($event){_vm.setService('2')}}},[_vm._v("2\n        ")])])])],1),_vm._v(" "),_c('window-tab',{attrs:{"title":"Data","icon":"database"}},[_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('federationCode')}},[_vm._v("Federation code")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.federationCode),expression:"federationCode",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('federationCode')},domProps:{"value":(_vm.federationCode)},on:{"change":function($event){_vm.federationCode=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('authToken')}},[_vm._v("Authorization")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.authToken),expression:"authToken",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('authToken')},domProps:{"value":(_vm.authToken)},on:{"change":function($event){_vm.authToken=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('matchId')}},[_vm._v("Match")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.matchId),expression:"matchId",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('matchId')},domProps:{"value":(_vm.matchId)},on:{"change":function($event){_vm.matchId=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('fetchIntervalMs')}},[_vm._v("Fetch Interval (ms)")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.fetchIntervalMs),expression:"fetchIntervalMs",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('fetchIntervalMs')},domProps:{"value":(_vm.fetchIntervalMs)},on:{"change":function($event){_vm.fetchIntervalMs=$event.target.value}}})])])]),_vm._v(" "),_c('window-tab',{attrs:{"title":"Settings","icon":"cog"}},[_c('template-settings',{attrs:{"templateId":_vm.templateId}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_template_not_found_vue__ = __webpack_require__(1827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bc0d445e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_template_not_found_vue__ = __webpack_require__(1828);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_template_not_found_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bc0d445e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_template_not_found_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_action_types__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'template-not-found',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["a" /* templateIdMixin */], __WEBPACK_IMPORTED_MODULE_0__mixins__["d" /* windowPropsMixin */]],
  methods: {
    remove: function remove() {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_action_types__["t" /* TEMPLATE_DELETE */], {
        templateId: this.templateId
      });
    }
  }
});

/***/ }),
/* 1828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('window',{attrs:{"window-id":_vm.windowId}},[_c('window-tab',{attrs:{"title":_vm.windowTitle}},[_c('div',{staticClass:"alert alert-warning",attrs:{"role":"alert"}},[_c('h4',{staticClass:"alert-heading"},[_vm._v("Template not found!")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("The template has been removed or is currently not available.")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('button',{staticClass:"btn btn-block btn-danger",on:{"click":_vm.remove}},[_vm._v("Delete Template")])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_template_library_vue__ = __webpack_require__(1831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08c8b67a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_template_library_vue__ = __webpack_require__(1832);
function injectStyle (ssrContext) {
  __webpack_require__(1830)
}
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-08c8b67a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_template_library_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08c8b67a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_template_library_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1830 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_AppService__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(50);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var BASE_URL_TEMPLATES = 'https://static.webcg.helvetic.stream/templates/';

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'template-library',
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins__["d" /* windowPropsMixin */]],
  data: function data() {
    return {
      errorMessage: null,
      selectedManifest: null,
      manifests: [],
      manifest: null
    };
  },

  watch: {
    selectedManifest: function selectedManifest(newManifest) {
      this.fetchManifest(newManifest);
    },
    selectedAccount: function selectedAccount() {
      this.fetchManifests();
    }
  },
  computed: {
    selectedAccount: function selectedAccount() {
      return this.$store.getters.selectedAccount;
    },
    templateLibraryPolicies: function templateLibraryPolicies() {
      return this.selectedAccount && this.selectedAccount.policies && this.selectedAccount.policies.templateLibrary && this.selectedAccount.policies.templateLibrary.allow || [];
    },
    nameAndId: function nameAndId() {
      if (!this.manifest) return '';
      return this.manifest.name ? this.manifest.name + ' (' + this.manifest.id + ')' : this.manifest.id;
    },
    properties: function properties() {
      if (!this.manifest) return '';
      var properties = this.manifest.schema.properties;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(properties).map(function (key) {
        var result = properties[key];
        result._key = key;
        return result;
      });
    }
  },
  created: function created() {
    this.appService = new __WEBPACK_IMPORTED_MODULE_5__api_AppService__["a" /* default */](this.$store, this.$keycloak);
  },
  mounted: function mounted() {
    this.fetchManifests();
  },

  methods: {
    getAllowedRules: function getAllowedRules() {
      if (this.templateLibraryPolicies && this.templateLibraryPolicies.length > 0) {
        return this.templateLibraryPolicies.filter(function (p) {
          return p.startsWith('library:');
        }).map(function (value) {
          return value.replace('library:', '');
        });
      }
      var roles = this.$keycloak && this.$keycloak.resourceAccess && this.$keycloak.resourceAccess['webcg-studio'] && this.$keycloak.resourceAccess['webcg-studio'].roles;
      roles = roles && roles.length > 0 ? roles : __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].prototype.$env && __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].prototype.$env.DEFAULT_ROLES || [];
      if (typeof roles === 'string') {
        try {
          roles = JSON.parse(roles);
        } catch (e) {}
      }
      return roles.filter(function (p) {
        return p.startsWith('library:');
      }).map(function (value) {
        return value.replace('library:', '');
      });
    },
    create: function create() {
      var description = this.manifest.description;
      var componentType = (description.match(/component=([a-z0-9-]+)/) || [])[1] || 'loopic-template';
      var overlayUrl = BASE_URL_TEMPLATES.replace('https://', '/') + this.selectedManifest.replace('manifest.ograf.json', 'resources/index.html');
      var properties = this.manifest.schema.properties;
      var data = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(properties).reduce(function (result, key) {
        result[key] = properties[key].default;
        return result;
      }, {});
      this.appService.openCreateTemplate({
        templateId: Object(__WEBPACK_IMPORTED_MODULE_3__lib__["e" /* uuid */])(),
        name: this.manifest.name || this.manifest.id,
        componentType: componentType,
        overlayData: data,
        templateData: {
          data: data
        },
        templateOptions: {
          schema: this.manifest.schema
        },
        overlays: [overlayUrl]
      });
    },
    fetchManifests: function fetchManifests() {
      this.errorMessage = null;
      var request = new XMLHttpRequest();
      request.open('GET', BASE_URL_TEMPLATES);
      request.onload = function (event) {
        if (!event.target) {
          this.errorMessage = 'Unknown error';
          return;
        }

        if (event.target.status !== 200) {
          this.errorMessage = event.target.statusText;
          return;
        }
        var response = JSON.parse(event.target.response);
        var allowedRules = this.getAllowedRules();
        console.log('[template-library] Allowed rules', allowedRules);
        this.manifests = response.manifests.filter(function (p) {
          var parts = p.split('/').filter(function (p) {
            return p !== 'manifest.ograf.json';
          });
          var rules = allowedRules.map(function (value) {
            return value.split(':');
          });

          var _loop = function _loop(i) {
            var part = parts[i];
            if (rules.filter(function (rule) {
              return rule[i] === '*';
            }).length > 0) {
              return {
                v: true
              };
            }
            rules = rules.filter(function (rule) {
              return rule[i] === part;
            });
            if (rules.length === 0) {
              return {
                v: false
              };
            }
          };

          for (var i = 0; i < parts.length; i++) {
            var _ret = _loop(i);

            if ((typeof _ret === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(_ret)) === "object") return _ret.v;
          }
          return rules.length > 0;
        }).map(function (value) {
          var parts = value.split('/');
          parts.pop();
          return {
            label: parts.join(' / '),
            value: value
          };
        });
        console.log('[template-library] Allowed templates', this.manifests);
      }.bind(this);
      request.onerror = function (event) {
        console.error('Failed to fetch manifests:', event);
        this.errorMessage = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(event);
      }.bind(this);
      request.send();
    },
    fetchManifest: function fetchManifest(newManifest) {
      this.errorMessage = null;
      var request = new XMLHttpRequest();
      request.open('GET', BASE_URL_TEMPLATES + newManifest);
      request.onload = function (event) {
        if (!event.target) {
          this.errorMessage = 'Unknown error';
          return;
        }

        if (event.target.status !== 200) {
          this.errorMessage = event.target.statusText;
          return;
        }
        this.manifest = JSON.parse(event.target.response);
      }.bind(this);
      request.onerror = function (event) {
        console.error('Failed to fetch manifest:', event);
        this.errorMessage = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(event);
      }.bind(this);
      request.send();
    }
  }
});

/***/ }),
/* 1832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('window',{attrs:{"window-id":_vm.windowId}},[_c('window-tab',{attrs:{"title":_vm.windowTitle}},[_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId()}},[_vm._v("Manifest")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('b-form-select',{attrs:{"id":_vm.safeId(),"options":_vm.manifests,"text-field":"label","value-field":"value"},model:{value:(_vm.selectedManifest),callback:function ($$v) {_vm.selectedManifest=$$v},expression:"selectedManifest"}})],1)]),_vm._v(" "),(_vm.manifest)?_c('div',[_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('nameAndId')}},[_vm._v("Name (ID)")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.nameAndId),expression:"nameAndId"}],staticClass:"form-control-plaintext",attrs:{"type":"text","readonly":"","id":_vm.safeId('nameAndId')},domProps:{"value":(_vm.nameAndId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.nameAndId=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('version')}},[_vm._v("Version")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.manifest.version),expression:"manifest.version"}],staticClass:"form-control-plaintext",attrs:{"type":"text","readonly":"","id":_vm.safeId('version')},domProps:{"value":(_vm.manifest.version)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.manifest, "version", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('description')}},[_vm._v("Description")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.manifest.description),expression:"manifest.description"}],staticClass:"form-control-plaintext",attrs:{"type":"text","readonly":"","id":_vm.safeId('description')},domProps:{"value":(_vm.manifest.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.manifest, "description", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('properties')}},[_vm._v("Properties")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},_vm._l((_vm.properties),function(prop){return _c('div',{key:prop._key},[_vm._v(_vm._s(prop.label)+": "+_vm._s(prop.type))])}))]),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('div',{staticClass:"col-sm-8 offset-sm-4"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":_vm.create}},[_vm._v("Create")])])])]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vertical_life_dataset_vue__ = __webpack_require__(1834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b8d2347e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vertical_life_dataset_vue__ = __webpack_require__(1835);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vertical_life_dataset_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b8d2347e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vertical_life_dataset_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_mutation_types__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dataset_settings_vue__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__dataset_table_vue__ = __webpack_require__(118);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vertical-life-dataset',
  components: { DatasetSettings: __WEBPACK_IMPORTED_MODULE_6__dataset_settings_vue__["a" /* default */], DatasetTable: __WEBPACK_IMPORTED_MODULE_7__dataset_table_vue__["a" /* default */] },
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins__["d" /* windowPropsMixin */]],
  data: function data() {
    return {
      errorMessage: null
    };
  },

  computed: {
    datasetId: function datasetId() {
      return this.$store.getters.windowData(this.windowId).contentId;
    },
    dataset: function dataset() {
      return this.$store.getters.dataset(this.datasetId) || {};
    },
    title: function title() {
      return this.dataset.title || 'Unnamed dataset';
    },

    fileName: {
      get: function get() {
        return this.dataset.fileName || '';
      },
      set: function set(val) {
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["o" /* DATASET_UPDATE_META */], {
          datasetId: this.datasetId,
          fileName: val,
          emit: true
        });
      }
    }
  },
  mounted: function mounted() {
    if (this.fileName && (this.dataset.records || []).length === 0) {
      this.fetch();
    }
  },

  methods: {
    fetch: function fetch() {
      console.log('[vertical-life-dataset] fetching data');
      this.errorMessage = null;
      var request = new XMLHttpRequest();
      request.open('GET', this.fileName, true);
      // TODO: This auth token should be taken from the settings
      request.setRequestHeader('X-Auth-Token', '63b0083436935fc8492e16de93cfa929485a5ce3');
      request.onload = function (event) {
        if (!event.target) {
          this.errorMessage = 'Unknown error';
          return;
        }

        if (event.target.status !== 200) {
          this.errorMessage = event.target.statusText;
          return;
        }
        var response = JSON.parse(event.target.response);

        var rows = response.ranking || response.startlist || [];

        var columnMap = {
          // 'starting_order': 'SORT_ORDER', // TODO: Is this needed somewhere?
          'firstname': 'FIRST NAME',
          'lastname': 'LAST NAME',
          'bib': 'BIB',
          'country': 'COUNTRY',
          'rank': 'RANK',
          'score': 'SCORE'
        };

        var records = this.mergeRecords(rows, columnMap);
        var columns = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(columnMap);

        this.$store.commit(__WEBPACK_IMPORTED_MODULE_5__store_mutation_types__["q" /* DATASET_UPDATE_RECORDS */], {
          datasetId: this.datasetId,
          columns: columns,
          records: records.map(function (record) {
            record.recordId = record.recordId || Object(__WEBPACK_IMPORTED_MODULE_3__lib__["e" /* uuid */])();
            return record;
          }),
          emit: true
        });
      }.bind(this);
      request.onerror = function (event) {
        console.log(event);
        this.errorMessage = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(event);
      }.bind(this);
      request.send();
    },
    mergeRecords: function mergeRecords(rows, columnMap) {
      var records = this.dataset.records || [];
      var newRecords = rows.map(function (row) {
        var record = {};
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(columnMap).forEach(function (key) {
          record[columnMap[key]] = row[key];
        });
        return record;
      });
      newRecords.forEach(function (newRecord) {
        var oldRecord = records.find(function (r) {
          return r.BIB === newRecord.BIB;
        });
        if (!oldRecord) {
          records.push(newRecord);
        } else {
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(newRecord).forEach(function (key) {
            oldRecord[key] = newRecord[key] || oldRecord[key];
          });
        }
      });
      return records;
    }
  }
});

/***/ }),
/* 1835 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('window',{attrs:{"window-id":_vm.windowId}},[_c('window-tab',{attrs:{"title":_vm.windowTitle}},[(_vm.datasetId)?_c('div',{staticClass:"form-group form-row"},[_c('label',{staticClass:"col-sm-4 col-form-label",attrs:{"for":_vm.safeId('fileName')}},[_vm._v("URL")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.fileName),expression:"fileName",modifiers:{"lazy":true}}],staticClass:"form-control",attrs:{"type":"text","id":_vm.safeId('fileName')},domProps:{"value":(_vm.fileName)},on:{"change":function($event){_vm.fileName=$event.target.value}}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group form-row"},[_c('div',{staticClass:"col-sm-8 offset-4"},[_c('button',{staticClass:"btn btn-block btn-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.fetch()}}},[_vm._v("Fetch")])])]),_vm._v(" "),(_vm.errorMessage)?_c('div',{staticClass:"alert alert-danger"},[_c('p',[_c('b',[_vm._v("Error:")]),_vm._v(" "+_vm._s(_vm.errorMessage))])]):_vm._e(),_vm._v(" "),_c('dataset-table',{attrs:{"dataset-id":_vm.datasetId}})],1),_vm._v(" "),_c('window-tab',{attrs:{"title":"Settings","icon":"cog"}},[_c('dataset-settings',{attrs:{"window-id":_vm.windowId,"dataset-id":_vm.datasetId}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_window_vue__ = __webpack_require__(1837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7238f1a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_window_vue__ = __webpack_require__(1838);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_window_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7238f1a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_window_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_index__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_index__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_action_types__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_index__["c" /* windowIdMixin */]],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2__utils_index__["h" /* mapWindowData */])({ 'tabIndex': { default: 0 } })),
  methods: {
    close: function close() {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_3__store_action_types__["D" /* WINDOW_CLOSE */], { windowId: this.windowId });
      this.$emit('closed');
    }
  },
  mounted: function mounted() {
    this.$shortcut.setContext(this.windowId);
  }
});

/***/ }),
/* 1838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"no-body":""}},[_c('window-tabs',{ref:"tabs",attrs:{"card":"","close":_vm.close},model:{value:(_vm.tabIndex),callback:function ($$v) {_vm.tabIndex=$$v},expression:"tabIndex"}},[_vm._t("default"),_vm._v(" "),_c('template',{slot:"tabs"},[_vm._t("tabs")],2)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_window_tab_vue__ = __webpack_require__(1841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29d1832a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_window_tab_vue__ = __webpack_require__(1842);
function injectStyle (ssrContext) {
  __webpack_require__(1840)
}
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_window_tab_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29d1832a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_window_tab_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1840 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    enter: function enter() {
      this.show = true;
    },
    beforeLeave: function beforeLeave() {
      this.show = false;
    }
  },
  data: function data() {
    return {
      fade: false,
      localActive: this.active,
      lazy: true,
      show: false
    };
  },

  computed: {
    controlledBy: function controlledBy() {
      return this.buttonId || (this.id ? this.id + '__BV_tab_button__' : null);
    }
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    tag: {
      type: String,
      default: 'div'
    },
    buttonId: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    headHtml: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: false
    },
    href: {
      type: String,
      default: '#'
    }
  }
});

/***/ }),
/* 1842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"mode":"out-in"},on:{"enter":_vm.enter,"before-leave":_vm.beforeLeave}},[(_vm.localActive || !_vm.lazy)?_c(_vm.tag,{directives:[{name:"show",rawName:"v-show",value:(_vm.localActive || _vm.lazy),expression:"localActive || lazy"}],ref:"panel",tag:"component",class:['tab-pane', 'window-tab-pane', {show: _vm.show, fade: _vm.fade, disabled: _vm.disabled, active: _vm.localActive}],attrs:{"id":_vm.id || null,"role":"tabpanel","aria-hidden":_vm.localActive ? 'false' : 'true',"aria-expanded":_vm.localActive ? 'true' : 'false',"aria-labelledby":_vm.controlledBy || null}},[_vm._t("default")],2):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_window_tabs_vue__ = __webpack_require__(1845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b5fc7f5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_window_tabs_vue__ = __webpack_require__(1846);
function injectStyle (ssrContext) {
  __webpack_require__(1844)
}
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_window_tabs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b5fc7f5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_window_tabs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1844 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(7);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      currentTab: this.value,
      tabs: []
    };
  },

  props: {
    id: {
      type: String,
      default: ''
    },
    tag: {
      type: String,
      default: 'div'
    },
    noFade: {
      type: Boolean,
      default: false
    },
    card: {
      type: Boolean,
      default: false
    },
    value: {
      type: Number,
      default: null
    },
    pills: {
      type: Boolean,
      default: false
    },
    lazy: {
      type: Boolean,
      default: false
    },
    bottom: {
      type: Boolean,
      default: false
    },
    close: {
      type: Function,
      default: null
    }
  },
  watch: {
    currentTab: function currentTab(val, old) {
      if (val === old) {
        return;
      }
      this.$root.$emit('changed::tab', this, val, this.tabs[val]);
      this.$emit('input', val);
      this.tabs[val].$emit('click');
    },
    value: function value(val, old) {
      if (val === old) {
        return;
      }
      this.setTab(val);
    },
    fade: function fade(val, old) {
      var _this = this;

      if (val === old) {
        return;
      }
      this.tabs.forEach(function (item) {
        _this.$set(item, 'fade', val);
      });
    }
  },
  computed: {
    fade: function fade() {
      return !this.noFade;
    },
    navStyle: function navStyle() {
      return this.pills ? 'pills' : 'tabs';
    }
  },
  methods: {
    /**
     * Util: Return the sign of a number (as -1, 0, or 1)
     */
    sign: function sign(x) {
      return x === 0 ? 0 : x > 0 ? 1 : -1;
    },

    /**
     * Move to next tab
     */
    nextTab: function nextTab() {
      this.setTab(this.currentTab, false, 1);
    },

    /**
     * Move to previous tab
     */
    previousTab: function previousTab() {
      this.setTab(this.currentTab, false, -1);
    },

    /**
     * Set active tab on the tabs collection and the child 'tab' component
     */
    setTab: function setTab(index, force, offset) {
      var _this2 = this;

      offset = offset || 0;
      // Prevent setting same tab!
      if (!force && index + offset === this.currentTab) {
        return;
      }
      var tab = this.tabs[index + offset];
      // Don't go beyond indexes!
      if (!tab) {
        return;
      }
      // Ignore or Skip disabled
      if (tab.disabled) {
        if (offset) {
          // Skip to next non disabled tab in offset direction (recursive)
          this.setTab(index, force, offset + this.sign(offset));
        }
        return;
      }
      // Activate current tab, and deactivte any old tabs
      this.tabs.forEach(function (t) {
        if (t === tab) {
          // Set new tab as active
          _this2.$set(t, 'localActive', true);
        } else {
          // Ensure non current tabs are not active
          _this2.$set(t, 'localActive', false);
        }
      });
      // Update currentTab
      this.currentTab = index + offset;
    },

    /**
     * Dynamically update tabs
     */
    updateTabs: function updateTabs() {
      var _this3 = this;

      // Probe tabs
      if (this.$slots.default) {
        this.tabs = this.$slots.default.filter(function (tab) {
          return tab.componentInstance || false;
        }).map(function (tab) {
          return tab.componentInstance;
        });
      } else {
        this.tabs = [];
      }
      this.tabs.forEach(function (tab) {
        _this3.$set(tab, 'fade', _this3.fade);
        _this3.$set(tab, 'lazy', _this3.lazy);
      });
      // Get initial active tab
      var tabIndex = this.currentTab;
      if (tabIndex === null || tabIndex === undefined) {
        // Make null for easier testing further on
        tabIndex = null;
      }
      if (tabIndex === null) {
        // Find last active non-dsabled tab in current tabs
        this.tabs.forEach(function (tab, index) {
          if (tab.active && !tab.disabled) {
            tabIndex = index;
          }
        });
      }
      if (tabIndex === null) {
        // Find first non-disabled tab in current tabs
        this.tabs.forEach(function (tab, index) {
          if (!tab.disabled && tabIndex === null) {
            tabIndex = index;
          }
        });
      }
      // Workaround to fix problem when currentTab is removed
      var offset = 0;
      if (tabIndex >= this.tabs.length) {
        offset = -1;
      }
      this.setTab(tabIndex || 0, true, offset);
    }
  },
  mounted: function mounted() {
    this.updateTabs();
    // Observe Child changes so we can notify tabs change
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["i" /* observeDom */])(this.$refs.tabsContainer, this.updateTabs.bind(this), { subtree: false });
  }
});

/***/ }),
/* 1846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",staticClass:"tabs",attrs:{"id":_vm.id || null}},[(_vm.bottom)?_c('div',{ref:"tabsContainer",class:['tab-content',{'card-block': _vm.card}]},[_vm._t("default"),_vm._v(" "),(!_vm.tabs || !_vm.tabs.length)?_vm._t("empty"):_vm._e()],2):_vm._e(),_vm._v(" "),_c('div',{class:{'card-header': _vm.card}},[_c('ul',{class:['nav','nav-' + _vm.navStyle, _vm.card ? 'card-header-'+_vm.navStyle : null],attrs:{"role":"tablist","tabindex":"0","aria-setsize":_vm.tabs.length,"aria-posinset":_vm.currentTab + 1},on:{"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"left",37,$event.key)){ return null; }if('button' in $event && $event.button !== 0){ return null; }_vm.previousTab($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"up",38,$event.key)){ return null; }_vm.previousTab($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"right",39,$event.key)){ return null; }if('button' in $event && $event.button !== 2){ return null; }_vm.nextTab($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"down",40,$event.key)){ return null; }_vm.nextTab($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"left",37,$event.key)){ return null; }if(!$event.shiftKey){ return null; }if('button' in $event && $event.button !== 0){ return null; }_vm.setTab(-1,false,1)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"up",38,$event.key)){ return null; }if(!$event.shiftKey){ return null; }_vm.setTab(-1,false,1)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"right",39,$event.key)){ return null; }if(!$event.shiftKey){ return null; }if('button' in $event && $event.button !== 2){ return null; }_vm.setTab(_vm.tabs.length,false,-1)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"down",40,$event.key)){ return null; }if(!$event.shiftKey){ return null; }_vm.setTab(_vm.tabs.length,false,-1)}]}},[_vm._l((_vm.tabs),function(tab,index){return _c('li',{class:['nav-item',{'nav-item-title': index === 0},{'vdr-drag-handle': index === 0}],attrs:{"role":"presentation","ondragstart":"return false"}},[(!tab.headHtml)?_c('a',{class:['nav-link',{active: tab.localActive, disabled: tab.disabled}],attrs:{"href":tab.href,"role":"tab","aria-selected":tab.localActive ? 'true' : 'false',"aria-controls":tab.id || null,"id":tab.controlledBy || null,"tabindex":"-1","title":tab.title},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();_vm.setTab(index)},"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"space",32,$event.key)){ return null; }$event.preventDefault();$event.stopPropagation();_vm.setTab(index)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }$event.preventDefault();$event.stopPropagation();_vm.setTab(index)}]}},[(tab.icon)?_c('icon',{attrs:{"name":tab.icon}}):_vm._e(),_vm._v(" "),(!tab.icon)?_c('span',[_vm._v(_vm._s(tab.title))]):_vm._e()],1):_c('div',{class:['tab-head',{active: tab.localActive, disabled: tab.disabled}],attrs:{"role":"heading","tabindex":"-1"},domProps:{"innerHTML":_vm._s(tab.headHtml)}})])}),_vm._v(" "),_vm._t("tabs"),_vm._v(" "),_c('b-nav-item',{attrs:{"href":"#","title":"Close"},on:{"click":_vm.close}},[_c('icon',{attrs:{"name":"close"}})],1)],2)]),_vm._v(" "),(!_vm.bottom)?_c('div',{ref:"tabsContainer",class:['tab-content',{'card-block': _vm.card}]},[_vm._t("default"),_vm._v(" "),(!_vm.tabs || !_vm.tabs.length)?_vm._t("empty"):_vm._e()],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__filesize__ = __webpack_require__(1848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__time__ = __webpack_require__(1849);



var Filters = {
  install: function install(Vue) {
    Object(__WEBPACK_IMPORTED_MODULE_0__filesize__["a" /* default */])(Vue);
    Object(__WEBPACK_IMPORTED_MODULE_1__time__["a" /* default */])(Vue);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Filters);

/***/ }),
/* 1848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (Vue) {
  Vue.filter('filesize', function (value) {
    if (!value) return value;
    return humanFileSize(value, true);
  });

  // https://stackoverflow.com/questions/16023824/how-do-i-format-bytes-to-human-readable-text-in-javascript
  function humanFileSize(bytes, si) {
    var thresh = si ? 1000 : 1024;
    if (bytes < thresh) return bytes + ' B';
    var units = si ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'] : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
    var u = -1;
    do {
      bytes /= thresh;
      ++u;
    } while (bytes >= thresh);
    return bytes.toFixed(1) + ' ' + units[u];
  }
});

/***/ }),
/* 1849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (Vue) {
  Vue.filter('time', function (value) {
    if (!value) return value;

    var time = new Date(value);
    if (value < 60 * 60 * 1000) {
      // Less than one hour
      return time.getMinutes() + ':' + ('0' + time.getSeconds()).slice(-2);
    } else {
      // Greater or equal one hour
      return time.getUTCHours() + ':' + ('0' + time.getMinutes()).slice(-2) + ':' + ('0' + time.getSeconds()).slice(-2);
    }
  });
});

/***/ }),
/* 1850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    id: {
      type: String,
      default: null
    }
  },
  data: function data() {
    return {
      localId_: null
    };
  },
  mounted: function mounted() {
    if (!this.id && this._uid) {
      this.localId_ = '__webcg__' + this._uid;
    }
  },

  methods: {
    safeId: function safeId() {
      var suffix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var id = this.id || this.localId_ || null;
      if (!id) {
        return null;
      }
      suffix = String(suffix).replace(/\s+/g, '_');
      return suffix ? id + '_' + suffix : id;
    }
  }
});

/***/ }),
/* 1851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_keyboardjs__ = __webpack_require__(1852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_keyboardjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_keyboardjs__);


var Shortcut = {
  install: function install(Vue, options) {
    var shortcut = {};
    shortcut.bind = function (keyComboStr, pressHandler, releaseHandler, preventRepeatByDefault) {
      __WEBPACK_IMPORTED_MODULE_0_keyboardjs___default.a.bind(keyComboStr, function (e) {
        if (typeof pressHandler === 'function') {
          e.preventDefault();
          pressHandler(e);
        }
      }, function (e) {
        if (typeof releaseHandler === 'function') {
          e.preventDefault();
          releaseHandler(e);
        }
      }, preventRepeatByDefault);
    };
    shortcut.on = shortcut.addListener = shortcut.bind;
    shortcut.unbind = __WEBPACK_IMPORTED_MODULE_0_keyboardjs___default.a.unbind;
    shortcut.setContext = __WEBPACK_IMPORTED_MODULE_0_keyboardjs___default.a.setContext.bind(__WEBPACK_IMPORTED_MODULE_0_keyboardjs___default.a);

    Vue.$shortcut = shortcut;
    Vue.prototype.$shortcut = shortcut;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Shortcut);

/***/ })
],[285]);


// WEBPACK FOOTER //
// static/js/app.a03531e83dee01f3b815.js